import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionContext, Card, useAccordionButton } from "react-bootstrap";
import OverlayContainer from "../Components/OverlayContainer";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Select from "react-dropdown-select";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import * as qs from "qs";
import PopoverStickOnHover from "../Components/PopoverStickOnHover";
import CustomControl from "../Components/CustomControl";
import CustomControlMulti from "../Components/CustomControlMulti";
import CustomDropdown from "../Components/CustomDropdown";
import CustomDropdownMulti from "../Components/CustomDropdownMulti";
import CustomDropdownWithSearch from "../Components/CustomDropdownWithSearch";
import NumberToPersianWord from "number_to_persian_word";
import MultipleFileUpload from "../Components/MultipleFileUpload";
import UploadedFilesList from "../Components/UploadedFilesList";
import UserProjects from "../Static Files/UserProjects.json";
import GetPrice from "../Functions/GetPrice";
import { useDispatch, useSelector } from "react-redux";
import { CartUpdatedTrue, ShowLogin2Modal } from "../Actions/types";
import authHeader from "../Services/auth-header";
import SaveUserProject from "../Functions/SaveUserProject";
import { refreshToken } from "../Services/auth.service";
import GetUserProjectData from "../Functions/GetUserProjectData";
import setGetDeps from "../Functions/setGetDeps";
import ModalLogin from "../Components/ModalLogin";
import AddProjectToCart from "../Functions/AddProjectToCart";
import GetMeasurementArray from "../Functions/GetMeasurementArray";
import GetSewingFilters from "../Functions/GetSewingFilters";
import {
  Capitalize,
  CapitalizeAllWords,
  convertToPersian,
  NumToFa,
  Uppercase,
  capitalizeWordsText,
} from "../Functions/TextTransform";
import { DebounceInput } from "react-debounce-input";
import { createGetCart, createGetHasZipcode } from "../Functions/FunctionsGrommet/cartAndZipcode";
import { createTopScroll } from "../Functions/FunctionsGrommet/topScroll";
import {
  createFilterSelected,
  createAddFailedFileToParent,
} from "../Functions/FunctionsGrommet/filterAndUpload";
import { convertTempToFiles } from "../Functions/FunctionsGrommet/convertTempToFiles";
import { createGetProjectDetail } from "../Functions/FunctionsGrommet/getProjectDetail";
import { createDeleteUploadedPdf } from "../Functions/FunctionsGrommet/deleteUploadedPdf";
import { createHandleDeleteFile2 } from "../Functions/FunctionsGrommet/handleDeleteFile2";
import {
  createSetDeleteUploaded,
  createDeleteUploadedImg,
} from "../Functions/FunctionsGrommet/deleteUploadedImg";
import { createAddUploadFileUrl } from "../Functions/FunctionsGrommet/addUploadFileUrl";
import { createSubmitUploadedFile } from "../Functions/FunctionsGrommet/submitUploadedFile";
import { createRoomLabelChanged } from "../Functions/FunctionsGrommet/roomLabelChanged";
import { createGetWindowSize } from "../Functions/FunctionsGrommet/getWindowSize";
import { createFabricSwatch } from "../Functions/FunctionsGrommet/fabricSwatch";
import {
  rooms,
  motorChannels,
  MotorPosition,
  privacyLayerSelect,
  privacyLayerSelect2,
  privacyLayerSelect3,
} from "../Static Files/Static_Labels";
import {
  draperiesSelect,
  sheersSelect,
  sheersSelect2,
  sheersSelect3,
} from "../Static Files/Static_Labels_Grommet";
import ShowMoreLineLimited from "../Components/ShowMoreLineLimited";
import RenderSideCart from "../Components/RenderSideCart";
import { useMediaQuery } from "react-responsive";
import AddSwatch from "../Functions/AddSwatch";
import { findFabricPhotoById } from "../Functions/GrommetUtils";
import { getGrommetStepLabels } from "../Functions/GrommetStepLabels/getGrommetStepLabels";
import Step5ARodGrommet from "../Components/Accordion/Step5ARodGrommet";
import ElectricHandModalGrommet from "../Components/Modal/ElectricHandModalGrommet";
import CompleteStep4Grommet from "../Components/Modal/CompleteStep4Grommet";
import FabricSelectionModalGrommet from "../Components/Modal/FabricSelectionModalGrommet";
import SelectNoPanelTypeModalGrommet from "../Components/Modal/SelectNoPanelTypeModalGrommet";
import SelectMountGrommetStep4 from "../Components/Modal/SelectMountGrommetStep4";
import SelectNoMeasurementsGrommet from "../Components/Modal/SelectNoMeasurementsGrommet";
import HelpMeasureModalGrommet from "../Components/Modal/HelpMeasureModalGrommet";
import WorkingSevenMedals from "../Components/Modal/WorkingSevenMedals";
import Step8GrommetOne from "../Components/Accordion/Step8GrommetOne";
import HardwareImgModal from "../Components/Modal/HardwareImgModal";
import { imgUrl } from "../config/api";
import {
  baseURLModel,
  baseURLFabrics,
  baseURLGetRail,
  baseURLPrice,
  baseURLZipCode,
  baseURLFreeShipping,
  baseURGetProject,
  baseURLGetCart,
  baseURLUploadImg,
  baseURLUploadPdf,
  baseURLDeleteFile,
  baseURLDeleteBasketProject,
} from "../Services/client";

function Grommet({
  CatID,
  ModelID,
  PageType,
  ProjectId,
  EditIndex,
  PageItem,
  QueryString,
  Parameters,
  PageId,
}) {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [pageLanguage, setPageLanguage] = useState(
    location.pathname
      .split("")
      .slice(1, 3)
      .join("")
  );
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 923px)" });
  const firstRender = useRef(true);
  const modalTopRef = useRef(null);
  const fabricsContainerRef = useRef(null);
  const fabricsContainerRef4 = useRef(null);
  const sheerFabricSelectionRef = useRef({ fabricId: "", designCode: "" });
  const changeFabricsGuardRef = useRef(false);
  const [catID, setCatID] = useState(CatID);
  const [modelID, setModelID] = useState(ModelID);
  const [pageType, setPageType] = useState(PageType);
  const [projectId, setProjectId] = useState(ProjectId);
  const [editIndex, setEditIndex] = useState(EditIndex);
  const [pageItem, setPageItem] = useState(PageItem);
  const [queryString, setQueryString] = useState(QueryString);
  const [parameters, setParameters] = useState(Parameters);
  const [pageId, setPageId] = useState(PageId);
  const [windowWidthPanelType, setWindowWidthPanelType] = useState(null);
  const { isLoggedIn, cartUpdated, mainCart, sideCartPrice } = useSelector((state) => state.auth);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const motorChannelsUserOpenRef10B = useRef(false);
  const motorChannelsUserOpenRefC = useRef(false);
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);
  const [showEmptyMessage2, setShowEmptyMessage2] = useState(false);
  const priceRequestCancelRef = useRef(null);
  const setCartRef = useRef(null);
  const measureDebounceRef = useRef({ Width: null, Height: null });
  const hiddenAtRef = useRef(null);
  const skipFirstPageShowRef = useRef(true);
  const multipleFileUploadRef = useRef();
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedPDFs, setUploadedPDFs] = useState([]);
  const formatFileSize = (bytes) => {
    if (!bytes && bytes !== 0) return "";
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(2)} MB`;
    return `${(bytes / 1024).toFixed(2)} KB`;
  };
  const [pageLoad, setPageLoad] = useState(undefined);
  const [boardLoad, setBoardLoad] = useState(undefined);
  const [rodsLoad, setRodsLoad] = useState(undefined);
  const [rodsLoad2, setRodsLoad2] = useState(undefined);
  const [motorLoad, setMotorLoad] = useState(false);
  const [stepSevenClick, setStepSevenClick] = useState(false);
  const [mesLoad, setMesLoad] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [model, setModel] = useState({});
  const [isClickStep4, setIsClickStep4] = useState(true);
  const [modelAccessories, setModelAccessories] = useState({});
  const [stepAccessories, setStepAccessories] = useState({});
  const [stepAccessoriesList, setStepAccessoriesList] = useState([]);
  const [trimAccessories, setTrimAccessories] = useState({});
  const [fabrics, setFabrics] = useState({});
  const [fabrics2, setFabrics2] = useState({});
  const [fabricsList, setFabricsList] = useState([]);
  const [fabricsList2, setFabricsList2] = useState([]);
  const [sheers, setSheers] = useState({});
  const [sheers2, setSheers2] = useState({});
  const [sheersModelId, setSheersModelId] = useState("");
  const [sheersModelId2, setSheersModelId2] = useState("");
  const [rails, setRails] = useState([]);
  const [rails2, setRails2] = useState([]);
  const [rails3, setRails3] = useState([]);
  const [rods, setRods] = useState({});
  const [tracks, setTracks] = useState({});
  const [rods2, setRods2] = useState({});
  const [tracks2, setTracks2] = useState({});
  const [rods3, setRods3] = useState({});
  const [tracks3, setTracks3] = useState({});
  const [rodsList, setRodsList] = useState([]);
  const [rodsListHardware, setRodsListHardware] = useState([]);
  const [rodsList2, setRodsList2] = useState([]);
  const [rodsList3, setRodsList3] = useState([]);
  const [rodsList4, setRodsList4] = useState([]);
  const [tracksList, setTracksList] = useState([]);
  const [tracksList2, setTracksList2] = useState([]);
  const [rodsColorList, setRodsColorList] = useState([]);
  const [rodsColorList2, setRodsColorList2] = useState([]);
  const [rodsColorList3, setRodsColorList3] = useState([]);
  const [rodsColorList4, setRodsColorList4] = useState([]);
  const [sheersList, setSheersList] = useState([]);
  const [sheersList2, setSheersList2] = useState([]);
  const [defaultFabricPhoto, setDefaultFabricPhoto] = useState(null);
  const [defaultModelName, setDefaultModelName] = useState("");
  const [defaultModelNameFa, setDefaultModelNameFa] = useState("");
  const [defaultModelDesc, setDefaultModelDesc] = useState("");
  const [defaultModelDescFa, setDefaultModelDescFa] = useState("");
  const [price, setPrice] = useState(0);
  const [liningPrice, setLiningPrice] = useState(undefined);
  const [handCurtainPricDrapery, setHandCurtainPricDrapery] = useState(undefined);
  const [handCurtainPricSheer, setHandCurtainPricSheer] = useState(undefined);
  const [freeShipPrice, setFreeShipPrice] = useState(0);
  const [show, setShow] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchShow, setSearchShow] = useState(false);
  const [searchText2, setSearchText2] = useState("");
  const [searchShow2, setSearchShow2] = useState(false);
  const [measurementsNextStep, setMeasurementsNextStep] = useState("4");
  const [hardwareNextStep, setHardwareNextStep] = useState("9");
  const [projectModalState, setProjectModalState] = useState(0);
  const [zoomModalHeader, setZoomModalHeader] = useState([]);
  const [zoomModalBody, setZoomModalBody] = useState([]);
  const [swatchId, setSwatchId] = useState(0);
  const [swatchDetailId, setSwatchDetailId] = useState(0);
  const [swatchPhotoPath, setSwatchPhotoPath] = useState("");
  const [hasSwatchId, setHasSwatchId] = useState(false);
  const [addCartErr, setAddCartErr] = useState([]);
  const [sideCartObjects, setSideCartObjects] = useState({});
  const [sideCartProductTotal, setSideCartProductTotal] = useState(0);
  const [sideCartInstallPrice, setSideCartInstallPrice] = useState(0);
  const [sideCartTransportPrice, setSideCartTransportPrice] = useState(0);
  const [sideCartHasSwatches, setSideCartHasSwatches] = useState(false);
  const [cartAgree, setCartAgree] = useState([]);
  const [cartChanged, setCartChanged] = useState(0);
  const [bagUpdate, setBagUpdate] = useState(false);
  const [bag, setBag] = useState({});
  const [remoteNames, setRemoteNames] = useState([]);
  const [showRemoteName, setShowRemoteName] = useState(false);
  const [accordionActiveKey, setAccordionActiveKey] = useState("");
  const [accordionActiveKey2, setAccordionActiveKey2] = useState("");
  const [roomLabelText, setRoomLabelText] = useState("");
  const [fabricSelected, setFabricSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
    FabricWidth: 0,
    SewingDirection: undefined,
  });
  const [fabricSelected2, setFabricSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedLeadRequired: false,
    selectedPhoto: "",
    selectedPhoto2: "",
    FabricWidth: 0,
    SewingDirection: undefined,
  });
  const fabricSelected2Ref = useRef(fabricSelected2);
  fabricSelected2Ref.current = fabricSelected2;
  const [borderSelected, setBorderSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [trimSelected, setTrimSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [borderSelected2, setBorderSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [trimSelected2, setTrimSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedDesignCode: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [sheersSelected, setSheersSelected] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [sheersSelected2, setSheersSelected2] = useState({
    selectedFabricId: 0,
    selectedTextEn: "",
    selectedTextFa: "",
    selectedColorEn: "",
    selectedColorFa: "",
    selectedHasTrim: false,
    selectedPhoto: "",
    selectedPhoto2: "",
  });
  const [roomLabelSelect, setRoomLabelSelect] = useState({
    label: "",
    value: "",
  });
  const [sheerHeaderStyleTemp, setSheerHeaderStyleTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [sheerHeaderStyleTemp2, setSheerHeaderStyleTemp2] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [mountTypeTemp, setMountTypeTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [curtainPosTemp, setCurtainPosTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [finishedLengthTemp, setFinishedLengthTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [hardwareSheerWarningTemp, setHardwareSheerWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [hardwarePLWarningTemp, setHardwarePLWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [panelSheerWarningTemp, setPanelSheerWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [panelPLWarningTemp, setPanelPLWarningTemp] = useState({
    stepValue: "",
    id: "",
    cartValue: "",
    event: "",
  });
  const [stepSelectedValue, setStepSelectedValue] = useState({});
  const [showLabels, setShowLabels] = useState(true);
  const [headerTruncated, setHeaderTruncated] = useState([]);
  const [extendedTitle, setExtendedTitle] = useState({
    1: [],
    2: [],
    6: [],
    8: [],
    "8A": [],
    "8B": [],
    "8C": [],
    9: [],
  });
  const [detailsShow, setDetailsShow] = useState(false);
  const [filtersShow, setFiltersShow] = useState(false);
  const [filtersShow2, setFiltersShow2] = useState(false);
  const [windowSize, setWindowSize] = useState("");
  const [windowSizeBool, setWindowSizeBool] = useState(false);
  const [stepSelectedLabel, setStepSelectedLabel] = useState({});
  const [modals, setModals] = useState({});
  const [showModals, setShowModals] = useState("");
  const [hideModals, setHideModals] = useState("");
  const [popoverImages, setPopoverImages] = useState([]);
  const [inputDifRef, setInputDifRef] = useState(undefined);
  const [inputDifdep, setInputDifdep] = useState("");
  const [leftRight, setLeftRight] = useState({
    left: "",
    right: "",
  });
  const [stepSelectedOptions, setStepSelectedOptions] = useState({
    values: {},
    labels: {},
  });
  const [selectCustomValues, setSelectCustomValues] = useState({
    width1: [],
    width2: [],
    width3: [],
    height1: [],
    height2: [],
    left: [],
    right: [],
    width: [],
    length: [],
    Depth: [],
    MouldingHeight: [],
    width3A: [],
    height3C: [],
    shadeMount: [],
    RodWidth: [],
    RodToBottom: [],
  });
  const [isDisabledRodGrommet9c, setIsDisabledRodGrommet9c] = useState(false);
  const [width, setWidth] = useState(undefined);
  const [height, setHeight] = useState(undefined);
  const [depth, setDepth] = useState(undefined);
  const [mouldingHeight, setMouldingHeight] = useState(undefined);
  const [rodToBottom, setRodToBottom] = useState(undefined);
  const [rodToFloor, setRodToFloor] = useState(undefined);
  const [windowToFloor, setWindowToFloor] = useState(undefined);
  const [ceilingToWindow1, setCeilingToWindow1] = useState(undefined);
  const [ceilingToWindow2, setCeilingToWindow2] = useState(undefined);
  const [ceilingToWindow3, setCeilingToWindow3] = useState(undefined);
  const [ceilingToFloor, setCeilingToFloor] = useState(undefined);
  const [ceilingToFloor1, setCeilingToFloor1] = useState(undefined);
  const [ceilingToFloor2, setCeilingToFloor2] = useState(undefined);
  const [ceilingToFloor3, setCeilingToFloor3] = useState(undefined);
  const [width3C, setWidth3C] = useState(undefined);
  const [rodWidth, setRodWidth] = useState(undefined);
  const [left, setLeft] = useState(undefined);
  const [right, setRight] = useState(undefined);
  const [height3E, setHeight3E] = useState(undefined);
  const [mount, setMount] = useState(undefined);
  const [anyMeasurements, setAnyMeasurements] = useState(false);
  const [widthCart, setWidthCart] = useState(undefined);
  const [heightCart, setHeightCart] = useState(undefined);
  const [heightCart2, setHeightCart2] = useState(undefined);
  const [fabricError, setFabricError] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [fabricsBoard, setFabricsBoard] = useState([]);
  const [fabricBoard, setFabricBoard] = useState(undefined);
  const [sheerBoard, setSheerBoard] = useState(undefined);
  const [fabricIsBoard, setFabricIsBoard] = useState(false);
  const [sheerIsBoard, setSheerIsBoard] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [requiredStep, setRequiredStep] = useState({});
  const [cartValues, setCartValues] = useState({});
  const [cartStateAgree, setCartStateAgree] = useState(false);
  const [cartAgreeDescription, setCartAgreeDescription] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [cartProjectIndex, setCartProjectIndex] = useState(-1);
  const [saveProjectCount, setSaveProjectCount] = useState(0);

  const [depSet, setDepSet] = useState(
    new Set(["1", "2", "2A", "2B", "2C", "3A0", "3", "4", "5", "6", "7", "8", "1001", "1002"])
  );

  const inputs = useRef({});
  const selectedTitle = useRef({});
  const search_input = useRef(null);
  const search_input2 = useRef(null);
  const accordion = useRef(null);
  const accordion2 = useRef(null);
  const [showMoreFilterTrigger, setShowMoreFilterTrigger] = useState(undefined);
  const filterCheckboxes = useRef({
    colors: [],
    patterns: [],
    types: [],
    prices: [],
    colors2: [],
    patterns2: [],
    types2: [],
    prices2: [],
    colorsSheer: [],
    patternsSheer: [],
    typesSheer: [],
    pricesSheer: [],
  });
  const steps = useRef({});
  const stepHeaders = useRef({});
  const depDetails = useRef({
    1: {},
    2: {},
    "2B": {},
    "2C": {},
    "3A0": {},
    3: {},
    4: {},
    5: {},
    6: {},
    7: {},
    8: {},
    9: {},
    10: {},
  });

  const [filterChanged, setFilterChanged] = useState({
    filter: 0,
    filter_id: undefined,
    isDelete: false,
    step: "1",
  });
  const [filterColors, setFilterColors] = useState([...queryString["colors"]]);
  const [filterPatterns, setFilterPatterns] = useState([...queryString["patterns"]]);
  const [filterTypes, setFilterTypes] = useState([...queryString["types"]]);
  const [filterPrices, setFilterPrices] = useState([...queryString["prices"]]);
  const [filterColors2, setFilterColors2] = useState([]);
  const [filterPatterns2, setFilterPatterns2] = useState([]);
  const [filterTypes2, setFilterTypes2] = useState([]);
  const [filterPrices2, setFilterPrices2] = useState([]);
  const [filterDesigns, setFilterDesigns] = useState([...queryString["designs"]]);

  const [isClearAll, setIsClearAll] = useState(false);

  const [step1, setStep1] = useState("");
  const [step1Check, setStep1Check] = useState("");
  const [step1Border, setStep1Border] = useState("");
  const [step1BorderRadio, setStep1BorderRadio] = useState("");
  const [step1Trim, setStep1Trim] = useState("");
  const [step2Check, setStep2Check] = useState("");
  const [step2Check2, setStep2Check2] = useState("");
  const [step2Border, setStep2Border] = useState("");
  const [step2BorderRadio, setStep2BorderRadio] = useState("");
  const [step2Trim, setStep2Trim] = useState("");
  const [step2, setStep2] = useState("");
  const [step2A, setStep2A] = useState("");
  const [step2B, setStep2B] = useState("");
  const [step2B1, setStep2B1] = useState("");
  const [step2C, setStep2C] = useState("");
  const [step3, setStep3] = useState("");
  const [step31, setStep31] = useState("");
  const [step3A0, setStep3A0] = useState("");
  const [step3A, setStep3A] = useState("Standard");
  const [step3B, setStep3B] = useState("Floor");
  const [step3ARod, setStep3ARod] = useState("Floor");
  const [step3ARod1, setStep3ARod1] = useState("true");
  const [step4, setStep4] = useState("");
  const [step5, setStep5] = useState("");
  const [step6, setStep6] = useState("Customize Style Per Curtain");
  const [step61, setStep61] = useState("");
  const [step6A, setStep6A] = useState("");
  const [step6B, setStep6B] = useState("");
  const [step6C, setStep6C] = useState("");
  const [step6BHead, setStep6BHead] = useState("Rod");
  const [step6CHead, setStep6CHead] = useState("Rod");
  const [step7, setStep7] = useState("");
  const [step8, setStep8] = useState("");
  const [step81, setStep81] = useState("");
  const [step82, setStep82] = useState("");
  const [step83, setStep83] = useState("");
  const [step8A, setStep8A] = useState("");
  const [step8A1, setStep8A1] = useState("");
  const [step8A2, setStep8A2] = useState("");
  const [step8A3, setStep8A3] = useState("");
  const [step8B, setStep8B] = useState("");
  const [step8B1, setStep8B1] = useState("");
  const [step8B2, setStep8B2] = useState("");
  const [step8B3, setStep8B3] = useState("");
  const [step8B5, setStep8B5] = useState("");
  const [step8C, setStep8C] = useState("");
  const [step8C1, setStep8C1] = useState("");
  const [step8C2, setStep8C2] = useState("");
  const [step8C3, setStep8C3] = useState("");
  const [step8C5, setStep8C5] = useState("");
  const [zipcodeChecked, setZipcodeChecked] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [zipcodeButton, setZipcodeButton] = useState(false);
  const [hasZipcode, setHasZipcode] = useState("");
  const [hasInstall, setHasInstall] = useState(null);
  const [installPrice, setInstallPrice] = useState(-1);
  const [transportPrice, setTransportPrice] = useState(-1);
  const [remoteNameB, setRemoteNameB] = useState("");
  const [remoteNameC, setRemoteNameC] = useState("");
  const [moreInfoInput, setMoreInfoInput] = useState("");
  const [selectedRoomLabel, setSelectedRoomLabel] = useState([]);
  const [trackType8B, setTrackType8B] = useState(undefined);
  const [trackType8C, setTrackType8C] = useState(undefined);
  const [backPage, setBackPage] = useState(false);
  const [motorErr1, setMotorErr1] = useState(false);
  const [step3BErr1, setStep3BErr1] = useState(false);
  const [step3ARodErr1, setStep3ARodErr1] = useState(false);
  const [mountErr1, setMountErr1] = useState(false);
  const [mountErr2, setMountErr2] = useState(false);
  const [depthHelp, setDepthHelp] = useState("Triple Layer");
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFileName, setSelectedFileName] = useState("");
  const [editedFileName, setEditedFileName] = useState("");
  const [uploadedImagesList, setUploadedImagesList] = useState([]);
  const [uploadedImagesNamesList, setUploadedImagesNamesList] = useState([]);
  const [uploadedPDFNameList, setUploadedPDFNameList] = useState([]);
  const [uploadedImagesFile, setUploadedImagesFile] = useState([]);
  const [uploadedPDFFile, setUploadedPDFFile] = useState([]);
  const [uploadedImagesURL, setUploadedImagesURL] = useState([]);
  const [uploadedPDFURL, setUploadedPDFURL] = useState([]);
  const [initFilterColors, setInitFilterColors] = useState({});
  const [initFilterPatterns, setInitFilterPatterns] = useState({});
  const [initFilterTypes, setInitFilterTypes] = useState({});
  const [initFilterPrices, setInitFilterPrices] = useState({});
  const [sewingColors, setSewingColors] = useState([]);
  const [sewingPatterns, setSewingPatterns] = useState([]);
  const [sewingTypes, setSewingTypes] = useState([]);
  const [sewingPrices, setSewingPrices] = useState([]);
  const [sewingColors2, setSewingColors2] = useState([]);
  const [sewingPatterns2, setSewingPatterns2] = useState([]);
  const [sewingTypes2, setSewingTypes2] = useState([]);
  const [sewingPrices2, setSewingPrices2] = useState([]);
  const [sewingColorsSheer, setSewingColorsSheer] = useState([]);
  const [sewingPatternsSheer, setSewingPatternsSheer] = useState([]);
  const [sewingTypesSheer, setSewingTypesSheer] = useState([]);
  const [sewingPricesSheer, setSewingPricesSheer] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState({
    colors: false,
    patterns: false,
    types: false,
    prices: false,
  });
  const [deleteUploadImageUrl, setDeleteUploadImageUrl] = useState("");
  const [deleteUploadPdfUrl, setDeleteUploadPdfUrl] = useState("");
  const [deleteUploadImageIndex, setDeleteUploadImageIndex] = useState(-1);
  const [deleteUploadPdfIndex, setDeleteUploadPdfIndex] = useState(-1);
  const [addingLoading, setAddingLoading] = useState(false);
  const [cartLoading, setCartLoading] = useState(false);
  const [savingLoading, setSavingLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [fabricLoading, setFabricLoading] = useState(false);
  const [swatchLogin, setSwatchLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [swatchLoginSwatchId, setSwatchLoginSwatchId] = useState(null);
  const [swatchLoginSwatchDetailId, setSwatchLoginSwatchDetailId] = useState(null);
  const [helpMeasure, setHelpMeasure] = useState("hasRod");
  const [helpMeasureLengthType, setHelpMeasureLengthType] = useState("Floor");
  const [customAcc, setCustomAcc] = useState([]);
  const [customAccActive, setCustomAccActive] = useState({});
  const [selectedMotorChannelsB, setSelectedMotorChannelsB] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorChannelsC, setSelectedMotorChannelsC] = useState([
    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
  ]);
  const [selectedMotorPositionB, setSelectedMotorPositionB] = useState([]);
  const [selectedMotorPositionC, setSelectedMotorPositionC] = useState([]);
  const [selectedRemoteName, setSelectedRemoteName] = useState([]);
  const [selectedDrapery, setSelectedDrapery] = useState([]);
  const [selectedSheer, setSelectedSheer] = useState([]);
  const [selectedPrivacyLayer, setSelectedPrivacyLayer] = useState([]);
  const [nameStep, setNameStep] = useState("5A");
  const [accessoriesDesign, setAccessoriesDesign] = useState({
    isPlus: undefined,
    SewingAccessoryValue: "",
    SewingAccessoryId: undefined,
    SewingModelAccessoryId: undefined,
    DesignCode: undefined,
    DesignNameEn: undefined,
    DesignNameFa: undefined,
    ColorNameEn: undefined,
    ColorNameFa: undefined,
    qty: undefined,
  });
  const [tiebackDrapery, setTiebackDrapery] = useState({
    isPlus: undefined,
    HandCurtainId: undefined,
    HandCurtainNum: 0,
  });
  const [tiebackDraperyQty, setTiebackDraperyQty] = useState(0);
  const [tiebackSheer, setTiebackSheer] = useState({
    isPlus: undefined,
    HandCurtainId: undefined,
    HandCurtainNum: 0,
  });
  const [tiebackSheerQty, setTiebackSheerQty] = useState(0);
  const getFabrics = () => {
    let paramObj = {
      modelId: modelID,
    };
    let promise5 = new Promise((resolve, reject) => {
      if (filterDesigns.length > 0) {
        paramObj["designs"] = [];
        filterDesigns.forEach((filter_id, index) => {
          paramObj["designs"] = [...paramObj["designs"], filter_id];
          if (index === filterDesigns.length - 1) {
            resolve();
          }
        });
      } else {
        resolve();
      }
    });

    let promise6 = new Promise((resolve, reject) => {
      if (heightCart2) {
        paramObj["windowheight"] = [heightCart2];
        resolve();
      } else {
        resolve();
      }
    });

    Promise.all([promise5, promise6]).then(() => {
      setShowEmptyMessage(false);
      setLoading(true);
      axios
        .get(baseURLFabrics, {
          params: paramObj,
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        })
        .then((response) => {
          console.log(response.data);
          const data = Array.isArray(response.data) ? response.data : [];
          getSheersFabrics("10010301,10010302");

          if (data.length === 0) {
            setShowEmptyMessage(true);
            setShowEmptyMessage2(true);
            setFabrics({});
            setFabrics2({});
            setFabricsList([]);
            setFabricsList2([]);
            setTimeout(() => {
              setIsClearAll(false);
            }, 1000);
            return;
          }

          setShowEmptyMessage(false);
          setShowEmptyMessage2(false);
          let tempFabrics = {};
          let tempFabrics2 = {};
          data.forEach((obj) => {
            obj["ShowMore"] = false;
            if (obj["FabricGroupId"] === "100101") {
              if (
                tempFabrics[obj["DesignEnName"]] === "" ||
                tempFabrics[obj["DesignEnName"]] === undefined ||
                tempFabrics[obj["DesignEnName"]] === null ||
                tempFabrics[obj["DesignEnName"]] === []
              )
                tempFabrics[obj["DesignEnName"]] = [];
              tempFabrics[obj["DesignEnName"]].push(obj);
            } else if (obj["FabricGroupId"] === "100102") {
              if (
                tempFabrics2[obj["DesignEnName"]] === "" ||
                tempFabrics2[obj["DesignEnName"]] === undefined ||
                tempFabrics2[obj["DesignEnName"]] === null ||
                tempFabrics2[obj["DesignEnName"]] === []
              )
                tempFabrics2[obj["DesignEnName"]] = [];
              tempFabrics2[obj["DesignEnName"]].push(obj);
            }
          });
          setFabrics(tempFabrics);
          setFabrics2(tempFabrics2);
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          setTimeout(() => {
            setIsClearAll(false);
          }, 1000);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  function getSheersFabrics(groupId) {
    let paramObj = {
      modelId: modelID,
    };
    setLoading(true);
    axios
      .get(baseURLFabrics, {
        params: paramObj,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      })
      .then((response) => {
        let tempFabrics = {};
        let tempFabrics2 = {};
        response.data.forEach((obj) => {
          obj["ShowMore"] = false;
          if (obj["FabricGroupId"] === "10010301") {
            if (
              tempFabrics[obj["DesignEnName"]] === "" ||
              tempFabrics[obj["DesignEnName"]] === undefined ||
              tempFabrics[obj["DesignEnName"]] === null ||
              tempFabrics[obj["DesignEnName"]] === []
            )
              tempFabrics[obj["DesignEnName"]] = [];
            tempFabrics[obj["DesignEnName"]].push(obj);
          } else if (obj["FabricGroupId"] === "10010302") {
            if (
              tempFabrics2[obj["DesignEnName"]] === "" ||
              tempFabrics2[obj["DesignEnName"]] === undefined ||
              tempFabrics2[obj["DesignEnName"]] === null ||
              tempFabrics2[obj["DesignEnName"]] === []
            )
              tempFabrics2[obj["DesignEnName"]] = [];
            tempFabrics2[obj["DesignEnName"]].push(obj);
          }
        });
        setSheers(tempFabrics);
        setSheers2(tempFabrics2);
        setTimeout(() => {
          setIsClearAll(false);
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
        setTimeout(() => {
          setIsClearAll(false);
        }, 1000);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getRails(width) {
    let params = {};
    params["modelId"] = modelID;
    if (width) {
      params["width"] = width;
    }
    axios
      .get(baseURLGetRail, {
        params: params,
      })
      .then((response) => {
        let temp = {};
        let temp2 = {};
        let temp3 = {};
        response.data.forEach((obj) => {
          if (obj["RailCategoryId"] === 5303) {
            if (
              temp[obj["DesignCode"]] === "" ||
              temp[obj["DesignCode"]] === undefined ||
              temp[obj["DesignCode"]] === null ||
              temp[obj["DesignCode"]] === []
            )
              temp[obj["DesignCode"]] = [];
            temp[obj["DesignCode"]].push(obj);
          } else if (obj["RailCategoryId"] === 5301) {
            if (
              temp2[obj["DesignCode"]] === "" ||
              temp2[obj["DesignCode"]] === undefined ||
              temp2[obj["DesignCode"]] === null ||
              temp2[obj["DesignCode"]] === []
            )
              temp2[obj["DesignCode"]] = [];
            temp2[obj["DesignCode"]].push(obj);
          }
        });
        setRods(temp);
        setTracks(temp2);
        setRails(response.data || []);
      })
      .catch((err) => {
        console.log(err);
        setRails([]);
        if (rodsLoad) {
          setRodsLoad(false);
        }
      });
  }
  function getSheersRails(modelID, width, isPrivacy) {
    let params = {};
    params["modelId"] = modelID;
    if (width) {
      params["width"] = width;
    }
    axios
      .get(baseURLGetRail, {
        params: params,
      })
      .then((response) => {
        let temp = {};
        let temp2 = {};
        let temp3 = {};
        response.data.forEach((obj) => {
          if (obj["RailCategoryId"] === 5303) {
            if (
              temp[obj["DesignCode"]] === "" ||
              temp[obj["DesignCode"]] === undefined ||
              temp[obj["DesignCode"]] === null ||
              temp[obj["DesignCode"]] === []
            )
              temp[obj["DesignCode"]] = [];
            temp[obj["DesignCode"]].push(obj);
          } else if (obj["RailCategoryId"] === 5301) {
            if (
              temp2[obj["DesignCode"]] === "" ||
              temp2[obj["DesignCode"]] === undefined ||
              temp2[obj["DesignCode"]] === null ||
              temp2[obj["DesignCode"]] === []
            )
              temp2[obj["DesignCode"]] = [];
            temp2[obj["DesignCode"]].push(obj);
          }
        });
        if (isPrivacy) {
          setRods3(temp);
          setTracks3(temp2);
          setRails3(response.data || []);
        } else {
          setRods2(temp);
          setTracks2(temp2);
          setRails2(response.data || []);
        }
      })
      .catch((err) => {
        console.log(err);
        if (isPrivacy) {
          setRails3([]);
        } else {
          setRails2([]);
        }
        if (rodsLoad2) {
          setRodsLoad2(false);
        }
      });
  }
  function getFabricsWithFilter(clearAll, step = "1") {
    if (clearAll) {
      getFabrics();
    } else {
      const isStep2 = step === "2";
      const currentSearchText = isStep2 ? searchText2 : searchText;
      const currentFilterColors = isStep2 ? filterColors2 : filterColors;
      const currentFilterPatterns = isStep2 ? filterPatterns2 : filterPatterns;
      const currentFilterTypes = isStep2 ? filterTypes2 : filterTypes;
      const currentFilterPrices = isStep2 ? filterPrices2 : filterPrices;

      if (isStep2) {
        setShowEmptyMessage2(false);
        setLoading2(true);
      } else {
        setShowEmptyMessage(false);
        setLoading(true);
      }

      let paramObj = { modelId: modelID, searchString: currentSearchText };

      let promise1 = new Promise((resolve, reject) => {
        if (currentFilterColors.length > 0) {
          paramObj["colorIds"] = [];
          currentFilterColors.forEach((filter_id, index) => {
            paramObj["colorIds"] = [...paramObj["colorIds"], filter_id];
            if (index === currentFilterColors.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise2 = new Promise((resolve, reject) => {
        if (currentFilterPatterns.length > 0) {
          paramObj["patternTypeIds"] = [];
          currentFilterPatterns.forEach((filter_id, index) => {
            paramObj["patternTypeIds"] = [...paramObj["patternTypeIds"], filter_id];
            if (index === currentFilterPatterns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise3 = new Promise((resolve, reject) => {
        if (currentFilterTypes.length > 0) {
          paramObj["typeIds"] = [];
          currentFilterTypes.forEach((filter_id, index) => {
            paramObj["typeIds"] = [...paramObj["typeIds"], filter_id];
            if (index === currentFilterTypes.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise4 = new Promise((resolve, reject) => {
        if (currentFilterPrices.length > 0) {
          paramObj["priceLevelIds"] = [];
          currentFilterPrices.forEach((filter_id, index) => {
            paramObj["priceLevelIds"] = [...paramObj["priceLevelIds"], filter_id];
            if (index === currentFilterPrices.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
      let promise5 = new Promise((resolve, reject) => {
        if (filterDesigns.length > 0) {
          paramObj["designs"] = [];
          filterDesigns.forEach((filter_id, index) => {
            paramObj["designs"] = [...paramObj["designs"], filter_id];
            if (index === filterDesigns.length - 1) {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });

      let promise6 = new Promise((resolve, reject) => {
        if (heightCart2) {
          paramObj["windowheight"] = [heightCart2];
          resolve();
        } else {
          resolve();
        }
      });
      Promise.all([promise1, promise2, promise3, promise4, promise5, promise6]).then(() => {
        axios
          .get(baseURLFabrics, {
            params: paramObj,
            paramsSerializer: (params) => {
              return qs.stringify(params, { arrayFormat: "repeat" });
            },
          })
          .then((response) => {
            const data = Array.isArray(response.data) ? response.data : [];
            if (!isStep2) {
              getSheersFabrics("10010301,10010302");
            }

            let tempFabrics = {};
            let tempFabrics2 = {};
            data.forEach((obj) => {
              obj["ShowMore"] = false;
              if (obj["FabricGroupId"] === "100101") {
                if (
                  tempFabrics[obj["DesignEnName"]] === "" ||
                  tempFabrics[obj["DesignEnName"]] === undefined ||
                  tempFabrics[obj["DesignEnName"]] === null ||
                  tempFabrics[obj["DesignEnName"]] === []
                )
                  tempFabrics[obj["DesignEnName"]] = [];
                tempFabrics[obj["DesignEnName"]].push(obj);
              } else if (obj["FabricGroupId"] === "100102") {
                if (
                  tempFabrics2[obj["DesignEnName"]] === "" ||
                  tempFabrics2[obj["DesignEnName"]] === undefined ||
                  tempFabrics2[obj["DesignEnName"]] === null ||
                  tempFabrics2[obj["DesignEnName"]] === []
                )
                  tempFabrics2[obj["DesignEnName"]] = [];
                tempFabrics2[obj["DesignEnName"]].push(obj);
              }
            });

            if (isStep2) {
              if (data.length === 0 || !Object.keys(tempFabrics2).length) {
                setShowEmptyMessage2(true);
                setFabrics2({});
                setFabricsList2([]);
              } else {
                setShowEmptyMessage2(false);
                setFabrics2(tempFabrics2);
              }
            } else {
              if (data.length === 0 || !Object.keys(tempFabrics).length) {
                setShowEmptyMessage(true);
                setFabrics({});
                setFabricsList([]);
              } else {
                setShowEmptyMessage(false);
                setFabrics(tempFabrics);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            if (isStep2) {
              setLoading2(false);
            } else {
              setLoading(false);
            }
          });
      });
    }
  }
  const getModel = () => {
    axios
      .get(baseURLModel, {
        params: {
          id: modelID,
        },
      })
      .then((response) => {
        setModel(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function renderFabrics(bag, limitedFabrics, isBoard) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];

    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let tempFabrics = JSON.parse(JSON.stringify(fabrics));
    if (limitedFabrics !== undefined) {
      tempFabrics = limitedFabrics;
    }

    let promiseArr = [];
    Object.keys(tempFabrics).forEach((key, index) => {
      let fabrics = tempFabrics;
      promiseArr[index] = new Promise((resolve, reject) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let HasTrim = fabrics[key][0]["CanHasTrim"];
        let HasBorder = fabrics[key][0]["CanHasBorder"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let designSelected = false;
        let designSelectedIndex = 0;
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];
        const fabric1 = [];

        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve, reject) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;
            let PhotoPath = "";
            let PhotoPath2 = "";
            fabrics[key][j].FabricPhotos.forEach((obj) => {
              if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
              if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
            });

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let DesignRaportLength = fabrics[key][j].DesignRaportLength;
            let DesignRaportWidth = fabrics[key][j].DesignRaportWidth;
            let PolyesterPercent = fabrics[key][j].PolyesterPercent;
            let ViscosePercent = fabrics[key][j].ViscosePercent;
            let NylonPercent = fabrics[key][j].NylonPercent;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let FabricWidth = fabrics[key][j].FabricWidth;
            let SewingDirection = fabrics[key][j].SewingDirection;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }
            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = fabric[fabricOrderSelected];
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            if (`${FabricId}` === step1) {
              designSelected = true;
              designSelectedIndex = pushIndex;
            }
            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  <input
                    className="radio"
                    type="radio"
                    ref-num="1"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onChange={(e) => {
                      let temp = JSON.parse(JSON.stringify(fabricSelected));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedDesignCode = DesignCode;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedHasTrim = HasTrim;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      temp.selectedPhoto2 = PhotoPath2;
                      temp.FabricWidth = FabricWidth;
                      temp.SewingDirection = SewingDirection;
                      setFabricSelected(temp);
                    }}
                    name="fabric"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step1}
                    ref={(ref) => (inputs.current[`1${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid ${`${FabricId}` === step1 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath2)}
                      alt=""
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );

            pushIndex = fabric.length;
            fabric1.push(
              <li className="fabric_design_border_list_item" key={"border" + key + j}>
                <OverlayContainer
                  classNames="Accessories_List_item_color"
                  placement="middle"
                  children={
                    <div
                      className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                    >
                      <label>
                        <input
                          className="radio"
                          type="radio"
                          outline="true"
                          onChange={(e) => {
                            let temp = JSON.parse(JSON.stringify(borderSelected));
                            temp.selectedFabricId = FabricId;
                            temp.selectedTextEn = DesignEnName;
                            temp.selectedTextFa = DesignName;
                            temp.selectedDesignCode = DesignCode;
                            temp.selectedColorEn = ColorEnName;
                            temp.selectedColorFa = ColorName;
                            setBorderSelected(temp);
                          }}
                          name="border-trim"
                          model-id={modelID}
                          value={FabricId}
                          checked={`${FabricId}` === step1Border}
                          ref={(ref) => (inputs.current[`border-trim${FabricId}`] = ref)}
                        />
                        <div className="frame_img">
                          <img
                            className={`img-fluid ${
                              `${FabricId}` === step1Border ? "img-fluid_checked" : ""
                            }`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                    </div>
                  }
                  component={
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_item_color_text">
                        {pageLanguage1 === "en" ? ColorEnName : ColorName}
                      </p>
                    </div>
                  }
                />
              </li>
            );
            resolve();
          });
        }

        Promise.all(promiseArr2).then(() => {
          if (designSelected) {
            if (isBoard) {
              let newPushIndex = Math.ceil((designSelectedIndex + 1) / 4) * 4;
              fabric.splice(
                newPushIndex,
                0,
                <div key={"board"} className="grommet_fabric_board_container 1">
                  <div className="card-body-display-flex">
                    <span className="checkbox_text">{t("fabricHasLine")}</span>
                  </div>
                </div>
              );
            }
          }
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = fabricList[designOrderSelected];
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <React.Fragment key={"fabric" + key}>
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <div
                  className={`5 material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <hr />
                  <span>
                    <p>
                      {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                      {pageLanguage1 === "en" ? DesignEnName : DesignName}
                    </p>
                    <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                    <p>
                      {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                      {GetPrice(
                        SamplePrice,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )}
                    </p>
                  </span>
                </div>
                {fabric}
              </div>
              {(HasTrim || HasBorder) && (
                <div
                  className={
                    step1Check === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step1Check === `${DesignCode}`}
                    onChange={(e) => {
                      if (
                        step1 !== "" &&
                        fabrics[DesignEnName].some((obj) => obj["FabricId"] === step1)
                      ) {
                        if (e.target.checked) {
                          setStep1Check(`${DesignCode}`);
                          setTimeout(() => {
                            if (fabricsContainerRef.current) {
                              fabricsContainerRef.current.scrollBy({
                                top: 300,
                                behavior: "smooth",
                              });
                            }
                          }, 300);
                        } else {
                          setStep1Check("");
                        }
                      } else {
                        setStep1Check("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 1"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {HasTrim && HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border / Trim"
                          : "اضافه کردن نواردوزی/ حاشیه تزئینی  "
                        : HasTrim
                        ? pageLanguage1 === "en"
                          ? "Add A Trim"
                          : "یک نوار اضافه کنید"
                        : HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border"
                          : "یک حاشیه تزئینی اضافه کنید"
                        : ""}
                    </span>
                  </label>
                </div>
              )}
              <div
                className={
                  step1Check === `${DesignCode}`
                    ? "fabric_design_trim_border_container active"
                    : "fabric_design_trim_border_container"
                }
              >
                <div>
                  <h1 className="fabric_design_trim_border_title">
                    {HasTrim && HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border / Trim Material"
                        : "نواردوزی/حاشیه تزئینی مورد نظرتان را انتخاب کنید."
                      : HasTrim
                      ? pageLanguage1 === "en"
                        ? "Select Your Trim Material"
                        : ""
                      : HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border"
                        : ""
                      : ""}
                  </h1>
                  {HasBorder && (
                    <div className="fabric_design_border_container">
                      <h2 className="fabric_design_trim_border_title2">
                        {pageLanguage1 === "en" ? "DECORATIVE BORDER" : "حاشیه تزئینی"}:{" "}
                        {pageLanguage1 === "en" ? DesignEnName : DesignName}
                      </h2>
                      <ul className="fabric_design_border_list">{fabric1}</ul>
                      {step1Border !== "" && (
                        <div className="fabric_design_border_checkbox_container">
                          <h3 className="fabric_design_trim_border_title3">
                            {pageLanguage1 === "en"
                              ? "Select A Border Position:"
                              : "حاشیه تزیینی کجای پرده دوخته شود؟"}
                          </h3>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "10cm Leading Edge"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge")}
                              value="1"
                              name="step1bordercheck"
                              id="border1"
                              checked={step1BorderRadio === "10cm Leading Edge"}
                              onChange={(e) => {
                                setStep1BorderRadio("10cm Leading Edge");
                                // setCart("borderPosition", "10cm Leading Edge");
                              }}
                              ref={(ref) => (inputs.current["border1"] = ref)}
                            />
                            <label htmlFor="border1">
                              {/* {t("10cm Leading Edge")} */}
                              {i18n.language === "fa"
                                ? "۱۰ سانتیمتر لبه عمودی"
                                : "10cm Leading Edge"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("60cm Bottom Border")}
                              value="2"
                              name="step1bordercheck"
                              id="border2"
                              checked={step1BorderRadio === "60cm Bottom Border"}
                              onChange={(e) => {
                                setStep1BorderRadio("60cm Bottom Border");
                                // setCart("borderPosition", "60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border2"] = ref)}
                            />
                            <label htmlFor="border2">
                              {/* {t("60cm Bottom Border")} */}
                              {i18n.language === "fa"
                                ? "۶۰ سانتیمتر لبه پایینی"
                                : "60cm Bottom Border"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step1BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge & 60cm Bottom Border")}
                              value="3"
                              name="step1bordercheck"
                              id="border3"
                              checked={
                                step1BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                              }
                              onChange={(e) => {
                                setStep1BorderRadio("10cm Leading Edge & 60cm Bottom Border");
                                // setCart("borderPosition", "10cm Leading Edge & 60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border3"] = ref)}
                            />
                            <label htmlFor="border3">
                              {t("10cm Leading Edge & 60cm Bottom Border")}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {HasTrim && (
                    <>
                      {Object.keys(trimAccessories).map((key, index) => {
                        return (
                          <div className="fabric_design_border_container" key={"trim" + key}>
                            <h2 className="fabric_design_trim_border_title2">
                              {pageLanguage1 === "en" ? "DECORATIVE TRIM" : "نوار تزئینی"}:{" "}
                              {pageLanguage1 === "en"
                                ? Uppercase(trimAccessories[key][0]["DesignENName"])
                                : convertToPersian(trimAccessories[key][0]["DesignName"])}
                            </h2>
                            <ul className="fabric_design_border_list">
                              {trimAccessories[key].map((el, i) => {
                                let FabricId = el["DetailId"];
                                let DesignName = convertToPersian(el["DesignName"]);
                                let DesignEnName = el["DesignENName"];
                                let ColorName = convertToPersian(el["ColorName"]);
                                let ColorEnName = el["ColorENName"];
                                let PhotoPath = "";
                                el["Photos"].forEach((obj) => {
                                  if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
                                });
                                return (
                                  <li
                                    className="fabric_design_border_list_item"
                                    key={"trim" + key + i}
                                  >
                                    <OverlayContainer
                                      classNames="Accessories_List_item_color"
                                      placement="middle"
                                      children={
                                        <div
                                          className={`radio_group ${
                                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                                          }`}
                                        >
                                          <label>
                                            <input
                                              className="radio"
                                              type="radio"
                                              outline="true"
                                              onChange={(e) => {
                                                let temp = JSON.parse(JSON.stringify(trimSelected));
                                                temp.selectedFabricId = FabricId;
                                                temp.selectedTextEn = DesignEnName;
                                                temp.selectedTextFa = DesignName;
                                                temp.selectedDesignCode = DesignCode;
                                                temp.selectedColorEn = ColorEnName;
                                                temp.selectedColorFa = ColorName;
                                                setTrimSelected(temp);
                                              }}
                                              name="border-trim"
                                              model-id={modelID}
                                              value={FabricId}
                                              checked={`${FabricId}` === step1Trim}
                                              ref={(ref) =>
                                                (inputs.current[`border-trim${FabricId}`] = ref)
                                              }
                                            />
                                            <div className="frame_img">
                                              <img
                                                className={`img-fluid ${
                                                  `${FabricId}` === step1Trim
                                                    ? "img-fluid_checked"
                                                    : ""
                                                }`}
                                                src={imgUrl(PhotoPath)}
                                                alt=""
                                              />
                                            </div>
                                          </label>
                                        </div>
                                      }
                                      component={
                                        <div className="Accessories_List_item_color_container">
                                          <p className="Accessories_List_item_color_text">
                                            {pageLanguage1 === "en" ? ColorEnName : ColorName}
                                          </p>
                                        </div>
                                      }
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );

          resolve();
        });
      });
    });

    Promise.all(promiseArr).then(() => {
      if (limitedFabrics !== undefined) {
      } else {
        setFabricsList(fabricList);
      }
    });
  }
  function renderFabrics2(bag, limitedFabrics, isBoard) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    let tempFabrics = JSON.parse(JSON.stringify(fabrics2));
    if (limitedFabrics !== undefined) {
      tempFabrics = limitedFabrics;
    }

    const isSheerFabricSelected = () => {
      const selectedId = String(
        sheerFabricSelectionRef.current.fabricId ||
          fabricSelected2Ref.current?.selectedFabricId ||
          step2 ||
          ""
      );
      return Boolean(selectedId && selectedId !== "0");
    };

    let promiseArr = [];
    Object.keys(tempFabrics).forEach((key, index) => {
      let fabrics = tempFabrics;
      promiseArr[index] = new Promise((resolve) => {
        let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
        let DesignEnName = fabrics[key][0]["DesignEnName"];
        let HasTrim = fabrics[key][0]["CanHasTrim"];
        let HasBorder = fabrics[key][0]["CanHasBorder"];
        let LeadRequired = fabrics[key][0]["LeadRequired"];
        let DesignCode = fabrics[key][0]["DesignCode"];
        let designSelected = false;
        let designSelectedIndex = 0;
        let SamplePrice = fabrics[key][0]["SamplePrice"];
        let designOrderSelected =
          params["Designs"] &&
          params["Designs"][DesignCode] &&
          params["Designs"][DesignCode]["order"] &&
          params["Designs"][DesignCode]["order"] >= 0
            ? params["Designs"][DesignCode]["order"]
            : -1;

        const fabric = [];
        const fabric1 = [];
        let promiseArr2 = [];
        for (let j = 0; j < fabrics[key].length; j++) {
          promiseArr2[j] = new Promise((resolve) => {
            let FabricId = fabrics[key][j].FabricId;
            let fabricOrderSelected =
              params["Fabrics"] &&
              params["Fabrics"][FabricId] &&
              (params["Fabrics"][FabricId]["order"] || params["Fabrics"][FabricId]["order"] === 0)
                ? params["Fabrics"][FabricId]["order"]
                : -1;

            let PhotoPath = "";
            let PhotoPath2 = "";
            fabrics[key][j].FabricPhotos.forEach((obj) => {
              if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
              if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
            });

            let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
            let ColorName = convertToPersian(fabrics[key][j].ColorName);
            let ColorEnName = fabrics[key][j].ColorEnName;
            let FabricWidth = fabrics[key][j].FabricWidth;
            let SewingDirection = fabrics[key][j].SewingDirection;
            let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
            let HasSwatchId = false;
            let swatchDetailId = undefined;
            let index = -1;
            if (isLoggedIn) {
              if (bag["CartDetails"]) {
                let index = bag["CartDetails"].findIndex((object) => {
                  return object["ProductId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                  swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
                }
              }
            } else {
              if (temp?.length > 0) {
                index = temp.findIndex((object) => {
                  return object["SwatchId"] === SwatchId;
                });
                if (index !== -1) {
                  HasSwatchId = true;
                }
              }
            }

            let pushIndex = 0;
            if (fabricOrderSelected !== -1 && !fabric[fabricOrderSelected]) {
              pushIndex = fabricOrderSelected;
            } else if (fabricOrderSelected !== -1 && fabric[fabricOrderSelected]) {
              fabric[fabric.length] = fabric[fabricOrderSelected];
              pushIndex = fabricOrderSelected;
            } else {
              pushIndex = fabric.length;
            }
            if (`${FabricId}` === step2) {
              designSelected = true;
              designSelectedIndex = pushIndex;
            }

            fabric[pushIndex] = (
              <div
                className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                key={"fabric" + key + j}
              >
                <label
                  data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                    pageLanguage1 === "en" ? ColorEnName : ColorName
                  }`}
                  data-for={"fabric" + key + j}
                  className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                  data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
                >
                  <input
                    className="radio"
                    type="radio"
                    ref-num="3"
                    default-fabric-photo={FabricOnModelPhotoUrl}
                    onClick={() => {
                      sheerFabricSelectionRef.current = {
                        fabricId: String(FabricId),
                        designCode: String(DesignCode),
                      };
                    }}
                    onChange={(e) => {
                      let temp = JSON.parse(JSON.stringify(fabricSelected2));
                      temp.selectedFabricId = FabricId;
                      temp.selectedTextEn = DesignEnName;
                      temp.selectedTextFa = DesignName;
                      temp.selectedDesignCode = DesignCode;
                      temp.selectedColorEn = ColorEnName;
                      temp.selectedColorFa = ColorName;
                      temp.selectedLeadRequired = LeadRequired;
                      temp.selectedPhoto = FabricOnModelPhotoUrl;
                      temp.selectedPhoto2 = PhotoPath2;
                      temp.FabricWidth = FabricWidth;
                      temp.SewingDirection = SewingDirection;
                      sheerFabricSelectionRef.current = {
                        fabricId: String(FabricId),
                        designCode: String(DesignCode),
                      };
                      setFabricSelected2(temp);
                    }}
                    name="fabric2"
                    model-id={modelID}
                    value={FabricId}
                    text-en={DesignEnName}
                    text-fa={DesignName}
                    checked={`${FabricId}` === step2}
                    ref={(ref) => (inputs.current[`15${FabricId}`] = ref)}
                  />
                  <div className="frame_img">
                    <img
                      className={`img-fluid  ${`${FabricId}` === step2 ? "img-fluid_checked" : ""}`}
                      src={imgUrl(PhotoPath2)}
                      alt=""
                    />
                  </div>
                </label>
                <div
                  className={`fabric_name_container ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                >
                  <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
                  <span
                    onClick={() => {
                      handleShow(fabrics[key][j], swatchDetailId);
                      setHasSwatchId(HasSwatchId);
                    }}
                  >
                    <i className="fa fa-search" aria-hidden="true" />
                  </span>
                </div>
                <button
                  className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                    pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                  }`}
                  current-state={HasSwatchId ? "1" : "0"}
                  onClick={(e) => {
                    fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
                  }}
                  disabled={SwatchId === -1}
                >
                  {HasSwatchId
                    ? pageLanguage1 === "en"
                      ? "SWATCH IN BAG"
                      : "نمونه در سبد"
                    : pageLanguage1 === "en"
                    ? "ORDER" + " SWATCH"
                    : "سفارش نمونه"}
                </button>
              </div>
            );

            pushIndex = fabric.length;
            fabric1.push(
              <li className="fabric_design_border_list_item" key={"border" + key + j}>
                <OverlayContainer
                  classNames="Accessories_List_item_color"
                  placement="middle"
                  children={
                    <div
                      className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                    >
                      <label>
                        <input
                          className="radio"
                          type="radio"
                          outline="true"
                          onChange={(e) => {
                            let temp = JSON.parse(JSON.stringify(borderSelected2));
                            temp.selectedFabricId = FabricId;
                            temp.selectedTextEn = DesignEnName;
                            temp.selectedTextFa = DesignName;
                            temp.selectedDesignCode = DesignCode;
                            temp.selectedColorEn = ColorEnName;
                            temp.selectedColorFa = ColorName;
                            setBorderSelected2(temp);
                          }}
                          name="border-trim"
                          model-id={modelID}
                          value={FabricId}
                          checked={`${FabricId}` === step2Border}
                          ref={(ref) => (inputs.current[`border-trim${FabricId}`] = ref)}
                        />
                        <div className="frame_img">
                          <img
                            className={`img-fluid ${
                              `${FabricId}` === step2Border ? "img-fluid_checked" : ""
                            }`}
                            src={imgUrl(PhotoPath)}
                            alt=""
                          />
                        </div>
                      </label>
                    </div>
                  }
                  component={
                    <div className="Accessories_List_item_color_container">
                      <p className="Accessories_List_item_color_text">
                        {pageLanguage1 === "en" ? ColorEnName : ColorName}
                      </p>
                    </div>
                  }
                />
              </li>
            );
            resolve();
          });
        }
        Promise.all(promiseArr2).then(() => {
          if (designSelected) {
            if (isBoard) {
              let newPushIndex = Math.ceil((designSelectedIndex + 1) / 4) * 4;
              fabric.splice(
                newPushIndex,
                0,
                <div key={"board"} className="grommet_fabric_board_container 2">
                  <div className="card-body-display-flex">
                    <span className="checkbox_text">{t("fabricHasLine2")}</span>
                  </div>
                </div>
              );
            }
          }
          let pushIndex = 0;
          if (designOrderSelected !== -1 && !fabricList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && fabricList[designOrderSelected]) {
            fabricList[fabricList.length] = fabricList[designOrderSelected];
            pushIndex = designOrderSelected;
          } else {
            let index = fabricList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? fabricList.length : index;
          }

          fabricList[pushIndex] = (
            <React.Fragment key={"fabric" + key}>
              <div
                className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              >
                <div
                  className={`6 material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
                >
                  <hr />
                  <span>
                    <p>
                      {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                      {pageLanguage1 === "en" ? DesignEnName : DesignName}
                    </p>
                    <span className="fabric_seperator">&nbsp;|&nbsp;</span>
                    <p>
                      {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                      {GetPrice(
                        SamplePrice,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )}
                    </p>
                  </span>
                </div>
                {fabric}
              </div>
              {LeadRequired && (
                <div className="fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline">
                  <span className="checkbox_text">
                    {pageLanguage1 === "en"
                      ? "Lead weight comes standard with this design."
                      : "این مدل تور به طور پیش فرض با وزنه سربی ارسال می شود."}
                  </span>
                </div>
              )}
              {LeadRequired === null && (
                <div
                  className={
                    step2Check2 === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check2 === `${DesignCode}`}
                    onChange={(e) => {
                      if (isSheerFabricSelected()) {
                        if (e.target.checked) {
                          setStep2Check2(`${DesignCode}`);
                        } else {
                          setStep2Check2("");
                        }
                      } else {
                        setStep2Check2("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 2"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {pageLanguage1 === "en" ? "Add A Lead Weight" : "وزنه سربی اضافه کنید."}
                    </span>
                  </label>
                </div>
              )}
              {(HasTrim || HasBorder) && (
                <div
                  className={
                    step2Check === `${DesignCode}`
                      ? "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline active"
                      : "fabric_design_checkbox_container width_max checkbox_style checkbox_style_inline"
                  }
                >
                  <input
                    type="checkbox"
                    name="step1Check"
                    checked={step2Check === `${DesignCode}`}
                    onChange={(e) => {
                      if (isSheerFabricSelected()) {
                        if (e.target.checked) {
                          setStep2Check(`${DesignCode}`);
                          setTimeout(() => {
                            if (fabricsContainerRef4.current) {
                              fabricsContainerRef4.current.scrollBy({
                                top: 300,
                                behavior: "smooth",
                              });
                            }
                          }, 400);
                        } else {
                          setStep2Check("");
                        }
                      } else {
                        setStep2Check("");
                        modalHandleShow("FabricDesignNotSelected");
                      }
                    }}
                    id={`${DesignCode}`}
                    ref={(ref) => (inputs.current[`trim-${DesignCode}`] = ref)}
                  />
                  <label htmlFor={`${DesignCode}`} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 3"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                    <span className="checkbox_text">
                      {HasTrim && HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border / Trim"
                          : "یک حاشیه / نوار تزئینی اضافه کنید"
                        : HasTrim
                        ? pageLanguage1 === "en"
                          ? "Add A Trim"
                          : "یک نوار اضافه کنید"
                        : HasBorder
                        ? pageLanguage1 === "en"
                          ? "Add A Decorative Border"
                          : "یک حاشیه تزئینی اضافه کنید"
                        : ""}
                    </span>
                  </label>
                </div>
              )}
              <div
                className={
                  step2Check === `${DesignCode}`
                    ? "fabric_design_trim_border_container active"
                    : "fabric_design_trim_border_container"
                }
              >
                <div>
                  <h1 className="fabric_design_trim_border_title">
                    {HasTrim && HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border / Trim Material"
                        : ""
                      : HasTrim
                      ? pageLanguage1 === "en"
                        ? "Select Your Trim Material"
                        : ""
                      : HasBorder
                      ? pageLanguage1 === "en"
                        ? "Select Your Decorative Border"
                        : ""
                      : ""}
                  </h1>
                  {HasBorder && (
                    <div className="fabric_design_border_container">
                      <h2 className="fabric_design_trim_border_title2">
                        {pageLanguage1 === "en" ? "DECORATIVE BORDER" : "حاشیه تزئینی"}:{" "}
                        {pageLanguage1 === "en" ? DesignEnName : DesignName}
                      </h2>
                      <ul className="fabric_design_border_list">{fabric1}</ul>
                      {step2Border !== "" && (
                        <div className="fabric_design_border_checkbox_container">
                          <h3 className="fabric_design_trim_border_title3">
                            {pageLanguage1 === "en"
                              ? "Select A Border Position:"
                              : "حاشیه کجای پرده دوخته شود؟"}
                          </h3>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge")}
                              value="1"
                              name="step2bordercheck"
                              id="border4"
                              checked={step2BorderRadio === "10cm Leading Edge"}
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge");
                              }}
                              ref={(ref) => (inputs.current["border4"] = ref)}
                            />
                            <label htmlFor="border4">
                              {i18n.language === "fa"
                                ? "۱۰ سانتیمتر لبه عمودی"
                                : "10cm Leading Edge"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("60cm Bottom Border")}
                              value="2"
                              name="step2bordercheck"
                              id="border5"
                              checked={step2BorderRadio === "60cm Bottom Border"}
                              onChange={(e) => {
                                setStep2BorderRadio("60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border5"] = ref)}
                            />
                            <label htmlFor="border5">
                              {i18n.language === "fa"
                                ? "۶۰ سانتیمتر لبه پایینی"
                                : "60cm Bottom Border"}
                            </label>
                          </div>
                          <div className="box100 radio_style">
                            <input
                              className={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                                  ? "radio radio_checked"
                                  : "radio"
                              }
                              type="radio"
                              text={t("10cm Leading Edge & 60cm Bottom Border")}
                              value="3"
                              name="step2bordercheck"
                              id="border6"
                              checked={
                                step2BorderRadio === "10cm Leading Edge & 60cm Bottom Border"
                              }
                              onChange={(e) => {
                                setStep2BorderRadio("10cm Leading Edge & 60cm Bottom Border");
                              }}
                              ref={(ref) => (inputs.current["border6"] = ref)}
                            />
                            <label htmlFor="border6">
                              {t("10cm Leading Edge & 60cm Bottom Border")}
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {HasTrim && (
                    <>
                      {Object.keys(trimAccessories).map((key, index) => {
                        return (
                          <div className="fabric_design_border_container" key={"trim" + key}>
                            <h2 className="fabric_design_trim_border_title2">
                              {pageLanguage1 === "en" ? "DECORATIVE TRIM" : "نوار تزئینی"}:{" "}
                              {pageLanguage1 === "en"
                                ? Uppercase(trimAccessories[key][0]["DesignENName"])
                                : convertToPersian(trimAccessories[key][0]["DesignName"])}
                            </h2>
                            <ul className="fabric_design_border_list">
                              {trimAccessories[key].map((el, i) => {
                                let FabricId = el["DetailId"];
                                let DesignName = convertToPersian(el["DesignName"]);
                                let DesignEnName = el["DesignENName"];
                                let ColorName = convertToPersian(el["ColorName"]);
                                let ColorEnName = el["ColorENName"];
                                let PhotoPath = "";
                                el["Photos"].forEach((obj) => {
                                  if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
                                });
                                return (
                                  <li
                                    className="fabric_design_border_list_item"
                                    key={"trim" + key + i}
                                  >
                                    <OverlayContainer
                                      classNames="Accessories_List_item_color"
                                      placement="middle"
                                      children={
                                        <div
                                          className={`radio_group ${
                                            pageLanguage1 === "fa" ? "font_farsi" : "font_en"
                                          }`}
                                        >
                                          <label>
                                            <input
                                              className="radio"
                                              type="radio"
                                              outline="true"
                                              onChange={(e) => {
                                                let temp = JSON.parse(
                                                  JSON.stringify(trimSelected2)
                                                );
                                                temp.selectedFabricId = FabricId;
                                                temp.selectedTextEn = DesignEnName;
                                                temp.selectedTextFa = DesignName;
                                                temp.selectedDesignCode = DesignCode;
                                                temp.selectedColorEn = ColorEnName;
                                                temp.selectedColorFa = ColorName;
                                                setTrimSelected2(temp);
                                              }}
                                              name="border-trim"
                                              model-id={modelID}
                                              value={FabricId}
                                              checked={`${FabricId}` === step2Trim}
                                              ref={(ref) =>
                                                (inputs.current[`border-trim${FabricId}`] = ref)
                                              }
                                            />
                                            <div className="frame_img">
                                              <img
                                                className={`img-fluid ${
                                                  `${FabricId}` === step2Trim
                                                    ? "img-fluid_checked"
                                                    : ""
                                                }`}
                                                src={imgUrl(PhotoPath)}
                                                alt=""
                                              />
                                            </div>
                                          </label>
                                        </div>
                                      }
                                      component={
                                        <div className="Accessories_List_item_color_container">
                                          <p className="Accessories_List_item_color_text">
                                            {pageLanguage1 === "en" ? ColorEnName : ColorName}
                                          </p>
                                        </div>
                                      }
                                    />
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
          resolve();
        });
      });
    });
    Promise.all(promiseArr).then(() => {
      if (limitedFabrics !== undefined) {
      } else {
        setFabricsList2(fabricList);
      }
    });
  }
  function renderSheers(bag) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];

    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    Object.keys(sheers).forEach((key, index) => {
      let fabrics = sheers;
      let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
      let DesignEnName = fabrics[key][0]["DesignEnName"];
      let SamplePrice = fabrics[key][0]["SamplePrice"];

      const fabric = [];
      for (let j = 0; j < fabrics[key].length; j++) {
        let FabricId = fabrics[key][j].FabricId;
        let PhotoPath = "";
        let PhotoPath2 = "";
        fabrics[key][j].FabricPhotos.forEach((obj) => {
          if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
          if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
        });

        let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
        let HasTrim = fabrics[key][j].HasTrim;
        let ColorName = convertToPersian(fabrics[key][j].ColorName);
        let ColorEnName = fabrics[key][j].ColorEnName;
        let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
        let HasSwatchId = false;
        let swatchDetailId = undefined;
        let index = -1;
        if (isLoggedIn) {
          if (bag["CartDetails"]) {
            let index = bag["CartDetails"].findIndex((object) => {
              return object["ProductId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
              swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
            }
          }
        } else {
          if (temp?.length > 0) {
            index = temp.findIndex((object) => {
              return object["SwatchId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
            }
          }
        }
        fabric.push(
          <div
            className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
            key={"fabric" + key + j}
          >
            <label
              data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                pageLanguage1 === "en" ? ColorEnName : ColorName
              }`}
              data-for={"fabric" + key + j}
              className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
            >
              {/*<ReactTooltip id={"fabric" + key + j} place="top" type="light" effect="float"/>*/}
              <input
                className="radio"
                type="radio"
                ref-num="2"
                default-fabric-photo={FabricOnModelPhotoUrl}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(sheersSelected));
                  temp.selectedFabricId = FabricId;
                  temp.selectedTextEn = DesignEnName;
                  temp.selectedTextFa = DesignName;
                  temp.selectedColorEn = ColorEnName;
                  temp.selectedColorFa = ColorName;
                  temp.selectedHasTrim = HasTrim;
                  temp.selectedPhoto = FabricOnModelPhotoUrl;
                  setSheersSelected(temp);
                }}
                name="fabric"
                model-id={modelID}
                value={FabricId}
                text-en={DesignEnName}
                text-fa={DesignName}
                checked={`${FabricId}` === step2B1}
                ref={(ref) => (inputs.current[`1${FabricId}`] = ref)}
              />
              <div className="frame_img">
                <img
                  className={`img-fluid ${`${FabricId}` === step2B1 ? "img-fluid_checked" : ""}`}
                  src={imgUrl(PhotoPath2)}
                  alt=""
                />
              </div>
            </label>
            <div
              className={`fabric_name_container ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
            >
              <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
              <span
                onClick={() => {
                  handleShow(fabrics[key][j], swatchDetailId);
                  setHasSwatchId(HasSwatchId);
                }}
              >
                <i className="fa fa-search" aria-hidden="true" />
              </span>
            </div>
            <button
              className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
              current-state={HasSwatchId ? "1" : "0"}
              onClick={(e) => {
                fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
              }}
              disabled={SwatchId === -1}
            >
              {HasSwatchId
                ? pageLanguage1 === "en"
                  ? "SWATCH IN BAG"
                  : "نمونه در سبد"
                : pageLanguage1 === "en"
                ? "ORDER" + " SWATCH"
                : "سفارش نمونه"}
            </button>
          </div>
        );
      }

      fabricList.push(
        <div
          className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          key={"fabric" + key}
        >
          <div className={`7 material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}>
            <hr />
            <span>
              <p>
                {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                {pageLanguage1 === "en" ? DesignEnName : DesignName}
              </p>
              <span className="fabric_seperator">&nbsp;|&nbsp;</span>
              <p>
                {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                {GetPrice(
                  SamplePrice,
                  pageLanguage1,
                  pageLanguage1 === "en" ? "Tomans" : "تومان",
                  isTabletOrMobile
                )}
              </p>
            </span>
          </div>
          {fabric}
        </div>
      );
    });
    setSheersList(fabricList);
  }
  function renderSheers2(bag) {
    const fabricList = [];
    let cartObj = {};
    let temp = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    if (Object.keys(bag).length > 0) {
      if (isLoggedIn) {
      } else {
        cartObj = JSON.parse(localStorage.getItem("cart"));
        temp = cartObj["swatches"];
      }
    }

    Object.keys(sheers2).forEach((key, index) => {
      let fabrics = sheers2;
      let DesignName = convertToPersian(fabrics[key][0]["DesignName"]);
      let DesignEnName = fabrics[key][0]["DesignEnName"];
      let SamplePrice = fabrics[key][0]["SamplePrice"];

      const fabric = [];
      for (let j = 0; j < fabrics[key].length; j++) {
        let FabricId = fabrics[key][j].FabricId;
        let PhotoPath = "";
        let PhotoPath2 = "";
        fabrics[key][j].FabricPhotos.forEach((obj) => {
          if (obj.PhotoTypeId === 4702) PhotoPath = obj.PhotoUrl;
          if (obj.PhotoTypeId === 4709) PhotoPath2 = obj.PhotoUrl;
        });

        let FabricOnModelPhotoUrl = fabrics[key][j].FabricOnModelPhotoUrl;
        let HasTrim = fabrics[key][j].HasTrim;
        let ColorName = convertToPersian(fabrics[key][j].ColorName);
        let ColorEnName = fabrics[key][j].ColorEnName;
        let SwatchId = fabrics[key][j].SwatchId ? fabrics[key][j].SwatchId : -1;
        let HasSwatchId = false;
        let swatchDetailId = undefined;
        let index = -1;
        if (isLoggedIn) {
          if (bag["CartDetails"]) {
            let index = bag["CartDetails"].findIndex((object) => {
              return object["ProductId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
              swatchDetailId = bag["CartDetails"][index]["CartDetailId"];
            }
          }
        } else {
          if (temp?.length > 0) {
            index = temp.findIndex((object) => {
              return object["SwatchId"] === SwatchId;
            });
            if (index !== -1) {
              HasSwatchId = true;
            }
          }
        }

        fabric.push(
          <div
            className={`radio_group ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
            key={"fabric" + key + j}
          >
            <label
              data-tip={`${pageLanguage1 === "en" ? DesignEnName : DesignName}: ${
                pageLanguage1 === "en" ? ColorEnName : ColorName
              }`}
              data-for={"fabric" + key + j}
              className={`radio_container ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
              data-img={`https://www.doopsalta.com/upload/${PhotoPath}`}
            >
              <input
                className="radio"
                type="radio"
                ref-num="3"
                default-fabric-photo={FabricOnModelPhotoUrl}
                onChange={(e) => {
                  let temp = JSON.parse(JSON.stringify(sheersSelected2));
                  temp.selectedFabricId = FabricId;
                  temp.selectedTextEn = DesignEnName;
                  temp.selectedTextFa = DesignName;
                  temp.selectedColorEn = ColorEnName;
                  temp.selectedColorFa = ColorName;
                  temp.selectedHasTrim = HasTrim;
                  temp.selectedPhoto = FabricOnModelPhotoUrl;
                  setSheersSelected2(temp);
                }}
                name="fabric2"
                model-id={modelID}
                value={FabricId}
                text-en={DesignEnName}
                text-fa={DesignName}
                checked={`${FabricId}` === step2B1}
                ref={(ref) => (inputs.current[`15${FabricId}`] = ref)}
              />
              <div className="frame_img">
                <img
                  className={`img-fluid ${`${FabricId}` === step2B1 ? "img-fluid_checked" : ""}`}
                  src={imgUrl(PhotoPath2)}
                  alt=""
                />
              </div>
            </label>
            <div
              className={`fabric_name_container ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
            >
              <h1>{pageLanguage1 === "en" ? CapitalizeAllWords(ColorEnName) : ColorName}</h1>
              <span
                onClick={() => {
                  handleShow(fabrics[key][j], swatchDetailId);
                  setHasSwatchId(HasSwatchId);
                }}
              >
                <i className="fa fa-search" aria-hidden="true" />
              </span>
            </div>
            <button
              className={`swatchButton ${HasSwatchId ? "activeSwatch" : ""} ${
                pageLanguage1 === "fa" ? "font_farsi" : "font_en"
              }`}
              current-state={HasSwatchId ? "1" : "0"}
              onClick={(e) => {
                fabricSwatch(e, SwatchId, swatchDetailId, PhotoPath);
              }}
              disabled={SwatchId === -1}
            >
              {HasSwatchId
                ? pageLanguage1 === "en"
                  ? "SWATCH IN BAG"
                  : "نمونه در سبد"
                : pageLanguage1 === "en"
                ? "ORDER" + " SWATCH"
                : "سفارش نمونه"}
            </button>
          </div>
        );
      }

      fabricList.push(
        <div
          className={`material_detail ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}
          key={"fabric" + key}
        >
          <div className={`8 material_traits ${pageLanguage1 === "fa" ? "font_farsi" : "font_en"}`}>
            <hr />
            <span>
              <p>
                {pageLanguage1 === "en" ? "DESIGN NAME" : "نام طرح"}:{" "}
                {pageLanguage1 === "en" ? DesignEnName : DesignName}
              </p>
              <span className="fabric_seperator">&nbsp;|&nbsp;</span>
              <p>
                {pageLanguage1 === "en" ? "FROM" : "قیمت از"}:{" "}
                {GetPrice(
                  SamplePrice,
                  pageLanguage1,
                  pageLanguage1 === "en" ? "Tomans" : "تومان",
                  isTabletOrMobile
                )}
              </p>
            </span>
          </div>
          {fabric}
        </div>
      );
    });
    setSheersList2(fabricList);
  }

  const [activeAccessoryColors, setActiveAccessoryColors] = useState({});

  const handleSelectAccessoryColor = (designKey, detailId) => {
    setActiveAccessoryColors((prev) => ({
      ...prev,
      [designKey]: detailId,
    }));
  };

  // Match saved accessory value against API color fields (DetailId or SewingAccessoryDetailId)
  const accessoryValueMatches = (el, savedValue) =>
    `${el?.DetailId}` === `${savedValue}` || `${el?.SewingAccessoryDetailId}` === `${savedValue}`;

  const findAccessoryColor = (colors, acc) => {
    if (!colors?.length || !acc) return undefined;
    const byId = colors.find((el) => accessoryValueMatches(el, acc["SewingAccessoryValue"]));
    if (byId) return byId;
    // Fallback: match by design + color names from cart
    return colors.find(
      (el) =>
        (acc["DesignNameFa"] &&
          el["DesignName"] === acc["DesignNameFa"] &&
          el["ColorName"] === acc["ColorNameFa"]) ||
        (acc["DesignNameEn"] &&
          el["DesignENName"] === acc["DesignNameEn"] &&
          el["ColorENName"] === acc["ColorNameEn"])
    );
  };

  function renderStepAccessories() {
    const tempList = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let temp2 = JSON.parse(JSON.stringify(customAccActive));
    let params =
      parameters === undefined ||
      parameters === null ||
      parameters === "undefined" ||
      parameters === "null" ||
      parameters === ""
        ? "{}"
        : JSON.parse(JSON.stringify(parameters));

    let promiseArr = [];
    Object.keys(stepAccessories).forEach((key, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        let temp = [];
        let PhotoPath = "";
        let DesignENName = stepAccessories[key][0]["DesignENName"];
        let DesignName = stepAccessories[key][0]["DesignName"];
        let promiseArr2 = [];
        stepAccessories[key].forEach((obj, index) => {
          const detailId = obj["DetailId"];
          if (
            obj["DetailId"] &&
            obj["DetailId"] !== "" &&
            obj["SewingAccessoryDetailId"] &&
            obj["SewingAccessoryId"] &&
            obj["ColorHtmlCode"]
          ) {
            promiseArr2[index] = new Promise((resolve, reject) => {
              let tempColor = obj["ColorHtmlCode"] !== "" ? obj["ColorHtmlCode"] : "#e2e2e2";
              let ColorENName = obj["ColorENName"];
              let ColorName = obj["ColorName"];
              let DetailId = obj["DetailId"];
              let SewingModelAccessoryId = obj["SewingModelAccessoryId"];
              let SewingAccessoryId = obj["SewingAccessoryId"];
              let colorSelected = !!(
                temp2[key] && `${temp2[key]["SewingAccessoryValue"]}` === `${DetailId}`
              );
              if (colorSelected) {
                if (obj["Photos"] && obj["Photos"].length)
                  obj["Photos"].forEach((obj) => {
                    if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
                  });
              }
              let fabricOrderSelected =
                params["AccColors"] &&
                params["AccColors"][DetailId] &&
                (params["AccColors"][DetailId]["order"] ||
                  params["AccColors"][DetailId]["order"] === 0)
                  ? params["AccColors"][DetailId]["order"]
                  : -1;

              let pushIndex = 0;
              if (fabricOrderSelected !== -1 && !temp[fabricOrderSelected]) {
                pushIndex = fabricOrderSelected;
              } else if (fabricOrderSelected !== -1 && temp[fabricOrderSelected]) {
                temp[temp.length] = JSON.parse(JSON.stringify(temp[fabricOrderSelected]));
                pushIndex = fabricOrderSelected;
              } else {
                pushIndex = temp.length;
              }

              temp[pushIndex] = (
                <li
                  className={
                    `${activeAccessoryColors[key]}` === `${detailId}`
                      ? "Accessories_List_item_colors_list_item_overlay_active"
                      : colorSelected
                      ? "Accessories_List_item_colors_list_item colorSelected"
                      : "Accessories_List_item_colors_list_item"
                  }
                  key={index}
                  onClick={() => {
                    handleSelectAccessoryColor(key, detailId);
                    setAccessoriesDesign({
                      isPlus: undefined,
                      SewingAccessoryValue: DetailId,
                      SewingAccessoryId: SewingAccessoryId,
                      SewingModelAccessoryId: SewingModelAccessoryId,
                      DesignCode: key,
                      DesignNameEn: DesignENName,
                      DesignNameFa: DesignName,
                      ColorNameEn: ColorENName,
                      ColorNameFa: ColorName,
                      qty: undefined,
                    });
                  }}
                >
                  <OverlayContainer
                    classNames="Accessories_List_item_color"
                    placement="middle"
                    children={
                      <div
                        className="Accessories_List_item_colors_list_item_overlay"
                        style={{ backgroundColor: tempColor }}
                        onClick={() => {
                          setSelectedColor(DetailId);
                        }}
                      />
                    }
                    component={
                      <div className="Accessories_List_item_color_container">
                        <p className="Accessories_List_item_color_text 7">
                          {pageLanguage1 === "en" ? capitalizeWordsText(ColorENName) : ColorName}
                        </p>
                      </div>
                    }
                  />
                </li>
              );
              resolve();
            });
          } else if (obj["Photos"] && obj["Photos"].length) {
            obj["Photos"].forEach((obj) => {
              if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
            });
          }
        });

        Promise.all(promiseArr2).then(() => {
          let obj = stepAccessories[key][0];
          let DesignCode = key;
          let DetailId = temp2[key] ? temp2[key]["SewingAccessoryValue"] : obj["DetailId"];
          let Price = obj["Price"];

          let designOrderSelected =
            params["Designs"] &&
            params["Designs"][DesignCode] &&
            params["Designs"][DesignCode]["order"] &&
            params["Designs"][DesignCode]["order"] >= 0
              ? params["Designs"][DesignCode]["order"]
              : -1;

          let pushIndex = 0;
          if (designOrderSelected !== -1 && !tempList[designOrderSelected]) {
            pushIndex = designOrderSelected;
          } else if (designOrderSelected !== -1 && tempList[designOrderSelected]) {
            tempList[tempList.length] = JSON.parse(JSON.stringify(tempList[designOrderSelected]));
            pushIndex = designOrderSelected;
          } else {
            let index = tempList.findIndex(Object.is.bind(null, undefined));
            pushIndex = index === -1 ? tempList.length : index;
          }

          tempList[pushIndex] = (
            <li className="Accessories_List_item" key={index}>
              <div className="Accessories_List_item_image">
                <img src={imgUrl(PhotoPath)} className="img-fluid" alt="" />
              </div>
              <div className="Accessories_List_item_desc 1">
                <h1
                  style={{ textAlign: pageLanguage === "fa" ? "right" : "left" }}
                  className="Accessories_List_item_title Accessories_List_title_new"
                >
                  {pageLanguage1 === "en" ? DesignENName : DesignName}
                </h1>
                <h2 className="Accessories_List_item_price">
                  {GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)}
                </h2>
                <div className="Accessories_List_item_colors">
                  <ul className="Accessories_List_item_colors_list">{temp}</ul>
                </div>
              </div>
              <div className="Accessories_List_item_qty">
                <div className="qty_numbers">
                  <button
                    type="text"
                    className="qty_minus"
                    onClick={() =>
                      setAccessoriesDesign({
                        isPlus: false,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: undefined,
                      })
                    }
                  >
                    <img
                      src={require("../Images/public/minus.svg").default}
                      alt=""
                      className="qty_math_icon"
                    />
                  </button>
                  <input
                    type="text"
                    className="qty_num"
                    name="qty_num_g11"
                    value={getAccValue(customAcc, "SewingAccessoryValue", DetailId, pageLanguage)}
                    onChange={(e) =>
                      setAccessoriesDesign({
                        isPlus: undefined,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: e.target.value,
                      })
                    }
                    readOnly
                  />
                  <button
                    type="text"
                    className="qty_plus"
                    onClick={() =>
                      setAccessoriesDesign({
                        isPlus: true,
                        SewingAccessoryValue: undefined,
                        SewingAccessoryId: undefined,
                        SewingModelAccessoryId: undefined,
                        DesignCode: key,
                        DesignNameEn: undefined,
                        DesignNameFa: undefined,
                        ColorNameEn: undefined,
                        ColorNameFa: undefined,
                        qty: undefined,
                      })
                    }
                  >
                    <img
                      src={require("../Images/public/plus.svg").default}
                      alt=""
                      className="qty_math_icon"
                    />
                  </button>
                </div>
              </div>
            </li>
          );
          resolve();
        });
      });
    });

    Promise.all(promiseArr).then(() => {
      setStepAccessoriesList(tempList);
    });
  }

  useEffect(() => {
    if (stepAccessories && Object.keys(stepAccessories).length > 0) {
      // Sync active color from restored Accessories; keep click selection when qty is 0
      setActiveAccessoryColors((prev) => {
        const nextActive = { ...prev };
        Object.keys(stepAccessories).forEach((designKey) => {
          const colors = stepAccessories[designKey] || [];
          const savedAcc = (customAcc || []).find((acc) => findAccessoryColor(colors, acc));
          if (savedAcc) {
            const colorObj = findAccessoryColor(colors, savedAcc);
            if (colorObj) {
              nextActive[designKey] = colorObj.DetailId;
            }
          } else if (nextActive[designKey] === undefined) {
            const firstColorObj = colors.find(
              (obj) =>
                obj["DetailId"] &&
                obj["DetailId"] !== "" &&
                obj["SewingAccessoryDetailId"] &&
                obj["SewingAccessoryId"] &&
                obj["ColorHtmlCode"]
            );
            if (firstColorObj) {
              nextActive[designKey] = firstColorObj.DetailId;
            }
          }
        });
        return nextActive;
      });
    }
  }, [stepAccessories, customAcc]);

  function getAccValue(array, searchRef, id, lang) {
    let qty = 0;

    let tempObj = {};
    tempObj =
      array.filter((obj) => {
        return `${obj[searchRef]}` === `${id}`;
      })[0] || tempObj;

    if (Object.keys(tempObj).length > 0) {
      qty = tempObj["Qty"] ? tempObj["Qty"] : 0;
    }

    if (lang === "fa") {
      return NumberToPersianWord.convertEnToPe(`${qty}`);
    } else {
      return qty;
    }
  }
  function renderRods() {
    const rodList = [];
    const rodList2 = [];
    const rodList3 = [];
    const rodList4 = [];
    const rodListHardware = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let promiseArr = [];
    let promiseArr2 = [];
    let promiseArr3 = [];
    Object.keys(rods).forEach((key, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        let obj = rods[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let Price = obj["Price"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step81"
              ref-num={"81"}
              id={"81" + index}
              checked={step81 === `${RailId}`}
              onChange={(e) => {
                setStep81(`${RailId}`);
              }}
              ref={(ref) => (inputs.current["81" + index] = ref)}
            />
            <label htmlFor={"81" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );
        rodListHardware.push(
          <div className="img_hardware" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
          </div>
        );

        rodList2.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8A1"
              ref-num={"8A1"}
              id={"8A1" + index}
              checked={step8A1 === `${RailId}`}
              onChange={(e) => {
                setStep8A1(`${RailId}`);
              }}
              ref={(ref) => (inputs.current["8A1" + index] = ref)}
            />
            <label htmlFor={"8A1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Object.keys(rods2).forEach((key, index) => {
      promiseArr2[index] = new Promise((resolve, reject) => {
        let obj = rods2[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let Price = obj["Price"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList3.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8B1"
              ref-num={"8B1"}
              id={"8B1" + index}
              checked={step8B1 === `${RailId}`}
              onChange={(e) => {
                setStep8B1(`${RailId}`);
              }}
              ref={(ref) => (inputs.current["8B1" + index] = ref)}
            />
            <label htmlFor={"8B1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Object.keys(rods3).forEach((key, index) => {
      promiseArr3[index] = new Promise((resolve, reject) => {
        let obj = rods3[key][0] || {};
        let DesignName = convertToPersian(obj["DesignName"]);
        let DesignEnName = obj["DesignENName"];
        let RailId = obj["RailId"];
        let Price = obj["Price"];
        let PhotoObj = {};
        PhotoObj =
          obj["Photos"].filter((obj) => {
            return obj["PhotoTypeId"] === 4701;
          })[0] || PhotoObj;
        let PhotoPath = PhotoObj["PhotoUrl"] || "";

        rodList4.push(
          <div className="box33 radio_style" key={index}>
            <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
            <input
              className="radio"
              type="radio"
              text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
              value={index}
              name="step8C1"
              ref-num={"8C1"}
              id={"8C1" + index}
              checked={step8C1 === `${RailId}`}
              onChange={(e) => {
                setStep8C1(`${RailId}`);
              }}
              ref={(ref) => (inputs.current["8C1" + index] = ref)}
            />
            <label htmlFor={"8C1" + index}>
              {pageLanguage1 === "fa" ? DesignName : DesignEnName}
              <br />
              <p className="surcharge_price">
                {Price > 0
                  ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                    GetPrice(
                      Price,
                      pageLanguage1,
                      pageLanguage1 === "en" ? "Tomans" : "تومان",
                      isTabletOrMobile
                    )
                  : pageLanguage1 === "en"
                  ? "Surcharge Applies"
                  : "+ شامل هزینه"}
              </p>
            </label>
          </div>
        );

        resolve();
      });
    });

    Promise.all(promiseArr).then(() => {
      setRodsList(rodList);
      setRodsListHardware(rodListHardware);
      setRodsList2(rodList2);
    });
    Promise.all(promiseArr2).then(() => {
      setRodsList3(rodList3);
    });
    Promise.all(promiseArr3).then(() => {
      setRodsList4(rodList4);
    });
  }
  function renderTracks() {
    const order = [2201, 2207, 2208];
    const rodList = [];
    const rodList2 = [];
    let pageLanguage1 = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let result_arr = [];
    let result_arr2 = [];

    let promiseArr = [];
    let promiseArr2 = [];
    let promiseArr3 = [];
    let promiseArr4 = [];

    promiseArr3[0] = new Promise((resolve, reject) => {
      result_arr = []
        .concat(...Object.values(tracks2))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr3).then(() => {
      result_arr.forEach((el, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let obj = el;
          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let Price = obj["Price"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          rodList.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="step8B1"
                ref-num={"8B1"}
                id={"8B1" + index}
                checked={step8B1 === `${RailId}`}
                onChange={(e) => {
                  setStep8B1(`${RailId}`);
                }}
                ref={(ref) => (inputs.current["8B1" + index] = ref)}
              />
              <label htmlFor={"8B1" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(Price, pageLanguage1, t("TOMANS"), isTabletOrMobile)
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr).then(() => {
        setTracksList(rodList);
      });
    });

    promiseArr4[0] = new Promise((resolve, reject) => {
      result_arr2 = []
        .concat(...Object.values(tracks3))
        .sort((a, b) => order.indexOf(a.RailTypeId) - order.indexOf(b.RailTypeId))
        .filter((item, index, self) => {
          return index === self.findIndex((t) => t.RailTypeId === item.RailTypeId);
        });
      setTimeout(() => {
        resolve();
      }, 200);
    });

    Promise.all(promiseArr4).then(() => {
      result_arr2.forEach((el, index) => {
        promiseArr2[index] = new Promise((resolve, reject) => {
          let obj = el;
          let DesignName = convertToPersian(obj["DesignName"]);
          let DesignEnName = obj["DesignENName"];
          let RailId = obj["RailId"];
          let Price = obj["Price"];
          let PhotoObj = {};
          PhotoObj =
            obj["Photos"].filter((obj) => {
              return obj["PhotoTypeId"] === 4701;
            })[0] || PhotoObj;
          let PhotoPath = PhotoObj["PhotoUrl"] || "";

          rodList2.push(
            <div className="box33 radio_style" key={index}>
              <img src={imgUrl(PhotoPath)} className="img-fluid height_auto" alt="" />
              <input
                className="radio"
                type="radio"
                text={pageLanguage1 === "fa" ? DesignName : DesignEnName}
                value={index}
                name="step8C1"
                ref-num={"8C1"}
                id={"8C1" + index}
                checked={step8C1 === `${RailId}`}
                onChange={(e) => {
                  setStep8C1(`${RailId}`);
                }}
                ref={(ref) => (inputs.current["8C1" + index] = ref)}
              />
              <label htmlFor={"8C1" + index}>
                {pageLanguage1 === "fa" ? DesignName : DesignEnName}
                <br />
                <p className="surcharge_price">
                  {Price > 0
                    ? (pageLanguage1 === "en" ? "Add " : "+ ") +
                      GetPrice(
                        Price,
                        pageLanguage1,
                        pageLanguage1 === "en" ? "Tomans" : "تومان",
                        isTabletOrMobile
                      )
                    : pageLanguage1 === "en"
                    ? "Surcharge Applies"
                    : "+ شامل هزینه"}
                </p>
              </label>
            </div>
          );

          resolve();
        });
      });

      Promise.all(promiseArr2).then(() => {
        setTracksList2(rodList2);
      });
    });
  }
  function handleClose() {
    setShow(false);
  }
  function handleShow(fabricObj, SwatchDetailId) {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");

    let DesignName = convertToPersian(fabricObj["DesignName"]);
    let DesignEnName = fabricObj["DesignEnName"];
    let PhotoPath = "";
    fabricObj["FabricPhotos"].forEach((obj) => {
      if (obj["PhotoTypeId"] === 4702) PhotoPath = obj["PhotoUrl"];
    });
    let PriceLevelEnTitle = fabricObj["PriceLevelEnTitle"];
    let PriceLevelTitle = fabricObj["PriceLevelTitle"];
    let PolyesterPercent = fabricObj["PolyesterPercent"] || 0;
    let ViscosePercent = fabricObj["ViscosePercent"] || 0;
    let NylonPercent = fabricObj["NylonPercent"] || 0;
    let ConttonPercent = fabricObj["ConttonPercent"] || 0;
    let LinenPercent = fabricObj["LinenPercent"] || 0;
    let FabricWidth = fabricObj["FabricWidth"] || 0;
    let ColorName = convertToPersian(fabricObj["ColorName"]);
    let ColorEnName = fabricObj["ColorEnName"];
    let SwatchId = fabricObj["SwatchId"] ? fabricObj["SwatchId"] : -1;

    const tempDiv = [];
    const tempDiv1 = [];
    tempDiv.push(
      <div key={PhotoPath} className="zoomImg">
        <div className="imageContainer">
          <ReactImageMagnify
            imageProps={{
              alt: "", // isFluidWidth: true,
              src: imgUrl(PhotoPath),
            }}
            magnifiedImageProps={{
              src: imgUrl(PhotoPath),
              width: 800,
              height: 800,
            }}
            portalProps={{ placement: "over" }}
          />
        </div>
      </div>
    );
    tempDiv1.push(
      <div key={1} className="zoom_modal_header_container">
        <h1 className="zoom_modal_header_design">
          {pageLanguage === "en" ? DesignEnName : DesignName} /{" "}
          {pageLanguage === "en" ? ColorEnName : ColorName}
        </h1>
        <h1 className="zoom_modal_header_Price">
          {t("PRICE GROUP: ")}
          {pageLanguage === "en" ? capitalizeWordsText(PriceLevelEnTitle) : PriceLevelTitle}
        </h1>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Contents")}</h1>
          {PolyesterPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? PolyesterPercent + "%" : NumToFa(PolyesterPercent) + "%"}{" "}
              {t("Polyester")}
            </p>
          )}
          {ViscosePercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ViscosePercent + "%" : NumToFa(ViscosePercent) + "%"}{" "}
              {t("Viscose")}
            </p>
          )}
          {NylonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {NumToFa(NylonPercent) + "%"} {t("Nylon")}
            </p>
          )}
          {ConttonPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? ConttonPercent + "%" : NumToFa(ConttonPercent) + "%"}{" "}
              {t("Contton")}
            </p>
          )}
          {LinenPercent > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? LinenPercent + "%" : NumToFa(LinenPercent) + "%"}{" "}
              {t("Linen")}
            </p>
          )}
        </div>
        <div className="zoom_modal_header_Contents_container">
          <h1 className="zoom_modal_header_Contents">{t("Fabric Width")}</h1>
          {FabricWidth > 0 && (
            <p className="zoom_modal_header_Contents_item">
              {pageLanguage === "en" ? FabricWidth + "cm" : NumToFa(FabricWidth) + "س\u200Cم"}
            </p>
          )}
        </div>
      </div>
    );

    setZoomModalBody(tempDiv);
    setZoomModalHeader(tempDiv1);
    setSwatchId(SwatchId);
    setSwatchDetailId(SwatchDetailId);
    setSwatchPhotoPath(PhotoPath);
    setShow(true);
  }
  function modalHandleClose(modalName) {
    setHideModals(modalName);
  }
  function modalHandleShow(modalName) {
    setShowModals(modalName);
  }
  useEffect(() => {
    if (!pageLoad && showModals !== "") {
      let tempModals = JSON.parse(JSON.stringify(modals));
      tempModals[showModals] = true;
      setModals(tempModals);
      setShowModals("");
    }
  }, [showModals]);

  useEffect(() => {
    if (!pageLoad && hideModals !== "") {
      let tempModals = JSON.parse(JSON.stringify(modals));
      tempModals[hideModals] = false;
      setModals(tempModals);
      setHideModals("");
    }
  }, [hideModals]);

  function ContextAwareToggle({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey("") : setAccordionActiveKey(eventKey);
      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });
    const isCurrentEventKey = activeEventKey === eventKey;
    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef] = ref)}
      >
        <div className="steps_header_num_container">
          <div className="steps_header_num">{stepNum}</div>
        </div>
        <div className="steps_header_title_container">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>

        <div className="steps_header_selected_container">
          <div className="steps_header_selected_title_container">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {showLabels
                ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                  ? extendedTitle[stepRef][0]
                  : stepSelected
                : null}
              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5> ...</h5>
              ) : (
                ""
              )}
            </div>
            {headerTruncated[stepNum] && (
              <div className="header_tooltip">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                        .replace(/,/g, "")
                  : stepSelected}
              </div>
            )}
          </div>
          {required && <div className="stepRequired" />}
        </div>
      </div>
    );
  }

  function ContextAwareToggle2({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey2("") : setAccordionActiveKey2(eventKey);

      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef + "2"] = ref)}
      >
        <div className="steps_header_num_container">
          <div className="steps_header_num">{stepNum}</div>
        </div>
        <div className="steps_header_title_container">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>
        <div className="steps_header_selected_container">
          <div className="steps_header_selected_title_container">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {showLabels
                ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                  ? extendedTitle[stepRef][0]
                  : stepSelected
                : null}
              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5> ...</h5>
              ) : (
                ""
              )}
            </div>
            {headerTruncated[stepNum] && (
              <div className="header_tooltip">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                  : stepSelected}
              </div>
            )}
          </div>
          <div
            className={isCurrentEventKey ? "steps_header_arrow_up" : "steps_header_arrow_down"}
          />
        </div>
      </div>
    );
  }

  function ContextAwareToggle3({
    stepNum,
    stepTitle,
    stepTitle2,
    stepSelected,
    eventKey,
    callback,
    stepRef,
    type,
    required,
    cartCustomText,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      activeEventKey === eventKey ? setAccordionActiveKey2("") : setAccordionActiveKey2(eventKey);

      setTimeout(() => {
        if (stepHeaders.current[stepRef] !== undefined && stepHeaders.current[stepRef] !== null)
          stepHeaders.current[stepRef].scrollIntoView();
      }, 500);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <div
        className={`w-100 h-100 steps_header ${isCurrentEventKey ? "steps_header_active" : ""}`}
        onClick={decoratedOnClick}
        ref={(ref) => (stepHeaders.current[stepRef + "2"] = ref)}
      >
        <div className="steps_header_title_container">
          <div
            className={"steps_header_title " + stepTitle2 ? "steps_header_title_max_content" : ""}
            type-of-step={type}
            cart-custom-text={cartCustomText === undefined ? stepTitle : cartCustomText}
            ref={(ref) => (steps.current[stepRef] = ref)}
          >
            {stepTitle}
            <h5>{stepTitle2}</h5>
          </div>
        </div>
        <div className="steps_header_selected_container steps_header_selected_container2">
          <div className="steps_header_selected_title_container">
            <div
              className={
                "steps_header_selected" +
                (stepSelected === t("Invalid Measurements") ? " steps_header_selected_red" : "")
              }
              onMouseEnter={() => {
                if (stepRef in extendedTitle && extendedTitle[stepRef].length > 1) {
                  let temp = JSON.parse(JSON.stringify(headerTruncated));
                  temp[stepNum] = true;
                  setHeaderTruncated(temp);
                }
              }}
              onMouseLeave={() => {
                let temp = JSON.parse(JSON.stringify(headerTruncated));
                temp[stepNum] = false;
                setHeaderTruncated(temp);
              }}
              ref={(ref) => (selectedTitle.current[stepNum] = ref)}
            >
              {showLabels
                ? stepRef in extendedTitle && extendedTitle[stepRef].length > 0
                  ? extendedTitle[stepRef][0]
                  : stepSelected
                : null}
              {showLabels && stepRef in extendedTitle && extendedTitle[stepRef].length > 1 ? (
                <h5> ...</h5>
              ) : (
                ""
              )}
            </div>
            {headerTruncated[stepNum] && (
              <div className="header_tooltip">
                {stepRef in extendedTitle
                  ? stepRef === "1" ||
                    stepRef === "2" ||
                    stepRef === "3A0" ||
                    stepRef === "6" ||
                    stepRef === "8" ||
                    stepRef === "8A" ||
                    stepRef === "8B" ||
                    stepRef === "8C"
                    ? extendedTitle[stepRef].slice(1).filter((n) => n)
                    : extendedTitle[stepRef]
                        .slice(1)
                        .filter((n) => n)
                        .join(", \n")
                  : stepSelected}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  function ContextAwareToggleViewDetails({
    eventKey,
    callback,
    textOnHide,
    textOnShow,
    customClass,
    customClass2,
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <button
        className={
          (customClass ? customClass : "basket_item_title_dropdown_btn") +
          " accordion_toggle_button"
        }
        aria-expanded={`${isCurrentEventKey}`}
        type="button"
        onClick={decoratedOnClick}
      >
        <h4 className={customClass2 ? customClass2 : "dk_curtain_preview_item_details"}>
          {isCurrentEventKey ? textOnShow : textOnHide}
        </h4>
      </button>
    );
  }

  function ContextAwareToggleFilters({ eventKey, callback, textOnHide, textOnShow }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        <button
          className="product_filter_accordion_btn"
          aria-expanded={`${isCurrentEventKey}`}
          type="button"
          onClick={decoratedOnClick}
        >
          <p className="product_filter_accordion_btn_title">
            {isCurrentEventKey ? textOnShow : textOnHide}
          </p>
          <div
            className={
              isCurrentEventKey
                ? "product_filter_accordion_btn_img_minus img-fluid"
                : "product_filter_accordion_btn_img_plus img-fluid"
            }
          ></div>
        </button>
      </>
    );
  }

  function NextStep({ children, eventKey, callback, onClick, currentStep }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      callback && callback(eventKey);
      onClick && onClick(eventKey);
      setAccordionActiveKey(eventKey);
      setTimeout(() => {
        if (
          currentStep &&
          stepHeaders.current[currentStep] !== undefined &&
          stepHeaders.current[currentStep] !== null
        )
          stepHeaders.current[currentStep].scrollIntoView();
      }, 800);
    });
    return (
      <div className="nextStep_area">
        <div className="nextStep" onClick={decoratedOnClick}>
          {children}
        </div>
      </div>
    );
  }

  function clearAllFilters() {
    filterCheckboxes.current["colors"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patterns"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["types"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["prices"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["colors2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patterns2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["types2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["prices2"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["colorsSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["patternsSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["typesSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    filterCheckboxes.current["pricesSheer"].forEach((obj) => {
      if (obj !== null) obj.checked = false;
    });
    if (search_input.current) search_input.current.value = "";
    if (search_input2.current) search_input2.current.value = "";
    setSearchText("");
    setSearchText2("");
    setSearchShow(false);
    setSearchShow2(false);

    setFilterColors([]);
    setFilterPatterns([]);
    setFilterTypes([]);
    setFilterPrices([]);
    setFilterColors2([]);
    setFilterPatterns2([]);
    setFilterTypes2([]);
    setFilterPrices2([]);
  }

  useEffect(() => {
    if (isClearAll) {
      clearAllFilters();
      getFabricsWithFilter(true, "1");
      getFabricsWithFilter(true, "2");
    }
  }, [isClearAll]);

  function clearFilters(e) {
    const refIndex = e.currentTarget.getAttribute("text") || e.target.getAttribute("text");
    const refStep = e.currentTarget.getAttribute("data-step") || e.target.getAttribute("data-step") || "1";
    const refKey =
      refStep === "2"
        ? refIndex === "colors"
          ? "colorsSheer"
          : refIndex === "patterns"
            ? "patternsSheer"
            : refIndex === "types"
              ? "typesSheer"
              : "pricesSheer"
        : refIndex;

    const items = filterCheckboxes.current[refKey] || [];
    items.forEach((obj) => {
      if (obj) obj.checked = false;
    });

    if (refStep === "2") {
      if (refIndex === "colors") {
        setFilterColors2([]);
      } else if (refIndex === "patterns") {
        setFilterPatterns2([]);
      } else if (refIndex === "types") {
        setFilterTypes2([]);
      } else {
        setFilterPrices2([]);
      }
    } else {
      if (refIndex === "colors") {
        setFilterColors([]);
      } else if (refIndex === "patterns") {
        setFilterPatterns([]);
      } else if (refIndex === "types") {
        setFilterTypes([]);
      } else {
        setFilterPrices([]);
      }
    }
  }

  function popoverThumbnailHover(e) {
    let refIndex = e.target.getAttribute("text");
    let tempImages = [...popoverImages];
    tempImages[refIndex] = e.target.src;
    setPopoverImages(tempImages);
  }

  function optionSelectChanged_three(
    obj,
    refIndex,
    position,
    isMin,
    modalRef,
    postfixEn,
    postfixFa,
    pageLang,
    eventKey
  ) {
    if (obj !== undefined && typeof obj === "object") {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj.label;
      temp.values[refIndex][position] = parseFloat(obj.value);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3EStandardCeiling") {
            setInputDifdep("3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3");
          } else if (refIndex === "3EStandardCeilingFloor") {
            setInputDifdep(
              "3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
            );
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    } else if (obj !== undefined) {
      let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
      if (temp.labels[refIndex] === undefined) temp.labels[refIndex] = [];
      if (temp.values[refIndex] === undefined) temp.values[refIndex] = [];
      temp.labels[refIndex][position] = obj;
      temp.values[refIndex][position] = parseFloat(obj);
      setStepSelectedOptions(temp);

      if (
        temp.values[refIndex].filter(function(e) {
          return e;
        }).length === 3
      ) {
        let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
        if (isMin) {
          let tempMin =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMin}`) + postfixFa
              : tempMin + postfixEn;
        } else {
          let tempMax =
            temp.values[refIndex][
              temp.values[refIndex].indexOf(Math.min(...temp.values[refIndex]))
            ];
          tempLabels[refIndex] =
            pageLang === "fa"
              ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
              : tempMax + postfixEn;
        }
        setStepSelectedLabel(tempLabels);
        let minValue = Math.min(...temp.values[refIndex]);
        let maxValue = Math.max(...temp.values[refIndex]);
        if (maxValue - minValue >= 2) {
          if (refIndex === "3EStandardCeiling") {
            setInputDifdep("3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3");
          } else if (refIndex === "3EStandardCeilingFloor") {
            setInputDifdep(
              "3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
            );
          }
          setInputDifRef(refIndex);
          setAccordionActiveKey(eventKey);
          modalHandleShow(modalRef);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    setRequiredStep(temp);
  }

  function optionSelectChanged_LeftRight(
    obj,
    refIndex,
    isLeft,
    postfixEn,
    postfixFa,
    pageLang,
    secondVal
  ) {
    if (obj !== undefined && typeof obj === "object") {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj.value;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj.value;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      }
    } else if (obj !== undefined) {
      if (isLeft) {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.left = obj;
        if (secondVal !== undefined) {
          temp.right = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      } else {
        let temp = JSON.parse(JSON.stringify(leftRight));
        temp.right = obj;
        if (secondVal !== undefined) {
          temp.left = secondVal;
        }
        setLeftRight(temp);

        if (temp.right !== "" && temp.left !== "") {
          let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
          tempLabels[refIndex] =
            pageLang === "fa"
              ? `راست:  ${NumberToPersianWord.convertEnToPe(`${temp.right}`) +
                  postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                  `${temp.left}`
                ) + postfixFa}`
              : `Left: ${temp.left + postfixEn}\u00A0\u00A0\u00A0Right: ${temp.right + postfixEn}`;
          setStepSelectedLabel(tempLabels);
        }
      }
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    setRequiredStep(temp);
  }

  function optionSelectChanged(refIndex, selected, postfixEn, postfixFa, pageLang) {
    if (selected !== undefined && typeof selected === "object") {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected.value}`) + postfixFa}`
          : `${selected.value + postfixEn}`;
      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected.value;
      setStepSelectedValue(tempValue);
    } else if (selected !== undefined) {
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels[refIndex] =
        pageLang === "fa"
          ? `${NumberToPersianWord.convertEnToPe(`${selected}`) + postfixFa}`
          : `${selected + postfixEn}`;
      setStepSelectedLabel(tempLabels);

      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue[refIndex] = selected;
      setStepSelectedValue(tempValue);
    }
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (requiredStep[refIndex]) {
      temp[refIndex] = false;
    }
    if (refIndex === "345" || refIndex === "3G") {
      temp["3"] = false;
    }

    setRequiredStep(temp);
  }

  function selectChanged(e, nums, customText, secondRefIndex, secText) {
    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (e && customText) {
      tempLabels[e] = customText;

      if (secondRefIndex !== undefined) {
        let tempArr1 = secondRefIndex.split(",");
        tempArr1.forEach((ref, index) => {
          if (ref !== undefined) {
            tempLabels[ref] = secText[index];
          }
        });
      }
      if (tempLabels[e] !== "" && requiredStep[e]) {
        temp[e] = false;
      }
    } else if (e) {
      let refIndex = e.target.getAttribute("ref-num");
      tempLabels[refIndex] = e.target.getAttribute("text");
      tempValue[refIndex] = e.target.value;

      if (requiredStep[refIndex]) {
        temp[refIndex] = false;
      }
    }
    if (nums !== undefined) {
      let tempArr = nums.split(",");
      tempArr.forEach((num) => {
        if (num !== undefined) {
          if (tempValue[num] !== undefined) delete tempValue[num];
          if (tempLabels[num] !== undefined) delete tempLabels[num];
          if (tempLabels[num] !== "" && requiredStep[num]) {
            temp[num] = false;
          }
        }
      });
    }
    setStepSelectedLabel(tempLabels);
    setStepSelectedValue(tempValue);
    setRequiredStep((prev) => {
      if (prev["8"] === false) {
        return { ...temp, "8": false };
      } else if (prev["3"] === true) {
        return { ...temp, "3": true };
      } else if (prev["311"]) {
        return { ...temp, "3": false };
      }
      return temp;
    });
  }

  let effectless = [
    "PhotoUrl",
    "PageType",
    "PageId",
    "SheerHeaderStyle",
    "SheerHeaderStyleID",
    "PrivacyLayer",
    "Depth",
    "MouldingHeight",
    "PanelCoverage",
    "hardwareDrapery",
    "hardwareSheer",
    "hardwarePrivacyLayer",
    "hasPowerB",
    "MotorPositionB",
    "RemoteNameB",
    "MotorChannelsB",
    "hasPowerC",
    "MotorPositionC",
    "RemoteNameC",
    "MotorChannelsC",
    "RoomNameFa",
    "RoomNameEn",
    "WindowName",
    "moreInfoInput",
  ];

  function setCart(refIndex, cartValue, delRefs, secondRefIndex, secondCartValue, customAccCart) {
    const isUserMeasureChange = refIndex === "Width" || refIndex === "Height";
    let temp;
    try {
      temp = JSON.parse(JSON.stringify(cartValues || {}));
    } catch (e) {
      console.error("setCart: cartValues clone failed", e);
      temp = Object.assign({}, cartValues);
    }
    let changingRefs = [];
    try {
      if (refIndex !== undefined) {
        temp[refIndex] = cartValue;
        changingRefs.push(refIndex);
      }
      if (delRefs !== undefined) {
        let tempArr = delRefs.split(",");
        changingRefs.push(...tempArr);
        tempArr.forEach((ref) => {
          if (ref !== undefined) {
            if (temp[ref] !== undefined) delete temp[ref];
          }
        });
      }
      if (secondRefIndex !== undefined) {
        let tempArr1 = secondRefIndex.split(",");
        changingRefs.push(...tempArr1);
        tempArr1.forEach((ref, index) => {
          if (ref !== undefined) {
            temp[ref] = secondCartValue[index];
          }
        });
      }

      let scenario = 0;
      if (!temp["hasRod"]) {
        if (temp["FinishedLengthType"] === "Sill" || temp["FinishedLengthType"] === "Apron") {
          if (
            (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
            (temp["CurtainPosition"] === "Standard" ||
              temp["CurtainPosition"] === "Left Corner Window" ||
              temp["CurtainPosition"] === "Right Corner Window")
          ) {
            scenario = 1;
          } else if (temp["Mount"] === "Wall" && temp["CurtainPosition"] === "Wall to Wall") {
            scenario = 2;
          } else if (
            (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
            temp["CurtainPosition"] === "Wall to Wall"
          ) {
            scenario = 3;
          } else {
            scenario = 4;
          }
        } else {
          if (
            (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
            (temp["CurtainPosition"] === "Standard" ||
              temp["CurtainPosition"] === "Left Corner Window" ||
              temp["CurtainPosition"] === "Right Corner Window")
          ) {
            scenario = 5;
          } else if (temp["Mount"] === "Wall" && temp["CurtainPosition"] === "Wall to Wall") {
            scenario = 6;
          } else if (
            (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
            temp["CurtainPosition"] === "Wall to Wall"
          ) {
            scenario = 7;
          } else {
            scenario = 8;
          }
        }
      } else {
        if (temp["FinishedLengthType"] === "Sill" || temp["FinishedLengthType"] === "Apron") {
          scenario = 9;
        } else {
          scenario = 10;
        }
      }

      let MesSce = ["Mount", "calcMeasurements"];
      if (temp["calcMeasurements"]) {
        MesSce.push(...["hasRod", "FinishedLengthType"]);
        if (scenario === 1) {
          MesSce.push(
            ...[
              "Width3C",
              "ExtensionLeft",
              "ExtensionRight",
              "CeilingToWindow1",
              "CeilingToWindow2",
              "CeilingToWindow3",
              "CeilingToFloor",
            ]
          );
        } else if (scenario === 2) {
          MesSce.push(...["Width3C", "Height3E", "ShadeMount", "CeilingToFloor"]);
        } else if (scenario === 3) {
          MesSce.push(
            ...[
              "Width3C",
              "CeilingToWindow1",
              "CeilingToWindow2",
              "CeilingToWindow3",
              "CeilingToFloor",
            ]
          );
        } else if (scenario === 4) {
          MesSce.push(
            ...[
              "Width3C",
              "Height3E",
              "ExtensionLeft",
              "ExtensionRight",
              "ShadeMount",
              "CeilingToFloor",
            ]
          );
        } else if (scenario === 5) {
          MesSce.push(
            ...[
              "Width3C",
              "ExtensionLeft",
              "ExtensionRight",
              "CeilingToFloor1",
              "CeilingToFloor2",
              "CeilingToFloor3",
            ]
          );
        } else if (scenario === 6) {
          MesSce.push(...["Width3C", "WindowToFloor", "ShadeMount", "CeilingToFloor"]);
        } else if (scenario === 7) {
          MesSce.push(...["Width3C", "CeilingToFloor1", "CeilingToFloor2", "CeilingToFloor3"]);
        } else if (scenario === 8) {
          MesSce.push(
            ...[
              "Width3C",
              "WindowToFloor",
              "ExtensionLeft",
              "ExtensionRight",
              "ShadeMount",
              "CeilingToFloor",
            ]
          );
        } else if (scenario === 9) {
          MesSce.push(...["RodWidth", "RodToBottom", "CeilingToFloor"]);
        } else if (scenario === 10) {
          MesSce.push(...["RodWidth", "RodToFloor", "CeilingToFloor"]);
        }
      } else {
        MesSce.push(...["Width", "Height"]);
      }
      const isMesCompleted = MesSce.every(
        (ref) => Object.keys(temp).includes(ref) && temp[ref] !== undefined
      );
      const isMesCleared =
        delRefs !== undefined &&
        delRefs.split(",").includes("calcMeasurements") &&
        temp["calcMeasurements"] === undefined;
      const isPageLoadEnd =
        refIndex === undefined &&
        cartValue === undefined &&
        delRefs === undefined &&
        secondRefIndex === undefined &&
        secondCartValue === undefined &&
        customAccCart === undefined;
      const isEffectless = changingRefs.every((ref) => effectless.includes(ref));
      const canCommitCart =
        isUserMeasureChange ||
        (!pageLoad &&
          !rodsLoad &&
          !rodsLoad2 &&
          !(
            refIndex === undefined &&
            delRefs === undefined &&
            secondRefIndex === undefined &&
            customAccCart === undefined
          ));

      // Always persist step-11 accessories into cartValues (short path used to skip this)
      if (customAccCart !== undefined) {
        temp["Accessories"] = customAccCart;
      } else if (customAcc && customAcc.length > 0) {
        temp["Accessories"] = customAcc;
      }

      if (!isPageLoadEnd && !isMesCleared && (isEffectless || (!isMesCompleted && !widthCart))) {
        if (canCommitCart) {
          setCartValues(temp);
        }
        setCartLoading(false);
      } else {
        let tempPostObj = {};
        tempPostObj["WindowCount"] = 1;
        tempPostObj["SewingModelId"] = `${modelID}`;

        const userProjects = UserProjects[`${modelID}`] && UserProjects[`${modelID}`]["data"];
        if (!userProjects) {
          console.error("setCart: UserProjects data missing for model", modelID);
          if (canCommitCart) {
            setCartValues(temp);
          }
          setCartLoading(false);
          return;
        }

        Object.keys(temp).forEach((key) => {
          if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
            let tempObj = userProjects.find((obj) => obj["cart"] === key);
            if (tempObj === undefined) {
            } else {
              if (tempObj && tempObj["apiLabel"] !== "") {
                if (tempObj["apiValue"] === null) {
                  tempPostObj[tempObj["apiLabel"]] = temp[key];
                } else {
                  tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
                }
              }
            }
          }
        });

        tempPostObj["SewingOrderDetails"] = [];

        for (let i = 0; i < 3; i++) {
          tempPostObj["SewingOrderDetails"][i] = {};

          tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
          tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
            i === 0 ? step5 !== "Decorative" : true;
          tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
        }

        tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
        tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

        tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
        tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

        tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
        tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

        Object.keys(temp).forEach((key) => {
          if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
            let tempObj = userProjects.find((obj) => obj["cart"] === key);
            if (tempObj) {
              for (let i = 0; i < 3; i++) {
                let j = +i + +2;
                if (tempObj["apiLabel" + j] !== undefined) {
                  if (tempObj["apiValue" + j] === null) {
                    tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                  } else {
                    tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                      tempObj["apiValue" + j][temp[key]];
                  }
                }
              }
            }
          }
        });
        tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
        tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
        tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
        Object.keys(temp).forEach((key) => {
          if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
            let tempObj = userProjects.find((obj) => obj["cart"] === key);
            if (tempObj) {
              if (tempObj["apiAcc"] !== undefined) {
                if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                  tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                    tempObj["apiAccValue"][temp[key]]
                  );
                } else if (tempObj["apiAcc"] === "value") {
                  let pushObj = tempObj["apiAccValue"] || {};
                  pushObj["SewingAccessoryValue"] = temp[key].toString();
                  tempPostObj["SewingOrderDetails"][0]["Accessories"].push(pushObj);
                }
              }
              if (tempObj["apiAcc2"] !== undefined) {
                if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                  tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                    tempObj["apiAccValue2"][temp[key]]
                  );
                } else if (tempObj["apiAcc"] === "value") {
                  let pushObj = tempObj["apiAccValue2"] || {};
                  pushObj["SewingAccessoryValue"] = temp[key].toString();
                  tempPostObj["SewingOrderDetails"][1]["Accessories"].push(pushObj);
                }
              }
              if (tempObj["apiAcc3"] !== undefined) {
                if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                  tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                    tempObj["apiAccValue3"][temp[key]]
                  );
                } else if (tempObj["apiAcc"] === "value") {
                  let pushObj = tempObj["apiAccValue3"] || {};
                  pushObj["SewingAccessoryValue"] = temp[key].toString();
                  tempPostObj["SewingOrderDetails"][2]["Accessories"].push(pushObj);
                }
              }
            }
          }
        });
        if (customAccCart && customAccCart.length > 0) {
          tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAccCart);
          temp["Accessories"] = customAccCart;
        } else if (customAcc && customAcc.length > 0) {
          tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
          temp["Accessories"] = customAcc;
        }
        tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj["SewingOrderDetails"][0][
          "Accessories"
        ].filter(function(el) {
          return el != null;
        });

        if (canCommitCart) {
          setCartValues(temp);
        }

        let promise2 = new Promise((resolve, reject) => {
          if (step3 !== "" && (isUserMeasureChange || (!pageLoad && !rodsLoad && !rodsLoad2))) {
            for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
              if (
                tempPostObj["SewingOrderDetails"] &&
                tempPostObj["SewingOrderDetails"][i] &&
                tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
              ) {
                tempPostObj["SewingOrderDetails"].splice(i, 1);
              }
            }
            if (zipcode && zipcode !== "") {
              tempPostObj["ZipCode"] = zipcode;
            }
            if (hasZipcode && hasZipcode !== "") {
              tempPostObj["ZipCode"] = hasZipcode;
              delete tempPostObj["InstallAmount"];
              delete tempPostObj["TransportationAmount"];
            }
            const liningTypeIdMap = {
              "Standard Lining": 6002,
              "Privacy Lining": 6003,
            };
            tempPostObj["SewingOrderDetails"].forEach((detail) => {
              if (detail && detail["LiningId"] !== undefined) {
                delete detail["LiningId"];
              }
            });
            const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
            if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
              tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
            }

            if (priceRequestCancelRef.current) {
              try {
                priceRequestCancelRef.current.cancel("newer-getPrice");
              } catch (e) {}
            }
            priceRequestCancelRef.current = axios.CancelToken.source();

            axios
              .post(baseURLPrice, tempPostObj, {
                timeout: 25000,
                cancelToken: priceRequestCancelRef.current.token,
              })
              .then((response) => {
                priceRequestCancelRef.current = null;
                setPrice(response.data["Price"]);
                setWindowWidthPanelType(response.data["WindowWidth"]);
                setLiningPrice(response.data["LiningPrice"]);
                response?.data?.SewingOrderDetails?.forEach((detail) => {
                  if (detail.CurtainPartId === 2303) {
                    setHandCurtainPricDrapery(detail.HandCurtainPrice);
                  } else if (detail.CurtainPartId === 2302) {
                    setHandCurtainPricSheer(detail.HandCurtainPrice);
                  }
                });
                if (response.data["Price"]) {
                  setInstallPrice(
                    response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                  );
                  setTransportPrice(
                    response.data["TransportationAmount"]
                      ? response.data["TransportationAmount"]
                      : 0
                  );
                  setHasInstall(!!response.data["TransportationAmount"]);
                }

                if (
                  response.data["SewingOrderDetails"] &&
                  response.data["SewingOrderDetails"].length &&
                  (!response.data["ErrorCode"] || response.data["ErrorCode"] === "")
                ) {
                  setFabricsBoard(
                    response.data["SewingOrderDetails"]
                      .filter((obj) => ["2302", "2303"].includes(obj["CurtainPartId"].toString()))
                      .map(({ CurtainPartId, FabricId, IsBoard, BoardNum }) => ({
                        CurtainPartId,
                        FabricId,
                        IsBoard,
                        BoardNum,
                      }))
                  );
                } else if (
                  boardLoad &&
                  refIndex === undefined &&
                  delRefs === undefined &&
                  secondRefIndex === undefined &&
                  customAccCart === undefined
                ) {
                  setBoardLoad(false);
                } else if (
                  response.data["SewingOrderDetails"] &&
                  response.data["SewingOrderDetails"].length &&
                  response.data["ErrorCode"] &&
                  response.data["ErrorCode"] !== ""
                ) {
                  setBoardLoad(true);
                }

                getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
                temp["WindowWidth"] = response.data["WindowWidth"];
                temp["WindowHeight"] = response.data["WindowHeight"];
                temp["WidthCart"] = response.data["Width"];
                temp["HeightCart"] = response.data["Height"];
                setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
                setWindowWidthPanelType(response.data["WindowWidth"] ? response.data["WindowWidth"] : undefined);
                setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
                setHeightCart2(
                  response.data["WindowHeight"] ? response.data["WindowHeight"] : undefined
                );

                if (response.data["ErrorCode"] && response.data["ErrorCode"] === 230) {
                  setFabricError(true);
                  setErrorData(response.data);
                }
                resolve();
              })
              .catch((err) => {
                if (axios.isCancel(err)) {
                  resolve();
                  return;
                }
                priceRequestCancelRef.current = null;
                setPrice(0);
                setWindowSize("");
                setLiningPrice(0);
                setHandCurtainPricDrapery(0);
                setHandCurtainPricSheer(0);
                setWidthCart(undefined);
                setWindowWidthPanelType(undefined);
                setHeightCart(undefined);
                setHeightCart2(undefined);
                setWindowSizeBool(false);
                resolve(1);
              });
          } else {
            resolve();
          }
        });
        promise2.then((res) => {
          setCartLoading(false);
          setFabricLoading(false);
        });
      }
    } catch (err) {
      console.error("setCart failed", err);
      setCartLoading(false);
      setFabricLoading(false);
    }
  }

  setCartRef.current = setCart;

  function applyOwnMeasurement(field, rawValue) {
    try {
      let newValue = NumberToPersianWord.convertPeToEn(rawValue);
      newValue = isNaN(newValue) ? "" : newValue;
      const depKey = field === "Width" ? "311" : "312";
      const setMeasure = field === "Width" ? setWidth : setHeight;
      if (newValue && newValue !== "" && parseInt(newValue) >= 1 && parseInt(newValue) <= 1000) {
        setCartLoading(true);
        if (setCartRef.current) {
          setCartRef.current(field, parseInt(newValue));
        }
        setDeps("", depKey);
        setMeasure(parseInt(newValue));
      } else {
        setCartLoading(true);
        if (setCartRef.current) {
          setCartRef.current("", "", field);
        }
        setDeps(depKey, "");
        if (newValue === "" || isNaN(parseInt(newValue))) {
          setMeasure(undefined);
          selectChanged(undefined, "3");
        } else {
          setMeasure(parseInt(newValue));
          selectChanged("3", undefined, t("Invalid Measurements"));
        }
        setWindowSize("");
      }
    } catch (err) {
      console.error("applyOwnMeasurement failed", err);
      setCartLoading(false);
    }
  }

  function scheduleOwnMeasurement(field, rawValue) {
    const timers = measureDebounceRef.current;
    if (timers[field]) {
      clearTimeout(timers[field]);
    }
    timers[field] = setTimeout(() => {
      timers[field] = null;
      applyOwnMeasurement(field, rawValue);
    }, 1500);
  }

  function flushOwnMeasurement(field, rawValue) {
    const timers = measureDebounceRef.current;
    if (timers[field]) {
      clearTimeout(timers[field]);
      timers[field] = null;
    }
    applyOwnMeasurement(field, rawValue);
  }

  function measureWindowSize(zipcode) {
    let promise2 = new Promise((resolve, reject) => {
      let temp = JSON.parse(JSON.stringify(cartValues));
      let tempPostObj = {};
      tempPostObj["WindowCount"] = 1;
      tempPostObj["SewingModelId"] = `${modelID}`;

      let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj === undefined) {
          } else {
            if (tempObj && tempObj["apiLabel"] !== "") {
              if (tempObj["apiValue"] === null) {
                tempPostObj[tempObj["apiLabel"]] = temp[key];
              } else {
                tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
              }
            }
          }
        }
      });

      tempPostObj["SewingOrderDetails"] = [];
      for (let i = 0; i < 3; i++) {
        tempPostObj["SewingOrderDetails"][i] = {};
        tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
        tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
          i === 0 ? step5 !== "Decorative" : true;
        tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
      }

      tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
      tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

      tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
      tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

      tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
      tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            for (let i = 0; i < 3; i++) {
              let j = +i + +2;
              if (tempObj["apiLabel" + j] !== undefined) {
                if (tempObj["apiValue" + j] === null) {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                } else {
                  tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                    tempObj["apiValue" + j][temp[key]];
                }
              }
            }
          }
        }
      });
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
      tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
      Object.keys(temp).forEach((key) => {
        if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
          let tempObj = userProjects.find((obj) => obj["cart"] === key);
          if (tempObj) {
            if (tempObj["apiAcc"] !== undefined) {
              if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                  tempObj["apiAccValue"][temp[key]]
                );
              } else {
              }
            }
            if (tempObj["apiAcc2"] !== undefined) {
              if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                  tempObj["apiAccValue2"][temp[key]]
                );
              } else {
              }
            }
            if (tempObj["apiAcc3"] !== undefined) {
              if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                  tempObj["apiAccValue3"][temp[key]]
                );
              } else {
              }
            }
          }
        }
      });
      if (customAcc.length > 0) {
        tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
      }
      tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj["SewingOrderDetails"][0][
        "Accessories"
      ].filter(function(el) {
        return el != null;
      });

      if (step3 !== "") {
        for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
          if (
            tempPostObj["SewingOrderDetails"] &&
            tempPostObj["SewingOrderDetails"][i] &&
            tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
          ) {
            tempPostObj["SewingOrderDetails"].splice(i, 1);
          }
        }

        if (zipcode && zipcode !== "") {
          tempPostObj["ZipCode"] = zipcode;
        }
        const liningTypeIdMap = {
          "Standard Lining": 6002,
          "Privacy Lining": 6003,
        };
        tempPostObj["SewingOrderDetails"].forEach((detail) => {
          if (detail && detail["LiningId"] !== undefined) {
            delete detail["LiningId"];
          }
        });
        const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
        if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
          tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
        }
        axios
          .post(baseURLPrice, tempPostObj)
          .then((response) => {
            if (zipcode && zipcode !== "") {
              if (response.data["Price"]) {
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                setTransportPrice(
                  response.data["TransportationAmount"] ? response.data["TransportationAmount"] : 0
                );
                setHasInstall(!!response.data["TransportationAmount"]);
                setZipcodeButton(true);
              } else {
                HasInstall(zipcode);
              }
            } else {
              setPrice(response.data["Price"]);
              setLiningPrice(response.data["LiningPrice"]);
              response?.data?.SewingOrderDetails?.forEach((detail) => {
                if (detail.CurtainPartId === 2303) {
                  setHandCurtainPricDrapery(detail.HandCurtainPrice);
                } else if (detail.CurtainPartId === 2302) {
                  setHandCurtainPricSheer(detail.HandCurtainPrice);
                }
              });
              getWindowSize(response.data["WindowWidth"], response.data["WindowHeight"]);
              temp["WindowWidth"] = response.data["WindowWidth"];
              temp["WindowHeight"] = response.data["WindowHeight"];
              temp["WidthCart"] = response.data["Width"];
              temp["HeightCart"] = response.data["Height"];
              setWidthCart(response.data["Width"] ? response.data["Width"] : undefined);
              setWindowWidthPanelType(response.data["WindowWidth"] ? response.data["WindowWidth"] : undefined);
              setHeightCart(response.data["Height"] ? response.data["Height"] : undefined);
              setHeightCart2(
                response.data["WindowHeight"] ? response.data["WindowHeight"] : undefined
              );
              setCartValues(temp);
              setTimeout(() => {
                resolve();
              }, 1000);
            }
          })
          .catch((err) => {
            if (zipcode && zipcode !== "") {
              setInstallPrice(-1);
              setTransportPrice(-1);
              HasInstall(zipcode);
              setTimeout(() => {
                reject();
              }, 1000);
            } else {
              setWidthCart(undefined);
              setWindowWidthPanelType(undefined);
              setHeightCart(undefined);
              setHeightCart2(undefined);
              setPrice(0);
              if (temp["HeightCart"] !== undefined) delete temp["HeightCart"];
              if (temp["WidthCart"] !== undefined) delete temp["WidthCart"];

              if (temp["WindowHeight"] !== undefined) delete temp["WindowHeight"];
              if (temp["WindowWidth"] !== undefined) delete temp["WindowWidth"];
              setWindowSizeBool(false);
              setCartValues(temp);
              setTimeout(() => {
                reject();
              }, 1000);
            }
          });
      } else {
        HasInstall(zipcode);
        reject();
      }
    });
    promise2
      .then(() => {
        return true;
      })
      .catch(() => {
        return false;
      });
  }

  function HasInstall(zipcode) {
    axios
      .post(
        baseURLZipCode,
        {},
        {
          params: {
            zipCode: zipcode,
          },
        }
      )
      .then((response) => {
        setHasInstall(response.data);
        setZipcodeButton(true);
      })
      .catch((err) => {
        setHasInstall(false);
        setZipcodeChecked("false");
        setCart("", "", "ZipCode");
        setZipcodeButton(true);
      });
  }
  function clearInputs(e, nums, addNums, Scenario) {
    if (Scenario === undefined) {
      setWidth(undefined);
      setHeight(undefined);
      setRodToBottom(undefined);
      setRodToFloor(undefined);
      setWindowToFloor(undefined);
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setCeilingToFloor(undefined);
      setCeilingToFloor1(undefined);
      setCeilingToFloor2(undefined);
      setCeilingToFloor3(undefined);
      setWidth3C(undefined);
      setRodWidth(undefined);
      setLeft(undefined);
      setRight(undefined);
      setHeight3E(undefined);
      setMount(undefined);
      setStepSelectedOptions({ values: {}, labels: {} });
    } else if (Scenario === "HeightDif") {
      setCeilingToWindow1(undefined);
      setCeilingToWindow2(undefined);
      setCeilingToWindow3(undefined);
      setCeilingToFloor1(undefined);
      setCeilingToFloor2(undefined);
      setCeilingToFloor3(undefined);
    }

    setTimeout(() => {
      setWindowSizeBool(false);
      selectChanged(
        e,
        nums
          ? nums
          : "3C,3D,3E,3EFloor,3EStandardCeiling,3EStandardCeilingFloor,3F,3G,325,335,336,345" +
              (addNums ? "," + addNums : "")
      );
    }, 100);
  }

  function selectUncheck(e) {
    let refIndex = e.target.getAttribute("ref-num");
    let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
    delete tempLabels[refIndex];
    setStepSelectedLabel(tempLabels);

    let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
    if (tempValue[refIndex] !== undefined) delete tempValue[refIndex];
    setStepSelectedValue(tempValue);
    e.target.checked = false;
  }

  function setDeps(addDeps, removeDeps, notMainStep) {
    console.log({
      "Added Dependencies": addDeps,
      "Removed Dependencies": removeDeps,
    });
    let temp = JSON.parse(JSON.stringify(requiredStep));
    let depSetTempArr = new Set([...depSet]);
    if (addDeps !== undefined && addDeps !== "") {
      let tempArr = addDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr.add(dep);
        }
      });
    }
    if (removeDeps !== undefined && removeDeps !== "") {
      let tempArr = removeDeps.split(",");
      tempArr.forEach((dep) => {
        if (dep !== undefined && dep !== "") {
          depSetTempArr = new Set([...depSetTempArr].filter((x) => x !== dep));
          // depSetTempArr.delete(dep);
          let tempDep = "";
          if (notMainStep) {
            tempDep = dep.slice(0, Math.abs(notMainStep) * -1);
          } else {
            tempDep = dep;
          }

          if (
            requiredStep[tempDep] &&
            [...depSetTempArr].findIndex((el) => el.startsWith(tempDep) && el.charAt(1) !== "0") ===
              -1
          ) {
            temp[tempDep] = false;
          }
        }
      });
    }

    setDepSet(depSetTempArr);
    setRequiredStep((prev) => {
      if (prev["2"] === false && isClickStep4) {
        setIsClickStep4(false);
        return { ...temp, "2": false };
      } else if (prev["3"] && removeDeps === "312") {
        return { ...temp, "3": false };
      }
      if (removeDeps === "211" || removeDeps === "21,211") {
        return { ...temp, 2: false };
      }
      if (removeDeps === "8C,8C1,8C2,865,888") {
        return { ...temp, 8: false };
      }
      return temp;
    });
  }
  function addToCart() {
    let temp = JSON.parse(JSON.stringify(requiredStep));
    if (step5 === "Full") {
      depSet.delete("5");
    }
    let tempDepSet = [...depSet];
    console.log(`tempDepSet`, tempDepSet);
    let tempErr = {};
    let promiseArr = [];
    tempDepSet.forEach((dependency, index) => {
      promiseArr[index] = new Promise((resolve, reject) => {
        if (steps.current[dependency] !== undefined && steps.current[dependency] !== null) {
          temp[dependency] = true;
          let type =
            steps.current[dependency].getAttribute("type-of-step") === "1"
              ? pageLanguage === "fa"
                ? ""
                : ""
              : pageLanguage === "fa"
              ? ""
              : "";
          tempErr[dependency] = {
            order: dependency,
            el: (
              <li key={index}>
                {pageLanguage === "fa"
                  ? "" + steps.current[dependency].getAttribute("cart-custom-text") + type
                  : "" + type + steps.current[dependency].getAttribute("cart-custom-text")}
              </li>
            ),
          };
        }
        resolve();
      });
    });

    Promise.all(promiseArr).then(() => {
      //  if (step8 === "Same Hardware For All Curtains") {
      //   const excludedValues = new Set(['325', '336', '345']);
      //   for (let val of excludedValues) {
      //     depSet.delete(val);
      //   }
      // } else
      if (step8 === "I Want To Customize Hardware Per Curtain" || step3 === "false") {
        const excludedValues = new Set(["8A1", "8A2", "8B2", "8B3"]);
        for (let val of excludedValues) {
          depSet.delete(val);
        }
      }

      // if(step31 === "false"){
      //   const excludedValues = new Set(['325', '336', '345']);
      //   for (let val of excludedValues) {
      //     depSet.delete(val);
      //   }
      // }

      if (depSet.size > 0) {
        let promiseArr2 = [];
        Object.keys(depDetails.current).forEach((key, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            let promiseArr3 = [];
            Object.keys(depDetails.current[key]).forEach((key2, index2) => {
              promiseArr3[index2] = new Promise((resolve, reject) => {
                if (
                  depDetails.current[key][key2] !== undefined &&
                  depDetails.current[key][key2] !== null &&
                  tempDepSet.includes(key2)
                ) {
                  let depGroup =
                    depDetails.current[key][key2].getAttribute("dep-group") === ""
                      ? key2
                      : depDetails.current[key][key2].getAttribute("dep-group");

                  // let depType=depDetails.current[key][key2].getAttribute("dep-type")||"";
                  let depText = depDetails.current[key][key2].getAttribute("text") || "";

                  if (steps.current[depGroup] !== undefined && steps.current[depGroup] !== null) {
                    temp[depGroup] = true;
                    if (tempErr[depGroup] === undefined) {
                      let type =
                        steps.current[depGroup].getAttribute("type-of-step") === "1"
                          ? pageLanguage === "fa"
                            ? ""
                            : ""
                          : pageLanguage === "fa"
                          ? ""
                          : "";
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: (
                          <li key={index}>
                            {pageLanguage === "fa"
                              ? "" + steps.current[depGroup].getAttribute("cart-custom-text") + type
                              : "" +
                                type +
                                steps.current[depGroup].getAttribute("cart-custom-text")}
                          </li>
                        ),
                      };
                    }
                    resolve();
                  } else {
                    temp[key] = true;
                    if (tempErr[depGroup] === undefined) {
                      tempErr[depGroup] = {
                        order: depGroup,
                        el: <li key={index + "_" + index2}>{depText}</li>,
                      };
                    }
                    resolve();
                  }
                } else {
                  resolve();
                }
              });
            });

            Promise.all(promiseArr3)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                console.log(err);
                resolve();
              });
          });
        });

        Promise.all(promiseArr2)
          .then(() => {
            const special = ["جانمایی پرده", "Room Label"];

            // ترتیب دلخواه
            const customOrder = [
              "1",
              "11",
              "111",
              "2",
              "21",
              "211",
              "2A",
              "2B",
              "2B1",
              "2C",
              "3A0",
              "3A11",
              "3A12",
              "3",
              "311",
              "312",
              "315",
              "3C",
              "325",
              "3D",
              "3E",
              "3EFloor",
              "335",
              "336",
              "3EStandardCeilingFloor",
              "3EStandardCeiling",
              "3F",
              "3G",
              "345",
              "4",
              "5",
              "6",
              "6A",
              "6B",
              "6C",
              "7",
              "8",
              "8A",
              "85",
              "84",
              "809",
              "810",
              "811",
              "812",
              "813",
              "8A1",
              "8A2",
              "8A3",
              "8C3",
              "8A4",
              "8C5",
              "8P5",
              "8P6",
              "814",
              "842",
              "843",
              "844",
              "845",
              "846",
              "847",
              "848",
              "86",
              "8B",
              "8B1",
              "8B2",
              "8B3",
              "8B5",
              "8B51",
              "8B6",
              "849",
              "850",
              "852",
              "853",
              "854",
              "855",
              "856",
              "857",
              "87",
              "8C",
              "8C1",
              "8C2",
              "8C51",
              "8C52",
              "8C6",
              "858",
              "859",
              "860",
              "861",
              "862",
              "863",
              "864",
              "865",
              "10",
            ];

            function getOrderIndex(order) {
              const idx = customOrder.indexOf(order);
              return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
            }
            console.log(`tempErr`, tempErr);
            const sortedArray = Object.entries(tempErr)
              .sort((a, b) => {
                const aText = a[1].el.props.children;
                const bText = b[1].el.props.children;

                return (
                  special.includes(aText) - special.includes(bText) ||
                  getOrderIndex(a[1].order) - getOrderIndex(b[1].order)
                );
              })
              .map(([, value]) => {
                const originalEl = value.el;
                const className = pageLanguage === "fa" ? "farsi" : "";
                return <li className={className}>{originalEl.props.children}</li>;
              });

            setAddCartErr(sortedArray);
            setRequiredStep(temp);
            modalHandleShow("addToCartErr");
            setAddingLoading(false);
          })
          .catch((err) => {
            console.log(err);
            setAddingLoading(false);
          });
      } else if (heightCart === undefined || widthCart === undefined) {
        if (measureWindowSize()) {
          addToCart();
        } else {
          setAddingLoading(false);
        }
      } else {
        if (price) {
          let userProjects = JSON.parse(JSON.stringify(UserProjects))[`${modelID}`]["data"];
          let tempArr = [];
          let temp1 = [];
          let temp2 = [];
          let temp3 = [];
          let temp4 = [];
          let temp5 = [];
          let temp = JSON.parse(JSON.stringify(cartValues));
          let tempPostObj = {};
          let tempBagPrice = 0;
          tempPostObj["WindowCount"] = 1;
          tempPostObj["SewingModelId"] = `${modelID}`;
          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj && tempObj["apiLabel"] !== "") {
                if (tempObj["apiValue"] === null) {
                  tempPostObj[tempObj["apiLabel"]] = temp[key];
                } else {
                  tempPostObj[tempObj["apiLabel"]] = tempObj["apiValue"][temp[key]];
                }
              }
            }
          });

          tempPostObj["SewingOrderDetails"] = [];
          for (let i = 0; i < 3; i++) {
            tempPostObj["SewingOrderDetails"][i] = {};
            tempPostObj["SewingOrderDetails"][i]["IsLowWrinkle"] = true;
            tempPostObj["SewingOrderDetails"][i]["IsCoverAll"] =
              i === 0 ? step5 !== "Decorative" : true;
            tempPostObj["SewingOrderDetails"][i]["IsAltogether"] = true;
          }

          tempPostObj["SewingOrderDetails"][0]["CurtainPartId"] = 2303;
          tempPostObj["SewingOrderDetails"][0]["SewingModelId"] = `${modelID}`;

          tempPostObj["SewingOrderDetails"][1]["CurtainPartId"] = 2302;
          tempPostObj["SewingOrderDetails"][1]["SewingModelId"] = tempPostObj["SewingModelId"];

          tempPostObj["SewingOrderDetails"][2]["CurtainPartId"] = 2301;
          tempPostObj["SewingOrderDetails"][2]["SewingModelId"] = tempPostObj["SewingModelId"];

          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj) {
                for (let i = 0; i < 3; i++) {
                  let j = +i + +2;
                  if (tempObj["apiLabel" + j] !== undefined) {
                    if (tempObj["apiValue" + j] === null) {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] = temp[key];
                    } else {
                      tempPostObj["SewingOrderDetails"][i][tempObj["apiLabel" + j]] =
                        tempObj["apiValue" + j][temp[key]];
                    }
                  }
                }
              }
            }
          });
          tempPostObj["SewingOrderDetails"][0]["Accessories"] = [];
          tempPostObj["SewingOrderDetails"][1]["Accessories"] = [];
          tempPostObj["SewingOrderDetails"][2]["Accessories"] = [];
          Object.keys(temp).forEach((key) => {
            if (temp[key] !== undefined && temp[key] !== null && temp[key] !== "") {
              let tempObj = userProjects.find((obj) => obj["cart"] === key);
              if (tempObj) {
                if (tempObj["apiAcc"] !== undefined) {
                  if (tempObj["apiAcc"] === true && tempObj["apiAccValue"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][0]["Accessories"].push(
                      tempObj["apiAccValue"][temp[key]]
                    );
                  } else {
                  }
                }
                if (tempObj["apiAcc2"] !== undefined) {
                  if (tempObj["apiAcc2"] === true && tempObj["apiAccValue2"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][1]["Accessories"].push(
                      tempObj["apiAccValue2"][temp[key]]
                    );
                  } else {
                  }
                }
                if (tempObj["apiAcc3"] !== undefined) {
                  if (tempObj["apiAcc3"] === true && tempObj["apiAccValue3"][temp[key]]) {
                    tempPostObj["SewingOrderDetails"][2]["Accessories"].push(
                      tempObj["apiAccValue3"][temp[key]]
                    );
                  } else {
                  }
                }
              }
            }
          });
          if (customAcc.length > 0) {
            tempPostObj["SewingOrderDetails"][0]["Accessories"].push(...customAcc);
          }
          tempPostObj["SewingOrderDetails"][0]["Accessories"] = tempPostObj[
            "SewingOrderDetails"
          ][0]["Accessories"].filter(function(el) {
            return el != null;
          });
          tempPostObj["SewingModelId"] = tempPostObj["SewingOrderDetails"][0]["SewingModelId"];
          for (let i = tempPostObj["SewingOrderDetails"].length - 1; i >= 0; i--) {
            if (
              tempPostObj["SewingOrderDetails"] &&
              tempPostObj["SewingOrderDetails"][i] &&
              tempPostObj["SewingOrderDetails"][i]["FabricId"] === undefined
            ) {
              tempPostObj["SewingOrderDetails"].splice(i, 1);
            }
          }
          if (tempPostObj["MountPositionId"] === 4803) {
            tempPostObj["ArcWidth"] = tempPostObj["WindowWidth"];
            tempPostObj["ArcHeight"] = tempPostObj["WindowHeight"];
          }
          const liningTypeIdMap = {
            "Standard Lining": 6002,
            "Privacy Lining": 6003,
          };
          tempPostObj["SewingOrderDetails"].forEach((detail) => {
            if (detail && detail["LiningId"] !== undefined) {
              delete detail["LiningId"];
            }
          });
          const liningTypeId = liningTypeIdMap[tempPostObj["Lining"]];
          if (liningTypeId !== undefined && tempPostObj["SewingOrderDetails"][0]) {
            tempPostObj["SewingOrderDetails"][0]["LiningTypeId"] = liningTypeId;
          }
          if (tempPostObj["SewingOrderDetails"][0]["FabricId"] !== undefined) {
            axios
              .post(baseURLPrice, tempPostObj)
              .then((response) => {
                tempBagPrice = response.data["Price"];
                temp["Price"] = response.data["Price"];
                if (zipcodeChecked && response.data["InstallAmount"]) {
                  temp["InstallAmount"] = response.data["InstallAmount"];
                  temp["TransportationAmount"] = response.data["TransportationAmount"];
                }
                setInstallPrice(
                  response.data["InstallAmount"] ? response.data["InstallAmount"] : 0
                );
                let roomNameFa = cartValues["RoomNameFa"];
                let roomName = cartValues["RoomNameEn"];
                let WindowName =
                  cartValues["WindowName"] === undefined ? "" : cartValues["WindowName"];
                let moreInfoInput =
                  cartValues["moreInfoInput"] === undefined ? "" : cartValues["moreInfoInput"];

                let promiseArr = [];
                customAcc.forEach((obj, index) => {
                  if (obj["DesignNameFa"] !== undefined && obj["DesignNameEn"] !== undefined) {
                    promiseArr[index] = new Promise((resolve, reject) => {
                      temp4[index] = (
                        <li className="cart_agree_item 1" key={"acc" + index}>
                          <h1 className="cart_agree_item_title">
                            {pageLanguage === "fa" ? obj["DesignNameFa"] : obj["DesignNameEn"]} /{" "}
                            {pageLanguage === "fa"
                              ? obj["ColorNameFa"]
                              : capitalizeWordsText(obj["ColorNameEn"])}
                          </h1>
                          <h2 className="cart_agree_item_desc">
                            {t("agree_Qty")}
                            {NumToFa(obj["Qty"], pageLanguage)}
                          </h2>
                        </li>
                      );
                      resolve();
                    });
                  }
                });

                let promiseArr2 = [];
                Object.keys(cartValues).forEach((key, index) => {
                  promiseArr2[index] = new Promise((resolve, reject) => {
                    let filteredProjects = userProjects || [];

                    if (step3 === "false") {
                      filteredProjects = filteredProjects.filter(
                        (obj) => obj.title !== "Finished Length Type"
                      );
                    } else {
                      if (step3B === "Slight Puddle" && step31 === "false") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      } else if (step3ARod === "Slight Puddle" && step31 === "true") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      } else if (step3B === "Slight Puddle" && step31 === "Track") {
                        filteredProjects = filteredProjects.filter(
                          (obj) => obj.title !== "Finished Length Type"
                        );
                      }
                    }

                    let tempObj = filteredProjects.find((obj) => obj.cart === key);
                    if (tempObj === undefined || cartValues[key] === undefined) {
                      resolve();
                    } else {
                      if (key === "WindowHeight" || key === "WindowWidth") {
                        resolve();
                      } else if (
                        (key === "PanelTypeOption" &&
                          cartValues["PanelTypeOption"] === "Customize Style Per Curtain") ||
                        (key === "Hardware" &&
                          cartValues["Hardware"] === "I Want To Customize Hardware Per Curtain")
                      ) {
                        resolve();
                      } else if (
                        tempObj["title"] !== "" &&
                        tempObj["lang"].indexOf(pageLanguage) > -1
                      ) {
                        let objLabel = "";
                        if (key === "ControlType" && cartValues["ControlType"] === "Motorized") {
                          objLabel =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(
                                  `${t(cartValues[key].toString())} / ${t(
                                    cartValues["MotorType"].toString()
                                  )}`
                                ).toString()
                              : `${t(cartValues[key].toString())} / ${t(
                                  cartValues["MotorType"].toString()
                                )}`;
                        } else if (
                          key === "DraperyHardware" &&
                          cartValues["DraperyHardware"] !== "None"
                        ) {
                          objLabel =
                            // t(cartValues[key].toString()) +
                            // " / " +
                            (pageLanguage === "fa"
                              ? cartValues["RailDesignFaA"]
                              : cartValues["RailDesignEnA"]) +
                            " \n " +
                            (pageLanguage === "fa"
                              ? cartValues["RailColorFaA"]
                              : cartValues["RailColorEnA"]) +
                            (cartValues["BatonOptionA"] && cartValues["BatonOptionA"] !== "None"
                              ? " / " + t(cartValues["BatonOptionA"])
                              : "");
                        } else if (
                          key === "SheerHardware" &&
                          cartValues["SheerHardware"] !== "None"
                        ) {
                          if (cartValues["RailDesignEnB"] === "Motorized Track") {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              pageLanguage === "fa"
                                ? cartValues["RailDesignFaB"]
                                : cartValues["RailDesignEnB"];
                          } else {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaB"]
                                : cartValues["RailDesignEnB"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaB"]
                                : cartValues["RailColorEnB"]) +
                              (cartValues["BatonOptionB"]
                                ? cartValues["BatonOptionB"] !== "None"
                                  ? " / " + t(cartValues["BatonOptionB"])
                                  : ""
                                : " / " + t(cartValues["ControlPositionB"]));
                          }
                        } else if (
                          key === "PrivacyLayerHardware" &&
                          cartValues["PrivacyLayerHardware"] !== "None"
                        ) {
                          if (cartValues["RailDesignEnC"] === "Motorized Track") {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              pageLanguage === "fa"
                                ? cartValues["RailDesignFaC"]
                                : cartValues["RailDesignEnC"];
                          } else {
                            objLabel =
                              // t(cartValues[key].toString()) +
                              // " / " +
                              (pageLanguage === "fa"
                                ? cartValues["RailDesignFaC"]
                                : cartValues["RailDesignEnC"]) +
                              " \n " +
                              (pageLanguage === "fa"
                                ? cartValues["RailColorFaC"]
                                : cartValues["RailColorEnC"]) +
                              (cartValues["BatonOptionC"]
                                ? cartValues["BatonOptionC"] !== "None"
                                  ? " / " + t(cartValues["BatonOptionC"])
                                  : ""
                                : " / " + t(cartValues["ControlPositionC"]));
                          }
                        } else if (key === "HandCurtainEn" || key === "HandCurtainFa") {
                          objLabel =
                            t("agree_Qty") + NumToFa(cartValues["HandCurtainNum"], pageLanguage);
                        } else if (key === "HandCurtainEn2" || key === "HandCurtainFa2") {
                          objLabel =
                            t("agree_Qty") + NumToFa(cartValues["HandCurtainNum2"], pageLanguage);
                        } else if (tempObj["titleValue"] === null || true) {
                          if (tempObj["titlePostfix"] === "") {
                            let rawValue = t(cartValues[key]?.toString());
                            if (/^[\d,]+$/.test(rawValue)) {
                              rawValue = rawValue.split(",").join(", ");
                            }
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${t(cartValues[key].toString())}`
                                  ).toString()
                                : rawValue;
                          } else {
                            objLabel =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(
                                    `${cartValues[key]}`
                                  ).toString() + t(tempObj["titlePostfix"])
                                : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                          }
                        } else {
                          if (tempObj["titleValue"][cartValues[key].toString()] === null) {
                            if (tempObj["titlePostfix"] === "") {
                              objLabel = t(cartValues[key].toString());
                            } else {
                              objLabel =
                                pageLanguage === "fa"
                                  ? NumberToPersianWord.convertEnToPe(
                                      `${cartValues[key]}`
                                    ).toString() + t(tempObj["titlePostfix"])
                                  : cartValues[key].toString() + t(tempObj["titlePostfix"]);
                            }
                          } else {
                            objLabel = t(tempObj["titleValue"][cartValues[key].toString()]);
                          }
                        }
                        if (tempObj["fabric"] === undefined) {
                          temp5[tempObj["order"]] = (
                            <li className="cart_agree_item 2" key={key}>
                              <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 1) {
                          temp1[tempObj["order"]] = (
                            <li className="cart_agree_item 3" key={key}>
                              <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 2) {
                          temp2[tempObj["order"]] = (
                            <li className="cart_agree_item 4" key={key}>
                              <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else if (tempObj["fabric"] === 3) {
                          temp3[tempObj["order"]] = (
                            <li className="cart_agree_item 5" key={key}>
                              <h1 className="cart_agree_item_title">{t(tempObj["title"])}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">{objLabel}</h2>
                            </li>
                          );
                          resolve();
                        } else {
                          resolve();
                        }
                      } else {
                        resolve();
                      }
                    }
                  });
                });

                Promise.all([...promiseArr, ...promiseArr2]).then(() => {
                  const measurementCartValues = {
                    ...cartValues,
                    step31: step31,
                  };
                  tempArr.push(
                    <div key={defaultModelName}>
                      <h2 className="cart_agree_title">
                        {pageLanguage === "fa"
                          ? convertToPersian(defaultModelNameFa) + " سفارشی "
                          : "Custom " + defaultModelName}
                      </h2>
                      <ul className="cart_agree_items_container">
                        <GetMeasurementArray
                          modelId={`${modelID}`}
                          cartValues={measurementCartValues}
                        />
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_general">
                          <h1 className="cart_agree_item_fabrics_sorted_title 14">
                            {t("General Details")}
                          </h1>
                          <ul>{temp5}</ul>
                        </li>
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_drapery">
                          <h1 className="cart_agree_item_fabrics_sorted_title 15">
                            {t("Drapery")}
                          </h1>
                          <ul>
                            <li className="cart_agree_item 6">
                              <h1 className="cart_agree_item_title">{t("Fabric & Color")}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["FabricDesignFa"] +
                                    " / " +
                                    cartValues["FabricColorFa"]
                                  : CapitalizeAllWords(
                                      cartValues["FabricDesignEn"] +
                                        " / " +
                                        cartValues["FabricColorEn"]
                                    )}
                              </h2>
                            </li>
                            {cartValues["BorderOrTrimId"] && cartValues["borderPosition"] && (
                              <li className="cart_agree_item">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Border")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa"] +
                                      " \n " +
                                      t(cartValues["borderPosition"])
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn"] +
                                          " \n " +
                                          t(cartValues["borderPosition"])
                                      )}
                                </h2>
                              </li>
                            )}
                            {cartValues["BorderOrTrimId"] && !cartValues["borderPosition"] && (
                              <li className="cart_agree_item 7">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Trim")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa"]
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn"]
                                      )}
                                </h2>
                              </li>
                            )}
                            {temp1.filter(
                              (item, index, array) =>
                                item !== null &&
                                (index !== array.findLastIndex((x) => x !== null) ||
                                  !item.props?.children?.[0]?.props?.children?.some(
                                    (x) =>
                                      x?.includes?.("Matching Tieback") ||
                                      x?.includes?.("کمرپرده پارچه ای")
                                  ))
                            )}
                            {cartValues["FinishedLengthType"] &&
                              cartValues["FinishedLengthType"] === "Slight Puddle" && (
                                <li className="cart_agree_item 8">
                                  <h1 className="cart_agree_item_title">{t("dk_step2A")}&nbsp;</h1>
                                  <h2 className="cart_agree_item_desc 6">
                                    {cartValues["FinishedLengthType"]}
                                  </h2>
                                </li>
                              )}
                            {cartValues["HandCurtainNum"] && (
                              <li className="cart_agree_item 9">
                                <h1 className="cart_agree_item_title">
                                  {t("Matching Tieback")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 6">
                                  {t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum"], pageLanguage)}
                                </h2>
                              </li>
                            )}
                          </ul>
                        </li>
                        <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_sheer">
                          <h1 className="cart_agree_item_fabrics_sorted_title">{t("Sheer")}</h1>
                          <ul>
                            <li className="cart_agree_item 10">
                              <h1 className="cart_agree_item_title">{t("Fabric & Color")}&nbsp;</h1>
                              <h2 className="cart_agree_item_desc">
                                {pageLanguage === "fa"
                                  ? cartValues["FabricDesignFa2"] +
                                    " / " +
                                    cartValues["FabricColorFa2"]
                                  : CapitalizeAllWords(
                                      cartValues["FabricDesignEn2"] +
                                        " / " +
                                        cartValues["FabricColorEn2"]
                                    )}
                              </h2>
                            </li>
                            {cartValues["BorderOrTrimId2"] && cartValues["borderPosition2"] && (
                              <li className="cart_agree_item 11">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Border")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa2"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa2"] +
                                      " \n " +
                                      t(cartValues["borderPosition2"])
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn2"] +
                                          " \n " +
                                          t(cartValues["borderPosition2"])
                                      )}
                                </h2>
                              </li>
                            )}
                            {cartValues["BorderOrTrimId2"] && !cartValues["borderPosition2"] && (
                              <li className="cart_agree_item 12">
                                <h1 className="cart_agree_item_title">
                                  {t("Decorative Trim")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc">
                                  {pageLanguage === "fa"
                                    ? cartValues["BorderOrTrimDesignFa2"] +
                                      " / " +
                                      cartValues["BorderOrTrimColorFa2"]
                                    : CapitalizeAllWords(
                                        cartValues["BorderOrTrimDesignEn2"] +
                                          " / " +
                                          cartValues["BorderOrTrimColorEn2"]
                                      )}
                                </h2>
                              </li>
                            )}
                            {temp2.filter(
                              (item) =>
                                item !== null &&
                                !item.props?.children?.[0]?.props?.children?.some(
                                  (x) =>
                                    x?.includes?.("Matching Tieback") ||
                                    x?.includes?.("کمرپرده پارچه ای")
                                )
                            )}
                            {cartValues["FinishedLengthType"] &&
                              cartValues["FinishedLengthType"] === "Slight Puddle" && (
                                <li className="cart_agree_item 13">
                                  <h1 className="cart_agree_item_title">{t("dk_step2A")}&nbsp;</h1>
                                  <h2 className="cart_agree_item_desc 6">{t("Floor")}</h2>
                                </li>
                              )}
                            {cartValues["HandCurtainNum2"] && (
                              <li className="cart_agree_item 14">
                                <h1 className="cart_agree_item_title">
                                  {t("Matching Tieback")}&nbsp;
                                </h1>
                                <h2 className="cart_agree_item_desc 6">
                                  {t("agree_Qty") +
                                    NumToFa(cartValues["HandCurtainNum2"], pageLanguage)}
                                </h2>
                              </li>
                            )}
                          </ul>
                        </li>
                        {cartValues["PrivacyLayer"] !== "none" &&
                          cartValues["SheersDesignEn"] &&
                          cartValues["SheersColorEn"] && (
                            <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_pl">
                              <h1 className="cart_agree_item_fabrics_sorted_title">
                                {t("Privacy Layer")}
                              </h1>
                              <ul>
                                <li className="cart_agree_item 15">
                                  <h1 className="cart_agree_item_title">
                                    {t("Fabric & Color")}&nbsp;
                                  </h1>
                                  <h2 className="cart_agree_item_desc">
                                    {pageLanguage === "fa"
                                      ? cartValues["SheersDesignFa"] +
                                        " / " +
                                        cartValues["SheersColorFa"]
                                      : CapitalizeAllWords(
                                          cartValues["SheersDesignEn"] +
                                            " / " +
                                            cartValues["SheersColorEn"]
                                        )}
                                  </h2>
                                </li>
                                {temp3}
                                {cartValues["FinishedLengthType"] &&
                                  cartValues["FinishedLengthType"] === "Slight Puddle" && (
                                    <li className="cart_agree_item 16">
                                      <h1 className="cart_agree_item_title">
                                        {t("dk_step2A")}&nbsp;
                                      </h1>
                                      <h2 className="cart_agree_item_desc 6">{t("Floor")}</h2>
                                    </li>
                                  )}
                              </ul>
                            </li>
                          )}
                        {!!temp4.length && (
                          <li className="cart_agree_item cart_agree_item_fabrics_sorted cart_agree_item_acc">
                            <h1 className="cart_agree_item_fabrics_sorted_title">
                              {t("Accessories")}
                            </h1>
                            <ul>{temp4}</ul>
                          </li>
                        )}
                        <li className="cart_agree_item 17">
                          <h1 className="cart_agree_item_title">
                            {pageLanguage === "fa" ? "نام اتاق" : "Room Label"}&nbsp;
                          </h1>
                          <h2 className="cart_agree_item_desc">
                            {pageLanguage === "fa"
                              ? roomNameFa + (WindowName === "" ? "" : " / " + WindowName)
                              : roomName + (WindowName === "" ? "" : " / " + WindowName)}
                          </h2>
                        </li>
                        {moreInfoInput !== "" && (
                          <li className="cart_agree_item 18">
                            <h1 className="cart_agree_item_title">{t("Order Notes")}&nbsp;</h1>
                            <ShowMoreLineLimited moreInfoInput={moreInfoInput} lines={3} />
                          </li>
                        )}
                        <li className="cart_agree_item 19">
                          <h1 className="cart_agree_item_title">{t("Price")}&nbsp;</h1>
                          <h2 className="cart_agree_item_desc">
                            {GetPrice(tempBagPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                          </h2>
                        </li>
                      </ul>
                    </div>
                  );
                  setCartAgree(tempArr);
                  modalHandleShow("cart_modal");
                  setCartValues(temp);
                  setAddingLoading(false);
                });
              })
              .catch((err) => {
                console.log(err);
                if (err.response && err.response.status === 401) {
                  refreshToken().then((response2) => {
                    if (response2 !== false) {
                      addToCart();
                    } else {
                      setPrice(0);

                      temp["Price"] = 0;
                      setCartValues(temp);
                      setAddingLoading(false);
                      navigate("/" + pageLanguage + "/User");
                    }
                  });
                } else {
                  setPrice(0);

                  temp["Price"] = 0;
                  setCartValues(temp);
                  setAddingLoading(false);
                  modalHandleClose("cart_modal");
                }
              });
          } else {
            setAddingLoading(false);
          }
        }
      }
    });
  }

  function addToCart_agreed() {
    const successImages = uploadedImages.filter((img) => img.status === "success");
    const imageFiles = successImages.map((img) => img.name);
    const imageUrls = successImages.map((img) => {
      if (img.url && img.url.startsWith("http")) {
        try {
          const urlObj = new URL(img.url);
          return urlObj.pathname;
        } catch (e) {
          return img.url;
        }
      }
      return img.url || "";
    });

    const successPdfs = uploadedPDFs.filter((pdf) => pdf.status === "success");
    const pdfFiles = successPdfs.map((pdf) => pdf.name);
    const pdfUrls = successPdfs.map((pdf) => {
      if (pdf.url && pdf.url.startsWith("http")) {
        try {
          const urlObj = new URL(pdf.url);
          return urlObj.pathname;
        } catch (e) {
          return pdf.url;
        }
      }
      return pdf.url || "";
    });

    const filesForCart = [imageFiles, imageUrls, pdfFiles, pdfUrls];

    AddProjectToCart(
      cartValues,
      `${modelID}`,
      price,
      defaultModelName,
      defaultModelNameFa,
      filesForCart,
      projectId && projectId !== "" ? projectId : cartProjectIndex,
      editIndex,
      navigate,
      isLoggedIn,
      customAcc
    )
      .then((temp) => {
        if (temp === 401) {
          addToCart_agreed();
        } else if (temp) {
          setCartAgreeDescription(false);
          renderCart(temp);
          setBag(temp);
          setTimeout(() => {
            // modalHandleShow("cart_modal");
            setCartStateAgree(true);
          }, 500);
          setAddingLoading(false);
        } else {
          setAddingLoading(false);
          setCartAgreeDescription(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setAddingLoading(false);
        setCartAgreeDescription(false);
      });
  }

  function updateSideCartSummary(cartObjects) {
    if (!cartObjects || !Object.keys(cartObjects).length) {
      setSideCartProductTotal(0);
      setSideCartInstallPrice(0);
      setSideCartTransportPrice(0);
      setSideCartHasSwatches(false);
      return;
    }

    if (isLoggedIn && cartObjects["CartDetails"]) {
      setSideCartProductTotal(cartObjects["TotalAmount"] || 0);
      setSideCartInstallPrice(cartObjects["InstallAmount"] || 0);
      setSideCartTransportPrice(cartObjects["TransportationAmount"] || 0);
      setSideCartHasSwatches(cartObjects["CartDetails"].some((item) => item["TypeId"] === 6402));
      return;
    }

    const draperies = cartObjects["drapery"] || [];
    const products = cartObjects["product"] || [];
    const swatches = cartObjects["swatches"] || [];
    let productTotal = 0;
    let installTotal = 0;

    [...draperies, ...products].forEach((item) => {
      const priceToUse =
        item["DiscountedPrice"] !== undefined && item["DiscountedPrice"] !== null
          ? item["DiscountedPrice"]
          : item["Price"];
      productTotal += (priceToUse || 0) * (item["Count"] || 1);
    });

    draperies.forEach((item) => {
      const installAmount = item["InstallAmount"] || 0;
      const windowCount = item["WindowCount"] || item["Count"] || 1;
      installTotal += installAmount * windowCount;
    });

    const transportItem = draperies.find((item) => item["TransportationAmount"] > 0);
    setSideCartProductTotal(productTotal);
    setSideCartInstallPrice(installTotal);
    setSideCartTransportPrice(transportItem ? transportItem["TransportationAmount"] : 0);
    setSideCartHasSwatches(swatches.length > 0);
  }

  function renderCart(customPageCart) {
    let cartObjects = {};
    let promise2 = new Promise((resolve, reject) => {
      if (customPageCart !== undefined) {
        cartObjects = customPageCart;
        resolve();
      } else {
        if (isLoggedIn) {
          axios
            .get(baseURLGetCart, {
              headers: authHeader(),
            })
            .then((response) => {
              cartObjects = response.data ? response.data : {};
              resolve();
            })
            .catch((err) => {
              console.log(err);
              if (err.response && err.response.status === 401) {
                refreshToken().then((response2) => {
                  if (response2 !== false) {
                    renderCart(customPageCart);
                  } else {
                    navigate("/" + pageLanguage + "/User");
                  }
                });
              } else {
                modalHandleClose("cart_modal");
                reject();
              }
            });
        } else {
          if (localStorage.getItem("cart") === null) {
            modalHandleClose("cart_modal");
            reject();
          } else {
            cartObjects = JSON.parse(localStorage.getItem("cart"));
            resolve();
          }
        }
      }
    });
    promise2.then(() => {
      let cartCount = 0;
      let totalPrice = 0;
      setSideCartObjects(cartObjects);
      updateSideCartSummary(cartObjects);
      if (isLoggedIn) {
        if (cartObjects["CartDetails"].length === 0) {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["CartDetails"].length;
      } else {
        if (
          cartObjects["drapery"].length +
            cartObjects["product"].length +
            cartObjects["swatches"].length ===
          0
        ) {
          setCartCount(0);
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }
        cartCount += cartObjects["drapery"].length;
      }
      setCartCount(cartCount);
    });
    axios
      .get(baseURLFreeShipping)
      .then((response) => {
        setFreeShipPrice(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function fabricClicked(photo, hasTrim) {
    if(photo !== undefined && photo !== null && photo !== "") {
    setDefaultFabricPhoto(photo);
    }
 
  }

  const fabricSwatch = createFabricSwatch({
    isLoggedIn,
    show,
    cartChanged,
    setBag,
    renderFabricsOnAdd: (data) => {
      renderFabrics(data);
      renderFabrics2(data);
    },
    setSwatchDetailId,
    setCartChanged,
    setHasSwatchId,
    setSwatchLogin,
    setSwatchLoginSwatchId,
    setSwatchLoginSwatchDetailId,
    modalHandleShow,
  });

  const getWindowSize = createGetWindowSize({
    location,
    setWindowSize,
    setWindowSizeBool,
  });

  const roomLabelChanged = createRoomLabelChanged({
    stepSelectedLabel,
    stepSelectedValue,
    roomLabelSelect,
    requiredStep,
    roomLabelText,
    setStepSelectedLabel,
    setStepSelectedValue,
    setRoomLabelSelect,
    setRequiredStep,
  });

  function uploadImg(file) {
    setSelectedFile(file);
    setSelectedFileName(file.name);
  }

  const addUploadFileUrl = createAddUploadFileUrl({
    setUploadedPDFs,
    setUploadedImages,
  });

  const submitUploadedFile = createSubmitUploadedFile({
    selectedFile,
    editedFileName,
    setIsUploading,
    setSelectedFile,
    setSelectedFileName,
    setEditedFileName,
    modalHandleClose,
    addUploadFileUrl,
    dispatch,
  });

  const setDeleteUploaded = createSetDeleteUploaded({
    setDeleteUploadPdfUrl,
    setDeleteUploadPdfIndex,
    setDeleteUploadImageUrl,
    setDeleteUploadImageIndex,
  });

  const deleteUploadedImg = createDeleteUploadedImg({
    uploadedImagesFile,
    uploadedImagesURL,
    setUploadedImagesURL,
    setUploadedImagesFile,
    setUploadedImagesList,
    setUploadedImagesNamesList,
    setDeleteUploadImageUrl,
    setDeleteUploadImageIndex,
  });

  const handleDeleteFile2 = createHandleDeleteFile2({
    uploadingFiles,
    uploadedImages,
    uploadedPDFs,
    multipleFileUploadRef,
    setUploadedPDFs,
    setUploadedImages,
  });

  const deleteUploadedPdf = createDeleteUploadedPdf({
    uploadedPDFFile,
    uploadedPDFURL,
    setUploadedPDFURL,
    setUploadedPDFFile,
    setUploadedPDFNameList,
    setDeleteUploadImageUrl,
    setDeleteUploadImageIndex,
  });

  const getProjectDetail = createGetProjectDetail({
    projectId,
    navigate,
    pageLanguage,
    catID,
    modelID,
    setProjectDetails,
  });

  function setProjectDetails(data, editIndex, changeLang) {
    let storedImages = [];
    let storedPDFs = [];
    try {
      const imagesRaw = sessionStorage.getItem("backup_uploadedImages");
      const pdfsRaw = sessionStorage.getItem("backup_uploadedPDFs");
      if (imagesRaw) storedImages = JSON.parse(imagesRaw);
      if (pdfsRaw) storedPDFs = JSON.parse(pdfsRaw);
    } catch (e) {
      console.error("sessionStorage read error", e);
    }
    if (storedImages.length) setUploadedImages(storedImages);
    if (storedPDFs.length) setUploadedPDFs(storedPDFs);

    setPageLoad(true);
    setBoardLoad(true);
    setRodsLoad(true);
    setRodsLoad2(true);
    setMesLoad(true);

    // Same object for restore mutations + setState (avoid stale extendedTitle)
    let tempExtended = {
      1: [],
      2: [],
      6: [],
      8: [],
      "8A": [],
      "8B": [],
      "8C": [],
      9: [],
    };
    setExtendedTitle(tempExtended);
    if (data && Object.keys(data).length !== 0) {
      setProjectData(data);
    }

    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let tempLabels = {};
    let tempValue = {};
    let selectValues = JSON.parse(JSON.stringify(selectCustomValues));
    let tempSelect = JSON.parse(JSON.stringify(roomLabelSelect));
    let depSetTempArr = new Set([...depSet]);

    let postfixFa = "س\u200Cم";
    let postfixEn = "cm";

    GetUserProjectData(data, isLoggedIn, editIndex, changeLang).then((temp) => {
      if (editIndex !== undefined && Object.keys(temp).length !== 0) {
        setCartProjectIndex(editIndex);
      }
      setCartValues(temp);

      let tempFabric = {};
      let tempFabric2 = {};
      let tempSheers = {};
      let tempSheers2 = {};
      let promise2 = new Promise((resolve, reject) => {
        if (temp["FabricId"] || temp["FabricId2"] || temp["SheersId1"] || temp["SheersId2"]) {
          let paramObj = {
            modelId: modelID,
          };
          setLoading(true);
          axios
            .get(baseURLFabrics, {
              params: paramObj,
            })
            .then((response) => {
              console.log(response.data);
              let promiseArr = [];
              response.data.forEach((obj, index) => {
                promiseArr[index] = new Promise((resolve, reject) => {
                  if (obj["FabricId"] === temp["FabricId"]) {
                    tempFabric = obj;
                  }
                  if (obj["FabricId"] === temp["FabricId2"]) {
                    tempFabric2 = obj;
                  }
                  if (obj["FabricId"] === temp["SheersId1"]) {
                    tempSheers = obj;
                  }
                  if (obj["FabricId"] === temp["SheersId2"]) {
                    tempSheers2 = obj;
                  }
                  resolve();
                });
              });
              Promise.all(promiseArr).then(() => {
                resolve();
              });
            })
            .catch((err) => {
              console.log(err);
              reject();
            })
            .finally(() => {
              setLoading(false);
            });
        } else {
          reject();
        }
      });
      promise2
        .then(() => {
          if (Object.keys(tempFabric).length > 0 || Object.keys(tempFabric2).length > 0) {
            if (Object.keys(tempFabric).length > 0) {
              const photoUrl4709 = findFabricPhotoById(tempFabric.FabricPhotos, 4709);
              let temp1 = JSON.parse(JSON.stringify(fabricSelected));
              temp1.selectedFabricId = tempFabric.FabricId;
              temp1.selectedTextEn = tempFabric.DesignEnName;
              temp1.selectedTextFa = tempFabric.DesignName;
              temp1.selectedDesignCode = tempFabric.DesignCode;
              temp1.selectedColorEn = tempFabric.ColorEnName;
              temp1.selectedColorFa = tempFabric.ColorName;
              temp1.selectedHasTrim = tempFabric.HasTrim;
              temp1.selectedPhoto = tempFabric.FabricOnModelPhotoUrl;
              temp1.selectedPhoto2 = photoUrl4709;
              temp1.FabricWidth = tempFabric.FabricWidth;
              temp1.SewingDirection = tempFabric.SewingDirection;
              setFabricSelected(temp1);
              tempLabels["1"] =
                location.pathname
                  .split("")
                  .slice(1, 3)
                  .join("") === "fa"
                  ? tempFabric["DesignName"] + " / " + tempFabric["ColorName"]
                  : tempFabric["DesignEnName"] + " / " + tempFabric["ColorEnName"];
              tempValue["1"] = temp["FabricId"];

              tempExtended["1"][0] = tempLabels["1"];
              depSetTempArr = new Set([...setGetDeps("", "1", depSetTempArr)]);
            }
            if (Object.keys(tempFabric2).length > 0) {
              const photoUrl4709 = findFabricPhotoById(tempFabric2.FabricPhotos, 4709);

              let temp1 = JSON.parse(JSON.stringify(fabricSelected2));
              temp1.selectedFabricId = tempFabric2.FabricId;
              temp1.selectedTextEn = tempFabric2.DesignEnName;
              temp1.selectedTextFa = tempFabric2.DesignName;
              temp1.selectedDesignCode = tempFabric.DesignCode;
              temp1.selectedColorEn = tempFabric2.ColorEnName;
              temp1.selectedColorFa = tempFabric2.ColorName;
              temp1.selectedHasTrim = tempFabric2.HasTrim;
              temp1.selectedPhoto = tempFabric2.FabricOnModelPhotoUrl;
              temp1.selectedPhoto2 = photoUrl4709;
              temp1.FabricWidth = tempFabric2.FabricWidth;
              temp1.SewingDirection = tempFabric2.SewingDirection;
              setFabricSelected2(temp1);
              tempLabels["2"] =
                location.pathname
                  .split("")
                  .slice(1, 3)
                  .join("") === "fa"
                  ? tempFabric2["DesignName"] + " / " + tempFabric2["ColorName"]
                  : tempFabric2["DesignEnName"] + " / " + tempFabric2["ColorEnName"];
              tempValue["2"] = temp["FabricId2"];
              tempExtended["2"][0] = tempLabels["2"];
              depSetTempArr = new Set([...setGetDeps("", "2", depSetTempArr)]);
            }
            if (Object.keys(tempSheers).length > 0) {
              let temp1 = JSON.parse(JSON.stringify(sheersSelected));
              temp1.selectedFabricId = tempSheers.FabricId;
              temp1.selectedTextEn = tempSheers.DesignEnName;
              temp1.selectedTextFa = tempSheers.DesignName;
              temp1.selectedColorEn = tempSheers.ColorEnName;
              temp1.selectedColorFa = tempSheers.ColorName;
              temp1.selectedHasTrim = tempSheers.HasTrim;
              temp1.selectedPhoto = tempSheers.FabricOnModelPhotoUrl;
              setSheersSelected(temp1);
              depSetTempArr = new Set([...setGetDeps("", "2B1", depSetTempArr)]);
            } else if (Object.keys(tempSheers2).length > 0) {
              let temp1 = JSON.parse(JSON.stringify(sheersSelected2));
              temp1.selectedFabricId = tempSheers2.FabricId;
              temp1.selectedTextEn = tempSheers2.DesignEnName;
              temp1.selectedTextFa = tempSheers2.DesignName;
              temp1.selectedColorEn = tempSheers2.ColorEnName;
              temp1.selectedColorFa = tempSheers2.ColorName;
              temp1.selectedHasTrim = tempSheers2.HasTrim;
              temp1.selectedPhoto = tempSheers2.FabricOnModelPhotoUrl;
              setSheersSelected2(temp1);
              depSetTempArr = new Set([...setGetDeps("", "2B1", depSetTempArr)]);
            }
            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            promise2.reject();
          }
        })
        .catch(() => {
          setTimeout(() => {
            if (temp["BorderOrTrimId"]) {
              setStep1Check(`${tempFabric.DesignCode}`);
              if (temp["borderPosition"]) {
                setStep1Border(temp["BorderOrTrimId"]);
                setStep1BorderRadio(temp["borderPosition"]);
                tempExtended["1"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Border")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa"] + " / " + temp["BorderOrTrimColorFa"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn"] + " / " + temp["BorderOrTrimColorEn"]
                          )}
                    </span>
                  </li>
                );
                tempExtended["1"][2] = (
                  <li key="2" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Border Position")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {pageLanguage === "en"
                        ? CapitalizeAllWords(t(temp["borderPosition"]))
                        : t(temp["borderPosition"])}
                    </span>
                  </li>
                );
              } else {
                setStep1Trim(temp["BorderOrTrimId"]);
                tempExtended["1"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Trim")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa"] + " / " + temp["BorderOrTrimColorFa"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn"] + " / " + temp["BorderOrTrimColorEn"]
                          )}
                    </span>
                  </li>
                );
              }
            }

            if (temp["BorderOrTrimId2"]) {
              setStep2Check(`${tempFabric2.DesignCode}`);
              if (temp["borderPosition2"]) {
                setStep2Border(temp["BorderOrTrimId2"]);
                setStep2BorderRadio(temp["borderPosition2"]);
                tempExtended["2"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Border")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa2"] + " / " + temp["BorderOrTrimColorFa2"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn2"] + " / " + temp["BorderOrTrimColorEn2"]
                          )}
                    </span>
                  </li>
                );
                tempExtended["2"][2] = (
                  <li key="2" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Border Position")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {pageLanguage === "en"
                        ? CapitalizeAllWords(t(temp["borderPosition2"]))
                        : t(temp["borderPosition2"])}
                    </span>
                  </li>
                );
              } else {
                setStep2Trim(temp["BorderOrTrimId2"]);
                tempExtended["2"][1] = (
                  <li key="1" className="step_title_extended_list_item">
                    <span className="step_title_extended_list_item_title">
                      {t("Decorative Trim")}
                    </span>
                    <span className="step_title_extended_list_item_text">
                      {location.pathname
                        .split("")
                        .slice(1, 3)
                        .join("") === "fa"
                        ? temp["BorderOrTrimDesignFa2"] + " / " + temp["BorderOrTrimColorFa2"]
                        : CapitalizeAllWords(
                            temp["BorderOrTrimDesignEn2"] + " / " + temp["BorderOrTrimColorEn2"]
                          )}
                    </span>
                  </li>
                );
              }
            }

            if (temp["SheerHeaderStyle"]) {
              setStep2A(temp["SheerHeaderStyle"]);
              if (temp["SheerHeaderStyle"] === "Grommet") {
                let refIndex = inputs.current["2A1"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2A1"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2A1"].value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0099");
              } else if (temp["SheerHeaderStyle"] === "Inverted Box Pleat") {
                let refIndex = inputs.current["2A2"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2A2"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2A2"].value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0036");
              } else if (temp["SheerHeaderStyle"] === "Pencil Pleat") {
                let refIndex = inputs.current["2A3"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2A3"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2A3"].value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
                setSheersModelId("0002");
              } else {
                let refIndex = inputs.current["2A4"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2A4"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2A4"].value;
                depSetTempArr = new Set([...setGetDeps("", "2A", depSetTempArr)]);
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["PrivacyLayer"]) {
              setStep2B(temp["PrivacyLayer"]);
              if (temp["PrivacyLayer"] === "None") {
                let refIndex = inputs.current["2B1"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2B1"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2B1"].value;
                depSetTempArr = new Set([...setGetDeps("", "2B,2B1", depSetTempArr)]);
              } else if (temp["PrivacyLayer"] === "Semi Sheer") {
                let refIndex = inputs.current["2B2"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2B2"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2B2"].value;
                if (temp["SheersId1"]) {
                  setStep2B1(temp["SheersId1"]);
                  tempLabels["2B"] =
                    location.pathname
                      .split("")
                      .slice(1, 3)
                      .join("") === "fa"
                      ? tempSheers["DesignName"] + " / " + tempSheers["ColorName"]
                      : tempSheers["DesignEnName"] + " / " + tempSheers["ColorEnName"];
                }
                depSetTempArr = new Set([
                  ...setGetDeps(temp["SheersId1"] !== undefined ? "" : "2B1,", "2B", depSetTempArr),
                ]);
              } else {
                let refIndex = inputs.current["2B3"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["2B3"].getAttribute("text");
                tempValue[refIndex] = inputs.current["2B3"].value;
                if (temp["SheersId2"]) {
                  setStep2B1(temp["SheersId2"]);
                  tempLabels["2B"] =
                    location.pathname
                      .split("")
                      .slice(1, 3)
                      .join("") === "fa"
                      ? tempSheers2["DesignName"] + " / " + tempSheers2["ColorName"]
                      : tempSheers2["DesignEnName"] + " / " + tempSheers2["ColorEnName"];
                }
                depSetTempArr = new Set([
                  ...setGetDeps(temp["SheersId2"] !== undefined ? "" : "2B1,", "2B", depSetTempArr),
                ]);
              }

              if (temp["PrivacyLayer"] !== "None") {
                if (temp["PrivacyLayerHeaderStyle"]) {
                  setStep2C(temp["PrivacyLayerHeaderStyle"]);
                  if (temp["PrivacyLayerHeaderStyle"] === "Grommet") {
                    let refIndex = inputs.current["2C1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C1"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0099");
                  } else if (temp["PrivacyLayerHeaderStyle"] === "Inverted Box Pleat") {
                    let refIndex = inputs.current["2C2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C2"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0036");
                  } else if (temp["PrivacyLayerHeaderStyle"] === "Pencil Pleat") {
                    let refIndex = inputs.current["2C3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C3"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                    setSheersModelId2("0002");
                  } else {
                    let refIndex = inputs.current["2C4"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["2C4"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["2C4"].value;
                    depSetTempArr = new Set([...setGetDeps("", "2C", depSetTempArr)]);
                  }
                }
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["Mount"]) {
              setStep3A0(temp["Mount"].toString());
              if (temp["Mount"] === "Wall") {
                let refIndex = inputs.current["3A01"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["3A01"].getAttribute("text");
                tempValue[refIndex] = inputs.current["3A01"].value;
                depSetTempArr = new Set([...setGetDeps("", "3A0", depSetTempArr)]);
              } else if (temp["Mount"] === "Ceiling") {
                let refIndex = inputs.current["3A02"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["3A02"].getAttribute("text");
                tempValue[refIndex] = inputs.current["3A02"].value;
                depSetTempArr = new Set([...setGetDeps("", "3A0", depSetTempArr)]);
              } else {
                let refIndex = inputs.current["3A03"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["3A03"].getAttribute("text");
                tempValue[refIndex] = inputs.current["3A03"].value;
                setDepth(temp["Depth"] ? temp["Depth"] : undefined);
                setMouldingHeight(temp["MouldingHeight"] ? temp["MouldingHeight"] : undefined);
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["Depth"] !== undefined ? "" : "3A11,") +
                      (temp["MouldingHeight"] !== undefined ? "" : "3A12,"),
                    "3A0",
                    depSetTempArr
                  ),
                ]);
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            const calcRaw = Array.isArray(temp["calcMeasurements"])
              ? temp["calcMeasurements"][0]
              : temp["calcMeasurements"];
            const hasOwnMeasurements = calcRaw === false || `${calcRaw}` === "false";

            if (temp["calcMeasurements"] !== undefined) {
              setStep3(temp["calcMeasurements"].toString());
              if (hasOwnMeasurements) {
                setStep5("Full");
                let refIndex = inputs.current["31"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["31"].getAttribute("text");
                tempValue[refIndex] = inputs.current["31"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);

                setWidth(temp["Width"] ? temp["Width"] : undefined);
                setHeight(temp["Height"] ? temp["Height"] : undefined);
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["Width"] ? "" : "311,") + (temp["Height"] ? "" : "312,"),
                    "3",
                    depSetTempArr
                  ),
                ]);
                setSelectCustomValues(selectValues);
              } else {
                let refIndex = inputs.current["32"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["32"].getAttribute("text");
                tempValue[refIndex] = inputs.current["32"].value;
                setStepSelectedLabel(tempLabels);
                setStepSelectedValue(tempValue);
                depSetTempArr = new Set([...setGetDeps("", "3", depSetTempArr)]);

                if (temp["hasRod"] !== undefined) {
                  setStep31(temp["hasRod"].toString());
                  depSetTempArr = new Set([...setGetDeps("", "3,31", depSetTempArr)]);
                  if (!temp["hasRod"]) {
                    let scenario = 0;
                    if (temp["CurtainPosition"]) {
                      setStep3A(temp["CurtainPosition"].toString());
                      if (temp["CurtainPosition"] === "Standard") {
                        let refIndex = inputs.current["3A1"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A1"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A1"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else if (temp["CurtainPosition"] === "Wall to Wall") {
                        let refIndex = inputs.current["3A2"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A2"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A2"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else if (temp["CurtainPosition"] === "Left Corner Window") {
                        let refIndex = inputs.current["3A3"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A3"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A3"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      } else {
                        let refIndex = inputs.current["3A4"].getAttribute("ref-num");
                        tempLabels[refIndex] = inputs.current["3A4"].getAttribute("text");
                        tempValue[refIndex] = inputs.current["3A4"].value;

                        depSetTempArr = new Set([...setGetDeps("", "3A", depSetTempArr)]);
                      }
                      if (temp["Mount"]) {
                        if (temp["FinishedLengthType"]) {
                          setStep3B(temp["FinishedLengthType"].toString());
                          if (
                            temp["FinishedLengthType"] === "Sill" ||
                            temp["FinishedLengthType"] === "Apron"
                          ) {
                            if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              (temp["CurtainPosition"] === "Standard" ||
                                temp["CurtainPosition"] === "Left Corner Window" ||
                                temp["CurtainPosition"] === "Right Corner Window")
                            ) {
                              scenario = 1;
                            } else if (
                              temp["Mount"] === "Wall" &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 2;
                            } else if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 3;
                            } else {
                              scenario = 4;
                            }

                            if (temp["FinishedLengthType"] === "Sill") {
                              let refIndex = inputs.current["3B1"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B1"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B1"].value;
                            } else {
                              let refIndex = inputs.current["3B2"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B2"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B2"].value;
                              // setStep3B1("true");
                            }
                          } else {
                            if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              (temp["CurtainPosition"] === "Standard" ||
                                temp["CurtainPosition"] === "Left Corner Window" ||
                                temp["CurtainPosition"] === "Right Corner Window")
                            ) {
                              scenario = 5;
                            } else if (
                              temp["Mount"] === "Wall" &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 6;
                            } else if (
                              (temp["Mount"] === "Ceiling" || temp["Mount"] === "Moulding") &&
                              temp["CurtainPosition"] === "Wall to Wall"
                            ) {
                              scenario = 7;
                            } else {
                              scenario = 8;
                            }

                            if (temp["FinishedLengthType"] === "Floor") {
                              let refIndex = inputs.current["3B3"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B3"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B3"].value;
                            } else {
                              let refIndex = inputs.current["3B4"].getAttribute("ref-num");
                              tempLabels[refIndex] = inputs.current["3B4"].getAttribute("text");
                              tempValue[refIndex] = inputs.current["3B4"].value;
                            }
                          }
                        }
                      }
                    }
                    setTimeout(() => {
                      if (scenario > 0) {
                        if (scenario === 1) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];

                          setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                          setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeiling"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeiling1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeiling2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeiling3,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 2) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["Height3E"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          // selectValues["Height3E"] = tempHeight ? [{value: tempHeight}] : [];
                          setHeight3E(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3E"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3E,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 3) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          let tempHeight = changeLang ? temp["CeilingToWindow1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToWindow2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToWindow3"] : temp["Height3"];

                          setCeilingToWindow1(tempHeight ? tempHeight : undefined);
                          setCeilingToWindow2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToWindow3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeiling"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeiling1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeiling2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeiling3,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 4) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["Height3E"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          setHeight3E(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3E"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3E,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 5) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }

                          let tempHeight = changeLang ? temp["CeilingToFloor1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToFloor2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToFloor3"] : temp["Height3"];

                          setCeilingToFloor1(tempHeight ? tempHeight : undefined);
                          setCeilingToFloor2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToFloor3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeilingFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeilingFloor1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeilingFloor2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeilingFloor3,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 6) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["WindowToFloor"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }

                          // selectValues["WindowToFloor"] = tempHeight ? [{value: tempHeight}] : [];
                          setWindowToFloor(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3EFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }

                          // selectValues["ShadeMount"] = temp["ShadeMount"] ? [{value: temp["ShadeMount"]}] : [];
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }

                          // selectValues["CeilingToFloor"] = temp["CeilingToFloor"] ? [{value: temp["CeilingToFloor"]}] : [];
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EFloor,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else if (scenario === 7) {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }
                          let tempHeight = changeLang ? temp["CeilingToFloor1"] : temp["Height"];
                          let tempHeight2 = changeLang ? temp["CeilingToFloor2"] : temp["Height2"];
                          let tempHeight3 = changeLang ? temp["CeilingToFloor3"] : temp["Height3"];

                          setCeilingToFloor1(tempHeight ? tempHeight : undefined);
                          setCeilingToFloor2(tempHeight2 ? tempHeight2 : undefined);
                          setCeilingToFloor3(tempHeight3 ? tempHeight3 : undefined);
                          if (tempHeight && tempHeight2 && tempHeight3) {
                            let tempMax = Math.min(tempHeight, tempHeight2, tempHeight3);
                            tempLabels["3EStandardCeilingFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempMax}`) + postfixFa
                                : tempMax + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (tempHeight !== undefined ? "" : "3EStandardCeilingFloor1,") +
                                (tempHeight2 !== undefined ? "" : "3EStandardCeilingFloor2,") +
                                (tempHeight3 !== undefined ? "" : "3EStandardCeilingFloor3,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        } else {
                          let tempWidth = changeLang ? temp["Width3C"] : temp["Width"];
                          let tempHeight = changeLang ? temp["WindowToFloor"] : temp["Height"];

                          // selectValues["Width3C"] = tempWidth ? [{value: tempWidth}] : [];
                          setWidth3C(tempWidth ? tempWidth : undefined);
                          if (tempWidth) {
                            tempLabels["3C"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                                : tempWidth + postfixEn;
                          }
                          setLeft(temp["ExtensionLeft"] ? temp["ExtensionLeft"] : undefined);
                          setRight(temp["ExtensionRight"] ? temp["ExtensionRight"] : undefined);
                          if (
                            temp["ExtensionLeft"] !== undefined &&
                            temp["ExtensionRight"] !== undefined
                          ) {
                            tempLabels["3D"] =
                              pageLanguage === "fa"
                                ? `راست:  ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionRight"]}`
                                  ) +
                                    postfixFa}\u00A0\u00A0\u00A0چپ: ${NumberToPersianWord.convertEnToPe(
                                    `${temp["ExtensionLeft"]}`
                                  ) + postfixFa}`
                                : `Left: ${temp["ExtensionLeft"] +
                                    postfixEn}\u00A0\u00A0\u00A0Right: ${temp["ExtensionRight"] +
                                    postfixEn}`;
                          }
                          setWindowToFloor(tempHeight ? tempHeight : undefined);
                          if (tempHeight) {
                            tempLabels["3EFloor"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                                : tempHeight + postfixEn;
                          }
                          setMount(temp["ShadeMount"] ? temp["ShadeMount"] : undefined);
                          if (temp["ShadeMount"] !== undefined) {
                            tempLabels["3F"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["ShadeMount"]}`) +
                                  postfixFa
                                : temp["ShadeMount"] + postfixEn;
                          }
                          setCeilingToFloor(
                            temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                          );
                          if (temp["CeilingToFloor"] !== undefined) {
                            tempLabels["3G"] =
                              pageLanguage === "fa"
                                ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                  postfixFa
                                : temp["CeilingToFloor"] + postfixEn;
                          }

                          depSetTempArr = new Set([
                            ...setGetDeps(
                              (tempWidth ? "" : "3C,") +
                                (temp["ExtensionLeft"] !== undefined ? "" : "3D1,") +
                                (temp["ExtensionRight"] !== undefined ? "" : "3D2,") +
                                (tempHeight !== undefined ? "" : "3EFloor,") +
                                (temp["ShadeMount"] !== undefined ? "" : "3F,") +
                                (temp["CeilingToFloor"] !== undefined ? "" : "3G,"),
                              "31,3A,3B,3B1",
                              depSetTempArr
                            ),
                          ]);
                        }
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      } else {
                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (temp["FinishedLengthType"] ? "" : "3B,") + "3A",
                            "3,31",
                            depSetTempArr
                          ),
                        ]);
                      }
                    }, 100);
                  } else {
                    if (temp["FinishedLengthType"]) {
                      setStep3ARod(temp["FinishedLengthType"].toString());
                      if (
                        temp["FinishedLengthType"] === "Sill" ||
                        temp["FinishedLengthType"] === "Apron"
                      ) {
                        if (temp["FinishedLengthType"] === "Sill") {
                          let refIndex = inputs.current["3ARod1"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod1"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod1"].value;
                        } else {
                          let refIndex = inputs.current["3ARod2"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod2"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod2"].value;
                          // setStep3ARod1("true");
                        }

                        let tempWidth = changeLang ? temp["RodWidth"] : temp["Width"];
                        let tempHeight = changeLang ? temp["RodToBottom"] : temp["Height"];
                        setRodWidth(tempWidth ? tempWidth : undefined);
                        if (tempWidth) {
                          tempLabels["325"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                              : tempWidth + postfixEn;
                        }
                        setRodToBottom(tempHeight ? tempHeight : undefined);
                        if (tempHeight) {
                          tempLabels["335"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                              : tempHeight + postfixEn;
                        }
                        setCeilingToFloor(
                          temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                        );
                        if (temp["CeilingToFloor"] !== undefined) {
                          tempLabels["345"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                postfixFa
                              : temp["CeilingToFloor"] + postfixEn;
                        }

                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (tempWidth !== undefined ? "" : "325,") +
                              (tempHeight !== undefined ? "" : "335,") +
                              (temp["CeilingToFloor"] !== undefined ? "" : "345,"),
                            "31,315,3ARod1",
                            depSetTempArr
                          ),
                        ]);
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      } else {
                        if (temp["FinishedLengthType"] === "Floor") {
                          let refIndex = inputs.current["3ARod3"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod3"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod3"].value;
                        } else {
                          let refIndex = inputs.current["3ARod4"].getAttribute("ref-num");
                          tempLabels[refIndex] = inputs.current["3ARod4"].getAttribute("text");
                          tempValue[refIndex] = inputs.current["3ARod4"].value;
                        }

                        let tempWidth = changeLang ? temp["RodWidth"] : temp["Width"];
                        let tempHeight = changeLang ? temp["RodToFloor"] : temp["Height"];
                        setRodWidth(tempWidth ? tempWidth : undefined);
                        if (tempWidth) {
                          tempLabels["325"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempWidth}`) + postfixFa
                              : tempWidth + postfixEn;
                        }
                        setRodToFloor(tempHeight ? tempHeight : undefined);
                        if (tempHeight) {
                          tempLabels["336"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${tempHeight}`) + postfixFa
                              : tempHeight + postfixEn;
                        }
                        setCeilingToFloor(
                          temp["CeilingToFloor"] ? temp["CeilingToFloor"] : undefined
                        );
                        if (temp["CeilingToFloor"] !== undefined) {
                          tempLabels["345"] =
                            pageLanguage === "fa"
                              ? NumberToPersianWord.convertEnToPe(`${temp["CeilingToFloor"]}`) +
                                postfixFa
                              : temp["CeilingToFloor"] + postfixEn;
                        }

                        depSetTempArr = new Set([
                          ...setGetDeps(
                            (tempWidth !== undefined ? "" : "325,") +
                              (tempHeight !== undefined ? "" : "336,") +
                              (temp["CeilingToFloor"] !== undefined ? "" : "345,"),
                            "31,315",
                            depSetTempArr
                          ),
                        ]);
                        setSelectCustomValues(selectValues);
                        setStepSelectedLabel(tempLabels);
                        setStepSelectedValue(tempValue);
                      }
                    } else {
                      depSetTempArr = new Set([...setGetDeps("315", "", depSetTempArr)]);
                    }
                  }
                } else {
                  depSetTempArr = new Set([...setGetDeps("31", "3", depSetTempArr)]);
                }
              }
            }
            if (temp["WindowWidth"] && temp["WindowHeight"]) {
              getWindowSize(temp["WindowWidth"], temp["WindowHeight"]);
            }

            if (temp["Lining"]) {
              setStep4(temp["Lining"]);
              if (temp["Lining"] === "Standard Lining") {
                let refIndex = inputs.current["41"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["41"].getAttribute("text");
                tempValue[refIndex] = inputs.current["41"].value;
              } else {
                let refIndex = inputs.current["42"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["42"].getAttribute("text");
                tempValue[refIndex] = inputs.current["42"].value;
              }
              depSetTempArr = new Set([...setGetDeps("", "4", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["PanelCoverage"] && !hasOwnMeasurements) {
              setStep5(temp["PanelCoverage"]);
              if (temp["PanelCoverage"] === "Full") {
                let refIndex = inputs.current["51"]?.getAttribute("ref-num");
                if (refIndex) {
                  tempLabels[refIndex] = inputs.current["51"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["51"].value;
                }
              } else {
                let refIndex = inputs.current["52"]?.getAttribute("ref-num");
                if (refIndex) {
                  tempLabels[refIndex] = inputs.current["52"].getAttribute("text");
                  tempValue[refIndex] = inputs.current["52"].value;
                }
              }
              depSetTempArr = new Set([...setGetDeps("", "5", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            // Drapery&Sheers often only stores PanelTypeA/B/C (PanelTypeOption may be missing)
            if (
              temp["PanelTypeA"] ||
              temp["PanelTypeB"] ||
              temp["PanelTypeC"] ||
              temp["PanelTypeOption"]
            ) {
              const panelOption = temp["PanelTypeOption"] || "Customize Style Per Curtain";
              setStep6(panelOption);
              const widthNum = parseInt(
                temp["CalcWidth"] || temp["Width"] || temp["WindowWidth"] || widthCart || 0,
                10
              );

              // Match live Step8GrommetOne drapery header labels
              const draperyHeaderLabel = (panelType) => {
                const narrow = widthNum < 160;
                if (panelType === "Single Panel")
                  return narrow
                    ? t("Drapery Panel Single Panel")
                    : t("Drapery Panel Rod Single Panel, Left2");
                if (panelType === "Single Panel, Right")
                  return narrow
                    ? t("Drapery Panel Single Panel, Right")
                    : t("Drapery Panel Rod Single Panel, Right2");
                if (panelType === "Single, Free Hanging")
                  return narrow
                    ? t("Drapery Panel Single, Free Hanging")
                    : t("Drapery Panel Rod Single, Free Hanging");
                if (panelType === "Pair, Free Hanging")
                  return narrow
                    ? t("Drapery Panel  Pair, Free Hanging")
                    : t("Drapery Panel Rod Pair, Free Hanging");
                if (panelType === "Pair, Split Draw")
                  return narrow
                    ? t("Drapery Panel Pair, Split Draw")
                    : t("Drapery Panel Rod Pair, Split Draw");
                if (panelType === "Three Panel, Split Draw") return t("Three Panel, Split Draw");
                return t(panelType);
              };

              // Prefer cart hardware over React head defaults (always "Rod" after refresh)
              // Do not call setStep6BHead/setStep6CHead here — it would re-fire the head
              // wipe effect after pageLoad=false in the same batch and clear hardware.
              const sheerHead =
                temp["SheerHardware"] === "Track" || temp["hardwareSheer"] === "Track"
                  ? "Track"
                  : "Rod";
              const privacyHead =
                temp["PrivacyLayerHardware"] === "Track" || temp["hardwarePrivacyLayer"] === "Track"
                  ? "Track"
                  : "Rod";

              // Match live sheer/privacy tooltip text (width + rod/track head)
              const layerPanelText = (panelType, head) => {
                if (widthNum <= 160) return t(panelType);
                if (panelType === "Single Panel") return t("Track Single Panel");
                if (panelType === "Single Panel, Right") return t("Track Single Panel, Right");
                if (panelType === "Single, Free Hanging") return t("Rod Single, Free Hanging");
                if (panelType === "Pair, Free Hanging") return t("Rod Pair, Free Hanging");
                if (panelType === "Pair, Split Draw")
                  return head === "Rod" ? t("Rod Pair, Split Draw") : t("Track Pair, Split Draw");
                return t(panelType);
              };

              if (panelOption === "Same Style For All Curtains" && inputs.current["61"]) {
                let refIndex = inputs.current["61"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["61"].getAttribute("text");
                tempValue[refIndex] = inputs.current["61"].value;
                tempExtended[refIndex][0] = tempLabels[refIndex];

                if (temp["PanelTypeA"]) {
                  setStep61(temp["PanelTypeA"]);
                  tempExtended[refIndex][1] = (
                    <li key="2" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("All Curtains")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {t(temp["PanelTypeA"])}
                      </span>
                    </li>
                  );
                  depSetTempArr = new Set([...setGetDeps("", "6,61", depSetTempArr)]);
                } else {
                  depSetTempArr = new Set([...setGetDeps("61", "6", depSetTempArr)]);
                }
              } else {
                // Customize per curtain — match live header: [0]=drapery, [2]=sheer, [3]=privacy
                if (!Array.isArray(tempExtended["6"])) {
                  tempExtended["6"] = [];
                }

                if (temp["PanelTypeA"]) {
                  setStep6A(temp["PanelTypeA"]);
                  const draperyLabel = draperyHeaderLabel(temp["PanelTypeA"]);
                  tempExtended["6"][0] = [draperyLabel];
                  tempLabels["6"] = draperyLabel;
                }
                if (temp["PanelTypeB"]) {
                  setStep6B(temp["PanelTypeB"]);
                  tempExtended["6"][2] = (
                    <li key="2" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("Sheer Panel")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {layerPanelText(temp["PanelTypeB"], sheerHead)}
                      </span>
                    </li>
                  );
                }
                if (temp["PanelTypeC"]) {
                  setStep6C(temp["PanelTypeC"]);
                  tempExtended["6"][3] = (
                    <li key="3" className="step_title_extended_list_item">
                      <span className="step_title_extended_list_item_title">
                        {t("Privacy Layer")}
                      </span>
                      <span className="step_title_extended_list_item_text">
                        {layerPanelText(temp["PanelTypeC"], privacyHead)}
                      </span>
                    </li>
                  );
                }
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["PanelTypeA"] !== undefined ? "" : "6A,") +
                      (temp["PanelTypeB"] !== undefined ? "" : "6B,") +
                      (temp["PanelTypeC"] !== undefined ||
                      temp["PrivacyLayer"] === "None" ||
                      temp["PrivacyLayer"] === undefined ||
                      temp["PrivacyLayerHeaderStyle"] === undefined
                        ? ""
                        : "6C,"),
                    "6",
                    depSetTempArr
                  ),
                ]);
              }
            }

            if (temp["GrommetFinish"]) {
              setStep7(temp["GrommetFinish"]);
              if (temp["GrommetFinish"] === "Satin Brass") {
                let refIndex = inputs.current["71"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["71"].getAttribute("text");
                tempValue[refIndex] = inputs.current["71"].value;
              } else if (temp["GrommetFinish"] === "Satin Nickel") {
                let refIndex = inputs.current["72"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["72"].getAttribute("text");
                tempValue[refIndex] = inputs.current["72"].value;
              } else {
                let refIndex = inputs.current["73"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["73"].getAttribute("text");
                tempValue[refIndex] = inputs.current["73"].value;
              }
              depSetTempArr = new Set([...setGetDeps("", "7", depSetTempArr)]);
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["Hardware"]) {
              setStep8(temp["Hardware"]);
              if (temp["Hardware"] === "I Have My Own Hardware") {
                let refIndex = inputs.current["81"].getAttribute("ref-num");
                // Match radio label: "نیاز ندارم." (not hardware1 / I Have My Own Hardware)
                tempLabels[refIndex] = t("None");
                tempValue[refIndex] = inputs.current["81"].value;
                tempExtended["8"] = [t("None")];

                const sheerOptionPools = [
                  ...(sheersSelect[pageLanguage] || []),
                  ...(sheersSelect2[pageLanguage] || []),
                  ...(sheersSelect3[pageLanguage] || []),
                ];
                const privacyOptionPools = [
                  ...(privacyLayerSelect[pageLanguage] || []),
                  ...(privacyLayerSelect2[pageLanguage] || []),
                  ...(privacyLayerSelect3[pageLanguage] || []),
                ];

                let ownHardwareDepsClear = "";
                let ownHardwareDepsNeed =
                  temp["PrivacyLayer"] === "None" || temp["PrivacyLayer"] === undefined
                    ? "85,86,"
                    : "85,86,87,";

                if (temp["hardwareDrapery"]) {
                  const draperyOption = (draperiesSelect[pageLanguage] || []).find(
                    (opt) => opt.value === temp["hardwareDrapery"]
                  );
                  if (draperyOption) {
                    setSelectedDrapery([draperyOption]);
                    tempExtended["8"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Drapery Hardware")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {pageLanguage === "fa" ? draperyOption.label : draperyOption.value}
                        </span>
                      </li>
                    );
                    ownHardwareDepsClear += "85,";
                    ownHardwareDepsNeed = ownHardwareDepsNeed.replace("85,", "");
                  }
                }

                if (temp["hardwareSheer"]) {
                  const sheerOption = sheerOptionPools.find(
                    (opt) => opt.value === temp["hardwareSheer"]
                  );
                  if (sheerOption) {
                    setSelectedSheer([sheerOption]);
                    tempExtended["8"][2] = (
                      <li key="2" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Sheer Hardware")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {pageLanguage === "fa" ? sheerOption.label : sheerOption.value}
                        </span>
                      </li>
                    );
                    ownHardwareDepsClear += "86,";
                    ownHardwareDepsNeed = ownHardwareDepsNeed.replace("86,", "");
                  }
                }

                if (temp["hardwarePrivacyLayer"]) {
                  const privacyOption = privacyOptionPools.find(
                    (opt) => opt.value === temp["hardwarePrivacyLayer"]
                  );
                  if (privacyOption) {
                    setSelectedPrivacyLayer([privacyOption]);
                    tempExtended["8"][3] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer Hardware")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {pageLanguage === "fa" ? privacyOption.label : privacyOption.value}
                        </span>
                      </li>
                    );
                    ownHardwareDepsClear += "87,";
                    ownHardwareDepsNeed = ownHardwareDepsNeed.replace("87,", "");
                  }
                }

                depSetTempArr = new Set([
                  ...setGetDeps(ownHardwareDepsNeed, "8," + ownHardwareDepsClear, depSetTempArr),
                ]);
              } else if (temp["Hardware"] === "Same Hardware For All Curtains") {
                let refIndex = inputs.current["82"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["82"].getAttribute("text");
                tempValue[refIndex] = inputs.current["82"].value;
                // Match live selection header
                tempExtended["8"] = [t("Same Hardware For All Curtains")];

                if (temp["RailDesignA"]) {
                  // Store as string to match live selection (`${RailId}`) and radio checks
                  setStep81(`${temp["RailDesignA"]}`);
                  let railObject =
                    rails.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignA"]}`) || {};

                  const designLabel = railObject["DesignENName"]
                    ? pageLanguage === "fa"
                      ? convertToPersian(railObject["DesignName"])
                      : railObject["DesignENName"]
                    : pageLanguage === "fa"
                    ? temp["RailDesignFaA"]
                    : temp["RailDesignEnA"];

                  if (designLabel) {
                    tempExtended["8"][1] = (
                      <li key="1" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">{t("Design")}</span>
                        <span className="step_title_extended_list_item_text">{designLabel}</span>
                      </li>
                    );
                  }

                  if (temp["RailIdA"]) {
                    setStep82(`${temp["RailIdA"]}`);

                    let railObject2 =
                      rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdA"]}`) || {};

                    const colorLabel =
                      railObject2["ColorName"] && railObject2["ColorEnName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject2["ColorName"])
                          : railObject2["ColorEnName"]
                        : pageLanguage === "fa"
                        ? temp["RailColorFaA"]
                        : temp["RailColorEnA"];

                    if (colorLabel) {
                      tempExtended["8"][2] = (
                        <li key="2" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Finish")}</span>
                          <span className="step_title_extended_list_item_text">{colorLabel}</span>
                        </li>
                      );
                    }
                  }

                  if (Object.keys(railObject).length > 0) {
                    showRodsColor(railObject, "82", temp["RailIdA"]);
                  }

                  if (temp["BatonOptionA"]) {
                    setStep83(temp["BatonOptionA"]);
                    if (temp["BatonOptionA"] === "None") {
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("None")}</span>
                        </li>
                      );
                    } else if (temp["BatonOptionA"] === "Baton 30cm") {
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 30cm")}
                          </span>
                        </li>
                      );
                    } else if (temp["BatonOptionA"] === "Baton 45cm") {
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">
                            {t("Baton 45cm")}
                          </span>
                        </li>
                      );
                    } else {
                      tempExtended["8"][3] = (
                        <li key="3" className="step_title_extended_list_item">
                          <span className="step_title_extended_list_item_title">{t("Baton")}</span>
                          <span className="step_title_extended_list_item_text">{t("Cord")}</span>
                        </li>
                      );
                    }
                  }
                }
                depSetTempArr = new Set([
                  ...setGetDeps(
                    (temp["RailDesignA"] !== undefined ? "" : "81,") +
                      (temp["RailIdA"] !== undefined ? "" : "82,") +
                      (temp["BatonOptionA"] !== undefined ? "" : "83,"),
                    "8",
                    depSetTempArr
                  ),
                ]);
              } else {
                let refIndex = inputs.current["83"].getAttribute("ref-num");
                tempLabels[refIndex] = inputs.current["83"].getAttribute("text");
                tempValue[refIndex] = inputs.current["83"].value;
                depSetTempArr = new Set([
                  ...setGetDeps(
                    "8A,8B," + (temp["PrivacyLayer"] === "None" ? "" : "8C,"),
                    "8",
                    depSetTempArr
                  ),
                ]);
                tempExtended["8"] = [inputs.current["83"].getAttribute("text")];

                if (temp["DraperyHardware"]) {
                  setStep8A(temp["DraperyHardware"]);
                  if (temp["DraperyHardware"] === "None") {
                    let refIndex = inputs.current["8A1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8A1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8A1"].value;
                    // Match live: "نیاز ندارم." + optional select detail for "..."
                    tempExtended["8A"] = [t("None")];

                    if (temp["hardwareDrapery"]) {
                      const draperyOption = (draperiesSelect[pageLanguage] || []).find(
                        (opt) => opt.value === temp["hardwareDrapery"]
                      );
                      if (draperyOption) {
                        setSelectedDrapery([draperyOption]);
                        tempExtended["8A"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Drapery Hardware")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {pageLanguage === "fa" ? draperyOption.label : draperyOption.value}
                            </span>
                          </li>
                        );
                        depSetTempArr = new Set([...setGetDeps("", "8A,85", depSetTempArr)]);
                      } else {
                        depSetTempArr = new Set([...setGetDeps("85", "8A", depSetTempArr)]);
                      }
                    } else {
                      depSetTempArr = new Set([...setGetDeps("85", "8A", depSetTempArr)]);
                    }
                  } else {
                    let refIndex = inputs.current["8A2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8A2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8A2"].value;
                    tempExtended["8A"] = [t("drapery_Rod")];

                    if (temp["RailDesignA"]) {
                      // Store as string to match live selection (`${RailId}`) and radio checks
                      setStep8A1(`${temp["RailDesignA"]}`);
                      let railObject =
                        rails.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignA"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaA"]
                        : temp["RailDesignEnA"];

                      if (designLabel) {
                        tempExtended["8A"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdA"]) {
                        setStep8A2(`${temp["RailIdA"]}`);

                        let railObject2 =
                          rails.find((obj) => `${obj["RailId"]}` === `${temp["RailIdA"]}`) || {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaA"]
                            : temp["RailColorEnA"];

                        if (colorLabel) {
                          tempExtended["8A"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8A2", temp["RailIdA"]);
                      }

                      if (temp["BatonOptionA"]) {
                        setStep8A3(temp["BatonOptionA"]);
                        if (temp["BatonOptionA"] === "None") {
                          tempExtended["8A"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("None")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionA"] === "Baton 30cm") {
                          tempExtended["8A"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 30cm")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionA"] === "Baton 45cm") {
                          tempExtended["8A"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 45cm")}
                              </span>
                            </li>
                          );
                        } else {
                          tempExtended["8A"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Cord")}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignA"] !== undefined ? "" : "8A1,") +
                          (temp["RailIdA"] !== undefined ? "" : "8A2,") +
                          (temp["BatonOptionA"] !== undefined ? "" : "8A3,"),
                        "8A",
                        depSetTempArr
                      ),
                    ]);
                  }
                }

                if (temp["SheerHardware"]) {
                  setStep8B(temp["SheerHardware"]);
                  if (temp["SheerHardware"] === "None") {
                    let refIndex = inputs.current["8B1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B1"].value;
                    // Match live: "نیاز ندارم." + optional select detail for "..."
                    tempExtended["8B"] = [t("None")];

                    const sheerOptionPools = [
                      ...(sheersSelect[pageLanguage] || []),
                      ...(sheersSelect2[pageLanguage] || []),
                      ...(sheersSelect3[pageLanguage] || []),
                    ];

                    if (temp["hardwareSheer"]) {
                      const sheerOption = sheerOptionPools.find(
                        (opt) => opt.value === temp["hardwareSheer"]
                      );
                      if (sheerOption) {
                        setSelectedSheer([sheerOption]);
                        tempExtended["8B"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Sheer Hardware")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {pageLanguage === "fa" ? sheerOption.label : sheerOption.value}
                            </span>
                          </li>
                        );
                        depSetTempArr = new Set([...setGetDeps("", "8B,8B1,8B2", depSetTempArr)]);
                      } else {
                        depSetTempArr = new Set([...setGetDeps("8B", "", depSetTempArr)]);
                      }
                    } else {
                      depSetTempArr = new Set([...setGetDeps("8B", "", depSetTempArr)]);
                    }
                  } else if (temp["SheerHardware"] === "Track") {
                    let refIndex = inputs.current["8B2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B2"].value;
                    tempExtended["8B"] = [t("sheer_Track")];
                    let railObject = {};

                    if (temp["RailDesignB"]) {
                      setStep8B1(`${temp["RailDesignB"]}`);
                      railObject =
                        rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignB"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaB"]
                        : temp["RailDesignEnB"];

                      if (designLabel) {
                        tempExtended["8B"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      // 2208 = motorized; if rails2 not loaded yet, infer from cart power fields
                      const isMotorizedTrackB =
                        railObject["RailTypeId"] === 2208 ||
                        temp["hasPowerB"] === true ||
                        temp["hasPowerB"] === "true" ||
                        !!temp["MotorPositionB"];

                      if (isMotorizedTrackB) {
                        setTrackType8B(1);
                        if (temp["hasPowerB"] === true || temp["hasPowerB"] === "true") {
                          // UI checks step8B5 === "true" (string), not boolean
                          setStep8B5("true");

                          if (temp["MotorPositionB"]) {
                            const motorOpt = MotorPosition[pageLanguage].find(
                              (opt) => opt.value === temp["MotorPositionB"]
                            );
                            setSelectedMotorPositionB([
                              {
                                value: temp["MotorPositionB"],
                                label: motorOpt ? motorOpt.label : temp["MotorPositionB"],
                              },
                            ]);
                            tempExtended["8B"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Motor Position")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {pageLanguage === "fa"
                                    ? motorOpt
                                      ? motorOpt.label
                                      : t(temp["MotorPositionB"])
                                    : temp["MotorPositionB"]}
                                </span>
                              </li>
                            );
                          }

                          if (temp["RemoteNameB"]) {
                            setRemoteNameB(temp["RemoteNameB"]);
                            setSelectedRemoteName([
                              { value: temp["RemoteNameB"], label: temp["RemoteNameB"] },
                            ]);
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Remote_name")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {temp["RemoteNameB"]}
                                </span>
                              </li>
                            );
                          }

                          if (temp["MotorChannelsB"] && temp["MotorChannelsB"].length) {
                            const channelOpts = temp["MotorChannelsB"].map((item) => {
                              const ch = motorChannels[pageLanguage].find(
                                (opt) => opt.value === item || `${opt.value}` === `${item}`
                              );
                              return ch
                                ? { value: ch.value, label: ch.label }
                                : { value: item, label: `${item}` };
                            });
                            setSelectedMotorChannelsB(channelOpts);
                            tempExtended["8B"][4] = (
                              <li key="4" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Channel(s)")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {channelOpts
                                    .map((item) =>
                                      pageLanguage === "fa" ? item.label : item.value
                                    )
                                    .join(", ")}
                                </span>
                              </li>
                            );
                          }
                        }
                      } else {
                        // 2207 = Super/cord-draw track (colors + control position); else simple track
                        if (railObject["RailTypeId"] === 2207) {
                          setTrackType8B(2);
                        } else {
                          setTrackType8B(undefined);
                        }

                        if (temp["RailIdB"]) {
                          setStep8B2(`${temp["RailIdB"]}`);

                          let railObject2 =
                            rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) || {};

                          const colorLabel =
                            railObject2["ColorName"] && railObject2["ColorEnName"]
                              ? pageLanguage === "fa"
                                ? convertToPersian(railObject2["ColorName"])
                                : railObject2["ColorEnName"]
                              : pageLanguage === "fa"
                              ? temp["RailColorFaB"]
                              : temp["RailColorEnB"];

                          if (colorLabel) {
                            tempExtended["8B"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Finish")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {colorLabel}
                                </span>
                              </li>
                            );
                          }
                        }

                        if (Object.keys(railObject).length > 0) {
                          showRodsColor(railObject, "8B2", temp["RailIdB"]);
                        }

                        if (temp["BatonOptionB"]) {
                          setStep8B3(temp["BatonOptionB"]);
                          if (temp["BatonOptionB"] === "None") {
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("None")}
                                </span>
                              </li>
                            );
                          } else if (temp["BatonOptionB"] === "Baton 30cm") {
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 30cm")}
                                </span>
                              </li>
                            );
                          } else if (temp["BatonOptionB"] === "Baton 45cm") {
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 45cm")}
                                </span>
                              </li>
                            );
                          } else {
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Cord")}
                                </span>
                              </li>
                            );
                          }
                        }
                        if (temp["ControlPositionB"]) {
                          // Cart stores "Left Control"/"Right Control"; UI checks "Left"/"Right"
                          const controlRaw = `${temp["ControlPositionB"]}`;
                          const isLeft = controlRaw === "Left" || controlRaw.startsWith("Left");
                          const controlUi = isLeft ? "Left" : "Right";
                          setStep8B3(controlUi);
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(controlUi)}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        railObject["RailTypeId"] === 2208 ||
                          temp["hasPowerB"] === true ||
                          temp["hasPowerB"] === "true" ||
                          !!temp["MotorPositionB"]
                          ? temp["hasPowerB"] === true || temp["hasPowerB"] === "true"
                            ? temp["MotorPositionB"]
                              ? ""
                              : "8B51,"
                            : "8B5,"
                          : (temp["RailDesignB"] !== undefined ? "" : "8B1,") +
                              (temp["RailIdB"] !== undefined ? "" : "8B2,") +
                              (temp["BatonOptionB"] !== undefined ||
                              temp["ControlPositionB"] !== undefined
                                ? ""
                                : "8B3,"),
                        "8B",
                        depSetTempArr
                      ),
                    ]);
                  } else {
                    // SheerHardware === "Rod"
                    let refIndex = inputs.current["8B3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8B3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8B3"].value;
                    tempExtended["8B"] = [t("sheer_Rod")];

                    if (temp["RailDesignB"]) {
                      setStep8B1(`${temp["RailDesignB"]}`);
                      let railObject =
                        rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignB"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaB"]
                        : temp["RailDesignEnB"];

                      if (designLabel) {
                        tempExtended["8B"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdB"]) {
                        setStep8B2(`${temp["RailIdB"]}`);

                        let railObject2 =
                          rails2.find((obj) => `${obj["RailId"]}` === `${temp["RailIdB"]}`) || {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaB"]
                            : temp["RailColorEnB"];

                        if (colorLabel) {
                          tempExtended["8B"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8B2", temp["RailIdB"]);
                      }

                      if (temp["BatonOptionB"]) {
                        setStep8B3(temp["BatonOptionB"]);
                        if (temp["BatonOptionB"] === "None") {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("None")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionB"] === "Baton 30cm") {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 30cm")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionB"] === "Baton 45cm") {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 45cm")}
                              </span>
                            </li>
                          );
                        } else {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Cord")}
                              </span>
                            </li>
                          );
                        }
                      }
                      if (temp["ControlPositionB"]) {
                        setStep8B3(temp["ControlPositionB"]);
                        if (temp["ControlPositionB"] === "Left") {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Left")}
                              </span>
                            </li>
                          );
                        } else {
                          tempExtended["8B"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Right")}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignB"] !== undefined ? "" : "8B1,") +
                          (temp["RailIdB"] !== undefined ? "" : "8B2,") +
                          (temp["BatonOptionB"] !== undefined ||
                          temp["ControlPositionB"] !== undefined
                            ? ""
                            : "8B3,"),
                        "8B",
                        depSetTempArr
                      ),
                    ]);
                  }
                }

                if (temp["PrivacyLayerHardware"]) {
                  setStep8C(temp["PrivacyLayerHardware"]);
                  if (temp["PrivacyLayerHardware"] === "None") {
                    let refIndex = inputs.current["8C1"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C1"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C1"].value;
                    // Match live: "نیاز ندارم." + optional select detail for "..."
                    tempExtended["8C"] = [t("None")];

                    const privacyOptionPools = [
                      ...(privacyLayerSelect[pageLanguage] || []),
                      ...(privacyLayerSelect2[pageLanguage] || []),
                      ...(privacyLayerSelect3[pageLanguage] || []),
                    ];

                    if (temp["hardwarePrivacyLayer"]) {
                      const privacyOption = privacyOptionPools.find(
                        (opt) => opt.value === temp["hardwarePrivacyLayer"]
                      );
                      if (privacyOption) {
                        setSelectedPrivacyLayer([privacyOption]);
                        tempExtended["8C"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Privacy Layer Hardware")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {pageLanguage === "fa" ? privacyOption.label : privacyOption.value}
                            </span>
                          </li>
                        );
                        depSetTempArr = new Set([
                          ...setGetDeps("", "8C,8C1,8C2,87", depSetTempArr),
                        ]);
                      } else {
                        depSetTempArr = new Set([...setGetDeps("87", "8C", depSetTempArr)]);
                      }
                    } else {
                      depSetTempArr = new Set([...setGetDeps("87", "8C", depSetTempArr)]);
                    }
                  } else if (temp["PrivacyLayerHardware"] === "Track") {
                    let refIndex = inputs.current["8C2"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C2"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C2"].value;
                    tempExtended["8C"] = [t("pl_Track")];
                    let railObject = {};

                    if (temp["RailDesignC"]) {
                      setStep8C1(`${temp["RailDesignC"]}`);
                      railObject =
                        rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignC"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaC"]
                        : temp["RailDesignEnC"];

                      if (designLabel) {
                        tempExtended["8C"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      // 2208 = motorized; if rails3 not loaded yet, infer from cart power fields
                      const isMotorizedTrackC =
                        railObject["RailTypeId"] === 2208 ||
                        temp["hasPowerC"] === true ||
                        temp["hasPowerC"] === "true" ||
                        !!temp["MotorPositionC"];

                      if (isMotorizedTrackC) {
                        setTrackType8C(1);
                        // Electric rail has no chain/control position in header
                        setStep8C3("");

                        if (temp["hasPowerC"] === true || temp["hasPowerC"] === "true") {
                          // UI checks step8C5 === "true" (string), not boolean
                          setStep8C5("true");

                          if (temp["MotorPositionC"]) {
                            const motorOpt = MotorPosition[pageLanguage].find(
                              (opt) => opt.value === temp["MotorPositionC"]
                            );
                            setSelectedMotorPositionC([
                              {
                                value: temp["MotorPositionC"],
                                label: motorOpt ? motorOpt.label : temp["MotorPositionC"],
                              },
                            ]);
                            tempExtended["8C"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Motor Position")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {pageLanguage === "fa"
                                    ? motorOpt
                                      ? motorOpt.label
                                      : t(temp["MotorPositionC"])
                                    : temp["MotorPositionC"]}
                                </span>
                              </li>
                            );
                          }

                          if (temp["RemoteNameC"]) {
                            setRemoteNameC(temp["RemoteNameC"]);
                            setSelectedRemoteName([
                              { value: temp["RemoteNameC"], label: temp["RemoteNameC"] },
                            ]);
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Remote_name")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {temp["RemoteNameC"]}
                                </span>
                              </li>
                            );
                          }

                          if (temp["MotorChannelsC"] && temp["MotorChannelsC"].length) {
                            const channelOpts = temp["MotorChannelsC"].map((item) => {
                              const ch = motorChannels[pageLanguage].find(
                                (opt) => opt.value === item || `${opt.value}` === `${item}`
                              );
                              return ch
                                ? { value: ch.value, label: ch.label }
                                : { value: item, label: `${item}` };
                            });
                            setSelectedMotorChannelsC(channelOpts);
                            tempExtended["8C"][4] = (
                              <li key="4" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Channel(s)")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {channelOpts
                                    .map((item) =>
                                      pageLanguage === "fa" ? item.label : item.value
                                    )
                                    .join(", ")}
                                </span>
                              </li>
                            );
                          }
                        }
                      } else {
                        // 2207 = Super/cord-draw track (colors + control position); else simple track
                        if (railObject["RailTypeId"] === 2207) {
                          setTrackType8C(2);
                        } else {
                          setTrackType8C(undefined);
                        }

                        if (temp["RailIdC"]) {
                          setStep8C2(`${temp["RailIdC"]}`);

                          let railObject2 =
                            rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailIdC"]}`) || {};

                          const colorLabel =
                            railObject2["ColorName"] && railObject2["ColorEnName"]
                              ? pageLanguage === "fa"
                                ? convertToPersian(railObject2["ColorName"])
                                : railObject2["ColorEnName"]
                              : pageLanguage === "fa"
                              ? temp["RailColorFaC"]
                              : temp["RailColorEnC"];

                          if (colorLabel) {
                            tempExtended["8C"][2] = (
                              <li key="2" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Finish")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {colorLabel}
                                </span>
                              </li>
                            );
                          }
                        }

                        if (Object.keys(railObject).length > 0) {
                          showRodsColor(railObject, "8C2", temp["RailIdC"]);
                        }

                        if (temp["BatonOptionC"]) {
                          setStep8C3(temp["BatonOptionC"]);
                          if (temp["BatonOptionC"] === "None") {
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("None")}
                                </span>
                              </li>
                            );
                          } else if (temp["BatonOptionC"] === "Baton 30cm") {
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 30cm")}
                                </span>
                              </li>
                            );
                          } else if (temp["BatonOptionC"] === "Baton 45cm") {
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 45cm")}
                                </span>
                              </li>
                            );
                          } else {
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Cord")}
                                </span>
                              </li>
                            );
                          }
                        }
                        if (temp["ControlPositionC"]) {
                          // Cart stores "Left Control"/"Right Control"; UI checks "Left"/"Right"
                          const controlRaw = `${temp["ControlPositionC"]}`;
                          const isLeft = controlRaw === "Left" || controlRaw.startsWith("Left");
                          const controlUi = isLeft ? "Left" : "Right";
                          setStep8C3(controlUi);
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Control Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t(controlUi)}
                              </span>
                            </li>
                          );
                        }
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        railObject["RailTypeId"] === 2208 ||
                          temp["hasPowerC"] === true ||
                          temp["hasPowerC"] === "true" ||
                          !!temp["MotorPositionC"]
                          ? temp["hasPowerC"] === true || temp["hasPowerC"] === "true"
                            ? temp["MotorPositionC"]
                              ? ""
                              : "8C51,"
                            : "8C5,"
                          : (temp["RailDesignC"] !== undefined ? "" : "8C1,") +
                              (temp["RailIdC"] !== undefined ? "" : "8C2,") +
                              (temp["BatonOptionC"] !== undefined ||
                              temp["ControlPositionC"] !== undefined
                                ? ""
                                : "8C3,"),
                        "8C",
                        depSetTempArr
                      ),
                    ]);
                  } else {
                    // PrivacyLayerHardware === "Rod"
                    let refIndex = inputs.current["8C3"].getAttribute("ref-num");
                    tempLabels[refIndex] = inputs.current["8C3"].getAttribute("text");
                    tempValue[refIndex] = inputs.current["8C3"].value;
                    tempExtended["8C"] = [t("pl_Rod")];

                    if (temp["RailDesignC"]) {
                      setStep8C1(`${temp["RailDesignC"]}`);
                      let railObject =
                        rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailDesignC"]}`) || {};

                      const designLabel = railObject["DesignENName"]
                        ? pageLanguage === "fa"
                          ? convertToPersian(railObject["DesignName"])
                          : railObject["DesignENName"]
                        : pageLanguage === "fa"
                        ? temp["RailDesignFaC"]
                        : temp["RailDesignEnC"];

                      if (designLabel) {
                        tempExtended["8C"][1] = (
                          <li key="1" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Design")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {designLabel}
                            </span>
                          </li>
                        );
                      }

                      if (temp["RailIdC"]) {
                        setStep8C2(`${temp["RailIdC"]}`);

                        let railObject2 =
                          rails3.find((obj) => `${obj["RailId"]}` === `${temp["RailIdC"]}`) || {};

                        const colorLabel =
                          railObject2["ColorName"] && railObject2["ColorEnName"]
                            ? pageLanguage === "fa"
                              ? convertToPersian(railObject2["ColorName"])
                              : railObject2["ColorEnName"]
                            : pageLanguage === "fa"
                            ? temp["RailColorFaC"]
                            : temp["RailColorEnC"];

                        if (colorLabel) {
                          tempExtended["8C"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Finish")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {colorLabel}
                              </span>
                            </li>
                          );
                        }
                      }

                      if (Object.keys(railObject).length > 0) {
                        showRodsColor(railObject, "8C2", temp["RailIdC"]);
                      }

                      if (temp["BatonOptionC"]) {
                        setStep8C3(temp["BatonOptionC"]);
                        if (temp["BatonOptionC"] === "None") {
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("None")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionC"] === "Baton 30cm") {
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 30cm")}
                              </span>
                            </li>
                          );
                        } else if (temp["BatonOptionC"] === "Baton 45cm") {
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Baton 45cm")}
                              </span>
                            </li>
                          );
                        } else {
                          tempExtended["8C"][3] = (
                            <li key="3" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Baton")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {t("Cord")}
                              </span>
                            </li>
                          );
                        }
                      }
                      if (temp["ControlPositionC"]) {
                        const controlRaw = `${temp["ControlPositionC"]}`;
                        const isLeft = controlRaw === "Left" || controlRaw.startsWith("Left");
                        const controlUi = isLeft ? "Left" : "Right";
                        setStep8C3(controlUi);
                        tempExtended["8C"][3] = (
                          <li key="3" className="step_title_extended_list_item">
                            <span className="step_title_extended_list_item_title">
                              {t("Control Position")}
                            </span>
                            <span className="step_title_extended_list_item_text">
                              {t(controlUi)}
                            </span>
                          </li>
                        );
                      }
                    }
                    depSetTempArr = new Set([
                      ...setGetDeps(
                        (temp["RailDesignC"] !== undefined ? "" : "8C1,") +
                          (temp["RailIdC"] !== undefined ? "" : "8C2,") +
                          (temp["BatonOptionC"] !== undefined ||
                          temp["ControlPositionC"] !== undefined
                            ? ""
                            : "8C3,"),
                        "8C",
                        depSetTempArr
                      ),
                    ]);
                  }
                }
              }
              setStepSelectedLabel(tempLabels);
              setStepSelectedValue(tempValue);
            }

            if (temp["HandCurtainId"] && temp["HandCurtainNum"]) {
              setTiebackDraperyQty(+temp["HandCurtainNum"]);
              setTiebackDrapery({
                isPlus: undefined,
                HandCurtainId: temp["HandCurtainId"],
                HandCurtainNum: +temp["HandCurtainNum"],
              });
            }

            if (temp["HandCurtainId2"] && temp["HandCurtainNum2"]) {
              setTiebackSheerQty(+temp["HandCurtainNum2"]);
              setTiebackSheer({
                isPlus: undefined,
                HandCurtainId: temp["HandCurtainId2"],
                HandCurtainNum: +temp["HandCurtainNum2"],
              });
            }

            if (temp["Accessories"] && temp["Accessories"].length) {
              setCustomAcc(temp["Accessories"]);
            }

            if (temp["RoomNameEn"] || temp["WindowName"]) {
              const roomOpt = (rooms[pageLanguage] || []).find(
                (opt) => opt.value === temp["RoomNameEn"]
              );
              const roomLabel = roomOpt
                ? roomOpt.label
                : pageLanguage === "fa" && temp["RoomNameFa"]
                ? temp["RoomNameFa"]
                : temp["RoomNameEn"] || "";
              const windowName = temp["WindowName"] || "";

              if (temp["RoomNameEn"] && roomLabel) {
                depSetTempArr = new Set([...setGetDeps("", "1001", depSetTempArr)]);
                setSelectedRoomLabel([{ value: temp["RoomNameEn"], label: roomLabel }]);
                tempSelect.label = roomLabel;
                tempSelect.value = temp["RoomNameEn"];
                setRoomLabelSelect(tempSelect);
              }

              if (windowName) {
                depSetTempArr = new Set([...setGetDeps("", "1002", depSetTempArr)]);
                setRoomLabelText(windowName);
              }

              // Match live header: "اتاق نشیمن - شرح پنجره"
              const headerText =
                roomLabel && windowName ? roomLabel + " - " + windowName : roomLabel || windowName;
              if (headerText) {
                tempLabels["10"] = headerText;
              }
            }

            if (temp["moreInfoInput"] && temp["moreInfoInput"] !== "") {
              setMoreInfoInput(temp["moreInfoInput"]);
            }

            if (
              temp["ZipCode"] &&
              temp["ZipCode"] !== "" &&
              temp["InstallAmount"] &&
              temp["InstallAmount"] > 0 &&
              temp["TransportationAmount"] &&
              temp["TransportationAmount"] > 0
            ) {
              setZipcode(temp["ZipCode"]);
              setZipcodeButton(true);
              setHasInstall(true);
              setZipcodeChecked("true");
              setInstallPrice(temp["InstallAmount"]);
              setTransportPrice(temp["TransportationAmount"]);
            } else if (temp["ZipCode"] && temp["ZipCode"] !== "") {
              setZipcode(temp["ZipCode"]);
              setZipcodeButton(true);
              setHasInstall(true);
              setZipcodeChecked("true");
            }

            if (temp["uploadedImagesURL"] && temp["uploadedImagesURL"].length > 0) {
              const { images, pdfs } = convertTempToFiles(temp);
              setUploadedImages(images);
              setUploadedPDFs(pdfs);
              sessionStorage.setItem("backup_uploadedImages", JSON.stringify(images));
              sessionStorage.setItem("backup_uploadedPDFs", JSON.stringify(pdfs));
              let tempArrayNames = [];
              let tempArray = [];

              let promise3 = new Promise((resolve, reject) => {
                temp["uploadedImagesFile"].forEach((obj, index) => {
                  tempArrayNames[index] = (
                    <li className="uploaded_name_item" key={index}>
                      <i className="fa fa-file" />
                      <span className="uploaded_name_item_text">
                        {obj.replace(/\.[^/.]+$/, "")}
                      </span>
                      <span
                        className="uploaded_name_item_x"
                        onClick={() => {
                          setDeleteUploaded(temp["uploadedImagesURL"][index], index, 2);
                        }}
                      >
                        X
                      </span>
                    </li>
                  );

                  tempArray[index] = (
                    <li className="uploaded_image_item" key={index}>
                      <img
                        src={imgUrl(temp["uploadedImagesURL"][index])}
                        className="img-fluid"
                        alt=""
                      />
                    </li>
                  );

                  if (index === temp["uploadedImagesFile"].length - 1) {
                    resolve();
                  }
                });
              });

              promise3.then(() => {
                setUploadedImagesNamesList(tempArrayNames);
                setUploadedImagesList(tempArray);
              });
            }
            if (temp["uploadedPDFURL"] && temp["uploadedPDFURL"].length > 0) {
              setUploadedPDFURL(temp["uploadedPDFURL"]);
              setUploadedPDFFile(temp["uploadedPDFFile"]);
              let tempArrayNames = [];

              let promise3 = new Promise((resolve, reject) => {
                temp["uploadedPDFFile"].forEach((obj, index) => {
                  tempArrayNames[index] = (
                    <li className="uploaded_name_item" key={index}>
                      <i className="fa fa-file" />
                      <span className="uploaded_name_item_text">
                        {obj.replace(/\.[^/.]+$/, "")}
                      </span>
                      <span
                        className="uploaded_name_item_x"
                        onClick={() => {
                          setDeleteUploaded(temp["uploadedPDFURL"][index], index, 1);
                        }}
                      >
                        X
                      </span>
                    </li>
                  );
                  if (index === temp["uploadedPDFFile"].length - 1) {
                    resolve();
                  }
                });
              });

              promise3.then(() => {
                setUploadedPDFNameList(tempArrayNames);
              });
            }

            // setTimeout(() => {

            // }, 300);

            setDepSet(depSetTempArr);
            setSelectCustomValues(selectValues);
            setStepSelectedLabel(tempLabels);
            setStepSelectedValue(tempValue);
            setExtendedTitle(tempExtended);
            setPageLoad(false);
          }, 300);
        });
    });
  }

  function filterSelected(filter, filterId, isDelete, step = "1") {
    const isStep2 = step === "2";
    const colors = isStep2 ? filterColors2 : filterColors;
    const patterns = isStep2 ? filterPatterns2 : filterPatterns;
    const types = isStep2 ? filterTypes2 : filterTypes;
    const prices = isStep2 ? filterPrices2 : filterPrices;
    const setColors = isStep2 ? setFilterColors2 : setFilterColors;
    const setPatterns = isStep2 ? setFilterPatterns2 : setFilterPatterns;
    const setTypes = isStep2 ? setFilterTypes2 : setFilterTypes;
    const setPrices = isStep2 ? setFilterPrices2 : setFilterPrices;

    if (filter === "colors") {
      if (isDelete) {
        if (!colors.includes(filterId)) setColors([...colors, filterId]);
      } else {
        setColors(colors.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "patterns") {
      if (isDelete) {
        if (!patterns.includes(filterId)) setPatterns([...patterns, filterId]);
      } else {
        setPatterns(patterns.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "types") {
      if (isDelete) {
        if (!types.includes(filterId)) setTypes([...types, filterId]);
      } else {
        setTypes(types.filter((id1) => id1 !== filterId));
      }
    } else if (filter === "prices") {
      if (isDelete) {
        if (!prices.includes(filterId)) setPrices([...prices, filterId]);
      } else {
        setPrices(prices.filter((id1) => id1 !== filterId));
      }
    }
  }

  const addFailedFileToParent = createAddFailedFileToParent({
    setUploadedPDFs,
    setUploadedImages,
  });

  const topScroll = createTopScroll({ isLoggedIn, modalTopRef });

  useEffect(() => {
    if (!pageLoad && !rodsLoad && !rodsLoad2 && !mesLoad) {
      if (step6 !== "") {
        // Do not wipe restored panel layout after refresh when cart already has panels
        const hasRestoredPanels =
          cartValues["PanelTypeA"] !== undefined ||
          cartValues["PanelTypeB"] !== undefined ||
          cartValues["PanelTypeC"] !== undefined;
        if (!hasRestoredPanels) {
          let tempExtended = extendedTitle;
          if (tempExtended["6"].length) {
            tempExtended["6"].splice(1, 3);
          }
          setExtendedTitle(tempExtended);
          setStep61("");
          setStep6A("");
          setStep6B("");
          setStep6C("");
          if (step6 === "Same Style For All Curtains") {
            setCart("", "", "PanelTypeA,PanelTypeB,PanelTypeC");
          } else {
            setCart("", "", "PanelTypeA,PanelTypeB,PanelTypeC");
          }
        }
      }
      if (widthCart && parseInt(widthCart) > 0) {
        getRails(parseInt(widthCart));
        if (sheersModelId !== "") getSheersRails(sheersModelId, parseInt(widthCart));
        if (sheersModelId2 !== "") getSheersRails(sheersModelId2, parseInt(widthCart), true);
      }
    }
    if (mesLoad) {
      setMesLoad(false);
    }
  }, [widthCart]);

  useEffect(() => {
    if (fabricSelected.selectedFabricId && fabricSelected.selectedFabricId !== 0 && !pageLoad) {
      setFabricLoading(true);
      fabricClicked(fabricSelected.selectedPhoto, fabricSelected.selectedHasTrim);
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["1"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? fabricSelected.selectedTextFa + " / " + fabricSelected.selectedColorFa
          : fabricSelected.selectedTextEn + " / " + fabricSelected.selectedColorEn;
      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue["1"] = fabricSelected.selectedFabricId;
      setStepSelectedLabel(tempLabels);
      setStepSelectedValue(tempValue);
      setCart(
        "FabricId",
        `${fabricSelected.selectedFabricId}`,
        "",
        "FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl",
        [
          fabricSelected.selectedTextFa,
          fabricSelected.selectedTextEn,
          fabricSelected.selectedColorEn,
          fabricSelected.selectedColorFa,
          fabricSelected.selectedPhoto,
        ]
      );
      setStep1(fabricSelected.selectedFabricId.toString());
      let tempExtended = extendedTitle;
      tempExtended["1"][0] = tempLabels["1"];
      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["1"] !== "" && requiredStep["1"]) {
        temp["1"] = false;
      }
      setRequiredStep(temp);
      if (step1Check !== `${fabricSelected.selectedDesignCode}`) {
        setStep1Check("");
        setStep1Border("");
        setStep1BorderRadio("");
        setStep1Trim("");
        tempExtended["1"].splice(1, 1);
        setDeps("", "1");
      } else {
        setDeps("", "1");
      }
      setExtendedTitle(tempExtended);
    }
  }, [fabricSelected]);

  useEffect(() => {
    if (fabricSelected2.selectedFabricId && fabricSelected2.selectedFabricId !== 0) {
      sheerFabricSelectionRef.current = {
        fabricId: String(fabricSelected2.selectedFabricId),
        designCode: String(fabricSelected2.selectedDesignCode || ""),
      };
    } else {
      sheerFabricSelectionRef.current = { fabricId: "", designCode: "" };
    }
  }, [fabricSelected2]);

  useEffect(() => {
    if (fabricSelected2.selectedFabricId && fabricSelected2.selectedFabricId !== 0 && !pageLoad) {
      setFabricLoading(true);

      fabricClicked(fabricSelected2.selectedPhoto, fabricSelected2.selectedHasTrim);
      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["2"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? fabricSelected2.selectedTextFa + " / " + fabricSelected2.selectedColorFa
          : fabricSelected2.selectedTextEn + " / " + fabricSelected2.selectedColorEn;
      let tempValue = JSON.parse(JSON.stringify(stepSelectedValue));
      tempValue["2"] = fabricSelected2.selectedFabricId;
      setStepSelectedLabel(tempLabels);
      setStepSelectedValue(tempValue);
      setCart(
        "FabricId2",
        `${fabricSelected2.selectedFabricId}`,
        fabricSelected2.selectedLeadRequired ? "" : "leadId,hasLead",
        "FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2" +
          (fabricSelected2.selectedLeadRequired ? ",leadId,hasLead" : ""),
        [
          fabricSelected2.selectedTextFa,
          fabricSelected2.selectedTextEn,
          fabricSelected2.selectedColorEn,
          fabricSelected2.selectedColorFa,
          fabricSelected2.selectedPhoto,
          fabricSelected2.selectedFabricId.toString(),
          "Included",
        ]
      );
      setStep2(fabricSelected2.selectedFabricId.toString());
      let tempExtended = extendedTitle;
      tempExtended["2"] = [tempLabels["2"]];
      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2"] !== "" && requiredStep["2"]) {
        temp["2"] = false;
      }
      setRequiredStep(temp);
      if (step2Check !== `${fabricSelected2.selectedDesignCode}`) {
        setStep2Check("");
        setStep2Check2("");
        setStep2Border("");
        setStep2BorderRadio("");
        setStep2Trim("");
        tempExtended["2"].splice(1, 1);
        setDeps("", "2");
      } else {
        setDeps("", "2");
      }
      if (fabricSelected2.selectedLeadRequired) {
        tempExtended["2"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Lead Weight")}</span>
            <span className="step_title_extended_list_item_text">
              {location.pathname
                .split("")
                .slice(1, 3)
                .join("") === "fa"
                ? "دارد"
                : "Included"}
            </span>
          </li>
        );
      }
      setExtendedTitle(tempExtended);
    }
  }, [fabricSelected2]);

  useEffect(() => {
    if (borderSelected.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId",
        `${borderSelected.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl",
        [
          borderSelected.selectedTextFa,
          borderSelected.selectedTextEn,
          borderSelected.selectedColorEn,
          borderSelected.selectedColorFa,
          borderSelected.selectedPhoto,
        ]
      );

      setStep1Border(borderSelected.selectedFabricId.toString());
      setStep1Trim("");
      setDeps("111", "11", 1);

      let tempExtended = extendedTitle;
      tempExtended["1"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Border")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? borderSelected.selectedTextFa + " / " + borderSelected.selectedColorFa
              : CapitalizeAllWords(
                  borderSelected.selectedTextEn + " / " + borderSelected.selectedColorEn
                )}
          </span>
        </li>
      );
      setExtendedTitle(tempExtended);
    }
  }, [borderSelected]);

  useEffect(() => {
    if (trimSelected.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId",
        `${trimSelected.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl",
        [
          trimSelected.selectedTextFa,
          trimSelected.selectedTextEn,
          trimSelected.selectedColorEn,
          trimSelected.selectedColorFa,
          trimSelected.selectedPhoto,
        ]
      );

      setStep1Border("");
      setStep1Trim(trimSelected.selectedFabricId.toString());
      setDeps("", "11,111", 1);

      let tempExtended = extendedTitle;
      tempExtended["1"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Trim")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? trimSelected.selectedTextFa + " / " + trimSelected.selectedColorFa
              : CapitalizeAllWords(
                  trimSelected.selectedTextEn + " / " + trimSelected.selectedColorEn
                )}
          </span>
        </li>
      );
      tempExtended["1"].splice(2, 1);
      setExtendedTitle(tempExtended);
    }
  }, [trimSelected]);

  useEffect(() => {
    if (borderSelected2.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId2",
        `${borderSelected2.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2",
        [
          borderSelected2.selectedTextFa,
          borderSelected2.selectedTextEn,
          borderSelected2.selectedColorEn,
          borderSelected2.selectedColorFa,
          borderSelected2.selectedPhoto,
        ]
      );

      setStep2Border(borderSelected2.selectedFabricId.toString());
      setStep2Trim("");
      setDeps("211", "21", 1);

      let tempExtended = extendedTitle;
      tempExtended["2"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Border")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? borderSelected2.selectedTextFa + " / " + borderSelected2.selectedColorFa
              : CapitalizeAllWords(
                  borderSelected2.selectedTextEn + " / " + borderSelected2.selectedColorEn
                )}
          </span>
        </li>
      );
      setExtendedTitle(tempExtended);
    }
  }, [borderSelected2]);

  useEffect(() => {
    if (trimSelected2.selectedFabricId && !pageLoad) {
      setCart(
        "BorderOrTrimId2",
        `${trimSelected2.selectedFabricId}`,
        "",
        "BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2",
        [
          trimSelected2.selectedTextFa,
          trimSelected2.selectedTextEn,
          trimSelected2.selectedColorEn,
          trimSelected2.selectedColorFa,
          trimSelected2.selectedPhoto,
        ]
      );

      setStep2Border("");
      setStep2Trim(trimSelected2.selectedFabricId.toString());
      setDeps("", "21,211", 1);

      let tempExtended = extendedTitle;
      tempExtended["2"][1] = (
        <li key="1" className="step_title_extended_list_item">
          <span className="step_title_extended_list_item_title">{t("Decorative Trim")}</span>
          <span className="step_title_extended_list_item_text">
            {location.pathname
              .split("")
              .slice(1, 3)
              .join("") === "fa"
              ? trimSelected2.selectedTextFa + " / " + trimSelected2.selectedColorFa
              : CapitalizeAllWords(
                  trimSelected2.selectedTextEn + " / " + trimSelected2.selectedColorEn
                )}
          </span>
        </li>
      );
      tempExtended["2"].splice(2, 1);
      setExtendedTitle(tempExtended);
    }
  }, [trimSelected2]);

  useEffect(() => {
    if (sheersSelected.selectedFabricId && sheersSelected.selectedFabricId !== 0 && !pageLoad) {
      setCart(
        "SheersId1",
        `${sheersSelected.selectedFabricId}`,
        "",
        "SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl",
        [
          sheersSelected.selectedTextFa,
          sheersSelected.selectedTextEn,
          sheersSelected.selectedColorEn,
          sheersSelected.selectedColorFa,
          sheersSelected.selectedPhoto,
        ]
      );

      setDeps("", "2B1");
      setStep2B1(sheersSelected.selectedFabricId.toString());

      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["2B"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? sheersSelected.selectedTextFa + " / " + sheersSelected.selectedColorFa
          : sheersSelected.selectedTextEn + " / " + sheersSelected.selectedColorEn;
      setStepSelectedLabel(tempLabels);

      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2B"] !== "" && requiredStep["2B"]) {
        temp["2B"] = false;
      }
      setRequiredStep(temp);
    }
  }, [sheersSelected]);

  useEffect(() => {
    if (sheersSelected2.selectedFabricId && sheersSelected2.selectedFabricId !== 0 && !pageLoad) {
      setCart(
        "SheersId2",
        `${sheersSelected2.selectedFabricId}`,
        "",
        "SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl",
        [
          sheersSelected2.selectedTextFa,
          sheersSelected2.selectedTextEn,
          sheersSelected2.selectedColorEn,
          sheersSelected2.selectedColorFa,
          sheersSelected2.selectedPhoto,
        ]
      );
      setDeps("", "2B1");
      setStep2B1(sheersSelected2.selectedFabricId.toString());

      let tempLabels = JSON.parse(JSON.stringify(stepSelectedLabel));
      tempLabels["2B"] =
        location.pathname
          .split("")
          .slice(1, 3)
          .join("") === "fa"
          ? sheersSelected2.selectedTextFa + " / " + sheersSelected2.selectedColorFa
          : sheersSelected2.selectedTextEn + " / " + sheersSelected2.selectedColorEn;
      setStepSelectedLabel(tempLabels);

      let temp = JSON.parse(JSON.stringify(requiredStep));
      if (tempLabels["2B"] !== "" && requiredStep["2B"]) {
        temp["2B"] = false;
      }
      setRequiredStep(temp);
    }
  }, [sheersSelected2]);

  useEffect(() => {
    if (!pageLoad) {
      if (step1BorderRadio !== "") {
        let tempExtended = extendedTitle;
        tempExtended["1"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Border Position")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "en"
                ? CapitalizeAllWords(t(step1BorderRadio))
                : t(step1BorderRadio)}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
        setCart("borderPosition", step1BorderRadio);
        setDeps("", "111", 2);
      } else {
        let tempExtended = extendedTitle;
        tempExtended["1"].splice(2, 1);
        setExtendedTitle(tempExtended);
      }
    }
  }, [step1BorderRadio]);

  useEffect(() => {
    if (!pageLoad) {
      if (step2BorderRadio !== "") {
        let tempExtended = extendedTitle;
        tempExtended["2"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Border Position")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "en"
                ? CapitalizeAllWords(t(step2BorderRadio))
                : t(step2BorderRadio)}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
        setCart("borderPosition2", step2BorderRadio);
        setDeps("", "211", 2);
      } else if (!fabricSelected2.selectedLeadRequired) {
        let tempExtended = extendedTitle;
        tempExtended["2"].splice(2, 1);
        setExtendedTitle(tempExtended);
      }
    }
  }, [step2BorderRadio]);

  useEffect(() => {
    if (!firstRender.current) {
      // getCart().then((temp) => {
      if (Object.keys(fabrics).length) {
        setTimeout(() => {
          renderFabrics(bag);
        }, 100);
      } else {
        setFabricsList([]);
      }
    }
  }, [step1]);

  useEffect(() => {
    if (Object.keys(fabrics).length) {
      renderFabrics(bag);
    } else {
      setFabricsList([]);
    }
  }, [step1Check, step1Border, step1BorderRadio, step1Trim]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected.selectedFabricId && step1Check !== "") {
        setDeps("11", "");
      } else if (fabricSelected.selectedFabricId) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["1"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setDeps("", "11,111", 1);
          setCart(
            "",
            "",
            "BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
        }, 500);
      }
    }
  }, [step1Check]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected2.selectedFabricId && step2Check !== "") {
        setDeps("21", "");
      } else if (fabricSelected2.selectedFabricId) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["2"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setDeps("", "21,211", 1);
          setCart(
            "",
            "",
            "BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
        }, 500);
      }
    }
  }, [step2Check]);

  useEffect(() => {
    if (!pageLoad) {
      if (fabricSelected2.selectedFabricId && step2Check2 !== "") {
        setCart("leadId", fabricSelected2.selectedFabricId.toString(), "", "hasLead", ["Yes"]);
        let tempExtended = extendedTitle;
        tempExtended["2"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Lead Weight")}</span>
            <span className="step_title_extended_list_item_text">
              {location.pathname
                .split("")
                .slice(1, 3)
                .join("") === "fa"
                ? "موجود"
                : "Yes"}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      } else if (fabricSelected2.selectedFabricId && !fabricSelected2.selectedLeadRequired) {
        setTimeout(() => {
          let tempExtended = extendedTitle;
          tempExtended["2"].splice(1, 2);
          setExtendedTitle(tempExtended);
          setCart("", "", "leadId,hasLead");
        }, 500);
      }
    }
  }, [step2Check2]);

  useEffect(() => {
    if (Object.keys(fabrics2).length) {
      renderFabrics2(bag);
    } else {
      setFabricsList2([]);
    }
  }, [step2Check2, step2Check, step2Border, step2BorderRadio, step2Trim]);

  useEffect(() => {
    if (!firstRender.current) {
      if (Object.keys(fabrics2).length) {
        setTimeout(() => {
          renderFabrics2(bag);
        }, 100);
      } else {
        setFabricsList2([]);
      }
    }
  }, [step2]);

  useEffect(() => {
    if (!firstRender.current) {
      if (Object.keys(sheers).length || Object.keys(sheers2).length) {
        setTimeout(() => {
          renderSheers(bag);
          renderSheers2(bag);
        }, 100);
      } else {
        setSheersList([]);
        setSheersList2([]);
      }
    }
  }, [step2B1]);

  useEffect(() => {
    if (fabricError && !accordionActiveKey.startsWith("3") && Object.keys(errorData).length) {
      let fabricBoard = undefined;
      let sheerBoard = undefined;
      let temp1 = {};
      let temp2 = {};
      if (errorData["SewingOrderDetails"] && errorData["SewingOrderDetails"].length) {
        setFabricsBoard(
          errorData["SewingOrderDetails"]
            .filter((obj) => ["2302", "2303"].includes(obj["CurtainPartId"].toString()))
            .map(({ CurtainPartId, FabricId, IsBoard, BoardNum }) => ({
              CurtainPartId,
              FabricId,
              IsBoard,
              BoardNum,
            }))
        );
        temp1 = errorData["SewingOrderDetails"].find(
          (obj) => obj["FabricId"] === fabricSelected.selectedFabricId
        );
        temp2 = errorData["SewingOrderDetails"].find(
          (obj) => obj["FabricId"] === fabricSelected2.selectedFabricId
        );
      }

      if (fabricSelected.selectedFabricId && Object.keys(temp1).length) {
        if (temp1["CanSewing"] === false) {
          fabricBoard = 1;
        } else if (temp1["IsBoard"] && temp1["BoardNum"] > 1) {
          fabricBoard = 0;
        }
      }
      if (fabricSelected2.selectedFabricId && Object.keys(temp2).length) {
        if (temp2["CanSewing"] === false) {
          sheerBoard = 1;
        } else if (temp2["IsBoard"] && temp2["BoardNum"] > 1) {
          sheerBoard = 0;
        }
      }

      setFabricError(false);
      setErrorData({});

      if (fabricBoard !== undefined || sheerBoard !== undefined) {
        if (changeFabricsGuardRef.current) {
          return;
        }
        changeFabricsGuardRef.current = true;
        if (fabricBoard === 1 && sheerBoard === 1) {
          setAccordionActiveKey2("");
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });

          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1,2", "11,111,21,211");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition,FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "1,2");
          setStep1("");

          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setExtendedTitle(tempExtended);
          setStep2("");
        } else if (fabricBoard === 1) {
          setAccordionActiveKey2("1");
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1", "11,111");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
          selectChanged(undefined, "1");
          setExtendedTitle(tempExtended);
          setStep1("");
        } else if (sheerBoard === 1) {
          setAccordionActiveKey2("2");
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setDeps("2", "21,211", 1);
          setCart(
            "",
            "",
            "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "2");
          setExtendedTitle(tempExtended);
          setStep2("");
        }

        if (fabricBoard !== undefined) {
          setFabricBoard(fabricBoard);
        }
        if (sheerBoard !== undefined) {
          setSheerBoard(sheerBoard);
        }
        setTimeout(() => {
          modalHandleShow("changeFabrics");
        }, 2000);
      }
    }
  }, [fabricError, errorData, accordionActiveKey]);

  useEffect(() => {
    if (fabricsBoard.length && !pageLoad && !boardLoad) {
      let fabricRail = undefined;
      let sheerRail = undefined;
      if (fabricSelected.selectedFabricId) {
        let temp = fabricsBoard.find((obj) => obj["FabricId"] === fabricSelected.selectedFabricId);

        if (temp && Object?.keys(temp)?.length) {
          if (temp["IsBoard"] && temp["BoardNum"] > 1) {
            fabricRail = 0;
          }
        }
      }
      if (fabricSelected2.selectedFabricId) {
        let temp = fabricsBoard.find((obj) => obj["FabricId"] === fabricSelected2.selectedFabricId);

        if (temp && Object?.keys(temp)?.length) {
          if (temp["IsBoard"] && temp["BoardNum"] > 1) {
            sheerRail = 0;
          }
        }
      }
      if (modals["changeFabrics"] || fabricBoard || sheerBoard) {
        setFabricIsBoard(fabricRail === 0);
        setSheerIsBoard(sheerRail === 0);
      } else {
        if (fabricRail === 0 && sheerRail === 0) {
          modalHandleShow("fabricHasLine3");
        } else if (fabricRail === 0 && sheerRail === undefined) {
          modalHandleShow("fabricHasLine");
        } else if (fabricRail === undefined && sheerRail === 0) {
          modalHandleShow("fabricHasLine2");
        }
      }
    }

    if (boardLoad) {
      setBoardLoad(false);
    }
  }, [JSON.stringify(fabricsBoard)]);

  useEffect(() => {
    if (heightCart === undefined) {
      setHeightCart2(undefined);
    }
  }, [heightCart]);

  useEffect(() => {
    if (fabricIsBoard) {
      renderFabrics(bag, undefined, fabricIsBoard);
      setFabricIsBoard(false);
    }
  }, [fabricIsBoard]);

  useEffect(() => {
    if (sheerIsBoard) {
      renderFabrics2(bag, undefined, sheerIsBoard);
      setSheerIsBoard(false);
    }
  }, [sheerIsBoard]);

  useEffect(() => {
    let arr = [
      width3C,
      height3E,
      left,
      right,
      mount,
      rodWidth,
      ceilingToFloor,
      ceilingToFloor1,
      ceilingToFloor2,
      ceilingToFloor3,
      ceilingToWindow1,
      ceilingToWindow2,
      ceilingToWindow3,
      windowToFloor,
      rodToFloor,
      rodToBottom,
    ];
    if (arr.every((el) => el === undefined)) {
      setAnyMeasurements(false);
    } else {
      setAnyMeasurements(true);
    }
  }, [
    width3C,
    height3E,
    left,
    right,
    mount,
    rodWidth,
    ceilingToFloor,
    ceilingToFloor1,
    ceilingToFloor2,
    ceilingToFloor3,
    ceilingToWindow1,
    ceilingToWindow2,
    ceilingToWindow3,
    windowToFloor,
    rodToFloor,
    rodToBottom,
  ]);

  useEffect(() => {
    if (pageLanguage !== "") {
      if (
        Object.keys(rods).length ||
        Object.keys(rods2).length ||
        Object.keys(rods3).length ||
        Object.keys(tracks).length ||
        Object.keys(tracks2).length ||
        Object.keys(tracks3).length
      ) {
        renderRods();
        renderTracks();
      } else {
        setRodsList([]);
        setRodsList2([]);
        setRodsList3([]);
        setRodsList4([]);
        setTracksList([]);
        setTracksList2([]);
      }
    }
  }, [step81, step8A1, step8B1, step8C1]);

  function showRodsColor(railObject, stepNum, selectedColorId) {
    let pageLanguage = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    const rodList = [];
    let promiseArr = [];
    const selectedId =
      selectedColorId !== undefined && selectedColorId !== null && selectedColorId !== ""
        ? selectedColorId
        : stepNum === "82"
        ? step82
        : stepNum === "8A2"
        ? step8A2
        : stepNum === "8B2"
        ? step8B2
        : step8C2;
    if (Object.keys(railObject).length > 0) {
      if (stepNum === "82") {
        const colorOptions = rods[railObject["DesignCode"]];
        if (colorOptions && colorOptions.length) {
          colorOptions.forEach((obj, index) => {
            promiseArr[index] = new Promise((resolve, reject) => {
              let ColorName = obj["ColorName"];
              let ColorEnName = obj["ColorEnName"];
              let RailId = obj["RailId"];
              let PhotoObj = {};
              PhotoObj =
                obj["Photos"].filter((obj) => {
                  return obj["PhotoTypeId"] === 4709;
                })[0] || PhotoObj;
              let PhotoPath = PhotoObj["PhotoUrl"] || "";

              rodList.push(
                <div className="box33" key={index}>
                  <div className="radio_group">
                    <label className="radio_container">
                      <input
                        className="radio"
                        type="radio"
                        text={pageLanguage === "fa" ? ColorName : ColorEnName}
                        value={index}
                        name="step82"
                        ref-num={"8"}
                        id={"82" + index}
                        outline="true"
                        checked={`${selectedId}` === `${RailId}`}
                        onChange={(e) => {
                          setStep82(`${RailId}`);
                        }}
                        ref={(ref) => (inputs.current["82" + index] = ref)}
                      />
                      <div className="frame_img">
                        <img
                          src={imgUrl(PhotoPath)}
                          className="img-fluid bracket_color_img"
                          alt=""
                        />
                      </div>
                    </label>
                    <div className="radio_group_name_container">
                      <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                    </div>
                  </div>
                </div>
              );
              resolve();
            });
          });
        }
      } else if (stepNum === "8A2") {
        const colorOptions = rods[railObject["DesignCode"]];
        if (colorOptions && colorOptions.length) {
          colorOptions.forEach((obj, index) => {
            promiseArr[index] = new Promise((resolve, reject) => {
              let ColorName = obj["ColorName"];
              let ColorEnName = obj["ColorEnName"];
              let RailId = obj["RailId"];
              let PhotoObj = {};
              PhotoObj =
                obj["Photos"].filter((obj) => {
                  return obj["PhotoTypeId"] === 4709;
                })[0] || PhotoObj;
              let PhotoPath = PhotoObj["PhotoUrl"] || "";

              rodList.push(
                <div className="box33" key={index}>
                  <div className="radio_group">
                    <label className="radio_container">
                      <input
                        className="radio"
                        type="radio"
                        text={pageLanguage === "fa" ? ColorName : ColorEnName}
                        value={index}
                        name="step8A2"
                        ref-num={"8A2"}
                        id={"8A2" + index}
                        outline="true"
                        checked={`${selectedId}` === `${RailId}`}
                        onChange={(e) => {
                          setStep8A2(`${RailId}`);
                        }}
                        ref={(ref) => (inputs.current["8A2" + index] = ref)}
                      />
                      <div className="frame_img">
                        <img
                          src={imgUrl(PhotoPath)}
                          className="img-fluid bracket_color_img"
                          alt=""
                        />
                      </div>
                    </label>
                    <div className="radio_group_name_container">
                      <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                    </div>
                  </div>
                </div>
              );
              resolve();
            });
          });
        }
      } else if (stepNum === "8B2") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods2;
        } else {
          tempRails = tracks2;
        }
        const colorOptions = tempRails[railObject["DesignCode"]];
        if (colorOptions && colorOptions.length) {
          colorOptions.forEach((obj, index) => {
            promiseArr[index] = new Promise((resolve, reject) => {
              let ColorName = obj["ColorName"];
              let ColorEnName = obj["ColorEnName"];
              let RailId = obj["RailId"];
              let PhotoObj = {};
              PhotoObj =
                obj["Photos"].filter((obj) => {
                  return obj["PhotoTypeId"] === 4709;
                })[0] || PhotoObj;
              let PhotoPath = PhotoObj["PhotoUrl"] || "";

              rodList.push(
                <div className="box33" key={index}>
                  <div className="radio_group">
                    <label className="radio_container">
                      <input
                        className="radio"
                        type="radio"
                        text={pageLanguage === "fa" ? ColorName : ColorEnName}
                        value={index}
                        name="step8B2"
                        ref-num={"8B2"}
                        id={"8B2" + index}
                        outline="true"
                        checked={`${selectedId}` === `${RailId}`}
                        onChange={(e) => {
                          setStep8B2(`${RailId}`);
                        }}
                        ref={(ref) => (inputs.current["8B2" + index] = ref)}
                      />
                      <div className="frame_img">
                        <img
                          src={imgUrl(PhotoPath)}
                          className={
                            `${selectedId}` === `${RailId}`
                              ? "img-fluid bracket_color_img img-fluid_checked"
                              : "img-fluid bracket_color_img"
                          }
                          alt=""
                        />
                      </div>
                    </label>
                    <div className="radio_group_name_container">
                      <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                    </div>
                  </div>
                </div>
              );
              resolve();
            });
          });
        }
      } else if (stepNum === "8C2") {
        let tempRails = {};
        if (railObject["RailCategoryId"] === 5303) {
          tempRails = rods3;
        } else {
          tempRails = tracks3;
        }
        tempRails[railObject["DesignCode"]].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            let ColorName = obj["ColorName"];
            let ColorEnName = obj["ColorEnName"];
            let RailId = obj["RailId"];
            let PhotoObj = {};
            PhotoObj =
              obj["Photos"].filter((obj) => {
                return obj["PhotoTypeId"] === 4709;
              })[0] || PhotoObj;
            let PhotoPath = PhotoObj["PhotoUrl"] || "";

            rodList.push(
              <div className="box33" key={index}>
                <div className="radio_group">
                  <label className="radio_container">
                    <input
                      className="radio"
                      type="radio"
                      text={pageLanguage === "fa" ? ColorName : ColorEnName}
                      value={index}
                      name="step8C2"
                      ref-num={"8C2"}
                      id={"8C2" + index}
                      outline="true"
                      checked={step8C2 === `${RailId}`}
                      onChange={(e) => {
                        setStep8C2(`${RailId}`);
                      }}
                      ref={(ref) => (inputs.current["8C2" + index] = ref)}
                    />
                    <div className="frame_img">
                      <img
                        src={imgUrl(PhotoPath)}
                        className={
                          step8C2 === `${RailId}`
                            ? "img-fluid bracket_color_img img-fluid_checked"
                            : "img-fluid bracket_color_img"
                        }
                        alt=""
                      />
                    </div>
                  </label>
                  <div className="radio_group_name_container">
                    <h1>{pageLanguage === "fa" ? ColorName : ColorEnName}</h1>
                  </div>
                </div>
              </div>
            );
            resolve();
          });
        });
      }
    }

    Promise.all(promiseArr).then(() => {
      if (Object.keys(railObject).length > 0) {
        if (stepNum === "82") {
          setRodsColorList(rodList);
        } else if (stepNum === "8A2") {
          setRodsColorList2(rodList);
        } else if (stepNum === "8B2") {
          setRodsColorList3(rodList);
        } else if (stepNum === "8C2") {
          setRodsColorList4(rodList);
        }
      }
    });
  }

  useEffect(() => {
    // Only wipe on live Rod/Track head changes (pageLoad === false).
    // Skip mount (undefined) and refresh restore (true).
    if (pageLoad !== false) return;
    if (step6 === "Customize Style Per Curtain") {
      setHardwareNextStep("9");
      setStep8("");
      let tempExtended = extendedTitle;
      tempExtended["8"] = [];
      tempExtended["8A"] = [];
      tempExtended["8B"] = [];
      tempExtended["8C"] = [];
      setExtendedTitle(tempExtended);
      selectChanged("", "8,8A,8B,8C");
      setDeps(
        "8",
        "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
      );
      setCart(
        "",
        "",
        "Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
      );
    }
  }, [step6BHead, step6CHead]);

  useEffect(() => {
    if (step81 !== "" && !pageLoad) {
      setDeps("812,813", "81,82,83,809");
      setStep82("");
      setStep83("");
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step81}`) || {};

      if (railObject["DesignENName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }
      setCart(
        undefined,
        undefined,
        "RailIdA,RailColorFaA,RailColorEnA,RailIdB,RailColorFaB,RailColorEnB,RailIdC,RailColorFaC,RailColorEnC",
        "RailDesignA,RailDesignFaA,RailDesignEnA,RailDesignB,RailDesignFaB,RailDesignEnB,RailDesignC,RailDesignFaC,RailDesignEnC",
        [
          step81,
          railObject["DesignName"],
          railObject["DesignENName"],
          step81,
          railObject["DesignName"],
          railObject["DesignENName"],
          step81,
          railObject["DesignName"],
          railObject["DesignENName"],
        ]
      );
      showRodsColor(railObject, "82");
    }
  }, [step81]);

  useEffect(() => {
    if (step82 !== "" && !pageLoad) {
      setDeps("", "82,812", 1);

      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step81}`) || {};

      let railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step82}`) || {};

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      setCart(
        undefined,
        undefined,
        "",
        "RailIdA,RailColorFaA,RailColorEnA,RailIdB,RailColorFaB,RailColorEnB,RailIdC,RailColorFaC,RailColorEnC",
        [
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
          step82,
          railObject2["ColorName"],
          railObject2["ColorEnName"],
        ]
      );
      showRodsColor(railObject, "82", step82);
    }
  }, [step82]);

  useEffect(() => {
    if (step8A1 !== "" && !pageLoad) {
      setDeps("842,843", "8,8A,8A1,8A2,8A3,84");
      setStep8A2("");
      setStep8A3("");
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};

      if (railObject["DesignENName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8A"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8A"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }
      setCart(
        "RailDesignA",
        step8A1,
        "RailIdA,RailColorFaA,RailColorEnA",
        "RailDesignFaA,RailDesignEnA",
        [railObject["DesignName"], railObject["DesignENName"]]
      );
      showRodsColor(railObject, "8A2");
    }
  }, [step8A1]);

  useEffect(() => {
    if (step8A2 !== "" && !pageLoad) {
      setDeps("", "8A2,842", 1);
      let railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};
      let railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step8A2}`) || {};

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8A"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      setCart("RailIdA", step8A2, "", "RailColorFaA,RailColorEnA", [
        railObject2["ColorName"],
        railObject2["ColorEnName"],
      ]);
      showRodsColor(railObject, "8A2", step8A2);
    }
  }, [step8A2]);

  useEffect(() => {
    if (step8B1 !== "" && !pageLoad) {
      // After refresh, design is set from cart — do not wipe color/control or splice tooltip
      const isRestoreHydrate =
        cartValues["RailDesignB"] !== undefined && `${cartValues["RailDesignB"]}` === `${step8B1}`;

      if (!isRestoreHydrate) {
        setStep8B2("");
        setStep8B3("");
        setStep8B5("");
      }

      let railObject = rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) || {};

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8B"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8B"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600) {
          modalHandleShow("width600cm");
        }
        setTrackType8B(1);
        if (!isRestoreHydrate) {
          setDeps("86", "849,850,852,853,854,855,856,857");
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8B(2);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("854,850", "8B,8A,849,86,852,853,855,856,857");
        }
        showRodsColor(
          railObject,
          "8B2",
          isRestoreHydrate ? step8B2 || cartValues["RailIdB"] : undefined
        );
      } else if (Object.keys(railObject).length) {
        setTrackType8B(undefined);
        if (!isRestoreHydrate) {
          if (step8B === "Rod") {
            setDeps("850,852", "8B,8A,849,86,853,854,855,856,857");
          } else {
            setDeps("850,853", "8B,8A,849,86,852,854,855,856,857");
          }
          setCart(
            "RailDesignB",
            step8B1,
            "RailIdB,RailColorFaB,RailColorEnB",
            "RailDesignFaB,RailDesignEnB",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
        }
        showRodsColor(
          railObject,
          "8B2",
          isRestoreHydrate ? step8B2 || cartValues["RailIdB"] : undefined
        );
      }
    }
  }, [step8B1]);

  useEffect(() => {
    if (step8B2 !== "" && !pageLoad) {
      setDeps("", "8B2,850", 1);
      let railObject = rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) || {};

      let railObject2 = rails2.find((obj) => `${obj["RailId"]}` === `${step8B2}`) || {};

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8B"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      setCart("RailIdB", step8B2, "", "RailColorFaB,RailColorEnB", [
        railObject2["ColorName"],
        railObject2["ColorEnName"],
      ]);
      showRodsColor(railObject, "8B2", step8B2);
    }
  }, [step8B2]);

  useEffect(() => {
    if (step8C1 !== "" && !pageLoad) {
      // After refresh, design is set from cart — do not wipe color/baton or splice tooltip
      const isRestoreHydrate =
        cartValues["RailDesignC"] !== undefined && `${cartValues["RailDesignC"]}` === `${step8C1}`;

      if (!isRestoreHydrate) {
        setStep8C2("");
        setStep8C3("");
        setStep8C5("");
      }

      let railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};

      if (railObject["DesignENName"] && !isRestoreHydrate) {
        let tempExtended = extendedTitle;
        tempExtended["8C"][1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        tempExtended["8C"].splice(2, 3);
        setExtendedTitle(tempExtended);
      }

      if (railObject["RailTypeId"] === 2208) {
        if (parseInt(widthCart) > 600) {
          modalHandleShow("width600cm");
        }
        setTrackType8C(1);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("87", "8C1,8C2,8C3,858,859,860,861,862,863,864,865");
        }
      } else if (railObject["RailTypeId"] === 2207) {
        setTrackType8C(2);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          setDeps("859,862", "8C1,8C5,8C51,8C52,87,,858,860,861,863,864,865");
        }
        showRodsColor(
          railObject,
          "8C2",
          isRestoreHydrate ? step8C2 || cartValues["RailIdC"] : undefined
        );
      } else if (Object.keys(railObject).length) {
        setTrackType8C(undefined);
        if (!isRestoreHydrate) {
          setCart(
            "RailDesignC",
            step8C1,
            "RailIdC,RailColorFaC,RailColorEnC",
            "RailDesignFaC,RailDesignEnC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
            [railObject["DesignName"], railObject["DesignENName"]]
          );
          if (step8C === "Rod") {
            setDeps("859,860", "8C1,8C5,8C51,8C52,858,87,,858,861,862,863,864,865");
          } else {
            setDeps("859,861", "8C1,8C5,8C51,8C52,858,87,858,860,862,863,864,865");
          }
        }
        showRodsColor(
          railObject,
          "8C2",
          isRestoreHydrate ? step8C2 || cartValues["RailIdC"] : undefined
        );
      }
    }
  }, [step8C1]);

  useEffect(() => {
    if (step8C2 !== "" && !pageLoad) {
      setDeps("", "8C2,859", 1);
      let railObject = {};
      railObject =
        rails3.filter((obj) => {
          return obj["RailId"] === step8C1;
        })[0] || railObject;

      let railObject2 = {};
      railObject2 =
        rails3.filter((obj) => {
          return obj["RailId"] === step8C2;
        })[0] || railObject2;

      if (railObject["DesignENName"] && railObject2["ColorName"] && railObject2["ColorEnName"]) {
        let tempExtended = extendedTitle;
        tempExtended["8C"][2] = (
          <li key="2" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Finish")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject2["ColorName"])
                : railObject2["ColorEnName"]}
            </span>
          </li>
        );
        setExtendedTitle(tempExtended);
      }
      setCart("RailIdC", step8C2, "", "RailColorFaC,RailColorEnC", [
        railObject2["ColorName"],
        railObject2["ColorEnName"],
      ]);
      showRodsColor(railObject, "8C2");
    }
  }, [step8C2]);

  // Rebuild rod color swatches when rails data arrives or restored step81/82 are set
  useEffect(() => {
    if (!rails.length || step81 === "") return;

    const railObject = rails.find((obj) => `${obj["RailId"]}` === `${step81}`) || {};
    if (!Object.keys(railObject).length) return;

    showRodsColor(railObject, "82", step82);

    // Fill header design/color from rails if still missing after restore (do not wipe baton)
    setExtendedTitle((prev) => {
      const temp8 = Array.isArray(prev["8"]) ? [...prev["8"]] : [];
      let changed = false;

      if (railObject["DesignENName"] && !temp8[1]) {
        temp8[1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        changed = true;
      }

      if (step82 && !temp8[2]) {
        const railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step82}`) || {};
        if (railObject2["ColorName"] && railObject2["ColorEnName"]) {
          temp8[2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject2["ColorName"])
                  : railObject2["ColorEnName"]}
              </span>
            </li>
          );
          changed = true;
        }
      }

      return changed ? { ...prev, 8: temp8 } : prev;
    });
  }, [rails, rods, step81, step82, pageLanguage]);

  // Rebuild 10.1 drapery rod colors when rails arrive / restored step8A1/8A2 are set
  useEffect(() => {
    if (!rails.length || step8A1 === "") return;

    const railObject = rails.find((obj) => `${obj["RailId"]}` === `${step8A1}`) || {};
    if (!Object.keys(railObject).length) return;

    showRodsColor(railObject, "8A2", step8A2);

    setExtendedTitle((prev) => {
      const temp8A = Array.isArray(prev["8A"]) ? [...prev["8A"]] : [];
      let changed = false;

      if (railObject["DesignENName"] && !temp8A[1]) {
        temp8A[1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        changed = true;
      }

      if (step8A2 && !temp8A[2]) {
        const railObject2 = rails.find((obj) => `${obj["RailId"]}` === `${step8A2}`) || {};
        if (railObject2["ColorName"] && railObject2["ColorEnName"]) {
          temp8A[2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">
                {pageLanguage === "fa"
                  ? convertToPersian(railObject2["ColorName"])
                  : railObject2["ColorEnName"]}
              </span>
            </li>
          );
          changed = true;
        }
      }

      return changed ? { ...prev, "8A": temp8A } : prev;
    });
  }, [rails, rods, step8A1, step8A2, pageLanguage]);

  // Rebuild 10.2 sheer rod/track colors/header when rails2/tracks2 arrive — do not wipe baton/control
  useEffect(() => {
    if (!rails2.length || step8B1 === "") return;

    const railObject = rails2.find((obj) => `${obj["RailId"]}` === `${step8B1}`) || {};
    if (!Object.keys(railObject).length) return;

    const colorId = step8B2 || cartValues["RailIdB"];

    // Re-hydrate color radio after refresh if wipe cleared local state but cart still has it
    if (railObject["RailTypeId"] !== 2208 && !step8B2 && cartValues["RailIdB"]) {
      setStep8B2(`${cartValues["RailIdB"]}`);
    }

    if (railObject["RailTypeId"] === 2208) {
      setTrackType8B(1);

      // Re-hydrate motorized power / inputs / tooltip after rails load
      if (cartValues["hasPowerB"] === true || cartValues["hasPowerB"] === "true") {
        setStep8B5("true");

        if (cartValues["MotorPositionB"]) {
          const motorOpt = MotorPosition[pageLanguage].find(
            (opt) => opt.value === cartValues["MotorPositionB"]
          );
          setSelectedMotorPositionB((prev) =>
            prev && prev.length
              ? prev
              : [
                  {
                    value: cartValues["MotorPositionB"],
                    label: motorOpt ? motorOpt.label : cartValues["MotorPositionB"],
                  },
                ]
          );
        }

        if (cartValues["RemoteNameB"]) {
          setRemoteNameB((prev) => prev || cartValues["RemoteNameB"]);
          setSelectedRemoteName((prev) =>
            prev && prev.length
              ? prev
              : [{ value: cartValues["RemoteNameB"], label: cartValues["RemoteNameB"] }]
          );
        }

        if (cartValues["MotorChannelsB"] && cartValues["MotorChannelsB"].length) {
          setSelectedMotorChannelsB(
            cartValues["MotorChannelsB"].map((item) => {
              const ch = motorChannels[pageLanguage].find(
                (opt) => opt.value === item || `${opt.value}` === `${item}`
              );
              return ch ? { value: ch.value, label: ch.label } : { value: item, label: `${item}` };
            })
          );
        }

        setExtendedTitle((prev) => {
          const temp8B = Array.isArray(prev["8B"]) ? [...prev["8B"]] : [];
          let changed = false;

          if (railObject["DesignENName"] && !temp8B[1]) {
            temp8B[1] = (
              <li key="1" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Design")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? convertToPersian(railObject["DesignName"])
                    : railObject["DesignENName"]}
                </span>
              </li>
            );
            changed = true;
          } else if (!temp8B[1] && (cartValues["RailDesignFaB"] || cartValues["RailDesignEnB"])) {
            temp8B[1] = (
              <li key="1" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Design")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? cartValues["RailDesignFaB"]
                    : cartValues["RailDesignEnB"]}
                </span>
              </li>
            );
            changed = true;
          }

          if (cartValues["MotorPositionB"] && !temp8B[2]) {
            const motorOpt = MotorPosition[pageLanguage].find(
              (opt) => opt.value === cartValues["MotorPositionB"]
            );
            temp8B[2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Motor Position")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? motorOpt
                      ? motorOpt.label
                      : t(cartValues["MotorPositionB"])
                    : cartValues["MotorPositionB"]}
                </span>
              </li>
            );
            changed = true;
          }

          if (cartValues["RemoteNameB"] && !temp8B[3]) {
            temp8B[3] = (
              <li key="3" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Remote_name")}</span>
                <span className="step_title_extended_list_item_text">
                  {cartValues["RemoteNameB"]}
                </span>
              </li>
            );
            changed = true;
          }

          if (cartValues["MotorChannelsB"] && cartValues["MotorChannelsB"].length && !temp8B[4]) {
            const channelOpts = cartValues["MotorChannelsB"].map((item) => {
              const ch = motorChannels[pageLanguage].find(
                (opt) => opt.value === item || `${opt.value}` === `${item}`
              );
              return ch ? { value: ch.value, label: ch.label } : { value: item, label: `${item}` };
            });
            temp8B[4] = (
              <li key="4" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Channel(s)")}</span>
                <span className="step_title_extended_list_item_text">
                  {channelOpts
                    .map((item) => (pageLanguage === "fa" ? item.label : item.value))
                    .join(", ")}
                </span>
              </li>
            );
            changed = true;
          }

          return changed ? { ...prev, "8B": temp8B } : prev;
        });
      }
    } else if (railObject["RailTypeId"] === 2207) {
      setTrackType8B(2);
      showRodsColor(railObject, "8B2", colorId);
    } else {
      setTrackType8B(undefined);
      showRodsColor(railObject, "8B2", colorId);
    }

    if (railObject["RailTypeId"] === 2208) return;

    setExtendedTitle((prev) => {
      const temp8B = Array.isArray(prev["8B"]) ? [...prev["8B"]] : [];
      let changed = false;

      if (railObject["DesignENName"] && !temp8B[1]) {
        temp8B[1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        changed = true;
      }

      if (colorId && !temp8B[2]) {
        const trackColors = tracks2[railObject["DesignCode"]] || [];
        const railObject2 =
          trackColors.find((obj) => `${obj["RailId"]}` === `${colorId}`) ||
          rails2.find((obj) => `${obj["RailId"]}` === `${colorId}`) ||
          {};
        const colorLabel =
          railObject2["ColorName"] && railObject2["ColorEnName"]
            ? pageLanguage === "fa"
              ? convertToPersian(railObject2["ColorName"])
              : railObject2["ColorEnName"]
            : pageLanguage === "fa"
            ? cartValues["RailColorFaB"]
            : cartValues["RailColorEnB"];
        if (colorLabel) {
          temp8B[2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">{colorLabel}</span>
            </li>
          );
          changed = true;
        }
      }

      const batonOrControl =
        step8B3 ||
        (cartValues["ControlPositionB"]
          ? `${cartValues["ControlPositionB"]}`.startsWith("Left")
            ? "Left"
            : "Right"
          : cartValues["BatonOptionB"] || "");

      if (batonOrControl && !temp8B[3]) {
        const isControl = batonOrControl === "Left" || batonOrControl === "Right";
        const labelText =
          batonOrControl === "None"
            ? t("None")
            : batonOrControl === "Baton 30cm"
            ? t("Baton 30cm")
            : batonOrControl === "Baton 45cm"
            ? t("Baton 45cm")
            : batonOrControl === "Cord"
            ? t("Cord")
            : t(batonOrControl);
        temp8B[3] = (
          <li key="3" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">
              {isControl ? t("Control Position") : t("Baton")}
            </span>
            <span className="step_title_extended_list_item_text">{labelText}</span>
          </li>
        );
        changed = true;
      }

      return changed ? { ...prev, "8B": temp8B } : prev;
    });

    // Ensure control radio state matches cart ("Left Control" → "Left")
    if (cartValues["ControlPositionB"] && (!step8B3 || `${step8B3}`.includes("Control"))) {
      const controlRaw = `${cartValues["ControlPositionB"]}`;
      const controlUi = controlRaw === "Left" || controlRaw.startsWith("Left") ? "Left" : "Right";
      if (step8B3 !== controlUi) setStep8B3(controlUi);
    }
  }, [
    rails2,
    rods2,
    tracks2,
    step8B1,
    step8B2,
    step8B3,
    pageLanguage,
    cartValues["RailIdB"],
    cartValues["RailColorFaB"],
    cartValues["RailColorEnB"],
    cartValues["RailDesignFaB"],
    cartValues["RailDesignEnB"],
    cartValues["BatonOptionB"],
    cartValues["ControlPositionB"],
    cartValues["hasPowerB"],
    cartValues["MotorPositionB"],
    cartValues["RemoteNameB"],
    cartValues["MotorChannelsB"],
  ]);

  // Rebuild 10.3 privacy rod/track colors/header when rails3 arrives — do not wipe baton/control
  useEffect(() => {
    if (!rails3.length || step8C1 === "") return;

    const railObject = rails3.find((obj) => `${obj["RailId"]}` === `${step8C1}`) || {};
    if (!Object.keys(railObject).length) return;

    const colorId = step8C2 || cartValues["RailIdC"];

    if (railObject["RailTypeId"] !== 2208 && !step8C2 && cartValues["RailIdC"]) {
      setStep8C2(`${cartValues["RailIdC"]}`);
    }

    if (railObject["RailTypeId"] === 2208) {
      setTrackType8C(1);
      // Electric rail: never show chain/control in header
      if (step8C3 === "Left" || step8C3 === "Right" || `${step8C3}`.includes("Control")) {
        setStep8C3("");
      }

      // Re-hydrate motorized power / inputs / tooltip after rails load
      if (cartValues["hasPowerC"] === true || cartValues["hasPowerC"] === "true") {
        setStep8C5("true");

        if (cartValues["MotorPositionC"]) {
          const motorOpt = MotorPosition[pageLanguage].find(
            (opt) => opt.value === cartValues["MotorPositionC"]
          );
          setSelectedMotorPositionC((prev) =>
            prev && prev.length
              ? prev
              : [
                  {
                    value: cartValues["MotorPositionC"],
                    label: motorOpt ? motorOpt.label : cartValues["MotorPositionC"],
                  },
                ]
          );
        }

        if (cartValues["RemoteNameC"]) {
          setRemoteNameC((prev) => prev || cartValues["RemoteNameC"]);
          setSelectedRemoteName((prev) =>
            prev && prev.length
              ? prev
              : [{ value: cartValues["RemoteNameC"], label: cartValues["RemoteNameC"] }]
          );
        }

        if (cartValues["MotorChannelsC"] && cartValues["MotorChannelsC"].length) {
          setSelectedMotorChannelsC(
            cartValues["MotorChannelsC"].map((item) => {
              const ch = motorChannels[pageLanguage].find(
                (opt) => opt.value === item || `${opt.value}` === `${item}`
              );
              return ch ? { value: ch.value, label: ch.label } : { value: item, label: `${item}` };
            })
          );
        }

        setExtendedTitle((prev) => {
          const temp8C = Array.isArray(prev["8C"]) ? [...prev["8C"]] : [];
          let changed = false;

          const designText = railObject["DesignENName"]
            ? pageLanguage === "fa"
              ? convertToPersian(railObject["DesignName"])
              : railObject["DesignENName"]
            : pageLanguage === "fa"
            ? cartValues["RailDesignFaC"]
            : cartValues["RailDesignEnC"];

          if (designText && !temp8C[1]) {
            temp8C[1] = (
              <li key="1" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Design")}</span>
                <span className="step_title_extended_list_item_text">{designText}</span>
              </li>
            );
            changed = true;
          }

          if (cartValues["MotorPositionC"]) {
            const motorOpt = MotorPosition[pageLanguage].find(
              (opt) => opt.value === cartValues["MotorPositionC"]
            );
            temp8C[2] = (
              <li key="2" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Motor Position")}</span>
                <span className="step_title_extended_list_item_text">
                  {pageLanguage === "fa"
                    ? motorOpt
                      ? motorOpt.label
                      : t(cartValues["MotorPositionC"])
                    : cartValues["MotorPositionC"]}
                </span>
              </li>
            );
            changed = true;
          }

          if (cartValues["RemoteNameC"]) {
            temp8C[3] = (
              <li key="3" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Remote_name")}</span>
                <span className="step_title_extended_list_item_text">
                  {cartValues["RemoteNameC"]}
                </span>
              </li>
            );
            changed = true;
          }

          if (cartValues["MotorChannelsC"] && cartValues["MotorChannelsC"].length) {
            const channelOpts = cartValues["MotorChannelsC"].map((item) => {
              const ch = motorChannels[pageLanguage].find(
                (opt) => opt.value === item || `${opt.value}` === `${item}`
              );
              return ch ? { value: ch.value, label: ch.label } : { value: item, label: `${item}` };
            });
            temp8C[4] = (
              <li key="4" className="step_title_extended_list_item">
                <span className="step_title_extended_list_item_title">{t("Channel(s)")}</span>
                <span className="step_title_extended_list_item_text">
                  {channelOpts
                    .map((item) => (pageLanguage === "fa" ? item.label : item.value))
                    .join(", ")}
                </span>
              </li>
            );
            changed = true;
          }

          return changed ? { ...prev, "8C": temp8C } : prev;
        });
      }
      return;
    }

    if (railObject["RailTypeId"] === 2207) {
      setTrackType8C(2);
      showRodsColor(railObject, "8C2", colorId);
    } else {
      setTrackType8C(undefined);
      showRodsColor(railObject, "8C2", colorId);
    }

    setExtendedTitle((prev) => {
      const temp8C = Array.isArray(prev["8C"]) ? [...prev["8C"]] : [];
      let changed = false;

      if (railObject["DesignENName"] && !temp8C[1]) {
        temp8C[1] = (
          <li key="1" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">{t("Design")}</span>
            <span className="step_title_extended_list_item_text">
              {pageLanguage === "fa"
                ? convertToPersian(railObject["DesignName"])
                : railObject["DesignENName"]}
            </span>
          </li>
        );
        changed = true;
      }

      if (colorId && !temp8C[2]) {
        const railObject2 = rails3.find((obj) => `${obj["RailId"]}` === `${colorId}`) || {};
        const colorLabel =
          railObject2["ColorName"] && railObject2["ColorEnName"]
            ? pageLanguage === "fa"
              ? convertToPersian(railObject2["ColorName"])
              : railObject2["ColorEnName"]
            : pageLanguage === "fa"
            ? cartValues["RailColorFaC"]
            : cartValues["RailColorEnC"];
        if (colorLabel) {
          temp8C[2] = (
            <li key="2" className="step_title_extended_list_item">
              <span className="step_title_extended_list_item_title">{t("Finish")}</span>
              <span className="step_title_extended_list_item_text">{colorLabel}</span>
            </li>
          );
          changed = true;
        }
      }

      const batonOrControl =
        step8C3 ||
        (cartValues["ControlPositionC"]
          ? `${cartValues["ControlPositionC"]}`.startsWith("Left")
            ? "Left"
            : "Right"
          : cartValues["BatonOptionC"] || "");

      if (batonOrControl && !temp8C[3]) {
        const isControl = batonOrControl === "Left" || batonOrControl === "Right";
        const labelText =
          batonOrControl === "None"
            ? t("None")
            : batonOrControl === "Baton 30cm"
            ? t("Baton 30cm")
            : batonOrControl === "Baton 45cm"
            ? t("Baton 45cm")
            : batonOrControl === "Cord"
            ? t("Cord")
            : t(batonOrControl);
        temp8C[3] = (
          <li key="3" className="step_title_extended_list_item">
            <span className="step_title_extended_list_item_title">
              {isControl ? t("Control Position") : t("Baton")}
            </span>
            <span className="step_title_extended_list_item_text">{labelText}</span>
          </li>
        );
        changed = true;
      }

      return changed ? { ...prev, "8C": temp8C } : prev;
    });

    if (cartValues["BatonOptionC"] && !step8C3) {
      setStep8C3(cartValues["BatonOptionC"]);
    } else if (cartValues["ControlPositionC"] && (!step8C3 || `${step8C3}`.includes("Control"))) {
      const controlRaw = `${cartValues["ControlPositionC"]}`;
      const controlUi = controlRaw === "Left" || controlRaw.startsWith("Left") ? "Left" : "Right";
      if (step8C3 !== controlUi) setStep8C3(controlUi);
    }
  }, [
    rails3,
    rods3,
    tracks3,
    step8C1,
    step8C2,
    step8C3,
    pageLanguage,
    cartValues["RailIdC"],
    cartValues["RailColorFaC"],
    cartValues["RailColorEnC"],
    cartValues["RailDesignFaC"],
    cartValues["RailDesignEnC"],
    cartValues["BatonOptionC"],
    cartValues["ControlPositionC"],
    cartValues["hasPowerC"],
    cartValues["MotorPositionC"],
    cartValues["RemoteNameC"],
    cartValues["MotorChannelsC"],
  ]);

  useEffect(() => {
    if (
      accessoriesDesign["isPlus"] !== undefined ||
      accessoriesDesign["qty"] !== undefined ||
      accessoriesDesign["DesignCode"] !== undefined
    ) {
      let temp = JSON.parse(JSON.stringify(customAcc));
      let temp2 = JSON.parse(JSON.stringify(customAccActive));

      if (
        accessoriesDesign["DesignCode"] !== "" &&
        temp2[accessoriesDesign["DesignCode"]] !== undefined
      ) {
        const found = temp.findIndex(
          (el) =>
            el["SewingAccessoryValue"] ===
            temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"]
        );

        if (accessoriesDesign["isPlus"] !== undefined) {
          if (accessoriesDesign["isPlus"]) {
            if (found === -1) {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: 1,
              });
            } else {
              let newQty = +temp[found]["Qty"] + +1;
              if (newQty > 10) {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: 10,
                };
              } else {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: newQty,
                };
              }
            }
          } else {
            if (found === -1) {
            } else {
              let newQty = +temp[found]["Qty"] - +1;
              if (newQty < 1) {
                temp.splice(found, 1);
              } else {
                temp[found] = {
                  SewingAccessoryId: temp[found]["SewingAccessoryId"],
                  SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                  SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                  DesignNameEn: temp[found]["DesignNameEn"],
                  DesignNameFa: temp[found]["DesignNameFa"],
                  ColorNameEn: temp[found]["ColorNameEn"],
                  ColorNameFa: temp[found]["ColorNameFa"],
                  Qty: newQty,
                };
              }
            }
          }
        } else if (accessoriesDesign["qty"] !== undefined) {
          if (found === -1) {
            let newQty = accessoriesDesign["qty"];
            if (newQty < 1) {
            } else if (newQty > 10) {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: 10,
              });
            } else {
              temp.push({
                SewingAccessoryId: temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryId"],
                SewingModelAccessoryId:
                  temp2[accessoriesDesign["DesignCode"]]["SewingModelAccessoryId"],
                SewingAccessoryValue:
                  temp2[accessoriesDesign["DesignCode"]]["SewingAccessoryValue"],
                DesignNameEn: temp2[accessoriesDesign["DesignCode"]]["DesignNameEn"],
                DesignNameFa: temp2[accessoriesDesign["DesignCode"]]["DesignNameFa"],
                ColorNameEn: temp2[accessoriesDesign["DesignCode"]]["ColorNameEn"],
                ColorNameFa: temp2[accessoriesDesign["DesignCode"]]["ColorNameFa"],
                Qty: newQty,
              });
            }
          } else {
            let newQty = accessoriesDesign["qty"];
            if (newQty < 1) {
              temp.splice(found, 1);
            } else if (newQty > 10) {
              temp[found] = {
                SewingAccessoryId: temp[found]["SewingAccessoryId"],
                SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                DesignNameEn: temp[found]["DesignNameEn"],
                DesignNameFa: temp[found]["DesignNameFa"],
                ColorNameEn: temp[found]["ColorNameEn"],
                ColorNameFa: temp[found]["ColorNameFa"],
                Qty: 10,
              };
            } else {
              temp[found] = {
                SewingAccessoryId: temp[found]["SewingAccessoryId"],
                SewingModelAccessoryId: temp[found]["SewingModelAccessoryId"],
                SewingAccessoryValue: temp[found]["SewingAccessoryValue"],
                DesignNameEn: temp[found]["DesignNameEn"],
                DesignNameFa: temp[found]["DesignNameFa"],
                ColorNameEn: temp[found]["ColorNameEn"],
                ColorNameFa: temp[found]["ColorNameFa"],
                Qty: newQty,
              };
            }
          }
        } else {
          if (found !== -1) {
            temp[found] = {
              SewingAccessoryId: accessoriesDesign["SewingAccessoryId"],
              SewingModelAccessoryId: accessoriesDesign["SewingModelAccessoryId"],
              SewingAccessoryValue: accessoriesDesign["SewingAccessoryValue"],
              DesignNameEn: accessoriesDesign["DesignNameEn"],
              DesignNameFa: accessoriesDesign["DesignNameFa"],
              ColorNameEn: accessoriesDesign["ColorNameEn"],
              ColorNameFa: accessoriesDesign["ColorNameFa"],
              Qty: temp[found]["Qty"],
            };
          }
          temp2[accessoriesDesign["DesignCode"]] = {
            SewingAccessoryId: accessoriesDesign["SewingAccessoryId"],
            SewingModelAccessoryId: accessoriesDesign["SewingModelAccessoryId"],
            SewingAccessoryValue: accessoriesDesign["SewingAccessoryValue"],
            DesignNameEn: accessoriesDesign["DesignNameEn"],
            DesignNameFa: accessoriesDesign["DesignNameFa"],
            ColorNameEn: accessoriesDesign["ColorNameEn"],
            ColorNameFa: accessoriesDesign["ColorNameFa"],
          };
          setCustomAccActive(temp2);
        }
      }
      setCart(undefined, undefined, undefined, undefined, undefined, temp);
      setCustomAcc(temp);
      setAccessoriesDesign({
        isPlus: undefined,
        SewingAccessoryValue: "",
        SewingAccessoryId: undefined,
        SewingModelAccessoryId: undefined,
        DesignCode: undefined,
        DesignNameEn: undefined,
        DesignNameFa: undefined,
        ColorNameEn: undefined,
        ColorNameFa: undefined,
        qty: undefined,
      });
    }
  }, [accessoriesDesign]);

  useEffect(() => {
    if (fabricSelected.selectedFabricId && tiebackDrapery["isPlus"] !== undefined) {
      if (tiebackDrapery["isPlus"]) {
        let newQty = +tiebackDraperyQty + +1;
        if (newQty > 10) {
          newQty = 10;
        }
        setTiebackDrapery({
          isPlus: undefined,
          HandCurtainId: tiebackDrapery["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackDraperyQty(newQty);
      } else {
        let newQty = +tiebackDraperyQty - +1;
        if (newQty < 0) {
          newQty = 0;
        }
        setTiebackDrapery({
          isPlus: undefined,
          HandCurtainId: tiebackDrapery["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackDraperyQty(newQty);
      }
    } else if (fabricSelected.selectedFabricId && tiebackDrapery["HandCurtainId"] !== undefined) {
      if (tiebackDrapery["HandCurtainNum"] > 0) {
        setCart(
          "HandCurtainId",
          tiebackDrapery["HandCurtainId"],
          "",
          "HandCurtainNum,HandCurtainEn,HandCurtainFa",
          [tiebackDraperyQty, "Matching Drapery Tieback", "کمرپرده پارچه ای"]
        );
      } else {
        setCart("", "", "HandCurtainId,HandCurtainNum");
      }
    }
  }, [tiebackDrapery]);

  useEffect(() => {
    if (fabricSelected2.selectedFabricId && tiebackSheer["isPlus"] !== undefined) {
      if (tiebackSheer["isPlus"]) {
        let newQty = +tiebackSheerQty + +1;
        if (newQty > 10) {
          newQty = 10;
        }
        setTiebackSheer({
          isPlus: undefined,
          HandCurtainId: tiebackSheer["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackSheerQty(newQty);
      } else {
        let newQty = +tiebackSheerQty - +1;
        if (newQty < 0) {
          newQty = 0;
        }
        setTiebackSheer({
          isPlus: undefined,
          HandCurtainId: tiebackSheer["HandCurtainId"],
          HandCurtainNum: newQty,
        });
        setTiebackSheerQty(newQty);
      }
    } else if (fabricSelected2.selectedFabricId && tiebackSheer["HandCurtainId"] !== undefined) {
      if (tiebackSheer["HandCurtainNum"] > 0) {
        setCart(
          "HandCurtainId2",
          tiebackSheer["HandCurtainId"],
          "",
          "HandCurtainNum2,HandCurtainEn2,HandCurtainFa2",
          [tiebackSheerQty, "Matching Sheer Tieback", "کمرپرده توری"]
        );
      } else {
        setCart("", "", "HandCurtainId2,HandCurtainNum2");
      }
    }
  }, [tiebackSheer]);

  useEffect(() => {
    if (Object.keys(customAccActive).length) {
      renderStepAccessories();
    }
  }, [customAcc, customAccActive, activeAccessoryColors]);

  useEffect(() => {
    if (customAcc.length + tiebackDraperyQty + tiebackSheerQty) {
      let tempText = [];

      if (tiebackDraperyQty > 0) {
        tempText.push(
          `${pageLanguage === "en" ? "Matching Drapery Tieback" : "کمرپرده پارچه ای"} ${NumToFa(
            tiebackDraperyQty,
            pageLanguage
          )}`
        );
      }

      if (tiebackSheerQty > 0) {
        tempText.push(
          `${pageLanguage === "en" ? "Matching Sheer Tieback" : "کمرپرده توری"} ${NumToFa(
            tiebackSheerQty,
            pageLanguage
          )}`
        );
      }

      let promiseArr = [];
      customAcc.forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          const found = Object.keys(stepAccessories).find((e) => {
            return !!findAccessoryColor(stepAccessories[e], obj);
          });

          setTimeout(() => {
            if (found !== undefined) {
              const colorObj = findAccessoryColor(stepAccessories[found], obj);
              const found2 = colorObj
                ? stepAccessories[found].findIndex(
                    (el) =>
                      `${el["DetailId"]}` === `${colorObj["DetailId"]}` ||
                      `${el["SewingAccessoryDetailId"]}` ===
                        `${colorObj["SewingAccessoryDetailId"]}`
                  )
                : -1;

              if (found2 !== -1) {
                let DesignENName = stepAccessories[found][found2]["DesignENName"];
                let DesignName = stepAccessories[found][found2]["DesignName"];
                let ColorENName = stepAccessories[found][found2]["ColorENName"];
                let ColorName = stepAccessories[found][found2]["ColorName"];
                let qty = obj["Qty"];
                tempText.push(
                  `${pageLanguage === "en" ? DesignENName : DesignName} / ${
                    pageLanguage === "en" ? capitalizeWordsText(ColorENName) : ColorName
                  } ${
                    pageLanguage === "en" ? `x${qty}` : NumberToPersianWord.convertEnToPe(`${qty}x`)
                  }`
                );
                resolve();
              } else {
                resolve();
              }
            } else {
              resolve();
            }
          }, 100);
        });
      });

      Promise.all(promiseArr).then(() => {
        const accTitle = tempText.join(", \n");
        setStepSelectedLabel((prev) => ({ ...prev, 9: accTitle }));
        setExtendedTitle((prev) => ({ ...prev, 9: tempText }));
      });
    } else {
      setStepSelectedLabel((prev) => ({ ...prev, 9: "" }));
      setExtendedTitle((prev) => ({ ...prev, 9: [] }));
    }
  }, [customAcc, tiebackDraperyQty, tiebackSheerQty, pageLanguage, stepAccessories]);

  // Restore step 12 header after refresh only (live header is set by roomLabelChanged)
  useEffect(() => {
    if (pageLoad !== false) return;
    const roomEn = cartValues["RoomNameEn"];
    const windowName = cartValues["WindowName"] || "";
    if (!roomEn && !windowName) return;

    const roomOpt = (rooms[pageLanguage] || []).find((opt) => opt.value === roomEn);
    const roomLabel = roomOpt
      ? roomOpt.label
      : pageLanguage === "fa" && cartValues["RoomNameFa"]
      ? cartValues["RoomNameFa"]
      : roomEn || "";
    const headerText =
      roomLabel && windowName ? `${roomLabel} - ${windowName}` : roomLabel || windowName;
    if (!headerText) return;

    setStepSelectedLabel((prev) =>
      prev["10"] === headerText ? prev : { ...prev, 10: headerText }
    );
  }, [pageLoad]);

  useEffect(() => {
    if (swatchLogin) {
      setSwatchLogin(false);
      modalHandleClose("side_login_modal");
      setTimeout(() => {
        fabricSwatch("0", swatchLoginSwatchId, swatchLoginSwatchDetailId);
      }, 500);
    } else if ((projectModalState === 2 && isLoggedIn) || (saveProjectCount !== 0 && isLoggedIn)) {
      if (roomLabelText !== "" && selectedRoomLabel.length) {
        if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            projectData,
            customAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              console.log(err);
              setProjectModalState(2);
              setSavingLoading(false);
            });
        } else {
          SaveUserProject(
            depSet,
            cartValues,
            [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
            `${modelID}`,
            price,
            defaultModelName,
            defaultModelNameFa,
            undefined,
            customAcc
          )
            .then((temp) => {
              if (temp === 401) {
                setSaveProjectCount(saveProjectCount + 1);
              } else if (temp) {
                setProjectModalState(1);
                setSavingLoading(false);
              } else {
                setSavingLoading(false);
              }
            })
            .catch((err) => {
              setProjectModalState(2);
              setSavingLoading(false);
            });
        }
      } else {
        setProjectModalState(0);
        modalHandleShow("add_to_project_modal");
      }
    }
  }, [isLoggedIn, saveProjectCount]);

  useEffect(() => {
    if (deleteUploadImageIndex !== -1) {
      if (deleteUploadImageUrl !== "") {
        deleteUploadedImg(
          uploadedImagesList,
          uploadedImagesNamesList,
          deleteUploadImageUrl,
          deleteUploadImageIndex
        );
      }
    }
  }, [deleteUploadImageUrl]);

  useEffect(() => {
    if (deleteUploadPdfIndex !== -1) {
      if (deleteUploadPdfUrl !== "") {
        deleteUploadedPdf(uploadedPDFNameList, deleteUploadPdfUrl, deleteUploadPdfIndex);
      }
    }
  }, [deleteUploadPdfUrl]);

  useEffect(() => {
    if (Object.keys(model).length !== 0 && widthCart !== undefined) {
      let tempObj = {};
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let tempObj2 = {};
          let promiseArr2 = [];
          obj["SewingAccessoryDetails"].forEach((el, index2) => {
            promiseArr2[index2] = new Promise((resolve, reject) => {
              tempObj2[el["SewingAccessoryDetailId"]] = JSON.parse(JSON.stringify(el));
              tempObj2[el["SewingAccessoryDetailId"]]["Price"] =
                obj["CalcMethodId"] === 5602 ? (el["Price"] * widthCart) / 100 : el["Price"];
              resolve();
            });
          });
          Promise.all(promiseArr2).then(() => {
            tempObj[obj["SewingAccessoryId"]] = tempObj2;
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setModelAccessories(tempObj);
      });
    } else {
      setModelAccessories({});
    }
    if (Object.keys(model).length > 0) {
      let tempObj = {};
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let promiseArr2 = [];
          if (obj["SewingAccessoryId"] === 26) {
            obj["SewingAccessoryDetails"].forEach((el, index2) => {
              promiseArr2[index2] = new Promise((resolve, reject) => {
                el["SewingModelAccessoryId"] = obj["SewingModelAccessoryId"];
                if (el["DesignCode"] && el["DesignCode"] !== "") {
                  if (
                    tempObj[el["DesignCode"]] === undefined ||
                    tempObj[el["DesignCode"]].length === 0
                  )
                    tempObj[el["DesignCode"]] = [];
                  tempObj[el["DesignCode"]].push(JSON.parse(JSON.stringify(el)));
                } else {
                  if (
                    tempObj[index2.toString()] === undefined ||
                    tempObj[index2.toString()].length === 0
                  )
                    tempObj[index2.toString()] = [];
                  tempObj[index2.toString()].push(JSON.parse(JSON.stringify(el)));
                }
                resolve();
              });
            });
          }
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        setStepAccessories(tempObj);
      });
    } else {
      setStepAccessories({});
    }

    if (Object.keys(model).length > 0) {
      let tempArr = [];
      let promiseArr = [];
      model["Accessories"].forEach((obj, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          let promiseArr2 = [];
          if (obj["SewingAccessoryId"] === 28) {
            obj["SewingAccessoryDetails"].forEach((el, index2) => {
              promiseArr2[index2] = new Promise((resolve, reject) => {
                el["SewingModelAccessoryId"] = obj["SewingModelAccessoryId"];
                tempArr.push(JSON.parse(JSON.stringify(el)));
                resolve();
              });
            });
          }
          Promise.all(promiseArr2).then(() => {
            resolve();
          });
        });
      });

      Promise.all(promiseArr).then(() => {
        let tempFabrics = {};
        let promiseArr2 = [];
        tempArr.forEach((obj, index) => {
          promiseArr2[index] = new Promise((resolve, reject) => {
            if (obj["ProductGroupId"] === "100703") {
              if (
                tempFabrics[obj["DesignCode"]] === "" ||
                tempFabrics[obj["DesignCode"]] === undefined ||
                tempFabrics[obj["DesignCode"]] === null ||
                tempFabrics[obj["DesignCode"]] === []
              )
                tempFabrics[obj["DesignCode"]] = [];
              tempFabrics[obj["DesignCode"]].push(obj);
            }
            resolve();
          });
        });
        Promise.all(promiseArr2).then(() => {
          setTrimAccessories(tempFabrics);
        });
      });
    } else {
      setTrimAccessories([]);
    }
  }, [model, widthCart]);

  useEffect(() => {
    if (!pageLoad && !rodsLoad && !rodsLoad2 && !motorLoad) {
      setCart(undefined, undefined);
    }
  }, [pageLoad, rodsLoad, rodsLoad2, motorLoad]);

  useEffect(() => {
    if (modelID !== "" && catID !== "") {
      getModel();
    }
  }, [modelID, catID]);

  useEffect(() => {
    if (pageItem) {
      setDefaultFabricPhoto(pageItem["MainImageUrl"]);
      if (pageType) {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageType,PageId", [pageType, pageId]);
      } else {
        setCart("PhotoUrl", pageItem["MainImageUrl"], "", "PageId", [pageId]);
      }
      setDefaultModelName(pageItem["EnTitle"]);
      setDefaultModelNameFa(pageItem["Title"]);
      setDefaultModelDesc(pageItem["DescriptionEn"]);
      setDefaultModelDescFa(pageItem["Description"]);
    }
  }, [pageItem]);

  async function setLang() {
    if (
      pageLanguage !==
      location.pathname
        .split("")
        .slice(1, 3)
        .join("")
    ) {
      const tempLang = location.pathname.split("");
      setPageLanguage(tempLang.slice(1, 3).join(""));
    }
  }

  const getHasZipcode = createGetHasZipcode({
    isLoggedIn,
    setHasZipcode,
    setZipcode,
    setZipcodeButton,
    setHasInstall,
  });

  const getCart = createGetCart({
    isLoggedIn,
    cartChanged,
    setBag,
    setCartChanged,
  });
  useEffect(() => {
    if (cartUpdated) {
      setBagUpdate(true);
      setBag(mainCart || {});
      if (mainCart && Object.keys(mainCart).length) {
        updateSideCartSummary(mainCart);
        setSideCartObjects(mainCart);
      } else if (!isLoggedIn && localStorage.getItem("cart")) {
        updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
      }
    }
  }, [cartUpdated]);

  useEffect(() => {
    if (!isLoggedIn && cartStateAgree && localStorage.getItem("cart")) {
      updateSideCartSummary(JSON.parse(localStorage.getItem("cart")));
    }
  }, [sideCartPrice, cartStateAgree, isLoggedIn]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(fabrics).length || Object.keys(fabrics2).length) {
          if (!firstRender.current) {
            getCart()
              .then((temp) => {
                getHasZipcode();
                setTimeout(() => {
                  renderFabrics(temp);
                  renderFabrics2(temp);
                }, 100);
              })
              .catch(() => {
                // getHasZipcode();
                setTimeout(() => {
                  renderFabrics({});
                  renderFabrics2({});
                }, 100);
              });
          }
        }
      }
    });
  }, [fabrics, fabrics2, cartChanged, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(sheers).length) {
          if (!firstRender.current) {
            renderSheers(bag);
            renderSheers2(bag);
          }
        } else {
          setSheersList([]);
          setSheersList2([]);
        }
      }
    });
  }, [sheers, sheers2, cartChanged, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (Object.keys(rods).length || Object.keys(rods2).length || Object.keys(rods3).length) {
          renderRods();
        } else {
          setRodsList([]);
          setRodsList2([]);
          setRodsList3([]);
          setRodsList4([]);
        }
      }
      if (rodsLoad) {
        setRodsLoad(false);
      }
      if (rodsLoad2) {
        setRodsLoad2(false);
      }
    });
  }, [rods, rods2, rods3, isLoggedIn, location.pathname]);

  useEffect(() => {
    setLang().then(() => {
      if (pageLanguage !== "") {
        if (
          Object.keys(tracks).length ||
          Object.keys(tracks2).length ||
          Object.keys(tracks3).length
        ) {
          renderTracks();
        } else {
          // Empty tracks => Rod-only UI. Do not wipe PanelTypeB/C (breaks refresh restore).
          setTracksList([]);
          setTracksList2([]);

          setStep6BHead("Rod");
          setStep6CHead("Rod");
        }
      }
    });
  }, [tracks, tracks2, tracks3, isLoggedIn, location.pathname]);

  useEffect(() => {
    if (Object.keys(stepAccessories).length > 0) {
      let temp = JSON.parse(JSON.stringify(customAccActive));

      let promiseArr = [];
      Object.keys(stepAccessories).forEach((key, index) => {
        promiseArr[index] = new Promise((resolve, reject) => {
          const colors = stepAccessories[key] || [];
          // Restore active color from saved Accessories when available
          const savedAcc = (customAcc || []).find((acc) => findAccessoryColor(colors, acc));
          const colorObj = savedAcc ? findAccessoryColor(colors, savedAcc) : undefined;

          if (colorObj) {
            temp[key] = {
              SewingAccessoryId: colorObj["SewingAccessoryId"],
              SewingModelAccessoryId: colorObj["SewingModelAccessoryId"],
              SewingAccessoryValue: colorObj["DetailId"],
              DesignNameEn: colorObj["DesignENName"],
              DesignNameFa: colorObj["DesignName"],
              ColorNameEn: colorObj["ColorENName"],
              ColorNameFa: colorObj["ColorName"],
            };
          } else if (temp[key] === undefined && colors[0]) {
            temp[key] = {
              SewingAccessoryId: colors[0]["SewingAccessoryId"],
              SewingModelAccessoryId: colors[0]["SewingModelAccessoryId"],
              SewingAccessoryValue: colors[0]["DetailId"],
              DesignNameEn: colors[0]["DesignENName"],
              DesignNameFa: colors[0]["DesignName"],
              ColorNameEn: colors[0]["ColorENName"],
              ColorNameFa: colors[0]["ColorName"],
            };
          }

          resolve();
        });
      });
      Promise.all(promiseArr).then(() => {
        setCustomAccActive(temp);
      });
    } else {
      setStepAccessoriesList([]);
      setCustomAccActive({});
    }
  }, [stepAccessories, customAcc, location.pathname]);

  useEffect(() => {
    if (sheersModelId !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getSheersRails(sheersModelId, parseInt(widthCart));
      } else {
        getSheersRails(sheersModelId);
      }
    } else {
      setRods2({});
      setTracks2({});
    }
  }, [sheersModelId, location.pathname]);

  useEffect(() => {
    if (sheersModelId2 !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getSheersRails(sheersModelId2, parseInt(widthCart), true);
      } else {
        getSheersRails(sheersModelId2, undefined, true);
      }
    } else {
      setRods3({});
      setTracks3({});
    }
  }, [sheersModelId2, location.pathname]);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      if (bagUpdate) {
        setBagUpdate(false);
      } else {
        dispatch({
          type: CartUpdatedTrue,
          payload: { mainCart: bag },
        });
      }
      if (isLoggedIn) {
        setCartCount(bag["CartDetails"]?.length || 0);
      } else {
        setCartCount(bag["drapery"]?.length || 0);
      }
    }
  }, [bag]);

  useEffect(() => {
    if (filterChanged["filter"] !== 0) {
      filterSelected(
        filterChanged["filter"],
        filterChanged["filter_id"],
        filterChanged["isDelete"],
        filterChanged["step"] || (accordionActiveKey === "2" ? "2" : "1")
      );

      setFilterChanged({
        filter: 0,
        filter_id: undefined,
        isDelete: false,
        step: "1",
      });
    }
  }, [filterChanged, accordionActiveKey]);

  useEffect(() => {
    if (!isClearAll) {
      getFabricsWithFilter(false, "1");
    }
  }, [filterColors, filterPatterns, filterTypes, filterPrices, searchText, heightCart2]);

  useEffect(() => {
    if (!isClearAll) {
      getFabricsWithFilter(false, "2");
    }
  }, [filterColors2, filterPatterns2, filterTypes2, filterPrices2, searchText2, heightCart2]);

  useEffect(() => {
    if (pageLanguage !== "") {
      if (widthCart && parseInt(widthCart) > 0) {
        getRails(parseInt(widthCart));
      } else {
        getRails();
      }
      GetSewingFilters(1, `${modelID}`).then((temp) => {
        setInitFilterColors(temp);
      });
      GetSewingFilters(2, `${modelID}`).then((temp) => {
        setInitFilterPatterns(temp);
      });
      GetSewingFilters(3, `${modelID}`).then((temp) => {
        setInitFilterTypes(temp);
      });
      GetSewingFilters(4, `${modelID}`).then((temp) => {
        setInitFilterPrices(temp);
      });
    }
  }, [pageLanguage, location.pathname]);

  useEffect(() => {
    let tempLang = location.pathname
      .split("")
      .slice(1, 3)
      .join("");
    let pageLanguage = tempLang;
    if (
      Object.keys(initFilterColors).length &&
      Object.keys(initFilterPatterns).length &&
      Object.keys(initFilterTypes).length &&
      Object.keys(initFilterPrices).length
    ) {
      if (initFilterColors[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterColors));

        setSewingColors(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["colors"] = [
                        ...filterCheckboxes.current["colors"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "colors",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_color" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_color" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 4"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        filterCheckboxes.current["colorsSheer"] = [];
        setSewingColorsSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-color-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterColors2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["colorsSheer"] = [
                        ...filterCheckboxes.current["colorsSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "colors",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_color_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_color_sheer" + obj.value + index}
                    className={
                      filterColors2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 4"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["colors"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 4"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterColors.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["colors2"] = [
                          ...filterCheckboxes.current["colors2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "colors",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_color2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_color2" + obj.value + index}
                      className={
                        filterColors.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 6"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("colors")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingColors2(tempArr);
        });
      }
      if (initFilterPatterns[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPatterns));

        setSewingPatterns(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["patterns"] = [
                        ...filterCheckboxes.current["patterns"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "patterns",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_pattern" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_pattern" + obj.value + index}
                    className="checkbox_label"
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 7"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        filterCheckboxes.current["patternsSheer"] = [];
        setSewingPatternsSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-pattern-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterPatterns2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["patternsSheer"] = [
                        ...filterCheckboxes.current["patternsSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "patterns",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_pattern_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_pattern_sheer" + obj.value + index}
                    className={
                      filterPatterns2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 7"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["patterns"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 8"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPatterns.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["patterns2"] = [
                          ...filterCheckboxes.current["patterns2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "patterns",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_pattern2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_pattern2" + obj.value + index}
                      className={
                        filterPatterns.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 9"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("patterns")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPatterns2(tempArr);
        });
      }
      if (initFilterTypes[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterTypes));
        setSewingTypes(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["types"] = [
                        ...filterCheckboxes.current["types"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "types",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_type" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_type" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 10"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        filterCheckboxes.current["typesSheer"] = [];
        setSewingTypesSheer(
          temp[tempLang]
            .sort((a, b) => a.label.localeCompare(b.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-type-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterTypes2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["typesSheer"] = [
                        ...filterCheckboxes.current["typesSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "types",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_type_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_type_sheer" + obj.value + index}
                    className={
                      filterTypes2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 10"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["types"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 11"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterTypes.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["types2"] = [
                          ...filterCheckboxes.current["types2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "types",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_type2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_type2" + obj.value + index}
                      className={
                        filterTypes.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 12"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p className="text_underline" onClick={() => setShowMoreFilterTrigger("types")}>
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingTypes2(tempArr);
        });
      }
      if (initFilterPrices[tempLang]?.length) {
        let temp = JSON.parse(JSON.stringify(initFilterPrices));

        setSewingPrices(
          temp[tempLang]
            .filter((obj) => !/\d/.test(obj.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    ref={(ref) =>
                      (filterCheckboxes.current["prices"] = [
                        ...filterCheckboxes.current["prices"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "prices",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "1",
                      });
                    }}
                    id={"dropdown_price" + obj.value + index}
                  />
                  <label htmlFor={"dropdown_price" + obj.value + index} className="checkbox_label">
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 13"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );
        filterCheckboxes.current["pricesSheer"] = [];
        setSewingPricesSheer(
          temp[tempLang]
            .filter((obj) => !/\d/.test(obj.label))
            .map((obj, index) => (
              <Dropdown.Item as={Button} key={"sheer-price-" + index}>
                <label className="dropdown_label">
                  <input
                    type="checkbox"
                    filter-id={obj.value}
                    checked={filterPrices2.includes(obj.value.toString())}
                    ref={(ref) =>
                      (filterCheckboxes.current["pricesSheer"] = [
                        ...filterCheckboxes.current["pricesSheer"],
                        ref,
                      ])
                    }
                    onChange={(e) => {
                      setFilterChanged({
                        filter: "prices",
                        filter_id: e.target.getAttribute("filter-id"),
                        isDelete: e.target.checked,
                        step: "2",
                      });
                    }}
                    id={"dropdown_price_sheer" + obj.value + index}
                  />
                  <label
                    htmlFor={"dropdown_price_sheer" + obj.value + index}
                    className={
                      filterPrices2.includes(obj.value.toString())
                        ? "checkbox_label checked_label"
                        : "checkbox_label"
                    }
                  >
                    <img
                      className="checkbox_label_img checkmark1 img-fluid 13"
                      src={require("../Images/public/checkmark1_checkbox.png")}
                      alt=""
                    />
                  </label>
                  {convertToPersian(capitalizeWordsText(obj.label), pageLanguage)}
                </label>
              </Dropdown.Item>
            ))
        );

        let promiseArr = [];
        let tempArr = [];
        temp[tempLang].forEach((obj, index) => {
          promiseArr[index] = new Promise((resolve, reject) => {
            if (index < 5 || showMoreFilter["prices"]) {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 14"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (temp[tempLang]?.length > 5 && index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show Less")}
                    </p>
                  </button>
                );
              }
              resolve();
            } else {
              tempArr.push(
                <button key={index} className="dropdown-item btn btn-primary hidden">
                  <label className="dropdown_label">
                    <input
                      type="checkbox"
                      filter-id={obj.value}
                      checked={filterPrices.includes(obj.value.toString())}
                      ref={(ref) =>
                        (filterCheckboxes.current["prices2"] = [
                          ...filterCheckboxes.current["prices2"],
                          ref,
                        ])
                      }
                      onChange={(e) => {
                        setFilterChanged({
                          filter: "prices",
                          filter_id: e.target.getAttribute("filter-id"),
                          isDelete: e.target.checked,
                        });
                      }}
                      id={"dropdown_price2" + obj.value + index}
                    />
                    <label
                      htmlFor={"dropdown_price2" + obj.value + index}
                      className={
                        filterPrices.includes(obj.value.toString())
                          ? "checkbox_label checked"
                          : "checkbox_label"
                      }
                    >
                      <img
                        className="checkbox_label_img checkmark1 img-fluid 15"
                        src={require("../Images/public/checkmark1_checkbox.png")}
                        alt=""
                      />
                    </label>
                    {convertToPersian(obj.label, pageLanguage)}
                  </label>
                </button>
              );
              if (index === temp[tempLang]?.length - 1) {
                tempArr.push(
                  <button
                    key={index + "show_more"}
                    className="dropdown-item btn btn-primary show_more_filters"
                  >
                    <p
                      className="text_underline"
                      onClick={() => setShowMoreFilterTrigger("prices")}
                    >
                      {t("Show More")}
                    </p>
                  </button>
                );
              }
              resolve();
            }
          });
        });
        Promise.all(promiseArr).then(() => {
          setSewingPrices2(tempArr);
        });
      }
    }
  }, [
    initFilterColors,
    initFilterPatterns,
    initFilterTypes,
    initFilterPrices,
    showMoreFilter,
    filterColors,
    filterPatterns,
    filterTypes,
    filterPrices,
    filterColors2,
    filterPatterns2,
    filterTypes2,
    filterPrices2,
  ]);
  useEffect(() => {
    if (showMoreFilterTrigger !== undefined) {
      let temp = JSON.parse(JSON.stringify(showMoreFilter));
      temp[showMoreFilterTrigger] = !temp[showMoreFilterTrigger];
      setShowMoreFilter(temp);
      setShowMoreFilterTrigger(undefined);
    }
  }, [showMoreFilterTrigger]);

  useEffect(() => {
    if (Object.keys(cartValues).length !== 0) {
      cartValues["SewingModelId"] = `${modelID}`;
      sessionStorage.setItem("cartValues", JSON.stringify(cartValues));
      if (editIndex) {
        sessionStorage.setItem("editIndex", JSON.stringify(editIndex));
      }
      if (projectId) {
        sessionStorage.setItem("projectId", JSON.stringify(projectId));
      }
    }
  }, [JSON.stringify(cartValues)]);

  useEffect(() => {
    getHasZipcode();
    if (
      sessionStorage.getItem("cartValues") !== null &&
      editIndex === undefined &&
      projectId === undefined
    ) {
      let tempCartValues = {};
      let tempEditIndex;
      let tempProjectId;
      if (sessionStorage.getItem("cartValues") !== null) {
        tempCartValues = JSON.parse(sessionStorage.getItem("cartValues"));
        if (Object.keys(tempCartValues).length !== 0) {
          if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
            setStepSelectedLabel({});
            setWindowSize("");
            setProjectDetails(tempCartValues, undefined, true);
          }
        }
      }
      if (sessionStorage.getItem("editIndex") !== null) {
        tempEditIndex = JSON.parse(
          sessionStorage.getItem("editIndex") &&
            sessionStorage.getItem("editIndex").toUpperCase() !== "UNDEFINED"
        );
        setEditIndex(tempEditIndex);
      }
      if (
        sessionStorage.getItem("projectId") !== null &&
        sessionStorage.getItem("projectId").toUpperCase() !== "UNDEFINED"
      ) {
        tempProjectId = JSON.parse(sessionStorage.getItem("projectId"));
        setProjectId(tempProjectId);
      }
      sessionStorage.removeItem("cartValues");
    }
  }, []);

  useEffect(() => {
    if (editIndex && editIndex !== "") {
      if (isLoggedIn) {
        getProjectDetail(editIndex);
      } else {
        if (localStorage.getItem("cart") !== null) {
          if (JSON.parse(localStorage.getItem("cart"))["drapery"] !== undefined) {
            setProjectDetails(
              JSON.parse(localStorage.getItem("cart"))["drapery"][editIndex],
              editIndex
            );
          } else {
            navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
          }
        } else {
          navigate("/" + pageLanguage + "/Curtain/" + catID + "/" + modelID);
        }
      }
    } else if (projectId && projectId !== "") {
      getProjectDetail();
    } else if (sessionStorage.getItem("cartCopy") !== null) {
      let tempCartValues = JSON.parse(sessionStorage.getItem("cartCopy"));
      if (Object.keys(tempCartValues).length !== 0) {
        if (tempCartValues["SewingModelId"] && tempCartValues["SewingModelId"] === `${modelID}`) {
          setStepSelectedLabel({});
          setWindowSize("");
          setProjectDetails(tempCartValues);
        }
      }
      sessionStorage.removeItem("cartCopy");
    } else if (Object.keys(cartValues).length !== 0) {
      setStepSelectedLabel({});
      setWindowSize("");
      setTimeout(() => {
        setProjectDetails(cartValues, undefined, true);
      }, 700);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (
      step3ARod === "Floor" &&
      (stepSelectedLabel["315"] === undefined || stepSelectedLabel["315"] === "")
    ) {
      setStepSelectedLabel((prev) => ({
        ...prev,
        ["315"]: pageLanguage === "en" ? "Floor" : "تا روی زمین",
      }));

      // فراخوانی توابع در useEffect
      setCart(
        "FinishedLengthType",
        "Floor",
        "RodToBottom,Width3C,ExtensionLeft,ExtensionRight,Height3E,WindowToFloor,ShadeMount,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
      );
    }
  }, [step3ARod, stepSelectedLabel]);

  const fixedDiv = useRef(null);
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    if (isTabletOrMobile) {
      setOffset(false);
      return undefined;
    }

    const onScroll = () => {
      if (fixedDiv.current.offsetTop < window.pageYOffset + 92) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isTabletOrMobile]);

  const {
    windowWidthTitle,
    sillStepNum,
    wallExtensionStepNum,
    privacyLayerStep9,
  } = getGrommetStepLabels({
    t,
    step3A0,
    step3A,
    step3B,
    selectedSheer,
    step31,
    step3,
    pageLanguage,
    widthCart,
    step2A,
    step6CHead,
    windowWidthPanelType,
  });

  useEffect(() => {
    let newIsDisabledRod;

    if (
      parseInt(windowWidthPanelType) > 160 &&
      step6CHead === "Track" &&
      step6C !== "" &&
      [...depSet].findIndex((el) => el.startsWith("8C")) !== -1
    ) {
      newIsDisabledRod = true;
    } else if (step6CHead === "Track" && parseInt(windowWidthPanelType) >= 160) {
      newIsDisabledRod = true;
    } else {
      newIsDisabledRod = false;
    }
    if (step8C === "Rod" && step8B === "Track") {
      setStep8C("");
      setStep8C1("");
      setStep8C3("");
      setDeps("8C", "");
      let tempExtended = extendedTitle;
      tempExtended["8C"] = [t("")];
      setExtendedTitle(tempExtended);
    }

    setIsDisabledRodGrommet9c(newIsDisabledRod);
  }, [ pageLanguage, step8B, step6CHead , windowWidthPanelType]);

  useEffect(() => {
    const resetAfterIdle = () => {
      setRodsLoad(false);
      setRodsLoad2(false);
      setPageLoad((prev) => (prev === true ? false : prev));
      if (priceRequestCancelRef.current) {
        try {
          priceRequestCancelRef.current.cancel("idle-reset");
        } catch (e) {}
        priceRequestCancelRef.current = null;
      }
      const timers = measureDebounceRef.current;
      Object.keys(timers).forEach((key) => {
        if (timers[key]) {
          clearTimeout(timers[key]);
          timers[key] = null;
        }
      });
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        hiddenAtRef.current = Date.now();
        return;
      }
      const hiddenFor = hiddenAtRef.current ? Date.now() - hiddenAtRef.current : 0;
      hiddenAtRef.current = null;
      if (hiddenFor >= 30000) {
        resetAfterIdle();
      }
    };

    const onPageShow = () => {
      if (skipFirstPageShowRef.current) {
        skipFirstPageShowRef.current = false;
        return;
      }
      resetAfterIdle();
    };

    const onOnline = () => {
      if (priceRequestCancelRef.current) {
        try {
          priceRequestCancelRef.current.cancel("network-reset");
        } catch (e) {}
        priceRequestCancelRef.current = null;
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);
    window.addEventListener("pageshow", onPageShow);
    window.addEventListener("online", onOnline);
    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pageshow", onPageShow);
      window.removeEventListener("online", onOnline);
    };
  }, []);

  const allFilesSorted = [...uploadingFiles, ...uploadedImages, ...uploadedPDFs].sort(
    (a, b) => new Date(a.uploadedAt) - new Date(b.uploadedAt)
  );

  return (
    <div className={`Custom_model_container ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_1")}
        dep-group=""
        ref={(ref) => ["11", "111"].forEach((dep) => (depDetails.current["1"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_11")}
        dep-group=""
        ref={(ref) => ["11"].forEach((dep) => (depDetails.current["1"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_3")}
        dep-group=""
        ref={(ref) => ["21"].forEach((dep) => (depDetails.current["2"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("dep_grommet_2")}
        dep-group=""
        ref={(ref) => ["211"].forEach((dep) => (depDetails.current["2"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("dep_grommet_2B1")}
        dep-group=""
        ref={(ref) => ["2B1"].forEach((dep) => (depDetails.current["2B"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3A0"}
        dep-group=""
        ref={(ref) => ["3A11", "3A12"].forEach((dep) => (depDetails.current["3A0"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Moulding Depth")}
        dep-group=""
        ref={(ref) => ["3A11"].forEach((dep) => (depDetails.current["3A0"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Moulding Height")}
        dep-group=""
        ref={(ref) => ["3A12"].forEach((dep) => (depDetails.current["3A0"][dep] = ref))}
      />

      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3"
        ref={(ref) => ["31"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Width")}
        dep-group=""
        ref={(ref) => ["311"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Height")}
        dep-group=""
        ref={(ref) => ["312"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      {/* برای استپ اندازه گیری  */}
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Finish Length Type")}
        dep-group=""
        ref={(ref) => ["315"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Rod Length")}
        dep-group=""
        ref={(ref) => ["325"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Rod To Sill Height")}
        dep-group=""
        ref={(ref) => ["335"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Rod To Floor Height")}
        dep-group=""
        ref={(ref) => ["336"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Room Height")}
        dep-group=""
        ref={(ref) => ["345"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Width")}
        dep-group=""
        ref={(ref) => ["3C"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Stack Width")}
        dep-group=""
        ref={(ref) => ["3D"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window Height")}
        dep-group=""
        ref={(ref) => ["3E"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Mount Height")}
        dep-group=""
        ref={(ref) => ["3F"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Height")}
        dep-group=""
        ref={(ref) =>
          ["3EStandardCeilingFloor"].forEach((dep) => (depDetails.current["3"][dep] = ref))
        }
      />
      {/*
       */}
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Window-To-Floor-Height")}
        dep-group=""
        ref={(ref) => ["3EFloor"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={t("Room Height")}
        dep-group=""
        ref={(ref) => ["3G"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3A"}
        dep-group=""
        ref={(ref) => ["3A1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3ARod"}
        dep-group=""
        ref={(ref) => ["3ARod1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={"dep_grommet_3B"}
        dep-group=""
        ref={(ref) => ["3B1"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3D"
        ref={(ref) => ["3D1", "3D2"].forEach((dep) => (depDetails.current["3"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3EStandardCeiling"
        ref={(ref) =>
          ["3EStandardCeiling1", "3EStandardCeiling2", "3EStandardCeiling3"].forEach(
            (dep) => (depDetails.current["3"][dep] = ref)
          )
        }
      />
      <div
        className="noDisplay"
        dep-type="Specify"
        text={""}
        dep-group="3EStandardCeilingFloor"
        ref={(ref) =>
          ["3EStandardCeilingFloor1", "3EStandardCeilingFloor2", "3EStandardCeilingFloor3"].forEach(
            (dep) => (depDetails.current["3"][dep] = ref)
          )
        }
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("")}
        dep-group="6"
        ref={(ref) => ["61"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />

      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Aerror")}
        dep-group=""
        ref={(ref) => ["6A"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Berror")}
        dep-group=""
        ref={(ref) => ["6B"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("step6Cerror")}
        dep-group=""
        ref={(ref) => ["6C"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_81")}
        dep-group=""
        ref={(ref) => ["81"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_82")}
        dep-group=""
        ref={(ref) => ["82"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_83")}
        dep-group=""
        ref={(ref) => ["83"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={t("dep_drapery_809")}
        dep-group=""
        ref={(ref) => ["84"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_85")}
        dep-group=""
        ref={(ref) => ["85"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_86")}
        dep-group=""
        ref={(ref) => ["86"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_87")}
        dep-group=""
        ref={(ref) => ["87"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_809")}
        dep-group=""
        ref={(ref) => ["809"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new")}
        dep-group=""
        ref={(ref) => ["812"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3_new")}
        dep-group=""
        ref={(ref) => ["813"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2_new2")}
        dep-group=""
        ref={(ref) => ["842"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3")}
        dep-group=""
        ref={(ref) => ["843"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Check"
        text={step8B === "Rod" ? t("dep_sheerRod_849") : t("dep_sheerTrack_849")}
        dep-group=""
        ref={(ref) => ["849"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_850")}
        dep-group=""
        ref={(ref) => ["850"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_852")}
        dep-group=""
        ref={(ref) => ["852"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_853")}
        dep-group=""
        ref={(ref) => ["853"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_854")}
        dep-group=""
        ref={(ref) => ["854"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_855")}
        dep-group=""
        ref={(ref) => ["855"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_856")}
        dep-group=""
        ref={(ref) => ["856"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_857")}
        dep-group=""
        ref={(ref) => ["857"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={step8C === "Rod" ? t("dep_layerRod_858") : t("dep_layerTrack_858")}
        dep-group=""
        ref={(ref) => ["858"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_859")}
        dep-group=""
        ref={(ref) => ["859"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_860")}
        dep-group=""
        ref={(ref) => ["860"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_861")}
        dep-group=""
        ref={(ref) => ["861"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_862")}
        dep-group=""
        ref={(ref) => ["862"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_863")}
        dep-group=""
        ref={(ref) => ["863"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={t("dep_grommet_864")}
        dep-group=""
        ref={(ref) => ["864"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_865")}
        dep-group=""
        ref={(ref) => ["865"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A1")}
        dep-group=""
        ref={(ref) => ["8A1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A2")}
        dep-group=""
        ref={(ref) => ["8A2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A3")}
        dep-group=""
        ref={(ref) => ["8A3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8A5")}
        dep-group=""
        ref={(ref) => ["8A5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B1")}
        dep-group=""
        ref={(ref) => ["8B1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B2")}
        dep-group=""
        ref={(ref) => ["8B2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B3")}
        dep-group=""
        ref={(ref) => ["8B3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B5")}
        dep-group=""
        ref={(ref) => ["8B5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B51")}
        dep-group=""
        ref={(ref) => ["8B51"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8B6")}
        dep-group=""
        ref={(ref) => ["8B6"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C1")}
        dep-group=""
        ref={(ref) => ["8C1"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C2")}
        dep-group=""
        ref={(ref) => ["8C2"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C3")}
        dep-group=""
        ref={(ref) => ["8C3"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C5")}
        dep-group=""
        ref={(ref) => ["8C5"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C51")}
        dep-group=""
        ref={(ref) => ["8C51"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C52")}
        dep-group=""
        ref={(ref) => ["8C52"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Select"
        text={t("dep_grommet_8C6")}
        dep-group=""
        ref={(ref) => ["8C6"].forEach((dep) => (depDetails.current["8"][dep] = ref))}
      />
      <div
        className="noDisplay"
        dep-type="Complete"
        text={""}
        dep-group="10"
        ref={(ref) => ["1001", "1002"].forEach((dep) => (depDetails.current["6"][dep] = ref))}
      />

      <div className="models_title_div">
        <h1>
          {defaultModelName === undefined || defaultModelName === ""
            ? " "
            : pageLanguage === "fa"
            ? convertToPersian(defaultModelNameFa) + " سفارشی "
            : "Custom " + defaultModelName}
        </h1>
        {defaultModelDesc && defaultModelDesc !== "" && (
          <h2>{pageLanguage === "fa" ? convertToPersian(defaultModelDescFa) : defaultModelDesc}</h2>
        )}
      </div>
      <div
        className="model_customize_container"
        style={{ justifyContent: "space-between", minHeight: "100%", backgroundColor: "#ece9e580" }}
      >
        <div
          className={
            offset ? "model_customize_image model_customize_image_fixed" : "model_customize_image"
          }
          ref={fixedDiv}
        >
          <div className="fixed-div">
            {defaultFabricPhoto && (
              <img src={imgUrl(defaultFabricPhoto)} className="img-fluid_allShade" alt="" />
            )}
          </div>
        </div>
        <div
          className={`model_customize_section ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
          style={{ marginInlineStart: "0", background: "#fff" }}
        >
          <Accordion ref={accordion} flush activeKey={accordionActiveKey}>
            {/* step 1 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="1"
                  stepNum={t("1")}
                  stepTitle={t("grommet_step1")}
                  stepRef="1"
                  type="1"
                  required={requiredStep["1"]}
                  stepSelected={stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  <div className="card_body card-body-fabric card-body-fabric-sheer">
                    <div className="search_filter_container">
                      <div className="search_container">
                        <div className="search_box">
                          <input
                            type="text"
                            placeholder={t("Search for product Name/Code")}
                            className="form-control search_input"
                            name="search_input"
                            value={searchText}
                            ref={search_input}
                            onChange={(e) => {
                              if (e.target.value !== "") setSearchShow(true);
                              else setSearchShow(false);
                              setSearchText(e.target.value);
                            }}
                          />
                          {searchShow && (
                            <div
                              className="clear-icon-container"
                              onClick={() => {
                                search_input.current.value = "";
                                setSearchText("");
                                setSearchShow(false);
                              }}
                            >
                              <i className="fa fa-times-circle clear-icon" />
                            </div>
                          )}
                          <div className="search-icon-container">
                            <i className="fa fa-search " />
                          </div>
                        </div>
                        <div
                          className="filters_show_hide_container"
                          onClick={() => {
                            if (filtersShow) {
                              setFiltersShow(false);
                            } else {
                              setFiltersShow(true);
                            }
                          }}
                        >
                          <span className="filters_toggle">{t("Filters")}</span>
                          <span className="filters_indicator">
                            {filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_up.svg").default}
                                alt=""
                              />
                            )}
                            {!filtersShow && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_down.svg").default}
                                alt=""
                              />
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        className={
                          filtersShow
                            ? "filters_container desktop_only"
                            : "filters_container desktop_only filters_container_hidden"
                        }
                      >
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Color")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="filter_color_items">
                              <div className="filter_items_container">{sewingColors}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="colors"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {/* {t("filter_Clear Filters")} */}
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Pattern")}</p>
                              {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPatterns}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="patterns"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {/* {t("filter_Clear Filters")} */}
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Type")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingTypes}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="types"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Price")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPrices}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="prices"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                    <div ref={fabricsContainerRef} className="fabrics_list_container 1">
                      {loading ? (
                        ""
                      ) : showEmptyMessage ? (
                        <div
                          className={`material_detail ${
                            pageLanguage === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric" + "empty"}
                        >
                          <div
                            className={`9 material_traits ${
                              pageLanguage === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button
                              className="empty_fabrics_btn white_btn btn 5"
                              onClick={() => {
                                setShowEmptyMessage(false);
                                setTimeout(() => {
                                  setIsClearAll(true);
                                }, 300);
                              }}
                            >
                              {pageLanguage === "fa"
                                ? "همه فیلترها را پاک کنید"
                                : "CLEAR ALL FILTERS"}
                            </button>
                          </div>
                        </div>
                      ) : (
                        fabricsList
                      )}
                    </div>
                    <NextStep currentStep="1" eventKey="2">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* step 2 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="2"
                  stepNum={t("2")}
                  stepTitle={t("grommet_step2")}
                  stepRef="2"
                  type="1"
                  required={requiredStep["2"]}
                  stepSelected={stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  <div className="card_body card-body-fabric card-body-fabric-sheer">
                    <div className="search_filter_container">
                      <div className="search_container">
                        <div className="search_box">
                          <input
                            type="text"
                            placeholder={t("Search for product Name/Code")}
                            className="form-control search_input"
                            name="search_input"
                            value={searchText2}
                            ref={search_input2}
                            onChange={(e) => {
                              if (e.target.value !== "") setSearchShow2(true);
                              else setSearchShow2(false);
                              setSearchText2(e.target.value);
                            }}
                          />
                          {searchShow2 && (
                            <div
                              className="clear-icon-container"
                              onClick={() => {
                                search_input2.current.value = "";
                                setSearchText2("");
                                setSearchShow2(false);
                              }}
                            >
                              <i className="fa fa-times-circle clear-icon" />
                            </div>
                          )}
                          <div className="search-icon-container">
                            <i className="fa fa-search" />
                          </div>
                        </div>
                        <div
                          className="filters_show_hide_container"
                          onClick={() => {
                            if (filtersShow2) {
                              setFiltersShow2(false);
                            } else {
                              setFiltersShow2(true);
                            }
                          }}
                        >
                          <span className="filters_toggle">{t("Filters")}</span>
                          <span className="filters_indicator">
                            {filtersShow2 && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_up.svg").default}
                                alt=""
                              />
                            )}
                            {!filtersShow2 && (
                              <img
                                className="arrow_down img-fluid"
                                src={require("../Images/public/arrow_down.svg").default}
                                alt=""
                              />
                            )}
                          </span>
                        </div>
                      </div>
                      <div
                        className={
                          filtersShow2
                            ? "filters_container desktop_only"
                            : "filters_container desktop_only filters_container_hidden"
                        }
                      >
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Color")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="filter_color_items">
                              <div className="filter_items_container">{sewingColorsSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="colors"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Pattern")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingPatternsSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="patterns"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Type")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">{sewingTypesSheer}</div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="types"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                        <div className="filter_container">
                          <Dropdown autoClose="outside" title="">
                            <Dropdown.Toggle className="dropdown_btn">
                              <p>{t("filter_Price")}</p>
                              <div className="select_control_handle_close img-fluid" />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <div className="filter_items_container">
                                <div className="price_filter_description">
                                  {t("filter_price_title")}
                                </div>
                                {sewingPricesSheer}
                              </div>
                              <div className="filter_inside_button_section">
                                <div
                                  className="clear_inside_filter"
                                  text="prices"
                                  data-step="2"
                                  onClick={(e) => clearFilters(e)}
                                >
                                  {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                </div>
                                <Dropdown.Toggle as="div" className="done_inside_filter">
                                  {t("filter_Done")}
                                </Dropdown.Toggle>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </div>
                    </div>
                    <div ref={fabricsContainerRef4} className="fabrics_list_container 2">
                      {loading2 ? (
                        ""
                      ) : showEmptyMessage2 ? (
                        <div
                          className={`material_detail ${
                            pageLanguage === "fa" ? "font_farsi" : "font_en"
                          }`}
                          key={"fabric2" + "empty"}
                        >
                          <div
                            className={`material_traits ${
                              pageLanguage === "fa" ? "font_farsi" : "font_en"
                            }`}
                          >
                            <h5 className="empty_fabrics">
                              {pageLanguage === "en"
                                ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                            </h5>
                            <button
                              className="empty_fabrics_btn white_btn btn"
                              onClick={() => {
                                setShowEmptyMessage2(false);
                                filterCheckboxes.current["colorsSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["patternsSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["typesSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                filterCheckboxes.current["pricesSheer"].forEach((obj) => {
                                  if (obj !== null) obj.checked = false;
                                });
                                if (search_input2.current) search_input2.current.value = "";
                                setSearchText2("");
                                setSearchShow2(false);
                                setFilterColors2([]);
                                setFilterPatterns2([]);
                                setFilterTypes2([]);
                                setFilterPrices2([]);
                              }}
                            >
                              {pageLanguage === "fa"
                                ? "همه فیلترها را پاک کنید"
                                : "CLEAR ALL FILTERS"}
                            </button>
                          </div>
                        </div>
                      ) : (
                        fabricsList2
                      )}
                    </div>
                    <NextStep currentStep="2" eventKey={step2 !== "" ? "2A" : "2B"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 2A */}
            <Card className={step2 !== "" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  step2A !== "" &&
                  (!accordionActiveKey.startsWith("2") ||
                    accordionActiveKey === "2B" ||
                    accordionActiveKey === "2C")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="2A"
                  stepNum={t("2A")}
                  stepTitle={t("grommet_step2A")}
                  stepRef="2A"
                  type="1"
                  required={requiredStep["2A"]}
                  stepSelected={
                    stepSelectedLabel["2A"] === undefined ? "" : stepSelectedLabel["2A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2A">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_radio_camera card_body_radio_small_img">
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/Grommet_sketch.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Grommet")}
                        value="1"
                        name="step2A"
                        ref-num="2A"
                        id="2A1"
                        checked={step2A === "Grommet"}
                        onChange={(e) => {
                          if (
                            (step2A === "Inverted Box Pleat" || step2A === "Pencil Pleat") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning");
                            setSheerHeaderStyleTemp({
                              stepValue: "Grommet",
                              id: "0099",
                              cartValue: "Grommet",
                              event: e,
                            });
                          } else {
                            setStep2A("Grommet");
                            setDeps("", "2A");
                            setCart("SheerHeaderStyle", "Grommet", "", "SheerHeaderStyleID", [
                              "0099",
                            ]);
                            selectChanged(e);
                            setSheersModelId("0099");
                          }
                        }}
                        ref={(ref) => (inputs.current["2A1"] = ref)}
                      />
                      <label htmlFor="2A1">{t("HeaderStyle1")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/Inverted_sketch.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Inverted Box Pleat")}
                        value="2"
                        name="step2A"
                        ref-num="2A"
                        id="2A2"
                        checked={step2A === "Inverted Box Pleat"}
                        onChange={(e) => {
                          if (
                            (step2A === "Grommet" || step2A === "Rod Pocket") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning");
                            setSheerHeaderStyleTemp({
                              stepValue: "Inverted Box Pleat",
                              id: "0036",
                              cartValue: "Inverted Box Pleat",
                              event: e,
                            });
                          } else {
                            setStep2A("Inverted Box Pleat");
                            setDeps("", "2A");
                            setCart(
                              "SheerHeaderStyle",
                              "Inverted Box Pleat",
                              "",
                              "SheerHeaderStyleID",
                              ["0036"]
                            );
                            selectChanged(e);
                            setSheersModelId("0036");
                          }
                        }}
                        ref={(ref) => (inputs.current["2A2"] = ref)}
                      />
                      <label htmlFor="2A2">{t("HeaderStyle2")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/pencilPleat.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Pencil Pleat")}
                        value="3"
                        name="step2A"
                        ref-num="2A"
                        id="2A3"
                        checked={step2A === "Pencil Pleat"}
                        onChange={(e) => {
                          if (
                            (step2A === "Grommet" || step2A === "Rod Pocket") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning");
                            setSheerHeaderStyleTemp({
                              stepValue: "Pencil Pleat",
                              id: "0001",
                              cartValue: "Pencil Pleat",
                              event: e,
                            });
                          } else {
                            setStep2A("Pencil Pleat");
                            setDeps("", "2A");
                            setCart("SheerHeaderStyle", "Pencil Pleat", "", "SheerHeaderStyleID", [
                              "0001",
                            ]);
                            selectChanged(e);
                            setSheersModelId("0001");
                          }
                        }}
                        ref={(ref) => (inputs.current["2A3"] = ref)}
                      />
                      <label htmlFor="2A3">{t("HeaderStyle3")}</label>
                    </div>

                    <NextStep currentStep={step2A !== "" ? "2" : "2A"} eventKey="2B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="2B"
                  stepNum={t("3")}
                  stepTitle={t("grommet3_step2")}
                  stepRef="2B"
                  type="1"
                  required={requiredStep["2B"]}
                  stepSelected={
                    stepSelectedLabel["2B"] === undefined ? "" : stepSelectedLabel["2B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2B">
                <Card.Body>
                  <div className="card_body card_body_radio card-body-fabric_grommet">
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("pl_None")}
                        value="1"
                        name="step2B"
                        ref-num="2B"
                        id="2B1"
                        checked={step2B === "None"}
                        onChange={(e) => {
                          setStep2B("None");
                          setStep2B1("");
                          setStep2C("");
                          setStep6C("");
                          let tempExtended = extendedTitle;
                          tempExtended["6"].splice(3, 1);
                          if (step8 === "I Want To Customize Hardware Per Curtain") {
                            setStep8C("");
                            setStep8C1("");
                            setStep8C2("");
                            setStep8C3("");
                            tempExtended["8C"] = [];
                            selectChanged(e, "8C");
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6");
                          } else if (step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C,87");
                          } else {
                            selectChanged(e, "6");
                            setCart(
                              "PrivacyLayer",
                              "None",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID,hardwarePrivacyLayer,PanelTypeC"
                            );
                            setDeps("", "2B,2B1,2C,6C");
                          }
                          setExtendedTitle(tempExtended);
                        }}
                        ref={(ref) => (inputs.current["2B1"] = ref)}
                      />
                      <label htmlFor="2B1">{t("pl_None")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Semi Sheer")}
                        value="2"
                        name="step2B"
                        ref-num="2B"
                        id="2B2"
                        checked={step2B === "Semi Sheer"}
                        onChange={(e) => {
                          if (
                            step2B === "None" &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Semi Sheer",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,8C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else if (step2B === "None" && step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Semi Sheer",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,87" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else {
                            if (step2B === "None") {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Semi Sheer",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                              );
                              setDeps(
                                "2B1,2C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                                "2B"
                              );
                            } else {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Semi Sheer",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl"
                              );
                              setDeps("2B1", "2B");
                            }
                          }
                          setStep2B("Semi Sheer");
                          setStep2B1("");
                        }}
                        ref={(ref) => (inputs.current["2B2"] = ref)}
                      />
                      <label htmlFor="2B2">
                        {i18n.language === "fa" ? "نازک (پر نورتر)" : "Semi Sheer"}
                      </label>
                    </div>
                    <div className="box33 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Opaque")}
                        value="3"
                        name="step2B"
                        ref-num="2B"
                        id="2B3"
                        checked={step2B === "Opaque"}
                        onChange={(e) => {
                          if (
                            step2B === "None" &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Opaque",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,8C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else if (step2B === "None" && step8 === "I Have My Own Hardware") {
                            selectChanged(e);
                            setCart(
                              "PrivacyLayer",
                              "Opaque",
                              "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                            );
                            setDeps(
                              "2B1,2C,87" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                              "2B"
                            );
                          } else {
                            if (step2B === "None") {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Opaque",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl,PrivacyLayerHeaderStyle,PrivacyLayerHeaderStyleID"
                              );
                              setDeps(
                                "2B1,2C" + (step6 === "Customize Style Per Curtain" ? ",6C" : ""),
                                "2B"
                              );
                            } else {
                              selectChanged(e);
                              setCart(
                                "PrivacyLayer",
                                "Opaque",
                                "SheersId1,SheersId2,SheersDesignFa,SheersDesignEn,SheersColorEn,SheersColorFa,SheersPhotoUrl"
                              );
                              setDeps("2B1", "2B");
                            }
                          }
                          setStep2B("Opaque");
                          setStep2B1("");
                        }}
                        ref={(ref) => (inputs.current["2B3"] = ref)}
                      />
                      <label htmlFor="2B3">
                        {/* {t("Opaque")} */}
                        {i18n.language === "fa" ? "ضخیم (کم نورتر)" : "Opaque"}
                      </label>
                    </div>

                    <div
                      className={
                        step2B === "Semi Sheer"
                          ? "fabrics_list_container grommet_fabrics_list_container"
                          : "noDisplay"
                      }
                    >
                      <div className="fabrics_list_container fabrics_list_container_sheer 3">
                        {sheersList}
                      </div>
                    </div>
                    <div
                      className={
                        step2B === "Opaque"
                          ? "fabrics_list_container grommet_fabrics_list_container"
                          : "noDisplay"
                      }
                    >
                      <div className="fabrics_list_container 4 cccc">{sheersList2}</div>
                    </div>
                    <NextStep
                      currentStep="2B"
                      eventKey={step2B !== "" && step2B !== "None" ? "2C" : "3A0"}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 3A */}
            <Card className={step2B !== "" && step2B !== "None" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  step2C !== "" &&
                  (!accordionActiveKey.startsWith("2") ||
                    accordionActiveKey === "2A" ||
                    accordionActiveKey === "2")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="2C"
                  stepNum={t("3A")}
                  stepTitle={t("grommet_step2A_sheer")}
                  stepRef="2C"
                  type="1"
                  required={requiredStep["2C"]}
                  stepSelected={
                    stepSelectedLabel["2C"] === undefined ? "" : stepSelectedLabel["2C"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="2C">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_radio_camera card_body_radio_small_img">
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/european/pleated2a.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("double european pleat")}
                        value="1"
                        name="step2C"
                        ref-num="2C"
                        id="2C1"
                        checked={step2C === "Double European Pleat"}
                        onChange={(e) => {
                          if (
                            (step2C === "Inverted Box Pleat" || step2C === "Pencil Pleat") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning2");
                            setSheerHeaderStyleTemp2({
                              stepValue: "Double European Pleat",
                              id: "0036",
                              cartValue: "Double European Pleat",
                              event: e,
                            });
                          } else {
                            setStep2C("Double European Pleat");
                            setDeps("", "2C");
                            setCart(
                              "PrivacyLayerHeaderStyle",
                              "Double European Pleat",
                              "",
                              "PrivacyLayerHeaderStyleID",
                              ["0036"]
                            );
                            selectChanged(e);
                            setSheersModelId2("0036");
                          }
                        }}
                        ref={(ref) => (inputs.current["2C1"] = ref)}
                      />
                      <label htmlFor="2C1">{t("HeaderStyle5")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/Inverted_sketch.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Inverted Box Pleat")}
                        value="2"
                        name="step2C"
                        ref-num="2C"
                        id="2C2"
                        checked={step2C === "Inverted Box Pleat"}
                        onChange={(e) => {
                          if (
                            (step2C === "Grommet" || step2C === "Rod Pocket") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning2");
                            setSheerHeaderStyleTemp2({
                              stepValue: "Inverted Box Pleat",
                              id: "0036",
                              cartValue: "Inverted Box Pleat",
                              event: e,
                            });
                          } else {
                            setStep2C("Inverted Box Pleat");
                            setDeps("", "2C");
                            setCart(
                              "PrivacyLayerHeaderStyle",
                              "Inverted Box Pleat",
                              "",
                              "PrivacyLayerHeaderStyleID",
                              ["0036"]
                            );
                            selectChanged(e);
                            setSheersModelId2("0036");
                          }
                        }}
                        ref={(ref) => (inputs.current["2C2"] = ref)}
                      />
                      <label htmlFor="2C2">{t("HeaderStyle2")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/pencilPleat.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Pencil Pleat")}
                        value="3"
                        name="step2C"
                        ref-num="2C"
                        id="2C3"
                        checked={step2C === "Pencil Pleat"}
                        onChange={(e) => {
                          if (
                            (step2C === "Grommet" || step2C === "Rod Pocket") &&
                            step8 === "I Want To Customize Hardware Per Curtain"
                          ) {
                            modalHandleShow("SheerHeaderStyleWarning2");
                            setSheerHeaderStyleTemp2({
                              stepValue: "Pencil Pleat",
                              id: "0002",
                              cartValue: "Pencil Pleat",
                              event: e,
                            });
                          } else {
                            setStep2C("Pencil Pleat");
                            setDeps("", "2C");
                            setCart(
                              "PrivacyLayerHeaderStyle",
                              "Pencil Pleat",
                              "",
                              "PrivacyLayerHeaderStyleID",
                              ["0002"]
                            );
                            selectChanged(e);
                            setSheersModelId2("0002");
                          }
                        }}
                        ref={(ref) => (inputs.current["2C3"] = ref)}
                      />
                      <label htmlFor="2C3">{t("HeaderStyle3")}</label>
                    </div>

                    <NextStep currentStep={step2C !== "" ? "2B" : "2C"} eventKey="3A0">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 4 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="3A0"
                  stepNum={t("4")}
                  stepTitle={t("zebra_step2")}
                  stepRef="3A0"
                  type="1"
                  required={requiredStep["3A0"]}
                  stepSelected={
                    stepSelectedLabel["3A0"] === undefined ? "" : stepSelectedLabel["3A0"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A0">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_radio_camera card_body_radio_medium_img">
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/mount_wall.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Wall")}
                        value="1"
                        name="step3A0"
                        ref-num="3A0"
                        id="3A01"
                        checked={step3A0 === "Wall"}
                        onChange={(e) => {
                          if (step3A0 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "Wall",
                              id: "",
                              cartValue: "Wall",
                              event: e,
                            });
                          } else {
                            setStep3A0("Wall");
                            setStep3("");
                            setStep5("");
                            setDepth(undefined);
                            setMouldingHeight(undefined);
                            setMountErr1(false);
                            setMountErr2(false);
                            setDeps(
                              "3",
                              "3A0,3A11,3A12,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                            );
                            setCart(
                              "Mount",
                              "Wall",
                              "Depth,MouldingHeight,calcMeasurements,WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            clearInputs(e, undefined, "3,3A,3B");
                            setMeasurementsNextStep("4");
                          }
                          let tempExtended = extendedTitle;
                          tempExtended["3A0"] = [];
                          setExtendedTitle(tempExtended);
                        }}
                        ref={(ref) => (inputs.current["3A01"] = ref)}
                      />
                      <label htmlFor="3A01">{t("Wall")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/mount_ceiling.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Ceiling")}
                        value="2"
                        name="step3A0"
                        ref-num="3A0"
                        id="3A02"
                        checked={step3A0 === "Ceiling"}
                        onChange={(e) => {
                          setStep5("");
                          if (step3A0 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "Ceiling",
                              id: "",
                              cartValue: "Ceiling",
                              event: e,
                            });
                          } else {
                            setStep3A0("Ceiling");
                            setStep3("");
                            setStep5("");
                            setDepth(undefined);
                            setMouldingHeight(undefined);
                            setMountErr1(false);
                            setMountErr2(false);
                            setDeps(
                              "3",
                              '3A0,3A11,3A12,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3");'
                            );
                            setCart(
                              "Mount",
                              "Ceiling",
                              "Depth,MouldingHeight,calcMeasurements,WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            clearInputs(e, undefined, "3,3A,3B");
                            setMeasurementsNextStep("4");
                          }
                          let tempExtended = extendedTitle;
                          tempExtended["3A0"] = [];
                          setExtendedTitle(tempExtended);
                        }}
                        ref={(ref) => (inputs.current["3A02"] = ref)}
                      />
                      <label htmlFor="3A02">{t("Ceiling")}</label>
                    </div>
                    <div className="box33 radio_style">
                      <img
                        src={require("../Images/drapery/grommet/mount_moulding.svg").default}
                        className="img-fluid"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Moulding")}
                        value="3"
                        name="step3A0"
                        ref-num="3A0"
                        id="3A03"
                        checked={step3A0 === "Moulding"}
                        onChange={(e) => {
                          if (step3A0 !== "" && step3 !== "") {
                            modalHandleShow("MountTypeWarning");
                            setMountTypeTemp({
                              stepValue: "Moulding",
                              id: "",
                              cartValue: "Moulding",
                              event: e,
                            });
                          } else {
                            setStep3A0("Moulding");
                            setStep3("");
                            setStep5("");
                            setDepth(undefined);
                            setMouldingHeight(undefined);
                            setDeps(
                              "3,3A11,3A12",
                              '3A0,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3");'
                            );
                            setCart(
                              "Mount",
                              "Moulding",
                              "calcMeasurements,WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            clearInputs(e, undefined, "3,3A0,3A,3B");
                            setMeasurementsNextStep("4");
                          }
                        }}
                        ref={(ref) => (inputs.current["3A03"] = ref)}
                      />
                      <label htmlFor="3A03">{t("mount_MouldingMount")}</label>
                    </div>

                    <div
                      className={
                        step3A0 === "Moulding" ? "own_measurements_container" : "noDisplay"
                      }
                    >
                      <div className="own_measurements_width">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Depth")}</h1>
                          <div className="measure_input_field_container">
                            <input
                              ref={(ref) => (inputs.current["depth"] = ref)}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["mouldingHeight"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                ((depth !== undefined && (depth < 1 || depth > 1000)) || mountErr1
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="depth"
                              value={NumToFa(`${depth || ""}`, pageLanguage)}
                              text={t("Moulding")}
                              ref-num="3A0"
                              onChange={(e) => {
                                let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                setDepth(parseInt(newValue));
                                setTimeout(() => {
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    // setDepth(parseInt(newValue));
                                    setCart("Depth", parseInt(newValue));
                                    setDeps("", "3A11");
                                    setMountErr1(false);
                                    if (
                                      mouldingHeight &&
                                      mouldingHeight !== "" &&
                                      parseInt(mouldingHeight) >= 1 &&
                                      parseInt(mouldingHeight) <= 40
                                    ) {
                                      selectChanged(e);
                                      let tempExtended = extendedTitle;
                                      tempExtended["3A0"] = [e.target.getAttribute("text")];
                                      tempExtended["3A0"][1] = (
                                        <li key="1" className="step_title_extended_list_item">
                                          <span className="step_title_extended_list_item_title">
                                            {t("Depth")}: {parseInt(newValue)}
                                            {t("cm_label")}
                                          </span>
                                          <span className="step_title_extended_list_item_text">
                                            {t("MouldingHeight")}: {parseInt(mouldingHeight)}
                                            {t("cm_label")}
                                          </span>
                                        </li>
                                      );
                                      setExtendedTitle(tempExtended);
                                    } else {
                                      selectChanged(undefined, "3A0");
                                      let tempExtended = extendedTitle;
                                      tempExtended["3A0"] = [];
                                      setExtendedTitle(tempExtended);
                                    }
                                  } else {
                                    setCartLoading(true);
                                    // setDepth(parseInt(newValue));
                                    selectChanged("3A0", undefined, t("Invalid Measurements"));

                                    setCart("", "", "Depth");
                                    setDeps("3A11", "");
                                    let tempExtended = extendedTitle;
                                    tempExtended["3A0"] = [];
                                    setExtendedTitle(tempExtended);
                                  }
                                }, 200);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          {mountErr1 && (
                            <h2 className="measure_input_desc measure_input_desc_err">
                              {t("Required field")}
                            </h2>
                          )}
                          <h2 className="measure_input_desc">
                            <Accordion>
                              <Accordion.Item eventKey="0">
                                <ContextAwareToggleViewDetails
                                  eventKey="0"
                                  textOnHide={t("Depth Requirements")}
                                  textOnShow={t("Hide Details")}
                                />
                                <Accordion.Body className="basket_item_title_dropdown dk_curtain_preview_dropdown">
                                  <div className="basket_item_title_container">
                                    <div className="accordion_help">
                                      <div className="help_container">
                                        <div className="help_multi_select_container">
                                          <span
                                            className={`help_column_header ${
                                              depthHelp === "Double Layer"
                                                ? "dk_curtain_symmetric_button_on"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              setDepthHelp("Double Layer");
                                            }}
                                          >
                                            {t("Double Layer")}
                                          </span>
                                          <span
                                            className={`help_column_header ${
                                              depthHelp === "Triple Layer"
                                                ? "dk_curtain_symmetric_button_on"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              setDepthHelp("Triple Layer");
                                            }}
                                          >
                                            {t("Triple Layer")}
                                          </span>
                                        </div>
                                        {depthHelp === "Double Layer" && (
                                          <div className="help_column help_right_column">
                                            {/*<h6 className="help_column_header">{t("Minimum Depth Required:")}</h6>*/}
                                            <ul className="help_column_list">
                                              <li className="no_listStyle">
                                                {t("Rod & Standard Track")}
                                              </li>
                                              <li className="no_listStyle">{t("25cm")}</li>
                                            </ul>
                                            <ul className="help_column_list">
                                              <li className="no_listStyle">
                                                {t("Rod & Cord Draw Track")}
                                              </li>
                                              <li className="no_listStyle">{t("25cm")}</li>
                                            </ul>
                                          </div>
                                        )}
                                        {depthHelp === "Triple Layer" && (
                                          <div className="help_column help_right_column">
                                            {/*<h6 className="help_column_header">{t("Minimum Depth Required:")}</h6>*/}
                                            <ul className="help_column_list">
                                              <li className="no_listStyle">
                                                {t("Rod & Two Standard Track")}
                                              </li>
                                              <li className="no_listStyle">{t("30cm")}</li>
                                            </ul>
                                            <ul className="help_column_list">
                                              <li className="no_listStyle">
                                                {t("Rod & Two Cord Draw Track")}
                                              </li>
                                              <li className="no_listStyle">{t("30cm")}</li>
                                            </ul>
                                            <ul className="help_column_list">
                                              <li className="no_listStyle">
                                                {t("Rod & Standard Track & Cord Draw Track")}
                                              </li>
                                              <li className="no_listStyle">{t("30cm")}</li>
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          </h2>
                        </div>
                      </div>
                      <div className="own_measurements_Length">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("MouldingHeight")}</h1>
                          <div className="measure_input_field_container">
                            <input
                              ref={(ref) => (inputs.current["mouldingHeight"] = ref)}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["depth"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                ((mouldingHeight !== undefined &&
                                  (mouldingHeight < 1 || mouldingHeight > 40)) ||
                                mountErr2
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="mouldingHeight"
                              value={NumToFa(`${mouldingHeight || ""}`, pageLanguage)}
                              text={t("Moulding")}
                              ref-num="3A0"
                              onChange={(e) => {
                                let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                setMouldingHeight(parseInt(newValue));
                                setTimeout(() => {
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 40
                                  ) {
                                    setCartLoading(true);
                                    setCart("MouldingHeight", parseInt(newValue));
                                    setDeps("", "3A12");
                                    setMountErr2(false);
                                    if (
                                      depth &&
                                      depth !== "" &&
                                      parseInt(depth) >= 1 &&
                                      parseInt(depth) <= 100
                                    ) {
                                      selectChanged(e);
                                      let tempExtended = extendedTitle;
                                      tempExtended["3A0"] = [e.target.getAttribute("text")];
                                      tempExtended["3A0"][1] = (
                                        <li key="1" className="step_title_extended_list_item">
                                          <span className="step_title_extended_list_item_title">
                                            {t("Depth")}: {parseInt(depth)}
                                            {t("cm_label")}
                                          </span>
                                          <span className="step_title_extended_list_item_text">
                                            {t("MouldingHeight")}: {parseInt(newValue)}
                                            {t("cm_label")}
                                          </span>
                                        </li>
                                      );
                                      setExtendedTitle(tempExtended);
                                    } else {
                                      selectChanged(undefined, "3A0");
                                      let tempExtended = extendedTitle;
                                      tempExtended["3A0"] = [];
                                      setExtendedTitle(tempExtended);
                                    }
                                  } else {
                                    setCartLoading(true);
                                    // setMouldingHeight(parseInt(newValue));
                                    selectChanged("3A0", undefined, t("Invalid Measurements"));

                                    setCart("", "", "MouldingHeight");
                                    setDeps("3A12", "");
                                    let tempExtended = extendedTitle;
                                    tempExtended["3A0"] = [];
                                    setExtendedTitle(tempExtended);
                                  }
                                }, 200);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          {mountErr2 && (
                            <h2 className="measure_input_desc measure_input_desc_err">
                              {t("Required field")}
                            </h2>
                          )}
                          <h2 className={"measure_input_desc"}>{t("Up to 40cm")}</h2>
                        </div>
                      </div>
                    </div>

                    <NextStep
                      currentStep="3A0"
                      eventKey={
                        step3A0 === "Moulding" &&
                        (!depth ||
                          depth < 1 ||
                          depth > 1000 ||
                          !mouldingHeight ||
                          mouldingHeight < 1 ||
                          mouldingHeight > 40)
                          ? "3A0"
                          : "3"
                      }
                      onClick={() => {
                        setTimeout(() => {
                          if (step3A0 === "Moulding") {
                            if (!depth) {
                              setMountErr1(true);
                            }
                            if (!mouldingHeight) {
                              setMountErr2(true);
                            }
                          }
                        }, 200);
                      }}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header"></p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <b>{t("grommet_mount_help1")}</b>
                            {t("grommet_mount_help2")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_mount_help3")}</b>
                            {t("grommet_mount_help4")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_mount_help5")}</b>
                            {t("grommet_mount_help6")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="3"
                  stepNum={t("5")}
                  stepTitle={t("zebra_step3")}
                  stepRef="3"
                  type="2"
                  required={requiredStep["3"]}
                  stepSelected={
                    windowSizeBool
                      ? windowSize
                      : stepSelectedLabel["3"] === undefined
                      ? ""
                      : stepSelectedLabel["3"]
                  }
                  cartCustomText={t("zebra_step3_custom_cart_text")}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("I have my own measurements")}
                        value="1"
                        name="step3"
                        ref-num="3"
                        id="31"
                        checked={step3 === "false"}
                        onChange={(e) => {
                          setMeasurementsNextStep("4");
                        setStep5("Full");
                          if (step3A0 === "") {
                            setStep3("");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "311,312");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else {
                            setStep3("false");
                            setStep31("");
                            setStep61("");
                            setDeps(
                              "311,312",
                              "3,31,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                            );
                            clearInputs(e, undefined, "315,3A,3B");
                            setCart(
                              "calcMeasurements",
                              false,
                              "WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                          }
                        }}
                        ref={(ref) => (inputs.current["31"] = ref)}
                      />
                      <label htmlFor="31">{t("I have my own measurements.")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Calculate my measurements")}
                        value="2"
                        name="step3"
                        checked={step3 === "true"}
                        ref-num="3"
                        id="32"
                        ref={(ref) => (inputs.current["32"] = ref)}
                        onChange={(e) => {
                          setMeasurementsNextStep("4");
                          setStep5("");
                          if (step3A0 === "") {
                            setStep3("");
                            selectUncheck(e);
                            modalHandleShow("noMount");
                            setDeps("3", "31,32");
                            setCart(
                              "",
                              "",
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight,calcMeasurements"
                            );
                          } else {
                            setStep3("true");
                            setStep31("");
                            setStep61("");
                            clearInputs(e);
                            setDeps("31", "3,311,312");
                            setCart(
                              "calcMeasurements",
                              true,
                              "Width,Height,WidthCart,HeightCart,WindowWidth,WindowHeight"
                            );
                          }
                        }}
                      />
                      <label htmlFor="32">{t("Calculate my measurements.")}</label>
                    </div>

                    <div className={step3 === "false" ? "own_measurements_container" : "noDisplay"}>
                      <div className="own_measurements_width">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Width"] = ref)}
                              debounceTimeout={0}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Height"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width !== undefined && (width < 1 || width > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width"
                              value={NumToFa(`${width || ""}`, pageLanguage)}
                              onChange={(e) => {
                                const rawValue = e && e.target ? e.target.value : "";
                                scheduleOwnMeasurement("Width", rawValue);
                              }}
                              onBlur={(e) => {
                                const rawValue = e && e.target ? e.target.value : "";
                                flushOwnMeasurement("Width", rawValue);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="own_measurements_Length">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Height"] = ref)}
                              debounceTimeout={0}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Width"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height !== undefined && (height < 1 || height > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height"
                              value={NumToFa(`${height || ""}`, pageLanguage)}
                              onChange={(e) => {
                                const rawValue = e && e.target ? e.target.value : "";
                                scheduleOwnMeasurement("Height", rawValue);
                              }}
                              onBlur={(e) => {
                                const rawValue = e && e.target ? e.target.value : "";
                                flushOwnMeasurement("Height", rawValue);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        step3 === "true"
                          ? "card_body card_body_radio card_body_grommet_measurements"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("grommet_step31_title")}</p>
                      </div>
                      <div className="box50 radio_style">
                        <img
                          src={
                            pageLanguage === "fa"
                              ? step3A0 === "Moulding"
                                ? require("../Images/drapery/grommet/HasRod_arc.svg").default
                                : require("../Images/drapery/european/calculatemeasurmenttrack-new.svg")
                                    .default
                              : step3A0 === "Moulding"
                              ? require("../Images/drapery/grommet/HasRod_arc.svg").default
                              : require("../Images/drapery/european/calculatemeasurmenttrack-new.svg")
                                  .default
                          }
                          className="img-fluid height_auto"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          value="1"
                          name="step31"
                          ref-num="31"
                          id="311"
                          checked={step31 === "true"}
                          onChange={(e) => {
                            setStep31("true");
                            setStep3A("Standard");
                            setStep3B("Floor");
                            clearInputs(e, undefined, "315");
                            if (step3ARod === "") {
                              setDeps(
                                "315,325,336,345",
                                "31,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3A0,3A,3A1,3ARod1,335,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "325,336,345",
                                "31,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,3A0,3A,3A1,3ARod1,335,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }

                            setCart(
                              "hasRod",
                              true,
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            setMeasurementsNextStep("3A");
                          }}
                          ref={(ref) => (inputs.current["311"] = ref)}
                        />
                        <label htmlFor="311">{t("grommet_has_rod")}</label>
                      </div>
                      <div className="box50 radio_style">
                        <img
                          src={
                            require("../Images/drapery/european/calculatemeasurmentnotrackrod-new.svg")
                              .default
                          }
                          className="img-fluid height_auto"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          value="2"
                          name="step31"
                          ref-num="31"
                          id="312"
                          checked={step31 === "false"}
                          onChange={(e) => {
                            setStep31("false");
                            setStep3A("Standard");
                            setStep3B("Floor");
                            setWidth3C(undefined);
                            setCeilingToFloor1(undefined);
                            setCeilingToFloor2(undefined);
                            setCeilingToFloor3(undefined);
                            setLeft(undefined);
                            setRight(undefined);

                            selectChanged(
                              "3A",
                              "3C,3D,3E,3EFloor,3F,3G,315,325,335,336,345,3EStandardCeiling,3EStandardCeilingFloor",
                              t("Standard"),
                              "3B",
                              [t("Floor")]
                            );
                            setCart(
                              "hasRod",
                              false,
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3",
                              "CurtainPosition,FinishedLengthType",
                              ["Standard", "Floor"]
                            );
                            if (step3A0 === "Wall") {
                              setDeps(
                                "3C,3D1,3D2,3EFloor,3F,3G",
                                "31,3A,3B,3B1,3E,315,3A1,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "31,3A,3B,3B1,3E,3F,3G,3EFloor,315,3A1,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            }
                            setMeasurementsNextStep("3A");
                          }}
                          ref={(ref) => (inputs.current["312"] = ref)}
                        />
                        <label htmlFor="312">{t("grommet_no_rod")}</label>
                      </div>
                    </div>
                    {step3 === "false" && step2B !== "None" && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text">{t("title_step5")}</span>
                      </div>
                    )}
                    {step3 === "false" && step2B === "None" && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text">{t("title_darpery&sheer_step5")}</span>
                      </div>
                    )}
                    <NextStep currentStep="3" eventKey={measurementsNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  {stepSelectedValue["3"] === "1" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <div className="measurementsHelp_link">
                                {t("step3_help_11")}
                                <span
                                  className="link_between_text"
                                  onClick={(e) => modalHandleShow("measurementsHelp")}
                                >
                                  {t("step3_help_12")}
                                </span>
                                {t("step3_help_13")}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                  {stepSelectedValue["3"] === "2" && (
                    <div className="accordion_help">
                      <div className="help_container">
                        <div className="help_column help_left_column">
                          <p className="help_column_header" />
                          <ul className="help_column_list">
                            <li className="no_listStyle single_line_height">
                              <b>{t("Note:&nbsp;")}</b>
                              {t("step3_help_2.5")}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* start step No, I don't have hardware */}
            {/* step 5A */}
            <Card className={step3 === "true" && step31 === "false" ? "" : "noDisplay"}>
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3A"
                  stepNum={t("5A")}
                  stepTitle={t("grommet_step3A")}
                  stepRef="3A"
                  type="1"
                  required={requiredStep["3A"]}
                  stepSelected={
                    stepSelectedLabel["3A"] === undefined ? "" : stepSelectedLabel["3A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3A">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_4_grommet">
                    <div className="box50 radio_style">
                      <img
                        src={
                          step3A0 === "Wall"
                            ? require("../Images/drapery/grommet/CP_standard.svg").default
                            : step3A0 === "Ceiling"
                            ? require("../Images/drapery/grommet/CP_standard2.svg").default
                            : require("../Images/drapery/grommet/CP_standard3.svg").default
                        }
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Standard")}
                        value="1"
                        name="step3A"
                        ref-num="3A"
                        id="3A1"
                        checked={step3A === "Standard"}
                        onChange={(e) => {
                          if (step3A !== "" && anyMeasurements) {
                            modalHandleShow("CurtainPosWarning");
                            setCurtainPosTemp({
                              stepValue: "Standard",
                              id: "",
                              cartValue: "Standard",
                              event: e,
                            });
                          } else {
                            setStep3A("Standard");
                            clearInputs(e);
                            setCart(
                              "CurtainPosition",
                              "Standard",
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            if (step3B === "Sill" || step3B === "Apron") {
                              if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                setDeps(
                                  "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                  "3A,3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3D1,3D2,3E,3F,3G",
                                  "3A,3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            } else {
                              if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                setDeps(
                                  "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                  "3A,3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                );
                              } else {
                                setDeps(
                                  "3C,3D1,3D2,3EFloor,3F,3G",
                                  "3A,3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3A1"] = ref)}
                      />
                      <label htmlFor="3A1">{t("Standard")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <img
                        src={
                          step3A0 === "Wall"
                            ? require("../Images/drapery/grommet/CP_Wall.svg").default
                            : step3A0 === "Ceiling"
                            ? require("../Images/drapery/grommet/CP_Wall2.svg").default
                            : require("../Images/drapery/grommet/CP_Wall3.svg").default
                        }
                        className="img-fluid half_margin"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Wall to Wall")}
                        value="2"
                        name="step3A"
                        ref-num="3A"
                        id="3A2"
                        checked={step3A === "Wall to Wall"}
                        onChange={(e) => {
                          if (step3A !== "" && anyMeasurements) {
                            modalHandleShow("CurtainPosWarning");
                            setCurtainPosTemp({
                              stepValue: "Wall to Wall",
                              id: "",
                              cartValue: "Wall to Wall",
                              event: e,
                            });
                          } else {
                            setStep3A("Wall to Wall");
                            clearInputs(e);
                            setCart(
                              "CurtainPosition",
                              "Wall to Wall",
                              "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                            );
                            if (step3B === "Sill" || step3B === "Apron") {
                              if (step3A0 === "Wall") {
                                setDeps(
                                  "3C,3E,3F,3G",
                                  "3A,3B,3B1,3D1,3D2,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                  "3A,3B,3B1,3D1,3D2,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              }
                            } else {
                              if (step3A0 === "Wall") {
                                setDeps(
                                  "3C,3EFloor,3F,3G",
                                  "3A,3B,3B1,3D1,3D2,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                );
                              } else {
                                setDeps(
                                  "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                  "3A,3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                );
                              }
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3A2"] = ref)}
                      />
                      <label htmlFor="3A2">{t("Wall to Wall")}</label>
                    </div>
                    <div className="box100 dir_ltr">
                      <div className="box50 radio_style">
                        <img
                          src={
                            step3A0 === "Wall"
                              ? require("../Images/drapery/grommet/CP_Left.svg").default
                              : step3A0 === "Ceiling"
                              ? require("../Images/drapery/grommet/CP_Left2.svg").default
                              : require("../Images/drapery/grommet/CP_Left3.svg").default
                          }
                          className="img-fluid half_margin"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          text={t("Left Corner Window")}
                          value="3"
                          name="step3A"
                          ref-num="3A"
                          id="3A3"
                          checked={step3A === "Left Corner Window"}
                          onChange={(e) => {
                            if (step3A !== "" && anyMeasurements) {
                              modalHandleShow("CurtainPosWarning");
                              setCurtainPosTemp({
                                stepValue: "Left Corner Window",
                                id: "",
                                cartValue: "Left Corner Window",
                                event: e,
                              });
                            } else {
                              setStep3A("Left Corner Window");
                              clearInputs(e);
                              setCart(
                                "CurtainPosition",
                                "Left Corner Window",
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              if (step3B === "Sill" || step3B === "Apron") {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                    "3A,3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3E,3F,3G",
                                    "3A,3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              } else {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                    "3A,3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3EFloor,3F,3G",
                                    "3A,3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              }
                            }
                          }}
                          ref={(ref) => (inputs.current["3A3"] = ref)}
                        />
                        <label htmlFor="3A3">{t("Left Corner Window")}</label>
                      </div>
                      <div className="box50 radio_style">
                        <img
                          src={
                            step3A0 === "Wall"
                              ? require("../Images/drapery/grommet/CP_Right.svg").default
                              : step3A0 === "Ceiling"
                              ? require("../Images/drapery/grommet/CP_Right2.svg").default
                              : require("../Images/drapery/grommet/CP_Right3.svg").default
                          }
                          className="img-fluid half_margin"
                          alt=""
                        />
                        <input
                          className="radio"
                          type="radio"
                          text={t("Right Corner Window")}
                          value="4"
                          name="step3A"
                          ref-num="3A"
                          id="3A4"
                          checked={step3A === "Right Corner Window"}
                          onChange={(e) => {
                            if (step3A !== "" && anyMeasurements) {
                              modalHandleShow("CurtainPosWarning");
                              setCurtainPosTemp({
                                stepValue: "Right Corner Window",
                                id: "",
                                cartValue: "Right Corner Window",
                                event: e,
                              });
                            } else {
                              setStep3A("Right Corner Window");
                              clearInputs(e);
                              setCart(
                                "CurtainPosition",
                                "Right Corner Window",
                                "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                              );
                              if (step3B === "Sill" || step3B === "Apron") {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                    "3A,3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3E,3F,3G",
                                    "3A,3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              } else {
                                if (step3A0 === "Ceiling" || step3A0 === "Moulding") {
                                  setDeps(
                                    "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                    "3A,3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                                  );
                                } else {
                                  setDeps(
                                    "3C,3D1,3D2,3EFloor,3F,3G",
                                    "3A,3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                                  );
                                }
                              }
                            }
                          }}
                          ref={(ref) => (inputs.current["3A4"] = ref)}
                        />
                        <label htmlFor="3A4">{t("Right Corner Window")}</label>
                      </div>
                    </div>

                    <NextStep currentStep="3A" eventKey="3B">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5B */}
            <Card
              className={
                step3 === "true" && step31 === "false" && step3A0 !== "" && step3A !== ""
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("5B")}
                  stepTitle={t("dk_step2A")}
                  stepRef="3B"
                  type="1"
                  required={requiredStep["3B"]}
                  stepSelected={
                    stepSelectedLabel["3B"] === undefined ? "" : stepSelectedLabel["3B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body card_body_radio card_body_finished_length card_body_finished_length_grommet">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2A_title")}</p>
                    </div>
                    <div className="box25 radio_style">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-05.svg").default
                            : require("../Images/drapery/grommet/length type-04.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Sill")}
                        value="1"
                        name="step3B"
                        ref-num="3B"
                        id="3B1"
                        checked={step3B === "Sill"}
                        onChange={(e) => {
                          if (
                            (step3B === "Floor" || step3B === "Slight Puddle") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Sill",
                              id: "",
                              cartValue: "Sill",
                              event: e,
                            });
                          } else {
                            setStep3B("Sill");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Sill");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3E,3F,3G",
                                "3B,3B1,3D1,3D2,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3D1,3D2,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3E,3F,3G",
                                "3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B1"] = ref)}
                      />
                      <label htmlFor="3B1">{t("Sill")}</label>
                    </div>
                    <div className="box25 radio_style">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-06.svg").default
                            : require("../Images/drapery/grommet/length type-03.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Apron")}
                        value="2"
                        name="step3B"
                        ref-num="3B"
                        id="3B2"
                        checked={step3B === "Apron"}
                        onChange={(e) => {
                          if (
                            (step3B === "Floor" || step3B === "Slight Puddle") &&
                            anyMeasurements
                          ) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Apron",
                              id: "",
                              cartValue: "Apron",
                              event: e,
                            });
                          } else {
                            setStep3B("Apron");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Apron");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3E,3F,3G",
                                "3B,3B1,3D1,3D2,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                                "3B,3B1,3D1,3D2,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3E,3F,3G",
                                "3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B2"] = ref)}
                      />
                      <label htmlFor="3B2">{t("Apron")}</label>
                    </div>
                    <div className="box25 radio_style">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-07.svg").default
                            : require("../Images/drapery/grommet/length type-02.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Floor")}
                        value="3"
                        name="step3B"
                        ref-num="3B"
                        id="3B3"
                        checked={step3B === "Floor"}
                        onChange={(e) => {
                          if ((step3B === "Sill" || step3B === "Apron") && anyMeasurements) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Floor",
                              id: "",
                              cartValue: "Floor",
                              event: e,
                            });
                          } else {
                            setStep3B("Floor");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Floor");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3EFloor,3F,3G",
                                "3B,3B1,3D1,3D2,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3EFloor,3F,3G",
                                "3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B3"] = ref)}
                      />
                      <label htmlFor="3B3">{t("Floor")}</label>
                    </div>
                    <div className="box25 radio_style">
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/grommet/length type-08.svg").default
                            : require("../Images/drapery/grommet/length type-01.svg").default
                        }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <input
                        className="radio"
                        type="radio"
                        text={t("Slight Puddle")}
                        value="4"
                        name="step3B"
                        ref-num="3B"
                        id="3B4"
                        checked={step3B === "Slight Puddle"}
                        onChange={(e) => {
                          if ((step3B === "Sill" || step3B === "Apron") && anyMeasurements) {
                            modalHandleShow("FinishedLengthWarning");
                            setFinishedLengthTemp({
                              stepValue: "Slight Puddle",
                              id: "",
                              cartValue: "Slight Puddle",
                              event: e,
                            });
                          } else {
                            setStep3B("Slight Puddle");
                            clearInputs(e);
                            setCart("FinishedLengthType", "Slight Puddle");
                            if (
                              (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                              (step3A === "Standard" ||
                                step3A === "Left Corner Window" ||
                                step3A === "Right Corner Window")
                            ) {
                              setDeps(
                                "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                              setDeps(
                                "3C,3EFloor,3F,3G",
                                "3B,3B1,3D1,3D2,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            } else if (
                              step3A === "Wall to Wall" &&
                              (step3A0 === "Ceiling" || step3A0 === "Moulding")
                            ) {
                              setDeps(
                                "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                                "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                              );
                            } else {
                              setDeps(
                                "3C,3D1,3D2,3EFloor,3F,3G",
                                "3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                              );
                            }
                          }
                        }}
                        ref={(ref) => (inputs.current["3B4"] = ref)}
                      />
                      <label htmlFor="3B4">{t("Slight Puddle")}</label>
                    </div>

                    <div
                      className={
                        step3B === "Apron"
                          ? step3BErr1
                            ? "secondary_options secondary_options_err secondary_options_text"
                            : "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">
                            {t("grommet_apron_checkbox_title")}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div
                      className={
                        step3B === "Slight Puddle"
                          ? "secondary_options secondary_options_text"
                          : "noDisplay"
                      }
                    >
                      <div className="card-body-display-flex">
                        <div className="checkbox_style checkbox_style_step2">
                          <span className="checkbox_text box100">{t("puddle_text")}</span>
                        </div>
                      </div>
                    </div>

                    {step3BErr1 && <div className="input_not_valid">{t("grommet_step3AErr1")}</div>}
                    <NextStep currentStep="3B" eventKey="3C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header"></p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <b>{t("dk_step2a_help1")}</b>
                            {t("dk_step2a_help2")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help2")}</b>
                            {t("grommet_step3a_help3")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help4")}</b>
                            {t("grommet_step3a_help5")}
                          </li>
                          <li className="no_listStyle">
                            <b>{t("grommet_step3a_help6")}</b>
                            {t("grommet_step3a_help7")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5C*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== ""
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={step3A === "Wall to Wall" ? t("grommet_width_wall") : t("dk_step2B")}
                  stepRef="3C"
                  type="2"
                  required={requiredStep["3C"]}
                  stepSelected={
                    stepSelectedLabel["3C"] === undefined ? "" : stepSelectedLabel["3C"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A === "Wall to Wall"
                          ? t("grommet_width_wall_title")
                          : t("dk_step2B_title")}
                      </p>
                      <img
                        src={
                          step3A === "Wall to Wall"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/grommet/FrameSize_wall_arc.svg").default
                              : pageLanguage === "en"
                              ? require("../Images/drapery/europeanNew2/WCE-IDONOT-WallToWall.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FWCE-IDONOT-WallToWall-01.svg")
                                  .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-Window-Width-01.svg")
                                .default
                        }
                        className="img-fluid frame_with_top"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (width3C !== undefined && (width3C < 1 || width3C > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="width3C"
                              value={NumToFa(`${width3C || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Width3C", parseInt(newValue));
                                    setDeps("", "3C");
                                    setWidth3C(parseInt(newValue));
                                    optionSelectChanged(
                                      "3C",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Width3C");
                                    setDeps("3C", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWidth3C(undefined);
                                      selectChanged(undefined, "3C");
                                    } else {
                                      setWidth3C(parseInt(newValue));
                                      selectChanged("3C", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3C" eventKey={step3A === "Wall to Wall" ? "3E" : "3D"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5D*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== "" &&
                !(step3A === "Wall to Wall")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3D"
                  stepNum={t("5D")}
                  stepTitle={t("dk_step2CCeiling")}
                  stepRef="3D"
                  type="2"
                  required={requiredStep["3D"]}
                  stepSelected={
                    stepSelectedLabel["3D"] === undefined ? "" : stepSelectedLabel["3D"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3D">
                <Card.Body>
                  <div className="card_body card_body_overflow_issue">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2c_out_title")}</p>
                      <img
                        src={
                          require("../Images/drapery/europeanNew2/WCE-IDONOT-Stack-Width -01.svg")
                            .default
                        }
                        className="img-fluid frame_with_top2"
                        alt=""
                      />
                    </div>
                    <div className="box100 Two_selection_container dir_ltr">
                      <div className="box50">
                        <div
                          className={
                            step3A === "Left Corner Window"
                              ? "measure_input_container disabled"
                              : "measure_input_container"
                          }
                        >
                          <h1 className="measure_input_label">{t("Left")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Left"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Right"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (left !== undefined && (left < 1 || left > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="Left"
                              value={NumToFa(`${left || ""}`, pageLanguage)}
                              disabled={step3A === "Left Corner Window"}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    if (step3A === "Right Corner Window") {
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        true,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage,
                                        0
                                      );
                                      setDeps("", "3D1,3D2");
                                      setCart(
                                        "ExtensionLeft",
                                        parseInt(newValue),
                                        "",
                                        "ExtensionRight",
                                        [0]
                                      );
                                    } else {
                                      setCart("ExtensionLeft", parseInt(newValue));
                                      setDeps("", "3D1");
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        true,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage
                                      );
                                    }
                                    setLeft(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    if (step3A === "Right Corner Window") {
                                      setDeps("3D1,3D2", "");
                                      setCart("", "", "ExtensionLeft,ExtensionRight");
                                    } else {
                                      setCart("", "", "ExtensionLeft");
                                      setDeps("3D1", "");
                                    }
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setLeft(undefined);
                                      selectChanged(undefined, "3D");
                                    } else {
                                      setLeft(parseInt(newValue));
                                      selectChanged("3D", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                        {step3A === "Left Corner Window" && (
                          <OverlayContainer
                            classNames="extension_unavailable"
                            placement="bottom"
                            children={
                              <div className="extension_unavailable_title text_underline">
                                {t("Why is this unavailable?")}
                              </div>
                            }
                            component={
                              <div className="extension_unavailable_container">
                                <div className="extension_unavailable_text">
                                  {t("Left_unavailable_text")}
                                </div>
                              </div>
                            }
                          />
                        )}
                      </div>
                      <div className="box50">
                        <div
                          className={
                            step3A === "Right Corner Window"
                              ? "measure_input_container disabled"
                              : "measure_input_container"
                          }
                        >
                          <h1 className="measure_input_label">{t("Right")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["Right"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["Left"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (right !== undefined && (right < 1 || right > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="right"
                              value={NumToFa(`${right || ""}`, pageLanguage)}
                              disabled={step3A === "Right Corner Window"}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    if (step3A === "Left Corner Window") {
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        false,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage,
                                        0
                                      );
                                      setDeps("", "3D2,3D1");
                                      setCart(
                                        "ExtensionRight",
                                        parseInt(newValue),
                                        "",
                                        "ExtensionLeft",
                                        [0]
                                      );
                                    } else {
                                      setCart("ExtensionRight", parseInt(newValue));
                                      setDeps("", "3D2");
                                      optionSelectChanged_LeftRight(
                                        parseInt(newValue),
                                        "3D",
                                        false,
                                        "cm",
                                        "س\u200Cم",
                                        pageLanguage
                                      );
                                    }
                                    setRight(parseInt(newValue));
                                  } else {
                                    setCartLoading(true);
                                    if (step3A === "Left Corner Window") {
                                      setDeps("3D2,3D1", "");
                                      setCart("", "", "ExtensionRight,ExtensionLeft");
                                    } else {
                                      setCart("", "", "ExtensionRight");
                                      setDeps("3D2", "");
                                    }
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRight(undefined);
                                      selectChanged(undefined, "3D");
                                    } else {
                                      setRight(parseInt(newValue));
                                      selectChanged("3D", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                        {step3A === "Right Corner Window" && (
                          <OverlayContainer
                            classNames="extension_unavailable"
                            placement="bottom"
                            children={
                              <div className="extension_unavailable_title text_underline">
                                {t("Why is this unavailable?")}
                              </div>
                            }
                            component={
                              <div className="extension_unavailable_container">
                                <div className="extension_unavailable_text">
                                  {t("Right_unavailable_text")}
                                </div>
                              </div>
                            }
                          />
                        )}
                      </div>
                    </div>

                    <NextStep currentStep="3D" eventKey="3E">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>

                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("grommet_step3C_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5E*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== "" &&
                !(
                  (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3A === "Standard" ||
                    step3A === "Left Corner Window" ||
                    step3A === "Right Corner Window")
                ) &&
                !(step3A === "Wall to Wall" && (step3A0 === "Ceiling" || step3A0 === "Moulding")) &&
                (step3B === "Sill" || step3B === "Apron")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={windowWidthTitle}
                  stepTitle={t("dk_step2EWall")}
                  stepRef="3E"
                  type="2"
                  required={requiredStep["3E"]}
                  stepSelected={
                    stepSelectedLabel["3E"] === undefined ? "" : stepSelectedLabel["3E"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2EWall_title")}</p>
                      <img
                        src={
                          require("../Images/drapery/europeanNew2/WCE-IDONOT-Window-Height-01.svg")
                            .default
                        }
                        className="img-fluid just_frame"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (height3E !== undefined && (height3E < 1 || height3E > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="height3E"
                              value={NumToFa(`${height3E || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("Height3E", parseInt(newValue));
                                    setDeps("", "3E");
                                    setHeight3E(parseInt(newValue));
                                    optionSelectChanged(
                                      "3E",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "Height3E");
                                    setDeps("3E", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setHeight3E(undefined);
                                      selectChanged(undefined, "3E");
                                    } else {
                                      setHeight3E(parseInt(newValue));
                                      selectChanged("3E", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3E" eventKey={step3A === "Wall to Wall" ? "3F" : "3F"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EFloor */}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== "" &&
                !(
                  (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3A === "Standard" ||
                    step3A === "Left Corner Window" ||
                    step3A === "Right Corner Window")
                ) &&
                !(step3A === "Wall to Wall" && (step3A0 === "Ceiling" || step3A0 === "Moulding")) &&
                (step3B === "Floor" || step3B === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={
                    step3A === "Wall to Wall" ? t("5D") : step3A0 === "Wall" ? t("5E") : t("5F")
                  }
                  stepTitle={t("dk_step2DWall")}
                  stepRef="3EFloor"
                  type="2"
                  required={requiredStep["3EFloor"]}
                  stepSelected={
                    stepSelectedLabel["3EFloor"] === undefined ? "" : stepSelectedLabel["3EFloor"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2DWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/FWCE-IDONOT-WindowToFloor-Height-01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-WindowToFloor-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (windowToFloor !== undefined &&
                                (windowToFloor < 1 || windowToFloor > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="windowToFloor1"
                              value={NumToFa(`${windowToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("WindowToFloor", parseInt(newValue));
                                    setDeps("", "3EFloor");
                                    setWindowToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3EFloor",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "WindowToFloor");
                                    setDeps("3EFloor", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setWindowToFloor(undefined);
                                      selectChanged(undefined, "3EFloor");
                                    } else {
                                      setWindowToFloor(parseInt(newValue));
                                      selectChanged(
                                        "3EFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep="3EFloor"
                      eventKey={step3A === "Wall to Wall" ? "3F" : "3F"}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EStandardCeiling */}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                (((step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3A === "Standard" ||
                    step3A === "Left Corner Window" ||
                    step3A === "Right Corner Window")) ||
                  (step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding"))) &&
                step3B !== "" &&
                step3A0 !== "" &&
                (step3B === "Sill" || step3B === "Apron")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={sillStepNum}
                  stepTitle={t("dk_step2D_sill")}
                  stepRef="3EStandardCeiling"
                  type="2"
                  required={requiredStep["3EStandardCeiling"]}
                  stepSelected={
                    stepSelectedLabel["3EStandardCeiling"] === undefined
                      ? ""
                      : stepSelectedLabel["3EStandardCeiling"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A0 === "Moulding" ? t("arc_step2D_title") : t("dk_step2D_title")}
                      </p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/dk/new_ceiling_to_window_3_arc_fa.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FCeiling-IDONOT-CeIlingToWindowHeight-01.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/dk/new_ceiling_to_window_3_arc.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/Ceiling-IDONOT-CeIlingToWindowHeight-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow1 !== undefined &&
                                (ceilingToWindow1 < 1 || ceilingToWindow1 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow1"
                              value={NumToFa(`${ceilingToWindow1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow1", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling1");
                                    setCeilingToWindow1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow1");
                                    setDeps("3EStandardCeiling1", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow1(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow1(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow2"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  if (pageLanguage === "fa") {
                                    inputs.current["ceilingToWindow1"].focus();
                                  } else {
                                    inputs.current["ceilingToWindow3"].focus();
                                  }
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow2 !== undefined &&
                                (ceilingToWindow2 < 1 || ceilingToWindow2 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow2"
                              value={NumToFa(`${ceilingToWindow2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow2", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling2");
                                    setCeilingToWindow2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow2");
                                    setDeps("3EStandardCeiling2", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow2(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow2(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3BIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToWindow3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToWindow2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToWindow3 !== undefined &&
                                (ceilingToWindow3 < 1 || ceilingToWindow3 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToWindow3"
                              value={NumToFa(`${ceilingToWindow3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToWindow3", parseInt(newValue));
                                    setDeps("", "3EStandardCeiling3");
                                    setCeilingToWindow3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeiling",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToWindow3");
                                    setDeps("3EStandardCeiling3", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToWindow3(undefined);
                                      selectChanged(undefined, "3EStandardCeiling");
                                    } else {
                                      setCeilingToWindow3(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeiling",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1
                          ? "3"
                          : "3EStandardCeiling"
                      }
                      eventKey="3G"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5EStandardCeilingFloor */}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                (((step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3A === "Standard" ||
                    step3A === "Left Corner Window" ||
                    step3A === "Right Corner Window")) ||
                  (step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding"))) &&
                step3B !== "" &&
                step3A0 !== "" &&
                (step3B === "Floor" || step3B === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3E"
                  stepNum={step3A === "Wall to Wall" ? t("5D") : t("5E")}
                  stepTitle={t("dk_step2E")}
                  stepRef="3EStandardCeilingFloor"
                  type="2"
                  required={requiredStep["3EStandardCeilingFloor"]}
                  stepSelected={
                    stepSelectedLabel["3EStandardCeilingFloor"] === undefined
                      ? ""
                      : stepSelectedLabel["3EStandardCeilingFloor"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3E">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">
                        {step3A0 === "Moulding" ? t("arc_step2E_title") : t("dk_step2E_title")}
                      </p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/dk/new_ceiling_to_floor_3_arc_fa.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/FCeiling-IDONOT-Height-01.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/dk/new_ceiling_to_floor_3_arc.svg").default
                            : require("../Images/drapery/europeanNew2/Ceiling-IDONOT-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>

                    <div className="box100 Three_selection_container">
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_A")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor1"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToFloor2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor1 !== undefined &&
                                (ceilingToFloor1 < 1 || ceilingToFloor1 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor1"
                              value={NumToFa(`${ceilingToFloor1 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor1", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor1");
                                    setCeilingToFloor1(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      0,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor1");
                                    setDeps("3EStandardCeilingFloor1", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor1(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor1(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_B")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor2"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  if (pageLanguage === "fa") {
                                    inputs.current["ceilingToFloor1"].focus();
                                  } else {
                                    inputs.current["ceilingToFloor3"].focus();
                                  }
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor2 !== undefined &&
                                (ceilingToFloor2 < 1 || ceilingToFloor2 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor2"
                              value={NumToFa(`${ceilingToFloor2 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor2", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor2");
                                    setCeilingToFloor2(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      1,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor2");
                                    setDeps("3EStandardCeilingFloor2", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor2(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor2(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                      <div className="Three_select_container">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("step3AIn_C")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              inputRef={(ref) => (inputs.current["ceilingToFloor3"] = ref)}
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  inputs.current["ceilingToFloor2"].focus();
                                } else if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor3 !== undefined &&
                                (ceilingToFloor3 < 1 || ceilingToFloor3 > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor3"
                              value={NumToFa(`${ceilingToFloor3 || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor3", parseInt(newValue));
                                    setDeps("", "3EStandardCeilingFloor3");
                                    setCeilingToFloor3(parseInt(newValue));
                                    optionSelectChanged_three(
                                      parseInt(newValue),
                                      "3EStandardCeilingFloor",
                                      2,
                                      true,
                                      "heightDifferent",
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage,
                                      "3E"
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor3");
                                    setDeps("3EStandardCeilingFloor3", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor3(undefined);
                                      selectChanged(undefined, "3EStandardCeilingFloor");
                                    } else {
                                      setCeilingToFloor3(parseInt(newValue));
                                      selectChanged(
                                        "3EStandardCeilingFloor",
                                        undefined,
                                        t("Invalid Measurements")
                                      );
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1
                          ? "3"
                          : "3EStandardCeilingFloor"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5F */}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== "" &&
                !(
                  (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3A === "Standard" ||
                    step3A === "Left Corner Window" ||
                    step3A === "Right Corner Window")
                ) &&
                !(step3A === "Wall to Wall" && (step3A0 === "Ceiling" || step3A0 === "Moulding"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3F"
                  stepNum={
                    step3A === "Wall to Wall" ? t("5E") : step3A0 === "Wall" ? t("5F") : t("5G")
                  }
                  stepTitle={t("dk_step2FWall")}
                  stepRef="3F"
                  type="2"
                  required={requiredStep["3F"]}
                  stepSelected={
                    stepSelectedLabel["3F"] === undefined ? "" : stepSelectedLabel["3F"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3F">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2FWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/WCE-IDONOT-Mount-Height-01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/WCE-IDONOT-Mount-Height-01.svg")
                                .default
                        }
                        className="img-fluid frame_with_top2"
                        alt="img-Height-Mount"
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (mount !== undefined && mount < 10 ? " measure_input_err" : "")
                              }
                              type="text"
                              name="mount"
                              value={NumToFa(`${mount || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (newValue && newValue !== "" && parseInt(newValue) >= 10) {
                                    setCartLoading(true);
                                    setCart("ShadeMount", parseInt(newValue));
                                    setDeps("", "3F");
                                    setMount(parseInt(newValue));
                                    optionSelectChanged(
                                      "3F",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "ShadeMount");
                                    setDeps("3F", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setMount(undefined);
                                      selectChanged(undefined, "3F");
                                    } else {
                                      setMount(parseInt(newValue));
                                      selectChanged("3F", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={`${
                              pageLanguage === "fa" ? "measure_input_desc_fa" : "measure_input_desc"
                            }${mount !== undefined && mount < 10 ? " measure_input_desc_err" : ""}`}
                          >
                            {t("Min: ")} {NumToFa(`10`, pageLanguage)} {t("cm_label")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="3F" eventKey="3G">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle single_line_height">
                            {t("grommet_step3E_help_1")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5G*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "false" &&
                step3A !== "" &&
                step3B !== "" &&
                step3A0 !== "" &&
                !(
                  (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                  (step3B === "Floor" || step3B === "Slight Puddle")
                )
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3G"
                  stepNum={wallExtensionStepNum}
                  stepTitle={t("dk_step2FWall2")}
                  stepRef="3G"
                  type="2"
                  required={requiredStep["3G"]}
                  stepSelected={
                    stepSelectedLabel["3G"] === undefined ? "" : stepSelectedLabel["3G"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3G">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2GWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? require("../Images/drapery/europeanNew2/FWall-IDONOT-Room-Height -01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/Wall-IDONOT-Room-Height-01.svg")
                                .default
                        }
                        className="img-fluid tall_curtain_image"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor !== undefined &&
                                (ceilingToFloor < 1 ||
                                  ceilingToFloor > 1000 ||
                                  (heightCart && ceilingToFloor < +heightCart))
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor"
                              value={NumToFa(`${ceilingToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000 &&
                                    !(heightCart && parseInt(newValue) < +heightCart)
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor", parseInt(newValue));
                                    setDeps("", "3G");
                                    setCeilingToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "3G",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor");
                                    setDeps("3G", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor(undefined);
                                      selectChanged(undefined, "3G");
                                    } else {
                                      setCeilingToFloor(parseInt(newValue));
                                      selectChanged("3G", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={
                              "measure_input_desc" +
                              (ceilingToFloor !== undefined &&
                              (ceilingToFloor < 1 ||
                                ceilingToFloor > 1000 ||
                                (heightCart && ceilingToFloor < +heightCart))
                                ? " measure_input_desc_err"
                                : "")
                            }
                          >
                            {heightCart && ceilingToFloor < +heightCart
                              ? t("roomHeight_more_than_height")
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "3G"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            {/* I HAVE ROD */}
            {/* step 5ARod */}

            <Step5ARodGrommet
              step3={step3}
              nameStep={nameStep}
              step31={step31}
              depSet={depSet}
              accordionActiveKey={accordionActiveKey}
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              pageLanguage={pageLanguage}
              step3ARod={step3ARod}
              setStep3ARod={setStep3ARod}
              clearInputs={clearInputs}
              setCart={setCart}
              setDeps={setDeps}
              inputs={inputs}
              step3ARodErr1={step3ARodErr1}
              NextStep={NextStep}
            />

            {/* step 5BRod*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                ((step3ARod !== "" && step3ARod !== "Apron") ||
                  (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3B"
                  stepNum={t("5B")}
                  stepTitle={t("grommet_step3BRod")}
                  stepRef="325"
                  type="2"
                  required={requiredStep["325"]}
                  stepSelected={
                    stepSelectedLabel["325"] === undefined ? "" : stepSelectedLabel["325"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3B">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3BRod_title")}</p>
                      <img
                        src={
                          step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRodWidth01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodlength.svg").default
                        }
                        className="img-fluid frame_with_top"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Width-1")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodWidth !== undefined && (rodWidth < 1 || rodWidth > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodWidth"
                              value={NumToFa(`${rodWidth || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodWidth", parseInt(newValue));
                                    setDeps("", "325");
                                    setRodWidth(parseInt(newValue));
                                    optionSelectChanged(
                                      "325",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodWidth");
                                    setDeps("325", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodWidth(undefined);
                                      selectChanged(undefined, "325");
                                    } else {
                                      setRodWidth(parseInt(newValue));
                                      selectChanged("325", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="325" eventKey="3C">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5CRod*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                (step3ARod === "Sill" || (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={t("grommet_step3DRod")}
                  stepRef="335"
                  type="2"
                  required={requiredStep["335"]}
                  stepSelected={
                    stepSelectedLabel["335"] === undefined ? "" : stepSelectedLabel["335"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3DRod_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Sill01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodsillheight.svg").default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Sill01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodsillheight.svg").default
                        }
                        className="img-fluid just_frame"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodToBottom !== undefined &&
                                (rodToBottom < 1 || rodToBottom > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodToBottom1"
                              value={NumToFa(`${rodToBottom || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodToBottom", parseInt(newValue));
                                    setDeps("", "335");
                                    setRodToBottom(parseInt(newValue));
                                    optionSelectChanged(
                                      "335",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodToBottom");
                                    setDeps("335", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodToBottom(undefined);
                                      selectChanged(undefined, "335");
                                    } else {
                                      setRodToBottom(parseInt(newValue));
                                      selectChanged("335", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="335" eventKey="3D">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5CRodFloor*/}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                (step3ARod === "Floor" || step3ARod === "Slight Puddle")
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3C"
                  stepNum={t("5C")}
                  stepTitle={t("grommet_step3DRodFloor")}
                  stepRef="336"
                  type="2"
                  required={requiredStep["336"]}
                  stepSelected={
                    stepSelectedLabel["336"] === undefined ? "" : stepSelectedLabel["336"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3C">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("grommet_step3DRodFloor_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Floor01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodfloorheight.svg")
                                  .default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Floor01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodfloorheight.svg").default
                        }
                        className="img-fluid just_frame"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <h1 className="measure_input_label">{t("Height")}</h1>
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (rodToFloor !== undefined && (rodToFloor < 1 || rodToFloor > 1000)
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="rodToFloor1"
                              value={NumToFa(`${rodToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000
                                  ) {
                                    setCartLoading(true);
                                    setCart("RodToFloor", parseInt(newValue));
                                    setDeps("", "336");
                                    setRodToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "336",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "RodToFloor");
                                    setDeps("336", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setRodToFloor(undefined);
                                      selectChanged(undefined, "336");
                                    } else {
                                      setRodToFloor(parseInt(newValue));
                                      selectChanged("336", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="336" eventKey="3D">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 5DRod */}
            <Card
              className={
                step3 === "true" &&
                step31 === "true" &&
                ((step3ARod !== "" && step3ARod !== "Apron") ||
                  (step3ARod === "Apron" && step3ARod1 === "true"))
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
                  !accordionActiveKey.startsWith("3")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="3D"
                  stepNum={t("5D")}
                  stepTitle={t("dk_step2FWall2")}
                  stepRef="345"
                  type="2"
                  required={requiredStep["345"]}
                  stepSelected={
                    stepSelectedLabel["345"] === undefined ? "" : stepSelectedLabel["345"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="3D">
                <Card.Body>
                  <div className="card_body">
                    <div className="box100">
                      <p className="step_selection_title">{t("dk_step2GWall_title")}</p>
                      <img
                        src={
                          pageLanguage === "fa"
                            ? step3A0 === "Moulding"
                              ? require("../Images/drapery/europeanNew2/FMouldingRod-Home01.svg")
                                  .default
                              : require("../Images/drapery/europeanNew2/Frodroomheight.svg").default
                            : step3A0 === "Moulding"
                            ? require("../Images/drapery/europeanNew2/MouldingRod-Home01.svg")
                                .default
                            : require("../Images/drapery/europeanNew2/rodroomheight.svg").default
                        }
                        className="img-fluid frame_with_top2"
                        alt=""
                      />
                    </div>
                    <div className="box100 Three_selection_container">
                      <div className="box100">
                        <div className="measure_input_container">
                          <div className="measure_input_field_container">
                            <DebounceInput
                              debounceTimeout={1500}
                              autoComplete="off"
                              onKeyDown={(e) => {
                                if (
                                  !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                                  e.keyCode !== 8 &&
                                  e.keyCode !== 46 &&
                                  e.keyCode !== 37 &&
                                  e.keyCode !== 39 &&
                                  e.keyCode !== 13
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={
                                "measure_input" +
                                (ceilingToFloor !== undefined &&
                                (ceilingToFloor < 1 ||
                                  ceilingToFloor > 1000 ||
                                  (heightCart && ceilingToFloor < +heightCart))
                                  ? " measure_input_err"
                                  : "")
                              }
                              type="text"
                              name="ceilingToFloor"
                              value={NumToFa(`${ceilingToFloor || ""}`, pageLanguage)}
                              onChange={(e) => {
                                setTimeout(() => {
                                  let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                                  newValue = isNaN(newValue) ? "" : newValue;
                                  if (
                                    newValue &&
                                    newValue !== "" &&
                                    parseInt(newValue) >= 1 &&
                                    parseInt(newValue) <= 1000 &&
                                    !(heightCart && parseInt(newValue) < +heightCart)
                                  ) {
                                    setCartLoading(true);
                                    setCart("CeilingToFloor", parseInt(newValue));
                                    setDeps("", "345");
                                    setCeilingToFloor(parseInt(newValue));
                                    optionSelectChanged(
                                      "345",
                                      parseInt(newValue),
                                      "cm",
                                      "س\u200Cم",
                                      pageLanguage
                                    );
                                  } else {
                                    setCartLoading(true);
                                    setCart("", "", "CeilingToFloor");
                                    setDeps("345", "");
                                    if (newValue === "" || isNaN(parseInt(newValue))) {
                                      setCeilingToFloor(undefined);
                                      selectChanged(undefined, "345");
                                    } else {
                                      setCeilingToFloor(parseInt(newValue));
                                      selectChanged("345", undefined, t("Invalid Measurements"));
                                    }
                                  }
                                }, 300);
                              }}
                            />
                            <div className="measure_input_postfix">{t("cm_label")}</div>
                          </div>
                          <h2
                            className={
                              "measure_input_desc" +
                              (ceilingToFloor !== undefined &&
                              (ceilingToFloor < 1 ||
                                ceilingToFloor > 1000 ||
                                (heightCart && ceilingToFloor < +heightCart))
                                ? " measure_input_desc_err"
                                : "")
                            }
                          >
                            {heightCart && ceilingToFloor < +heightCart
                              ? t("roomHeight_more_than_height")
                              : ""}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <NextStep
                      currentStep={
                        [...depSet].findIndex((el) => el.startsWith("3")) === -1 ? "3" : "345"
                      }
                      eventKey="4"
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 6 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="4"
                  stepNum={t("6")}
                  stepTitle={t("grommet_step4_Drapery")}
                  stepRef="4"
                  type="1"
                  required={requiredStep["4"]}
                  stepSelected={stepSelectedLabel["4"] === undefined ? "" : stepSelectedLabel["4"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="4">
                <Card.Body>
                  <div className="card_body card_body_radio tall_img_card_body">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Standard Lining")}
                        value="1"
                        name="step4"
                        ref-num="4"
                        id="41"
                        checked={step4 === "Standard Lining"}
                        onChange={(e) => {
                          setStep4("Standard Lining");
                          setDeps("", "4");
                          setCart("Lining", "Standard Lining");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["41"] = ref)}
                      />
                      <label htmlFor="41">
                        {t("Standard Lining")}
                        <br />
                        <p className="surcharge_price">{t("No Additional Charge")}</p>
                      </label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Privacy Lining")}
                        value="2"
                        name="step4"
                        ref-num="4"
                        id="42"
                        checked={step4 === "Privacy Lining"}
                        onChange={(e) => {
                          setStep4("Privacy Lining");
                          setDeps("", "4");
                          setCart("Lining", "Privacy Lining");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["42"] = ref)}
                      />
                      <label htmlFor="42">
                        {t("Privacy Lining")}
                        <br />
                        <p className="surcharge_price">
                          {liningPrice !== undefined
                            ? liningPrice !== 0
                              ? t("Add ") +
                                GetPrice(liningPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)
                              : t("Surcharge Applies")
                            : t("Surcharge Applies")}
                        </p>
                      </label>
                    </div>

                    <NextStep currentStep="4" eventKey={ step5 === "Full" ? "6" : "5"}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header">{t("grommet_lining_help_1")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix">
                                        <img
                                          src={
                                            popoverImages["step41"] === undefined
                                              ? require("../Images/drapery/grommet/standard_lining.jpg")
                                              : popoverImages["step41"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("grommet_lining_help_1")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/grommet/standard_lining.jpg")}
                                              text="step41"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("grommet_lining_help_2")}
                          </li>
                          <li>{t("grommet_lining_help_3")}</li>
                          <li>{t("grommet_lining_help_4")}</li>
                        </ul>
                      </div>
                      <div className="help_column help_right_column">
                        <p className="help_column_header">{t("grommet_lining_help_5")}</p>
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix">
                                        <img
                                          src={
                                            popoverImages["step42"] === undefined
                                              ? require("../Images/drapery/grommet/privacy_lining.jpg")
                                              : popoverImages["step42"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("grommet_lining_help_5")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/grommet/privacy_lining.jpg")}
                                              text="step42"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("grommet_lining_help_6")}
                          </li>
                          <li>{t("grommet_lining_help_7")}</li>
                          <li>{t("grommet_lining_help_8")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 7 */}
            
            {(step5 !== "Full" || step3 === "true") && (
              <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="5"
                  stepNum={t("7")}
                  stepTitle={t("grommet_step5_Drapery")}
                  stepRef="5"
                  type="1"
                  required={requiredStep["5"]}
                  stepSelected={stepSelectedLabel["5"] === undefined ? "" : stepSelectedLabel["5"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="5">
                <Card.Body>
                  <div className="card_body card_body_radio tall_img_card_body">
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Full")}
                        value="1"
                        name="step5"
                        ref-num="5"
                        id="51"
                        checked={step5 === "Full"}
                        onChange={(e) => {
                          setStep5("Full");
                          if (step2B === "None") {
                            setDeps("6A,6B", "5,6");
                          } else {
                            setDeps("6A,6B,6C", "5,6");
                          }
                          setCart("PanelCoverage", "Full");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["51"] = ref)}
                      />
                      <label htmlFor="51">{t("Full")}</label>
                    </div>
                    <div className="box50 radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("Decorative")}
                        value="2"
                        name="step5"
                        ref-num="5"
                        id="52"
                        checked={step5 === "Decorative"}
                        onChange={(e) => {
                          setStep5("Decorative");
                          if (step2B === "None") {
                            setDeps("6A,6B", "5,6");
                          } else {
                            setDeps("6A,6B,6C", "5,6");
                          }

                          setCart("PanelCoverage", "Decorative");
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["52"] = ref)}
                      />
                      <label htmlFor="52">{t("Decorative")}</label>
                    </div>

                    <NextStep
                      currentStep="5"
                      eventKey="6"
                      onClick={() => {
                        setStepSevenClick(true);
                      }}
                    >
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header">{t("grommet_panel_help_3")}</p>
                        <ul className="help_column_list">
                          <li>{t("grommet_panel_help_4")}</li>
                        </ul>
                      </div>
                      <div className="help_column help_right_column">
                        <p className="help_column_header">{t("grommet_panel_help_1")}</p>
                        <ul className="help_column_list">
                          <li>{t("grommet_panel_help_2.5")}</li>
                          <li>{t("grommet_panel_help_2")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            )}
            

            {/* step 8 */}
            <Step8GrommetOne
              ContextAwareToggle={ContextAwareToggle}
              t={t}
              requiredStep={requiredStep}
              stepSelectedLabel={stepSelectedLabel}
              windowWidthPanelType={windowWidthPanelType}
              step6={step6}
              widthCart={widthCart}
              step5={step5}
              step3A0={step3A0}
              step6A={step6A}
              setStep6A={setStep6A}
              setStep6={setStep6}
              selectChanged={selectChanged}
              setExtendedTitle={setExtendedTitle}
              extendedTitle={extendedTitle}
              setDeps={setDeps}
              setCart={setCart}
              setStep5={setStep5}
              inputs={inputs}
              pageLanguage={pageLanguage}
              NextStep={NextStep}
              modalHandleShow={modalHandleShow}
              setPanelSheerWarningTemp={setPanelSheerWarningTemp}
              setStep6BHead={setStep6BHead}
              step8B={step8B}
              setStep8={setStep8}
              setHardwareNextStep={setHardwareNextStep}
              step6BHead={step6BHead}
              tracksList={tracksList}
              step2A={step2A}
              step8={step8}
              setStep6B={setStep6B}
              step6B={step6B}
              step6CHead={step6CHead}
              setStep6CHead={setStep6CHead}
              step6C={step6C}
              setStep6C={setStep6C}
              step8C={step8C}
              PopoverStickOnHover={PopoverStickOnHover}
              popoverThumbnailHover={popoverThumbnailHover}
              popoverImages={popoverImages}
              step2B={step2B}
              tracksList2={tracksList2}
              step2C={step2C}
              setPanelPLWarningTemp={setPanelPLWarningTemp}
              step3={step3}
            />

            {/* step 9 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="7"
                  stepNum={step5 === "Full" && step3 === "false" ? t("8") : t("9")}
                  stepTitle={t("grommet_step7")}
                  stepRef="7"
                  type="1"
                  required={requiredStep["7"]}
                  stepSelected={stepSelectedLabel["7"] === undefined ? "" : stepSelectedLabel["7"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="7">
                <Card.Body>
                  <div className="card_body card_body_radio bracket_color">
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor1")}
                            value="1"
                            name="step7"
                            ref-num="7"
                            id="71"
                            outline="true"
                            checked={step7 === "Satin Brass"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep7("Satin Brass");
                              setDeps("", "7");
                              setCart("GrommetFinish", "Satin Brass");
                            }}
                            ref={(ref) => (inputs.current["71"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/SatinBrass.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor1")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor2")}
                            value="2"
                            name="step7"
                            ref-num="7"
                            id="72"
                            outline="true"
                            checked={step7 === "Satin Nickel"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep7("Satin Nickel");
                              setDeps("", "7");
                              setCart("GrommetFinish", "Satin Nickel");
                            }}
                            ref={(ref) => (inputs.current["72"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/SatinNickel.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor2")}</h1>
                        </div>
                      </div>
                    </div>
                    <div className="box33">
                      <div className="radio_group">
                        <label className="radio_container">
                          <input
                            className="radio"
                            type="radio"
                            text={t("BracketColor3")}
                            value="3"
                            name="step7"
                            ref-num="7"
                            id="73"
                            outline="true"
                            checked={step7 === "Gun Metal"}
                            onChange={(e) => {
                              selectChanged(e);
                              setStep7("Gun Metal");
                              setDeps("", "7");
                              setCart("GrommetFinish", "Gun Metal");
                            }}
                            ref={(ref) => (inputs.current["73"] = ref)}
                          />
                          <div className="frame_img">
                            <img
                              src={require("../Images/drapery/roller/GunMetal.jpg")}
                              className="img-fluid bracket_color_img"
                              alt=""
                            />
                          </div>
                        </label>
                        <div className="radio_group_name_container">
                          <h1>{t("BracketColor3")}</h1>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="7" eventKey="8">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className="accordion_help">
                    <div className="help_container">
                      <div className="help_column help_left_column">
                        <p className="help_column_header" />
                        <ul className="help_column_list">
                          <li className="no_listStyle">
                            <span className="popover_indicator">
                              {
                                <PopoverStickOnHover
                                  placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                                  children={
                                    <object
                                      className="popover_camera"
                                      type="image/svg+xml"
                                      data={require("../Images/public/camera.svg").default}
                                    />
                                  }
                                  component={
                                    <div className="clearfix">
                                      <div className="popover_image clearfix">
                                        <img
                                          src={
                                            popoverImages["step7"] === undefined
                                              ? require("../Images/drapery/grommet/gold_ring.jpg")
                                              : popoverImages["step7"]
                                          }
                                          className="img-fluid"
                                          alt=""
                                        />
                                      </div>
                                      <div className="popover_footer">
                                        <span className="popover_footer_title">
                                          {t("GrommetFinish_help_camera")}
                                        </span>
                                        <span className="popover_thumbnails">
                                          <div>
                                            <img
                                              src={require("../Images/drapery/grommet/gold_ring.jpg")}
                                              text="step7"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/grommet/white_ring.jpg")}
                                              text="step7"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                          <div>
                                            <img
                                              src={require("../Images/drapery/grommet/black_ring.jpg")}
                                              text="step7"
                                              onMouseEnter={(e) => popoverThumbnailHover(e)}
                                              className="popover_thumbnail_img img-fluid"
                                              alt=""
                                            />
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  }
                                />
                              }
                            </span>
                            {t("GrommetFinish_help1")}
                          </li>
                          <li>
                            <b>{t("Note:&nbsp;")}</b>
                            {t("GrommetFinish_help2")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 10 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="8"
                  stepNum={step5 === "Full" && step3 === "false" ? t("9") : t("10")}
                  stepTitle={t("grommet_step8")}
                  stepRef="8"
                  type="1"
                  required={requiredStep["8"]}
                  stepSelected={stepSelectedLabel["8"] === undefined ? "" : stepSelectedLabel["8"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="8">
                <Card.Body>
                  <div
                    className={
                      step6A === "" || step5 === "" || step3A0 === "" || step2B === ""
                        ? "card_body_info_body card_body_info_body_grommet"
                        : "noDisplay"
                    }
                  >
                    <h1 className="card_body_info_header_title title_step10">{t("more_info")}</h1>

                    <hr />
                    <div>
                      <p className="card_body_info_text card_body_info_text_grommet">
                        {step2A === ""
                          ? t("panel_type_text1_new_hardware")
                          : step2B === ""
                          ? t("panel_type_text1_new_step2B_hardware")
                          : widthCart === undefined && step5 === "" && step3A0 === ""
                          ? t("panel_type_text1_hardware")
                          : widthCart === undefined && step5 !== "" && step3A0 === ""
                          ? t("panel_type_text2")
                          : widthCart === undefined && step5 !== "" && step3A0 !== ""
                          ? t("panel_type_text3")
                          : widthCart === undefined && step5 === "" && step3A0 !== ""
                          ? t("panel_type_text4_hardware")
                          : step5 === ""
                          ? t("panel_type_text6_hardware")
                          : t("panel_type_text5_hardware")}
                        <button
                          className="btn_step10"
                          onClick={() => {
                            modalHandleShow("hardwareCollections");
                          }}
                        >
                          {t("Preview our hardware collections.")}
                        </button>
                      </p>
                    </div>
                    <NextStep currentStep="6" eventKey="7">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div
                    className={
                      widthCart !== undefined && step5 !== "" && step6A !== ""
                        ? "card-body"
                        : "noDisplay"
                    }
                  >
                    <div className="card_body card_body_radio card_body_hardware card_body_hardware3 5">
                      <div className="box-card-hardware-pleated">
                        <div className="box50 box51 radio_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("hardware1")}
                            value="1"
                            name="step8"
                            ref-num="8"
                            id="81"
                            outline="true"
                            checked={step8 === "I Have My Own Hardware"}
                            onChange={(e) => {
                              setStep81("");
                              setStep82("");
                              setStep83("");
                              // setStep84("");
                              setStep8A("");
                              setStep8B("");
                              setStep8C("");
                              setSelectedDrapery([]);
                              setSelectedSheer([]);
                              setSelectedPrivacyLayer([]);
                              let tempExtended = extendedTitle;
                              if (step6 === "") {
                                setHardwareNextStep("9");
                                setStep8("");
                                tempExtended["8"] = [];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                selectUncheck(e);
                                modalHandleShow("noPanelType");
                                setDeps(
                                  "8",
                                  "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                                );
                                setCart(
                                  "",
                                  "",
                                  "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                );
                              } else if (
                                step2A === "" ||
                                step2B === "" ||
                                (step2B !== "None" && step2B1 === "") ||
                                (step2B !== "None" && step2C === "")
                              ) {
                                setHardwareNextStep("9");
                                setStep8("");
                                tempExtended["8"] = [];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                selectUncheck(e);
                                modalHandleShow("noPrivacyLayer");
                                setDeps(
                                  "8",
                                  "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809"
                                );
                                setCart(
                                  "",
                                  "",
                                  "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                );
                              } else {
                                // Match radio label: "نیاز ندارم." (not "I Have My Own Hardware")
                                tempExtended["8"] = [t("None")];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                setExtendedTitle(tempExtended);
                                selectChanged(e, "8A,8B,8C");
                                setStep8("I Have My Own Hardware");
                                setHardwareNextStep("9");
                                if (step2B === "None") {
                                  setDeps(
                                    "85,86",
                                    "8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809,812,813,842,849,850,852,853,854,855,856,857,858,859,860,861,862,863,864,865"
                                  );
                                } else {
                                  setDeps(
                                    "85,86,87",
                                    "8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809,812,813,842,849,850,852,853,854,855,856,857,858,859,860,861,862,863,864,865"
                                  );
                                }
                                setCart(
                                  "Hardware",
                                  "I Have My Own Hardware",
                                  "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                );
                              }
                            }}
                            ref={(ref) => (inputs.current["81"] = ref)}
                          />
                          <label htmlFor="81">{t("I Don't Need Any Hardware")}</label>
                        </div>
                        <div className="box50 box51 radio_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("Same Hardware For All Curtains")}
                            value="2"
                            name="step8"
                            ref-num="8"
                            id="82"
                            outline="true"
                            checked={step8 === "Same Hardware For All Curtains"}
                            disabled={
                              parseInt(windowWidthPanelType) > 160 &&
                              (step6BHead === "Track" || step6CHead === "Track")
                            }
                            onChange={(e) => {
                              setStep8A("");
                              setStep8B("");
                              setStep8C("");
                              let tempExtended = extendedTitle;
                              if (step3 === "" || (step3 === "true" && step31 === "")) {
                                setHardwareNextStep("9");
                                setStep8("");
                                tempExtended["8"] = [];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                selectUncheck(e);
                                modalHandleShow("noMeasurements");
                                setDeps(
                                  "8",
                                  "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                                );
                                setCart(
                                  "",
                                  "",
                                  "Hardware,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                );
                              } else {
                                selectChanged(e, "8A,8B,8C");
                                setTimeout(() => {
                                  setStep8("Same Hardware For All Curtains");
                                }, 300);
                                tempExtended["8"] = [t("Same Hardware For All Curtains")];
                                setHardwareNextStep("9");
                                setDeps(
                                  "809",
                                  "8,81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,812,813,842,849,850,852,853,854,855,856,857,858,859,860,861,862,863,864,865"
                                );

                                setCart(
                                  "Hardware",
                                  "Same Hardware For All Curtains",
                                  "hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                                  "DraperyHardware,SheerHardware,PrivacyLayerHardware",
                                  ["Rod", "Rod", "Rod"]
                                );
                              }
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["82"] = ref)}
                          />
                          <label htmlFor="82" className="same_line_extension_unavailable">
                            {t("hardware2")}
                            {parseInt(windowWidthPanelType) > 160 &&
                              (step6BHead === "Track" || step6CHead === "Track") && (
                                <OverlayContainer
                                  classNames="extension_unavailable"
                                  placement="bottom"
                                  children={
                                    <div className="extension_unavailable_title text_underline">
                                      {t("Why is this unavailable?")}
                                    </div>
                                  }
                                  component={
                                    <div className="extension_unavailable_container">
                                      <div className="extension_unavailable_text">
                                        {t("rod_track_hardware_text")}
                                      </div>
                                    </div>
                                  }
                                />
                              )}
                          </label>
                        </div>
                        <div className="box50 box51 radio_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("Customize Hardware Per Curtain")}
                            value="3"
                            name="step8"
                            ref-num="8"
                            id="83"
                            outline="true"
                            checked={step8 === "I Want To Customize Hardware Per Curtain"}
                            onChange={(e) => {
                              setStep81("");
                              setStep82("");
                              setStep83("");
                              // setStep84("");
                              setStep8A("");
                              setStep8B("");
                              setStep8C("");
                              let tempExtended = extendedTitle;
                              if (
                                step2A === "" ||
                                step2B === "" ||
                                (step2B !== "None" && step2B1 === "") ||
                                (step2B !== "None" && step2C === "")
                              ) {
                                setHardwareNextStep("9");
                                setStep8("");
                                tempExtended["8"] = [];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                selectUncheck(e);
                                modalHandleShow("noPrivacyLayer");
                                setDeps(
                                  "8",
                                  "81,82,83,85,86,87,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809"
                                );
                                setCart(
                                  "",
                                  "",
                                  "Hardware,DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                );
                              } else {
                                setHardwareNextStep("8A");
                                selectChanged(e, "8A,8B,8C");
                                setStep8("I Want To Customize Hardware Per Curtain");
                                tempExtended["8"] = [t("Customize Hardware Per Curtain")];
                                tempExtended["8A"] = [];
                                tempExtended["8B"] = [];
                                tempExtended["8C"] = [];
                                if (step2B === "None") {
                                  setDeps(
                                    "8A,8B",
                                    "8,81,82,83,84,85,86,8A1,8A2,8A3,8A4,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809,812,813,842,849,850,852,853,854,855,856,857,858,859,860,861,862,863,864,865"
                                  );
                                } else {
                                  setDeps(
                                    "8A,8B,8C",
                                    "8,81,82,83,84,85,86,87,8A1,8A2,8A3,8A4,8B1,8B2,8B3,8B5,8B51,8B6,8B5,8B51,8C1,8C2,8C3,8C5,8C51,8C52,8C6,809,812,813,842,849,850,852,853,854,855,856,857,858,859,860,861,862,863,864,865"
                                  );
                                }
                                setCart(
                                  "Hardware",
                                  "I Want To Customize Hardware Per Curtain",
                                  "DraperyHardware,SheerHardware,PrivacyLayerHardware,RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,hardwareDrapery,hardwareSheer,hardwarePrivacyLayer"
                                );
                              }
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["83"] = ref)}
                          />
                          <label htmlFor="83">{t("hardware3")}</label>
                        </div>
                      </div>

                      {/* step 10 Questions */}
                      <div
                        className={
                          step8 === "Same Hardware For All Curtains"
                            ? "card_body card_body_radio card_body_Rod"
                            : "noDisplay"
                        }
                      >
                        {rodsList}
                      </div>
                      <div
                        className={
                          step8 === "Same Hardware For All Curtains" && step81 !== ""
                            ? "card_body card_body_radio card_body_Rod_color"
                            : "noDisplay"
                        }
                      >
                        <div className="box100">
                          <p className="step_selection_title">{t("step8_rod_finish_title")}</p>
                        </div>
                        {rodsColorList}
                      </div>

                      <div
                        className={
                          step8 === "Same Hardware For All Curtains" && step81 !== ""
                            ? "card_body card_body_radio card_body_baton 1"
                            : "noDisplay"
                        }
                      >
                        <div className="box100">
                          <p className="step_selection_title">{t("Baton Option")}</p>
                        </div>
                        <div className="box33 radio_style baton_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("None")}
                            value="1"
                            name="step83"
                            ref-num="8"
                            id="831"
                            checked={step83 === "None"}
                            onChange={(e) => {
                              setStep83("None");
                              setDeps("", "83,813");
                              setCart(
                                undefined,
                                undefined,
                                "",
                                "BatonOptionA,BatonOptionB,ControlPositionB,BatonOptionC,ControlPositionC",
                                ["None", "None", "None"]
                              );
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Baton")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("None")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["831"] = ref)}
                          />
                          <label htmlFor="831">{t("None")}</label>
                        </div>
                        <div className="box33 radio_style baton_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("Baton 30cm")}
                            value="2"
                            name="step83"
                            ref-num="8"
                            id="832"
                            checked={step83 === "Baton 30cm"}
                            onChange={(e) => {
                              setStep83("Baton 30cm");
                              setDeps("", "83,813");
                              setCart(
                                undefined,
                                undefined,
                                "",
                                "BatonOptionA,BatonOptionB,BatonOptionC",
                                ["Baton 30cm", "Baton 30cm", "Baton 30cm"]
                              );
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Baton")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Baton 30cm")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["832"] = ref)}
                          />
                          <label htmlFor="832">
                            {t("Baton 30cm")}
                            <br />
                            <p className="surcharge_price">
                              {Object.keys(modelAccessories).length !== 0
                                ? t("Add ")
                                : t("Surcharge Applies")}
                              {modelAccessories["27"]
                                ? modelAccessories["27"]["58"]
                                  ? GetPrice(
                                      modelAccessories["27"]["58"]["Price"],
                                      pageLanguage,
                                      t("TOMANS"),
                                      isTabletOrMobile
                                    )
                                  : null
                                : null}
                            </p>
                          </label>
                        </div>
                        <div className="box33 radio_style baton_style">
                          <input
                            className="radio"
                            type="radio"
                            text={t("Baton 45cm")}
                            value="3"
                            name="step83"
                            ref-num="8"
                            id="833"
                            checked={step83 === "Baton 45cm"}
                            onChange={(e) => {
                              setStep83("Baton 45cm");
                              setDeps("", "83,813");
                              setCart(
                                undefined,
                                undefined,
                                "",
                                "BatonOptionA,BatonOptionB,BatonOptionC",
                                ["Baton 45cm", "Baton 45cm", "Baton 45cm"]
                              );
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Baton")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Baton 45cm")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["833"] = ref)}
                          />
                          <label htmlFor="833">
                            {t("Baton 45cm")}
                            <br />
                            <p className="surcharge_price">
                              {Object.keys(modelAccessories).length !== 0
                                ? t("Add ")
                                : t("Surcharge Applies")}
                              {modelAccessories["27"]
                                ? modelAccessories["27"]["59"]
                                  ? GetPrice(
                                      modelAccessories["27"]["59"]["Price"],
                                      pageLanguage,
                                      t("TOMANS"),
                                      isTabletOrMobile
                                    )
                                  : null
                                : null}
                            </p>
                          </label>
                        </div>
                      </div>

                      <div
                        className={
                          step8 === "I Have My Own Hardware"
                            ? "card_body card_body_radio card_body_have_hardware"
                            : "noDisplay"
                        }
                      >
                        <div className="box100">
                          <p className="step_selection_title">{t("step8_haveHardware_title")}</p>
                        </div>
                        <div className="box50 radio_style">
                          <div className="same_row_selection_title">{t("Drapery Hardware")}</div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedDrapery}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwareDrapery", selected[0].value);
                                  setDeps("", "85", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8"][1] = (
                                    <li key="1" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Drapery Hardware")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedDrapery(selected);
                                }
                              }}
                              options={draperiesSelect[pageLanguage]}
                            />
                          </div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="same_row_selection_title">{t("Sheer Hardware")}</div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedSheer}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwareSheer", selected[0].value);
                                  setDeps("", "86", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8"][2] = (
                                    <li key="2" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Sheer Hardware")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedSheer(selected);
                                }
                              }}
                              options={
                                parseInt(windowWidthPanelType) <= 160 && step2A === "Grommet"
                                  ? sheersSelect[pageLanguage]
                                  : parseInt(windowWidthPanelType) <= 160 && step2A !== "Grommet"
                                  ? sheersSelect3[pageLanguage]
                                  : step6BHead === "Rod"
                                  ? sheersSelect[pageLanguage]
                                  : sheersSelect2[pageLanguage]
                              }
                            />
                          </div>
                        </div>
                        <div className={step2B !== "None" ? "box50 radio_style" : "noDisplay"}>
                          <div className="same_row_selection_title">
                            {t("Privacy Layer Hardware")}
                          </div>
                        </div>
                        <div
                          className={
                            step2B !== "None" && step2C !== "" ? "box50 radio_style" : "noDisplay"
                          }
                        >
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedPrivacyLayer}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwarePrivacyLayer", selected[0].value);
                                  setDeps("", "87", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8"][3] = (
                                    <li key="3" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Privacy Layer Hardware")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedPrivacyLayer(selected);
                                }
                              }}
                              options={privacyLayerStep9}
                            />
                          </div>
                        </div>
                        <div
                          className={
                            step2B !== "None" && step2C === "" ? "box50 radio_style" : "noDisplay"
                          }
                        >
                          <div className="checkbox_text_info_container">
                            <div className="card-body-display-flex">
                              <span className="checkbox_text">{t("pl_hs_incomplete2")}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <NextStep currentStep="8" eventKey={hardwareNextStep}>
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 10A */}
            <Card
              className={step8 === "I Want To Customize Hardware Per Curtain" ? "" : "noDisplay"}
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
                  !accordionActiveKey.startsWith("8")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="8A"
                  stepNum={step5 === "Full" && step3 === "false" ? t("9A") : t("10A")}
                  stepTitle={t("grommet_step8A")}
                  stepRef="8A"
                  type="1"
                  required={requiredStep["8A"]}
                  stepSelected={
                    stepSelectedLabel["8A"] === undefined ? "" : stepSelectedLabel["8A"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="8A">
                <Card.Body>
                  <div className="card_body2 card_body_radio  card_body_hardware 1">
                    <div className="box33  radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("None")}
                        value="1"
                        name="step8A"
                        ref-num="8A"
                        id="8A1"
                        checked={step8A === "None"}
                        onChange={(e) => {
                          setStep8A1("");
                          setStep8A2("");
                          setStep8A3("");
                          setSelectedDrapery([]);
                          setStep8A("None");
                          let tempExtended = extendedTitle;
                          tempExtended["8A"] = [t("None")];
                          setExtendedTitle(tempExtended);
                          setDeps("85", "84,8A,842,843");
                          setCart(
                            "DraperyHardware",
                            "None",
                            "BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,hardwareDrapery"
                          );
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["8A1"] = ref)}
                      />
                      <label htmlFor="8A1">{t("None")}</label>
                    </div>
                    <div className="box33  radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("drapery_Rod")}
                        value="2"
                        name="step8A"
                        ref-num="8A"
                        id="8A2"
                        checked={step8A === "Rod"}
                        onChange={(e) => {
                          let tempExtended = extendedTitle;
                          setStep8A1("");
                          setStep8A2("");
                          setStep8A3("");
                          if (step3 === "" || (step3 === "true" && step31 === "")) {
                            setStep8A("");
                            tempExtended["8A"] = [];
                            selectUncheck(e);
                            modalHandleShow("noMeasurements");
                            setDeps("", "8A");
                            setCart(
                              "",
                              "",
                              "DraperyHardware,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,hardwareDrapery"
                            );
                          } else {
                            setTimeout(() => {
                              setStep8A("Rod");
                            }, 300);
                            tempExtended["8A"] = [t("drapery_Rod")];
                            setCart("DraperyHardware", "Rod", "hardwareDrapery");
                            selectChanged(e);
                            setDeps("84", "8A,85");
                          }
                          setExtendedTitle(tempExtended);
                        }}
                        ref={(ref) => (inputs.current["8A2"] = ref)}
                      />
                      <label htmlFor="8A2">{t("drapery_Rod")}</label>
                    </div>

                    {/* step 10 Questions */}
                    <div
                      className={
                        step8A !== "None" && step8A !== ""
                          ? "card_body card_body_radio card_body_Rod"
                          : "noDisplay"
                      }
                    >
                      {rodsList2}
                    </div>
                    <div
                      className={
                        step8A !== "None" && step8A !== "" && step8A1 !== ""
                          ? "card_body card_body_radio card_body_Rod_color bracket_color"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("step8_rod_finish_title")}</p>
                      </div>
                      {rodsColorList2}
                    </div>

                    <div
                      className={
                        step8A !== "None" && step8A !== "" && step8A1 !== ""
                          ? "card_body card_body_radio card_body_baton 2"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("Baton Option")}</p>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("None")}
                          value="1"
                          name="step8A3"
                          ref-num="8A"
                          id="8A31"
                          checked={step8A3 === "None"}
                          onChange={(e) => {
                            setStep8A3("None");
                            setDeps("", "8A3,843", 1);
                            setCart("BatonOptionA", "None");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8A"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("None")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8A31"] = ref)}
                        />
                        <label htmlFor="8A31">{t("None")}</label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 30cm")}
                          value="2"
                          name="step8A3"
                          ref-num="8A"
                          id="8A32"
                          checked={step8A3 === "Baton 30cm"}
                          onChange={(e) => {
                            setStep8A3("Baton 30cm");
                            setDeps("", "8A3,843", 1);
                            setCart("BatonOptionA", "Baton 30cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8A"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 30cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8A32"] = ref)}
                        />
                        <label htmlFor="8A32">
                          {t("Baton 30cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["58"]
                                ? GetPrice(
                                    modelAccessories["27"]["58"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 45cm")}
                          value="3"
                          name="step8A3"
                          ref-num="8A"
                          id="8A33"
                          checked={step8A3 === "Baton 45cm"}
                          onChange={(e) => {
                            setStep8A3("Baton 45cm");
                            setDeps("", "8A3,843", 1);
                            setCart("BatonOptionA", "Baton 45cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8A"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 45cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8A33"] = ref)}
                        />
                        <label htmlFor="8A33">
                          {t("Baton 45cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["59"]
                                ? GetPrice(
                                    modelAccessories["27"]["59"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                    </div>

                    <div
                      className={
                        step8A === "None"
                          ? "card_body card_body_radio card_body_have_hardware  card_body_have_hardware_new"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title step_selection_title_new">
                          {t("step8A_haveHardware_title")}
                        </p>
                      </div>
                      <div className="box-step9a">
                        <div className="box50 radio_style">
                          <div className="same_row_selection_title">{t("Drapery Hardware")}</div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedDrapery}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwareDrapery", selected[0].value);
                                  setDeps("", "8A", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8A"][1] = (
                                    <li key="1" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Drapery Hardware")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedDrapery(selected);
                                }
                              }}
                              options={draperiesSelect[pageLanguage]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <NextStep currentStep="8A" eventKey="8B">
                    {t("NEXT STEP")}
                  </NextStep>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 10B */}
            <Card
              className={step8 === "I Want To Customize Hardware Per Curtain" ? "" : "noDisplay"}
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
                  !accordionActiveKey.startsWith("8")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="8B"
                  stepNum={step5 === "Full" && step3 === "false" ? t("9B") : t("10B")}
                  stepTitle={t("grommet_step8B")}
                  stepRef="8B"
                  type="1"
                  required={requiredStep["8B"]}
                  stepSelected={
                    stepSelectedLabel["8B"] === undefined ? "" : stepSelectedLabel["8B"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="8B">
                <Card.Body>
                  <div
                    className={
                      "card_body2 card_body_radio card_body_radio_new card_body_hardware 2" +
                      (tracksList.length > 0 && rodsList3.length > 0 ? " " : "")
                    }
                  >
                    <div className="boxHardware radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("None")}
                        value="1"
                        name="step8B"
                        ref-num="8B"
                        id="8B1"
                        checked={step8B === "None"}
                        onChange={(e) => {
                          setStep8B1("");
                          setStep8B2("");
                          setStep8B3("");
                          setStep8B5("");
                          setSelectedSheer([]);
                          setStep8B("None");
                          let tempExtended = extendedTitle;
                          tempExtended["8B"] = [t("None")];
                          setExtendedTitle(tempExtended);
                          setDeps("8B", "849,850,852,853,854,855,856,857,86");
                          setCart(
                            "SheerHardware",
                            "None",
                            "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                          );
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["8B1"] = ref)}
                      />
                      <label htmlFor="8B1">{t("None")}</label>
                    </div>

                    <div className={rodsList3.length > 0 ? "boxHardware radio_style" : "noDisplay"}>
                      <input
                        className="radio"
                        type="radio"
                        text={t("sheer_Rod")}
                        value="3"
                        name="step8B"
                        ref-num="8B"
                        id="8B3"
                        checked={step8B === "Rod"}
                        disabled={
                          parseInt(windowWidthPanelType) > 160 &&
                          step6BHead === "Track" &&
                          step6B !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8B")) !== -1
                        }
                        onChange={(e) => {
                          if (
                            parseInt(windowWidthPanelType) > 160 &&
                            step6BHead === "Track" &&
                            step6B !== ""
                          ) {
                            modalHandleShow("hardwareSheerWarning");
                            setHardwareSheerWarningTemp({
                              stepValue: "Rod",
                              id: "sheer_Rod",
                              cartValue: "Rod",
                              event: e,
                            });
                          } else {
                            setStep8B1("");
                            setStep8B2("");
                            setStep8B3("");
                            setStep8B5("");
                            setDeps("849", "8B,86,850,852,853,854,855,856,857");
                            setTimeout(() => {
                              setStep8B("Rod");
                              if (step6 !== "Customize Style Per Curtain") {
                                setStep6BHead("Rod");
                              }
                            }, 300);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"] = [t("sheer_Rod")];
                            setExtendedTitle(tempExtended);
                            setCart(
                              "SheerHardware",
                              "Rod",
                              "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                            );
                            selectChanged(e);
                          }
                        }}
                        ref={(ref) => (inputs.current["8B3"] = ref)}
                      />
                      <label htmlFor="8B3">
                        {t("sheer_Rod")}
                        <br />
                        {parseInt(windowWidthPanelType) > 160 &&
                          step6BHead === "Track" &&
                          step6B !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8B")) !== -1 && (
                            <OverlayContainer
                              classNames="extension_unavailable"
                              placement="bottom"
                              children={
                                <div className="extension_unavailable_title text_underline">
                                  {t("Why is this unavailable?")}
                                </div>
                              }
                              component={
                                <div className="extension_unavailable_container">
                                  <div className="extension_unavailable_text">
                                    {t("track_sheer_hardware_text")}
                                  </div>
                                </div>
                              }
                            />
                          )}
                      </label>
                    </div>
                    <div
                      className={tracksList.length > 0 ? "boxHardware radio_style" : "noDisplay"}
                    >
                      <input
                        className="radio"
                        type="radio"
                        text={t("sheer_Track")}
                        value="2"
                        name="step8B"
                        ref-num="8B"
                        id="8B2"
                        checked={step8B === "Track"}
                        disabled={
                          parseInt(windowWidthPanelType) > 160 &&
                          step6BHead === "Rod" &&
                          step6B !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8B")) !== -1
                        }
                        onChange={(e) => {
                          if (parseInt(windowWidthPanelType) > 160 && step6BHead === "Rod" && step6B !== "") {
                            modalHandleShow("hardwareSheerWarning");
                            setHardwareSheerWarningTemp({
                              stepValue: "Track",
                              id: "sheer_Track",
                              cartValue: "Track",
                              event: e,
                            });
                          } else {
                            setStep8B1("");
                            setStep8B2("");
                            setStep8B3("");
                            setDeps("849", "8B,86,850,852,853,854,855,856,857");
                            setTimeout(() => {
                              setStep8B("Track");
                              if (step6 !== "Customize Style Per Curtain") {
                                setStep6BHead("Track");
                              }
                            }, 300);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"] = [t("sheer_Track")];
                            setExtendedTitle(tempExtended);
                            setCart(
                              "SheerHardware",
                              "Track",
                              "RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                            );
                            selectChanged(e);
                          }
                        }}
                        ref={(ref) => (inputs.current["8B2"] = ref)}
                      />
                      <label htmlFor="8B2">
                        {t("sheer_Track")}
                        <br />
                        {parseInt(windowWidthPanelType) > 160 &&
                          step6BHead === "Rod" &&
                          step6B !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8B")) !== -1 && (
                            <OverlayContainer
                              classNames="extension_unavailable"
                              placement="bottom"
                              children={
                                <div className="extension_unavailable_title text_underline">
                                  {t("Why is this unavailable?")}
                                </div>
                              }
                              component={
                                <div className="extension_unavailable_container">
                                  <div className="extension_unavailable_text">
                                    {t("rod_sheer_hardware_text")}
                                  </div>
                                </div>
                              }
                            />
                          )}
                      </label>
                    </div>

                    {/* step 10 Questions */}
                    <div
                      className={
                        step8B !== "None" && step8B !== ""
                          ? "card_body card_body_radio card_body_Rod"
                          : "noDisplay"
                      }
                    >
                      {step8B === "Rod" ? rodsList3 : tracksList}
                    </div>
                    <div
                      className={
                        step8B !== "None" && step8B !== "" && step8B1 !== "" && !trackType8B
                          ? "card_body card_body_radio card_body_Rod_color bracket_color"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">
                          {step8B === "Rod"
                            ? t("step8_rod_finish_title")
                            : t("step8_rod_finish_title_track")}
                        </p>
                      </div>
                      {rodsColorList3}
                    </div>
                    <div
                      className={
                        step8B !== "None" && step8B !== "" && step8B1 !== "" && trackType8B === 2
                          ? "card_body card_body_radio card_body_Rod_color bracket_color"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">
                          {step8B === "Rod"
                            ? t("step8_rod_finish_title")
                            : t("step8_rod_finish_title_track")}
                        </p>
                      </div>
                      {rodsColorList3}
                    </div>

                    <div
                      className={
                        step8B !== "None" && step8B !== "" && step8B1 !== "" && !trackType8B
                          ? "card_body card_body_radio card_body_baton 3"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("Baton Option")}</p>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("None")}
                          value="1"
                          name="step8B3"
                          ref-num="8B"
                          id="8B31"
                          checked={step8B3 === "None"}
                          onChange={(e) => {
                            setStep8B3("None");
                            setDeps("", "8B1,852,853", 1);
                            setCart("BatonOptionB", "None");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("None")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8B31"] = ref)}
                        />
                        <label htmlFor="8B31">{t("None")}</label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 30cm")}
                          value="2"
                          name="step8B3"
                          ref-num="8B"
                          id="8B32"
                          checked={step8B3 === "Baton 30cm"}
                          onChange={(e) => {
                            setStep8B3("Baton 30cm");
                            setDeps("", "8B1,852,853", 1);
                            setCart("BatonOptionB", "Baton 30cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 30cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8B32"] = ref)}
                        />
                        <label htmlFor="8B32">
                          {t("Baton 30cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["58"]
                                ? GetPrice(
                                    modelAccessories["27"]["58"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 45cm")}
                          value="3"
                          name="step8B3"
                          ref-num="8B"
                          id="8B33"
                          checked={step8B3 === "Baton 45cm"}
                          onChange={(e) => {
                            setStep8B3("Baton 45cm");
                            setDeps("", "8B1,852,853", 1);
                            setCart("BatonOptionB", "Baton 45cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 45cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8B33"] = ref)}
                        />
                        <label htmlFor="8B33">
                          {t("Baton 45cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["59"]
                                ? GetPrice(
                                    modelAccessories["27"]["59"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                      {/* <div className={step8B === "Track" ? "box33 radio_style" : "noDisplay"}>
                        <input
                          className="radio"
                          type="radio"
                          text={t("Cord")}
                          value="4"
                          name="step8B3"
                          ref-num="8B"
                          id="8B34"
                          checked={step8B3 === "Cord"}
                          onChange={(e) => {
                            setStep8B3("Cord");
                            setDeps("", "8B1", 1);
                            setCart("BatonOptionB", "Cord");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8B"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Cord")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8B34"] = ref)}
                        />
                        <label htmlFor="8B34">
                          {t("Cord")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["60"]
                                ? GetPrice(
                                    modelAccessories["27"]["60"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div> */}
                    </div>
                    <div
                      className={
                        step8B !== "None" && step8B !== "" && step8B1 !== "" && trackType8B === 2
                          ? "card_body card_body_radio card_body_baton 4"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("Control Position")}</p>
                      </div>
                      <div className="box33 radio_style">
                        <div className="width_max">
                          <img
                            src={require("../Images/drapery/grommet/cp_hardware_left.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            text={t("Left")}
                            value="5"
                            name="step8B3"
                            ref-num="8B"
                            id="8B35"
                            checked={step8B3 === "Left"}
                            onChange={(e) => {
                              setStep8B3("Left");
                              setDeps("", "8B2,854", 1);
                              setCart("ControlPositionB", "Left Control");
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8B"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Control Position")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Left")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["8B35"] = ref)}
                          />
                          <label htmlFor="8B35">{t("Left")}</label>
                        </div>
                      </div>
                      <div className="box33 radio_style">
                        <div className="width_max">
                          <img
                            src={require("../Images/drapery/grommet/cp_hardware_right.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            text={t("Right")}
                            value="6"
                            name="step8B3"
                            ref-num="8B"
                            id="8B36"
                            checked={step8B3 === "Right"}
                            onChange={(e) => {
                              setStep8B3("Right");
                              setDeps("", "8B2,854", 1);
                              setCart("ControlPositionB", "Right Control");
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8B"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Control Position")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Right")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["8B36"] = ref)}
                          />
                          <label htmlFor="8B36">{t("Right")}</label>
                        </div>
                      </div>
                    </div>

                    <div className={trackType8B === 1 ? "tracks_motorized_section" : "noDisplay"}>
                      <div
                        className={
                          motorErr1
                            ? "secondary_options secondary_options_err"
                            : "secondary_options"
                        }
                      >
                        <div className="card-body-display-flex">
                          <div className="width_max checkbox_style">
                            <input
                              type="checkbox"
                              text={t("Motorized")}
                              value="1"
                              name="step8B5"
                              ref-num="8B5"
                              checked={step8B5 === "true"}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  selectChanged(e);
                                  setStep8B5("true");
                                  setMotorErr1(false);
                                  setSelectedMotorPositionB([]);
                                  setDeps("855,856,857", "86,8B");
                                  setSelectedRemoteName([]);
                                  setSelectedMotorChannelsB([
                                    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                                  ]);
                                  setRemoteNameB("");
                                  setCart("hasPowerB", true, "", "MotorChannelsB", [
                                    selectedMotorChannelsB.map((obj) => obj.value),
                                  ]);
                                } else {
                                  selectUncheck(e);
                                  setStep8B5("");
                                  setDeps("855,856,857", "86,8B");
                                  setCart(
                                    "",
                                    "",
                                    "hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                                  );
                                }
                              }}
                              id="8B51"
                              ref={(ref) => (inputs.current["8B51"] = ref)}
                            />
                            <label htmlFor="8B51" className="checkbox_label">
                              <img
                                className="checkbox_label_img checkmark1 img-fluid 16"
                                src={require("../Images/public/checkmark1_checkbox.png")}
                                alt=""
                              />
                            </label>
                            <span className="checkbox_text">{t("Motor_title")}</span>
                          </div>
                        </div>
                      </div>
                      {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
                      <div
                        className={
                          trackType8B === 1 && step8B5 === "true"
                            ? "motorized_options"
                            : "noDisplay"
                        }
                      >
                        <div className="motorized_option_left">
                          <p>{t("Motor Position")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore2")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedMotorPositionB}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setSelectedMotorPositionB(selected);
                                  setDeps("", "8B,8B1,8B2,855", 2);
                                  setCart("MotorPositionB", selected[0].value);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8B"][2] = (
                                    <li key="2" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Motor Position")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                }
                              }}
                              options={MotorPosition[pageLanguage]}
                            />
                          </div>
                        </div>
                        <div className="motorized_option_left">
                          <p>{t("Remote Name")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore3")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          {!!(remoteNames.length > 1) && (
                            <div className="select_container">
                              <Select
                                className="select"
                                placeholder={t("Please Select")}
                                portal={document.body}
                                dropdownPosition="bottom"
                                dropdownHandle={false}
                                dropdownGap={0}
                                values={selectedRemoteName}
                                onDropdownOpen={() => {
                                  let temp1 = window.scrollY;
                                  window.scrollTo(window.scrollX, window.scrollY + 1);
                                  setTimeout(() => {
                                    let temp2 = window.scrollY;
                                    if (temp2 === temp1)
                                      window.scrollTo(window.scrollX, window.scrollY - 1);
                                  }, 100);
                                }}
                                dropdownRenderer={({ props, state, methods }) => (
                                  <CustomDropdownWithSearch
                                    props={props}
                                    state={state}
                                    methods={methods}
                                  />
                                )}
                                contentRenderer={({ props, state, methods }) => (
                                  <CustomControl props={props} state={state} methods={methods} />
                                )}
                                onChange={(selected) => {
                                  if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                    setSelectedRemoteName(selected);
                                    if (selected[0]["value"] === "addNewRemoteName") {
                                      setShowRemoteName(true);
                                      setDeps("", "8B,856");
                                      setCart("", "", "RemoteNameB");
                                      setRemoteNameB("");
                                    } else {
                                      setShowRemoteName(false);
                                      setDeps("", "8B52,856");
                                      setCart("RemoteNameB", selected[0]["value"]);
                                      setRemoteNameB(selected[0]["value"]);
                                    }
                                  }
                                }}
                                options={remoteNames}
                              />
                            </div>
                          )}
                          {(remoteNames.length === 1 || remoteNames.length === 0) && (
                            <DebounceInput
                              debounceTimeout={1500}
                              onKeyDown={() => setCartLoading(true)}
                              className="Remote_name"
                              type="text"
                              name="Remote_name"
                              value={remoteNameB}
                              placeholder={t("Enter a name for your remote")}
                              onChange={(e) => {
                                setTimeout(() => {
                                  setDeps("", "8B,8B1,8B2,856");
                                  setCart("RemoteNameB", capitalizeWordsText(e.target.value));
                                  setRemoteNameB(capitalizeWordsText(e.target.value));
                                  let tempExtended = extendedTitle;
                                  tempExtended["8B"][3] = (
                                    <li key="3" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Remote_name")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {capitalizeWordsText(e.target.value)}
                                      </span>
                                    </li>
                                  );
                                }, 300);
                              }}
                            />
                          )}
                        </div>
                        {showRemoteName && (
                          <div className="motorized_option_left">
                            <p>&nbsp;</p>
                          </div>
                        )}
                        {showRemoteName && (
                          <div className="motorized_option_right">
                            <DebounceInput
                              debounceTimeout={1500}
                              onKeyDown={() => setCartLoading(true)}
                              className="Remote_name"
                              type="text"
                              name="Remote_name"
                              value={remoteNameB}
                              placeholder={t("Enter a name for your remote")}
                              onChange={(e) => {
                                setTimeout(() => {
                                  // if (e.target.value === "") {
                                  //   setDeps("8B52", "");
                                  // } else {
                                  //   setDeps("", "8B52");
                                  // }
                                  setDeps("", "8B,856");
                                  setCart("RemoteNameB", e.target.value);
                                  setRemoteNameB(Capitalize(e.target.value));
                                }, 300);
                              }}
                            />
                          </div>
                        )}
                        <div className="motorized_option_left">
                          <p>{t("Channel(s)")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore4")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          <div className="select_container multi_select_container">
                            <Select
                              className="select select_motor_channels"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              multi={true}
                              values={selectedMotorChannelsB}
                              onDropdownOpen={() => {
                                motorChannelsUserOpenRef10B.current = true;
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdownMulti
                                  props={props}
                                  state={state}
                                  methods={methods}
                                />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControlMulti props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                // setDeps("", "412");
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  if (motorChannelsUserOpenRef10B.current) {
                                    setDeps("", "857");
                                    motorChannelsUserOpenRef10B.current = false;
                                  }
                                  setCart("MotorChannelsB", selected.map((obj) => obj.value));
                                  setSelectedMotorChannelsB(selected);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8B"][4] = (
                                    <li key="4" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Channel(s)")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {selected
                                          .map((item) =>
                                            pageLanguage === "fa" ? item.label : item.value
                                          )
                                          .join(", ")}
                                      </span>
                                    </li>
                                  );
                                }
                              }}
                              options={motorChannels[pageLanguage]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        step8B === "None"
                          ? "card_body card_body_radio card_body_have_hardware  card_body_have_hardware_new"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title step_selection_title_new">
                          {t("step8B_haveHardware_title")}
                        </p>
                      </div>
                      <div className="box-step9a">
                        <div className="box50 radio_style">
                          <div className="same_row_selection_title">{t("Sheer Hardware")}</div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedSheer}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwareSheer", selected[0].value);
                                  setDeps("", "8B,8B1,8B2", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8B"][1] = (
                                    <li key="1" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Sheer Hardware")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedSheer(selected);
                                }
                              }}
                              options={
                                parseInt(windowWidthPanelType) <= 160 && step2A === "Grommet"
                                  ? sheersSelect[pageLanguage]
                                  : parseInt(windowWidthPanelType) <= 160 && step2A !== "Grommet"
                                  ? sheersSelect3[pageLanguage]
                                  : step6BHead === "Rod"
                                  ? sheersSelect[pageLanguage]
                                  : sheersSelect2[pageLanguage]
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <NextStep currentStep="8B" eventKey="8C">
                    {t("NEXT STEP")}
                  </NextStep>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 10C */}
            <Card
              className={
                step8 === "I Want To Customize Hardware Per Curtain" && step2B !== "None"
                  ? ""
                  : "noDisplay"
              }
            >
              <Card.Header
                className={
                  [...depSet].findIndex((el) => el.startsWith("8")) === -1 &&
                  !accordionActiveKey.startsWith("8")
                    ? "hidden"
                    : ""
                }
              >
                <ContextAwareToggle
                  eventKey="8C"
                  stepNum={step5 === "Full" && step3 === "false" ? t("9C") : t("10C")}
                  stepTitle={t("grommet_step8C")}
                  stepRef="8C"
                  type="1"
                  required={requiredStep["8C"]}
                  stepSelected={
                    stepSelectedLabel["8C"] === undefined ? "" : stepSelectedLabel["8C"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="8C">
                <Card.Body>
                  <div
                    className={
                      step2B !== "None" && step2C === ""
                        ? "card_body card_body_radio card_body_hardware 3"
                        : "noDisplay"
                    }
                  >
                    <div className="checkbox_text_info_container">
                      <div className="card-body-display-flex">
                        <span className="checkbox_text">{t("pl_hs_incomplete2")}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      step2B !== "None" && step2C !== ""
                        ? "card_body2 card_body_radio card_body_radio_new card_body_hardware 3" +
                          (tracksList2.length > 0 && rodsList4.length > 0 ? "" : "")
                        : "noDisplay"
                    }
                  >
                    <div className="boxHardware radio_style">
                      <input
                        className="radio"
                        type="radio"
                        text={t("None")}
                        value="1"
                        name="step8C"
                        ref-num="8C"
                        id="8C1"
                        checked={step8C === "None"}
                        onChange={(e) => {
                          setStep8C1("");
                          setStep8C2("");
                          setStep8C3("");
                          setStep8C5("");
                          setSelectedPrivacyLayer([]);
                          setDeps("87", "8C,858,859,860,861,862,863,864,865");
                          setStep8C("None");
                          let tempExtended = extendedTitle;
                          tempExtended["8C"] = [t("None")];
                          setExtendedTitle(tempExtended);
                          setCart(
                            "PrivacyLayerHardware",
                            "None",
                            "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                          );
                          selectChanged(e);
                        }}
                        ref={(ref) => (inputs.current["8C1"] = ref)}
                      />
                      <label htmlFor="8C1">{t("None")}</label>
                    </div>

                    <div className={rodsList4.length > 0 ? "boxHardware radio_style" : "noDisplay"}>
                      <input
                        className="radio"
                        type="radio"
                        text={t("pl_Rod")}
                        value="3"
                        name="step8C"
                        ref-num="8C"
                        id="8C3"
                        checked={step8C === "Rod"}
                        disabled={isDisabledRodGrommet9c}
                        onChange={(e) => {
                          if (
                            parseInt(windowWidthPanelType) > 160 &&
                            step6CHead === "Track" &&
                            step6C !== ""
                          ) {
                            modalHandleShow("hardwarePLWarning");
                            setHardwarePLWarningTemp({
                              stepValue: "Rod",
                              id: "pl_Rod",
                              cartValue: "Rod",
                              event: e,
                            });
                          } else {
                            setStep8C1("");
                            setStep8C2("");
                            setStep8C3("");
                            setStep8C5("");
                            setDeps("858", "8C,87,859,860,861,862,863,864,865");
                            setTimeout(() => {
                              setStep8C("Rod");
                              if (step6 !== "Customize Style Per Curtain") {
                                setStep6CHead("Rod");
                              }
                            }, 300);
                            let tempExtended = extendedTitle;
                            tempExtended["8C"] = [t("pl_Rod")];
                            setExtendedTitle(tempExtended);
                            setCart(
                              "PrivacyLayerHardware",
                              "Rod",
                              "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                            );
                            selectChanged(e);
                          }
                        }}
                        ref={(ref) => (inputs.current["8C3"] = ref)}
                      />
                      <label htmlFor="8C3">
                        {t("pl_Rod")}
                        <br />
                    
                        {isDisabledRodGrommet9c && (
                          <OverlayContainer
                            classNames="extension_unavailable"
                            placement="bottom"
                            children={
                              <div className="extension_unavailable_title text_underline">
                                {t("Why is this unavailable?")}
                              </div>
                            }
                            component={
                              <div className="extension_unavailable_container">
                                <div className="extension_unavailable_text">
                                  {t("track_sheer_hardware_text")}
                                </div>
                              </div>
                            }
                          />
                        )}
                      </label>
                    </div>
                    <div
                      className={tracksList2.length > 0 ? "boxHardware radio_style" : "noDisplay"}
                    >
                      <input
                        className="radio"
                        type="radio"
                        text={t("pl_Track")}
                        value="2"
                        name="step8C"
                        ref-num="8C"
                        id="8C2"
                        checked={step8C === "Track"}
                        disabled={
                          parseInt(windowWidthPanelType) > 160 &&
                          step6CHead === "Rod" &&
                          step6C !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8C")) !== -1
                        }
                        onChange={(e) => {
                          if (parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod" && step6C !== "") {
                            modalHandleShow("hardwarePLWarning");
                            setHardwarePLWarningTemp({
                              stepValue: "Track",
                              id: "pl_Track",
                              cartValue: "Track",
                              event: e,
                            });
                          } else {
                            setStep8C1("");
                            setStep8C2("");
                            setStep8C3("");
                            setDeps("858", "8C,87,859,860,861,862,863,864,865");
                            setTimeout(() => {
                              setStep8C("Track");
                              if (step6 !== "Customize Style Per Curtain") {
                                setStep6CHead("Track");
                              }
                            }, 300);
                            let tempExtended = extendedTitle;
                            tempExtended["8C"] = [t("pl_Track")];
                            setExtendedTitle(tempExtended);
                            setCart(
                              "PrivacyLayerHardware",
                              "Track",
                              "RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                            );
                            selectChanged(e);
                          }
                        }}
                        ref={(ref) => (inputs.current["8C2"] = ref)}
                      />
                      <label htmlFor="8C2">
                        {t("pl_Track")}
                        <br />
                        {parseInt(windowWidthPanelType) > 160 &&
                          step6CHead === "Rod" &&
                          step6C !== "" &&
                          [...depSet].findIndex((el) => el.startsWith("8C")) !== -1 && (
                            <OverlayContainer
                              classNames="extension_unavailable"
                              placement="bottom"
                              children={
                                <div className="extension_unavailable_title text_underline">
                                  {t("Why is this unavailable?")}
                                </div>
                              }
                              component={
                                <div className="extension_unavailable_container">
                                  <div className="extension_unavailable_text">
                                    {t("rod_sheer_hardware_text")}
                                  </div>
                                </div>
                              }
                            />
                          )}
                      </label>
                    </div>
                    {/* step 10 Questions */}
                    <div
                      className={
                        step8C !== "None" && step8C !== ""
                          ? "card_body card_body_radio card_body_Rod"
                          : "noDisplay"
                      }
                    >
                      {step8C === "Rod" ? rodsList4 : tracksList2}
                    </div>
                    <div
                      className={
                        step8C !== "None" && step8C !== "" && step8C1 !== "" && !trackType8C
                          ? "card_body card_body_radio card_body_Rod_color bracket_color"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">
                          {step8C === "Rod"
                            ? t("step8_rod_finish_title")
                            : t("step8_rod_finish_title_track")}
                        </p>
                      </div>
                      {rodsColorList4}
                    </div>
                    <div
                      className={
                        step8C !== "None" && step8C !== "" && step8C1 !== "" && trackType8C === 2
                          ? "card_body card_body_radio card_body_Rod_color bracket_color"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">
                          {step8C === "Rod"
                            ? t("step8_rod_finish_title")
                            : t("step8_rod_finish_title_track")}
                        </p>
                      </div>
                      {rodsColorList4}
                    </div>

                    <div
                      className={
                        step8C !== "None" && step8C !== "" && step8C1 !== "" && !trackType8C
                          ? "card_body card_body_radio card_body_baton 5"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("Baton Option")}</p>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("None")}
                          value="1"
                          name="step8C3"
                          ref-num="8"
                          id="8C31"
                          checked={step8C3 === "None"}
                          onChange={(e) => {
                            setStep8C3("None");
                            if (step8C === "Rod") {
                              setDeps("", "8C,8C1,8C2,860", 1);
                            } else {
                              setDeps("", "8C,8C1,8C2,861", 1);
                            }
                            setCart("BatonOptionC", "None");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("None")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8C31"] = ref)}
                        />
                        <label htmlFor="8C31">{t("None")}</label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 30cm")}
                          value="2"
                          name="step8C3"
                          ref-num="8"
                          id="8C32"
                          checked={step8C3 === "Baton 30cm"}
                          onChange={(e) => {
                            setStep8C3("Baton 30cm");
                            if (step8C === "Rod") {
                              setDeps("", "8C,8C1,8C2,860", 1);
                            } else {
                              setDeps("", "8C,8C1,8C2,861", 1);
                            }
                            setCart("BatonOptionC", "Baton 30cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 30cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8C32"] = ref)}
                        />
                        <label htmlFor="8C32">
                          {t("Baton 30cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["58"]
                                ? GetPrice(
                                    modelAccessories["27"]["58"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                      <div className="box33 radio_style baton_style">
                        <input
                          className="radio"
                          type="radio"
                          text={t("Baton 45cm")}
                          value="3"
                          name="step8C3"
                          ref-num="8"
                          id="8C33"
                          checked={step8C3 === "Baton 45cm"}
                          onChange={(e) => {
                            setStep8C3("Baton 45cm");
                            if (step8C === "Rod") {
                              setDeps("", "8C,8C1,8C2,860", 1);
                            } else {
                              setDeps("", "8C,8C1,8C2,861", 1);
                            }
                            setCart("BatonOptionC", "Baton 45cm");
                            selectChanged(e);
                            let tempExtended = extendedTitle;
                            tempExtended["8C"][3] = (
                              <li key="3" className="step_title_extended_list_item">
                                <span className="step_title_extended_list_item_title">
                                  {t("Baton")}
                                </span>
                                <span className="step_title_extended_list_item_text">
                                  {t("Baton 45cm")}
                                </span>
                              </li>
                            );
                            setExtendedTitle(tempExtended);
                          }}
                          ref={(ref) => (inputs.current["8C33"] = ref)}
                        />
                        <label htmlFor="8C33">
                          {t("Baton 45cm")}
                          <br />
                          <p className="surcharge_price">
                            {Object.keys(modelAccessories).length !== 0
                              ? t("Add ")
                              : t("Surcharge Applies")}
                            {modelAccessories["27"]
                              ? modelAccessories["27"]["59"]
                                ? GetPrice(
                                    modelAccessories["27"]["59"]["Price"],
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : null
                              : null}
                          </p>
                        </label>
                      </div>
                    </div>
                    <div
                      className={
                        step8C !== "None" && step8C !== "" && step8C1 !== "" && trackType8C === 2
                          ? "card_body card_body_radio card_body_baton 6"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title">{t("Control Position")}</p>
                      </div>
                      <div className="box33 radio_style">
                        <div className="width_max">
                          <img
                            src={require("../Images/drapery/grommet/cp_hardware_left.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            text={t("Left")}
                            value="5"
                            name="step8C3"
                            ref-num="8"
                            id="8C35"
                            checked={step8C3 === "Left"}
                            onChange={(e) => {
                              setStep8C3("Left");
                              setDeps("", "8C,8C1,8C2,862", 1);
                              setCart("ControlPositionC", "Left Control");
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8C"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Control Position")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Left")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["8C35"] = ref)}
                          />
                          <label htmlFor="8C35">{t("Left")}</label>
                        </div>
                      </div>
                      <div className="box33 radio_style">
                        <div className="width_max">
                          <img
                            src={require("../Images/drapery/grommet/cp_hardware_right.svg").default}
                            className="img-fluid"
                            alt=""
                          />
                          <input
                            className="radio"
                            type="radio"
                            text={t("Right")}
                            value="2"
                            name="step8C6"
                            ref-num="8"
                            id="8C36"
                            checked={step8C3 === "Right"}
                            onChange={(e) => {
                              setStep8C3("Right");
                              setDeps("", "8C,8C1,8C2,862", 1);
                              setCart("ControlPositionC", "Right Control");
                              selectChanged(e);
                              let tempExtended = extendedTitle;
                              tempExtended["8C"][3] = (
                                <li key="3" className="step_title_extended_list_item">
                                  <span className="step_title_extended_list_item_title">
                                    {t("Control Position")}
                                  </span>
                                  <span className="step_title_extended_list_item_text">
                                    {t("Right")}
                                  </span>
                                </li>
                              );
                              setExtendedTitle(tempExtended);
                            }}
                            ref={(ref) => (inputs.current["8C36"] = ref)}
                          />
                          <label htmlFor="8C36">{t("Right")}</label>
                        </div>
                      </div>
                    </div>

                    <div className={trackType8C === 1 ? "tracks_motorized_section" : "noDisplay"}>
                      <div
                        className={
                          motorErr1
                            ? "secondary_options secondary_options_err"
                            : "secondary_options"
                        }
                      >
                        <div className="card-body-display-flex">
                          <div className="width_max checkbox_style">
                            <input
                              type="checkbox"
                              text={t("Motorized")}
                              value="1"
                              name="step8C5"
                              ref-num="8C5"
                              checked={step8C5 === "true"}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  selectChanged(e);
                                  setStep8C5("true");
                                  setMotorErr1(false);
                                  setSelectedMotorPositionC([]);
                                  setDeps("863,864,865", "87");
                                  setSelectedRemoteName([]);
                                  setSelectedMotorChannelsC([
                                    motorChannels[pageLanguage].find((opt) => opt.value === "0"),
                                  ]);
                                  setRemoteNameC("");

                                  setCart("hasPowerC", true, "", "MotorChannelsC", [
                                    selectedMotorChannelsC.map((obj) => obj.value),
                                  ]);
                                } else {
                                  selectUncheck(e);
                                  setStep8C5("");
                                  setDeps("87", "863,864,865");
                                  setCart(
                                    "",
                                    "",
                                    "hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                                  );
                                }
                              }}
                              id="8C51"
                              ref={(ref) => (inputs.current["8C51"] = ref)}
                            />
                            <label htmlFor="8C51" className="checkbox_label">
                              <img
                                className="checkbox_label_img checkmark1 img-fluid 17"
                                src={require("../Images/public/checkmark1_checkbox.png")}
                                alt=""
                              />
                            </label>
                            <span className="checkbox_text">{t("Motor_title")}</span>
                          </div>
                        </div>
                      </div>
                      {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
                      <div
                        className={
                          trackType8C === 1 && step8C5 === "true"
                            ? "motorized_options"
                            : "noDisplay"
                        }
                      >
                        <div className="motorized_option_left">
                          <p>{t("Motor Position")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore2")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedMotorPositionC}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setSelectedMotorPositionC(selected);
                                  setDeps("", "8C,8C1,8C2,863", 2);
                                  setCart("MotorPositionC", selected[0].value);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8C"][2] = (
                                    <li key="2" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Motor Position")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                }
                              }}
                              options={MotorPosition[pageLanguage]}
                            />
                          </div>
                        </div>
                        <div className="motorized_option_left">
                          <p>{t("Remote Name")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore3")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          {!!(remoteNames.length > 1) && (
                            <div className="select_container">
                              <Select
                                className="select"
                                placeholder={t("Please Select")}
                                portal={document.body}
                                dropdownPosition="bottom"
                                dropdownHandle={false}
                                dropdownGap={0}
                                values={selectedRemoteName}
                                onDropdownOpen={() => {
                                  let temp1 = window.scrollY;
                                  window.scrollTo(window.scrollX, window.scrollY + 1);
                                  setTimeout(() => {
                                    let temp2 = window.scrollY;
                                    if (temp2 === temp1)
                                      window.scrollTo(window.scrollX, window.scrollY - 1);
                                  }, 100);
                                }}
                                dropdownRenderer={({ props, state, methods }) => (
                                  <CustomDropdownWithSearch
                                    props={props}
                                    state={state}
                                    methods={methods}
                                  />
                                )}
                                contentRenderer={({ props, state, methods }) => (
                                  <CustomControl props={props} state={state} methods={methods} />
                                )}
                                onChange={(selected) => {
                                  if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                    setSelectedRemoteName(selected);
                                    if (selected[0]["value"] === "addNewRemoteName") {
                                      setShowRemoteName(true);
                                      setDeps("", "8C,8C1,8C2,864", 1);
                                      setCart("", "", "RemoteNameC");
                                      setRemoteNameC("");
                                    } else {
                                      setShowRemoteName(false);
                                      // setDeps("", "8B,8C");
                                      setCart("RemoteNameC", selected[0]["value"]);
                                      setRemoteNameC(selected[0]["value"]);
                                    }
                                  }
                                }}
                                options={remoteNames}
                              />
                            </div>
                          )}
                          {(remoteNames.length === 1 || remoteNames.length === 0) && (
                            <DebounceInput
                              debounceTimeout={1500}
                              onKeyDown={() => setCartLoading(true)}
                              className="Remote_name"
                              type="text"
                              name="Remote_name"
                              value={remoteNameC}
                              placeholder={t("Enter a name for your remote")}
                              onChange={(e) => {
                                setTimeout(() => {
                                  setDeps("", "8C,8C1,8C2,864", 1);
                                  setCart("RemoteNameC", capitalizeWordsText(e.target.value));
                                  setRemoteNameC(capitalizeWordsText(e.target.value));
                                  let tempExtended = extendedTitle;
                                  tempExtended["8C"][3] = (
                                    <li key="3" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Remote_name")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {capitalizeWordsText(e.target.value)}
                                      </span>
                                    </li>
                                  );
                                }, 300);
                              }}
                            />
                          )}
                        </div>
                        {showRemoteName && (
                          <div className="motorized_option_left">
                            <p>&nbsp;</p>
                          </div>
                        )}
                        {showRemoteName && (
                          <div className="motorized_option_right">
                            <DebounceInput
                              debounceTimeout={1500}
                              onKeyDown={() => setCartLoading(true)}
                              className="Remote_name"
                              type="text"
                              name="Remote_name"
                              value={remoteNameC}
                              placeholder={t("Enter a name for your remote")}
                              onChange={(e) => {
                                setTimeout(() => {
                                  setDeps("", "8C,8C1,8C2,865", 1);
                                  setCart("RemoteNameC", e.target.value);
                                  setRemoteNameC(Capitalize(e.target.value));
                                }, 300);
                              }}
                            />
                          </div>
                        )}
                        <div className="motorized_option_left">
                          <p>{t("Channel(s)")}</p>
                          &nbsp;
                          <span onClick={() => modalHandleShow("learnMore4")}>
                            {t("(Learn More)")}
                          </span>
                        </div>
                        <div className="motorized_option_right">
                          <div className="select_container multi_select_container">
                            <Select
                              className="select select_motor_channels"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              multi={true}
                              ref-num="8"
                              values={selectedMotorChannelsC}
                              onDropdownOpen={() => {
                                motorChannelsUserOpenRefC.current = true;
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdownMulti
                                  props={props}
                                  state={state}
                                  methods={methods}
                                />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControlMulti props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                // setDeps("", "412");
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  if (motorChannelsUserOpenRefC.current) {
                                    setDeps("", "8C,8C1,8C2,865,888", 1);
                                    motorChannelsUserOpenRefC.current = false;
                                  }
                                  setCart("MotorChannelsC", selected.map((obj) => obj.value));
                                  setSelectedMotorChannelsC(selected);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8C"][4] = (
                                    <li key="4" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Channel(s)")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {selected
                                          .map((item) =>
                                            pageLanguage === "fa" ? item.label : item.value
                                          )
                                          .join(", ")}
                                      </span>
                                    </li>
                                  );
                                }
                              }}
                              options={motorChannels[pageLanguage]}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        step8C === "None"
                          ? "card_body card_body_radio card_body_have_hardware  card_body_have_hardware_new"
                          : "noDisplay"
                      }
                    >
                      <div className="box100">
                        <p className="step_selection_title step_selection_title_new">
                          {t("step8C_haveHardware_title")}
                        </p>
                      </div>
                      <div className="box-step9a">
                        <div className="box50 radio_style">
                          <div className="same_row_selection_title">
                            {t("Privacy Layer Hardware")}
                          </div>
                        </div>
                        <div className="box50 radio_style">
                          <div className="select_container">
                            <Select
                              className="select"
                              placeholder={t("Please Select")}
                              portal={document.body}
                              dropdownPosition="bottom"
                              dropdownHandle={false}
                              dropdownGap={0}
                              values={selectedPrivacyLayer}
                              onDropdownOpen={() => {
                                let temp1 = window.scrollY;
                                window.scrollTo(window.scrollX, window.scrollY + 1);
                                setTimeout(() => {
                                  let temp2 = window.scrollY;
                                  if (temp2 === temp1)
                                    window.scrollTo(window.scrollX, window.scrollY - 1);
                                }, 100);
                              }}
                              dropdownRenderer={({ props, state, methods }) => (
                                <CustomDropdown props={props} state={state} methods={methods} />
                              )}
                              contentRenderer={({ props, state, methods }) => (
                                <CustomControl props={props} state={state} methods={methods} />
                              )}
                              onChange={(selected) => {
                                if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                  setCart("hardwarePrivacyLayer", selected[0].value);
                                  setDeps("", "8C,8C1,8C2,87", 1);
                                  let tempExtended = extendedTitle;
                                  tempExtended["8C"][1] = (
                                    <li key="1" className="step_title_extended_list_item">
                                      <span className="step_title_extended_list_item_title">
                                        {t("Privacy Layer HW")}
                                      </span>
                                      <span className="step_title_extended_list_item_text">
                                        {pageLanguage === "fa"
                                          ? selected[0].label
                                          : selected[0].value}
                                      </span>
                                    </li>
                                  );
                                  setExtendedTitle(tempExtended);
                                  setSelectedPrivacyLayer(selected);
                                }
                              }}
                              options={
                                parseInt(windowWidthPanelType) <= 160 && step8B === "Track"
                                  ? privacyLayerSelect2[pageLanguage]
                                  : parseInt(windowWidthPanelType) <= 160 && step2A === "Grommet"
                                  ? privacyLayerSelect[pageLanguage]
                                  : parseInt(windowWidthPanelType) <= 160 && step2A !== "Grommet"
                                  ? privacyLayerSelect3[pageLanguage]
                                  : step6CHead === "Rod"
                                  ? privacyLayerSelect[pageLanguage]
                                  : privacyLayerSelect2[pageLanguage]
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <NextStep currentStep="8C" eventKey="9">
                    {t("NEXT STEP")}
                  </NextStep>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 11 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="9"
                  stepNum={step5 === "Full" && step3 === "false" ? t("10") : t("11")}
                  stepTitle={t("grommet_step9")}
                  stepTitle2={t("(Optional)")}
                  stepRef="9"
                  type="1"
                  required={requiredStep["9"]}
                  stepSelected={stepSelectedLabel["9"] === undefined ? "" : stepSelectedLabel["9"]}
                />
              </Card.Header>
              <Accordion.Collapse eventKey="9">
                <Card.Body>
                  <div className="card_body card_body_Accessories">
                    <div className="Accessories_container">
                      <ul className="Accessories_List">
                        <li className="Accessories_List_item">
                          <div className="Accessories_List_item_image">
                            <img
                              src={require("../Images/drapery/grommet/MatchingTieback.jpg")}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="Accessories_List_item_desc 2">
                            <h1
                              style={{ textAlign: pageLanguage === "fa" ? "right" : "left" }}
                              className="Accessories_List_item_title Accessories_List_title_new"
                            >
                              {t("Matching Drapery Tieback")}
                            </h1>
                            <h2 className="Accessories_List_item_price">
                              {handCurtainPricDrapery !== 0 && handCurtainPricDrapery !== undefined
                                ? GetPrice(
                                    handCurtainPricDrapery,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : t("Surcharge Applies")}
                            </h2>
                            <div className="Accessories_List_item_colors"></div>
                          </div>
                          <div className="Accessories_List_item_qty">
                            <div className="qty_numbers">
                              <button
                                type="text"
                                className="qty_minus"
                                onClick={() =>
                                  setTiebackDrapery({
                                    isPlus: false,
                                    HandCurtainId: 2401,
                                    HandCurtainNum: undefined,
                                  })
                                }
                              >
                                <img
                                  src={require("../Images/public/minus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                              <input
                                type="text"
                                className="qty_num"
                                name="qty_num_g2"
                                value={
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${tiebackDraperyQty}`)
                                    : tiebackDraperyQty
                                }
                                onChange={(e) => {}}
                                readOnly
                              />
                              <button
                                type="text"
                                className="qty_plus"
                                onClick={() =>
                                  setTiebackDrapery({
                                    isPlus: true,
                                    HandCurtainId: 2401,
                                    HandCurtainNum: undefined,
                                  })
                                }
                              >
                                <img
                                  src={require("../Images/public/plus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                            </div>
                          </div>
                        </li>
                        <li className="Accessories_List_item">
                          <div className="Accessories_List_item_image">
                            <img
                              src={require("../Images/drapery/grommet/MatchingTieback.jpg")}
                              className="img-fluid"
                              alt=""
                            />
                          </div>
                          <div className="Accessories_List_item_desc 3">
                            <h1
                              style={{ textAlign: pageLanguage === "fa" ? "right" : "left" }}
                              className="Accessories_List_item_title Accessories_List_title_new"
                            >
                              {t("Matching Sheer Tieback")}
                            </h1>
                            <h2 className="Accessories_List_item_price">
                              {handCurtainPricSheer !== 0 && handCurtainPricSheer !== undefined
                                ? GetPrice(
                                    handCurtainPricSheer,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )
                                : t("Surcharge Applies")}
                            </h2>
                            <div className="Accessories_List_item_colors"></div>
                          </div>
                          <div className="Accessories_List_item_qty">
                            <div className="qty_numbers">
                              <button
                                type="text"
                                className="qty_minus"
                                onClick={() =>
                                  setTiebackSheer({
                                    isPlus: false,
                                    HandCurtainId: 2401,
                                    HandCurtainNum: undefined,
                                  })
                                }
                              >
                                <img
                                  src={require("../Images/public/minus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                              <input
                                type="text"
                                className="qty_num"
                                name="qty_num_g3"
                                value={
                                  pageLanguage === "fa"
                                    ? NumberToPersianWord.convertEnToPe(`${tiebackSheerQty}`)
                                    : tiebackSheerQty
                                }
                                onChange={(e) => {}}
                                readOnly
                              />
                              <button
                                type="text"
                                className="qty_plus"
                                onClick={() =>
                                  setTiebackSheer({
                                    isPlus: true,
                                    HandCurtainId: 2401,
                                    HandCurtainNum: undefined,
                                  })
                                }
                              >
                                <img
                                  src={require("../Images/public/plus.svg").default}
                                  alt=""
                                  className="qty_math_icon"
                                />
                              </button>
                            </div>
                          </div>
                        </li>
                        {stepAccessoriesList}
                      </ul>
                    </div>
                  </div>
                  <NextStep currentStep="9" eventKey="10">
                    {t("NEXT STEP")}
                  </NextStep>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 12 */}
            <Card>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="10"
                  stepNum={step5 === "Full" && step3 === "false" ? t("11") : t("12")}
                  stepTitle={t("zebra_step6")}
                  stepRef="10"
                  type="2"
                  required={requiredStep["10"]}
                  stepSelected={
                    stepSelectedLabel["10"] === undefined ? "" : stepSelectedLabel["10"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="10">
                <Card.Body>
                  <div className="card_body card_body_radio">
                    <div className="box100 selectInput_section">
                      <div className="room_select">
                        <label className="select_label">{t("Room")}</label>
                        <div className="select_container">
                          <Select
                            className="select"
                            placeholder={t("Please Select")}
                            portal={document.body}
                            dropdownPosition="bottom"
                            dropdownHandle={false}
                            dropdownGap={0}
                            values={selectedRoomLabel}
                            onDropdownOpen={() => {
                              let temp1 = window.scrollY;
                              window.scrollTo(window.scrollX, window.scrollY + 1);
                              setTimeout(() => {
                                let temp2 = window.scrollY;
                                if (temp2 === temp1)
                                  window.scrollTo(window.scrollX, window.scrollY - 1);
                              }, 100);
                            }}
                            dropdownRenderer={({ props, state, methods }) => (
                              <CustomDropdownWithSearch
                                props={props}
                                state={state}
                                methods={methods}
                              />
                            )}
                            contentRenderer={({ props, state, methods }) => (
                              <CustomControl props={props} state={state} methods={methods} />
                            )}
                            onChange={(selected) => {
                              if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                                setDeps("", "1001", 2);
                                roomLabelChanged(selected[0], "10", false);
                                setSelectedRoomLabel(selected);
                                setCart(
                                  "RoomNameFa",
                                  rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                                  "",
                                  "RoomNameEn",
                                  [selected[0].value]
                                );
                              }
                            }}
                            options={rooms[pageLanguage]}
                          />
                        </div>
                      </div>
                      <div className="room_select">
                        <label className="select_label">{t("Window Description")}</label>
                        <DebounceInput
                          debounceTimeout={1500}
                          onKeyDown={() => setCartLoading(true)}
                          type="text"
                          placeholder={t("E.g. Bedroom east wall")}
                          className="form-control window_name"
                          name="order_window_name"
                          value={roomLabelText}
                          onChange={(e) => {
                            setTimeout(() => {
                              if (e.target.value === "") {
                                setDeps("1002", "");
                              } else {
                                setDeps("", "1002", 2);
                              }
                              roomLabelChanged(capitalizeWordsText(e.target.value), "10", true);
                              setRoomLabelText(capitalizeWordsText(e.target.value));
                              setCart("WindowName", capitalizeWordsText(e.target.value));
                            }, 300);
                          }}
                        />
                      </div>
                    </div>
                    <div className="box100 upload_section">
                      <div
                        className="big_box big_box-new"
                        onDragOver={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                        onDrop={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                            setSelectedFile(e.dataTransfer.files[0]);
                            setSelectedFileName(e.dataTransfer.files[0].name);
                            setEditedFileName(e.dataTransfer.files[0].name);
                          }
                        }}
                        style={{
                          border: "0.09375rem solid #aaa",
                          height: detailsShow ? "8.5rem" : "3rem",
                          margin: "1.25rem auto",
                          width: "85%",
                          display: "inline-flex",
                          position: "relative",
                          transition: "height 0.3s ease",
                        }}
                      >
                        <div
                          className="upload_button_displayer"
                          onClick={() => {
                            if (detailsShow) setDetailsShow(false);
                            else setDetailsShow(true);
                          }}
                        >
                          <p
                            className="d-flex align-items-center"
                            style={{
                              position: "absolute",
                              top: "0.8rem",
                              left: "0.5rem",
                              right: "0.5rem",
                              width: "100%",
                              zIndex: "2",
                              cursor: "pointer",
                            }}
                          >
                            <span className="details-label unselectable">
                              {detailsShow ? t("room Hide Details") : t("Add Room Image")}
                              <h5>{detailsShow ? "" : t("(Optional)")}</h5>
                            </span>
                            <span className="details_indicator">
                              {detailsShow && (
                                <img
                                  className="arrow_down img-fluid"
                                  src={require("../Images/public/arrow_up.svg").default}
                                  alt=""
                                />
                              )}
                              {!detailsShow && (
                                <img
                                  className="arrow_down img-fluid"
                                  src={require("../Images/public/arrow_down.svg").default}
                                  alt=""
                                />
                              )}
                            </span>
                          </p>
                        </div>

                        <div
                          className="uploaded_images_section"
                          style={{
                            display: detailsShow ? "block" : "none",
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "100%",
                            textAlign: "center",
                          }}
                        ></div>

                        <MultipleFileUpload
                          ref={multipleFileUploadRef}
                          baseURLUploadPdf={baseURLUploadPdf}
                          baseURLUploadImg={baseURLUploadImg}
                          addUploadFileUrl={addUploadFileUrl} // تابع موجود شما
                          maxSizeMB={5} // حداکثر حجم بر حسب مگابایت
                          acceptedFormats={[
                            "image/jpeg",
                            "image/png",
                            "image/gif",
                            "application/pdf",
                          ]}
                          t={t}
                          detailsShow={detailsShow}
                          setUploadedImages={setUploadedImages}
                          setUploadedPDFs={setUploadedPDFs}
                          addFailedFileToParent={addFailedFileToParent}
                          onFilesChange={setUploadingFiles}
                        />

                        {detailsShow && (
                          <p
                            className="d-flex text-muted"
                            style={{
                              position: "absolute",
                              bottom: "0.5rem",
                              width: "100%",
                              fontSize: "0.8rem",
                              padding: "0 0.6rem",
                              direction: pageLanguage === "fa" ? "rtl" : "ltr",
                            }}
                          >
                            {t("JPG, PNG, GIF, PDF. Maximum file size 5MB.")}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      className={`box100 hidden_upload_section ${
                        detailsShow ? "show_upload_section" : ""
                      }`}
                    ></div>
                    <div className="box100 uploaded_name_section">
                      <div className="mid_upload">
                        {allFilesSorted.length > 0 && (
                          <UploadedFilesList
                            files={allFilesSorted}
                            onDelete={handleDeleteFile2}
                            formatFileSize={formatFileSize}
                            pageLanguage={pageLanguage}
                          />
                        )}
                      </div>
                    </div>
                    <div className="more_info_section">
                      <div className="more_info_container">
                        <h3 className="more_info_title">{t("Anything else we need to know?")}</h3>
                        <div className="more_info_desc">
                          <p>{t("orderNotes1")}</p>
                        </div>
                      </div>
                      <div className="more_info_input_container">
                        <DebounceInput
                          debounceTimeout={1500}
                          onKeyDown={() => setCartLoading(true)}
                          className="more_info_input"
                          type="text"
                          name="more_info_input"
                          value={moreInfoInput}
                          placeholder=""
                          onChange={(e) => {
                            setTimeout(() => {
                              setCart("moreInfoInput", e.target.value);
                              setMoreInfoInput(e.target.value);
                            }, 300);
                          }}
                        />
                      </div>
                    </div>
                    <NextStep currentStep="10" eventKey="11">
                      {t("NEXT STEP")}
                    </NextStep>
                  </div>
                  <div className=" accordion_help">
                    <div className=" help_container">
                      <div className=" help_column help_left_column">
                        <p className=" help_column_header">{t("step6_help_1")}</p>
                        <ul className=" help_column_list">
                          <li className=" no_listStyle">{t("step6_help_2")}</li>
                        </ul>
                      </div>
                      <div className=" help_column help_right_column">
                        <p className=" help_column_header">{t("step6_help_3")}</p>
                        <ul className=" help_column_list">
                          <li className=" no_listStyle">{t("step6_help_4")}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>

            {/* step 13 */}
            <Card className={accordionActiveKey === "" ? "card_little_margin" : "card_big_margin"}>
              <Card.Header>
                <ContextAwareToggle
                  eventKey="11"
                  stepNum={step5 === "Full" && step3 === "false" ? t("12") : t("13")}
                  stepTitle={t("zebra_step7")}
                  stepTitle2={t("(Optional)")}
                  stepRef="101"
                  type="2"
                  required={false}
                  stepSelected={
                    stepSelectedLabel["101"] === undefined ? "" : stepSelectedLabel["101"]
                  }
                />
              </Card.Header>
              <Accordion.Collapse eventKey="11">
                <Card.Body>
                  <div className="card_body card_body_zipcode">
                    <div className="zipcode_bag_section">
                      <div className="zipcode_section_container">
                        <div className="zipcode_text zipcode_section_title_container">
                          <img
                            src={require("../Images/public/W_truck.png")}
                            alt=""
                            className="img-fluid"
                          />
                          <h3 className={`${pageLanguage === "fa" ? "font_farsi" : ""}`}>
                            {t("zipcode_text1")}
                          </h3>
                        </div>
                        {hasZipcode === "" && (
                          <h3 className="zipcode_text">{t("zipcode_text1.5")}</h3>
                        )}

                        {hasZipcode === "" && (
                          <div className="zipcode_dropdown_div_container">
                            <div className="zipcode_input_container"  style={{gap: "0.5rem"}}>
                              <input
                                className="form-control"
                                type="text"
                                name="zipcode_input"
                                value={zipcode}
                                placeholder={t("Enter Zip Code")}
                                onChange={(e) => {
                                  setZipcode(e.target.value.replace(/\D+/g, ""));
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    measureWindowSize(zipcode);
                                  }
                                }}
                              />
                              <button
                                className="zipcode_input_button white_btn"
                                onClick={() => {
                                  measureWindowSize(zipcode);
                                }}
                              >
                                <div>   
                               {t("UPDATE")}
                                </div>
                              </button>
                            </div>
                          </div>
                        )}
                        {zipcodeButton && (
                          <h3 className="zipcode_text2">
                            {zipcodeButton && hasInstall === false && t("zipcode_text2")}
                            {zipcodeButton && hasInstall && hasZipcode === "" && t("zipcode_text3")}
                            {zipcodeButton &&
                              hasInstall &&
                              hasZipcode !== "" &&
                              installPrice === -1 &&
                              t("zipcode_text3")}
                          </h3>
                        )}
                        {zipcodeButton && hasInstall && installPrice === -1 && (
                          <h3 className="zipcode_text">{t("zipcode_text8")}</h3>
                        )}
                        {zipcodeButton &&
                          hasInstall &&
                          !!installPrice &&
                          installPrice !== -1 &&
                          hasZipcode === "" && (
                            <div className="zipcode_available_container">
                              <div className="checkbox_style">
                                <input
                                  type="checkbox"
                                  value="1"
                                  name="zipcode"
                                  disabled={addingLoading}
                                  checked={zipcodeChecked === "true"}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setZipcodeChecked("true");
                                      setCart("ZipCode", zipcode);
                                    } else {
                                      setZipcodeChecked("false");
                                      setCart("", "", "ZipCode");
                                    }
                                  }}
                                  id="zipcode"
                                  ref={(ref) => (inputs.current["zipcode"] = ref)}
                                />
                                <label htmlFor="zipcode" className="checkbox_label">
                                  <img
                                    className="checkbox_label_img checkmark1 img-fluid 18"
                                    src={require("../Images/public/checkmark1_checkbox.png")}
                                    alt=""
                                  />
                                </label>
                                <span className="checkbox_text">
                                  {t("zipcode_text4")}
                                  {GetPrice(
                                    installPrice,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                  {t("zipcode_text5")}
                                  <br />
                                  {t("zipcode_text5.5")}
                                  {GetPrice(
                                    transportPrice,
                                    pageLanguage,
                                    t("TOMANS"),
                                    isTabletOrMobile
                                  )}
                                  {t("zipcode_text6")}
                                </span>
                              </div>
                            </div>
                          )}
                        {installPrice !== -1 && hasZipcode && hasZipcode !== "" && (
                          <div className="checkbox_style checkbox_style_hasZipcode">
                            <input
                              type="checkbox"
                              value="1"
                              name="zipcode"
                              disabled={addingLoading}
                              checked={zipcodeChecked === "true"}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setZipcodeChecked("true");
                                  setCart("ZipCode", zipcode);
                                } else {
                                  setZipcodeChecked("false");
                                  setCart("", "", "ZipCode");
                                }
                              }}
                              id="zipcode"
                              ref={(ref) => (inputs.current["zipcode"] = ref)}
                            />
                            <label htmlFor="zipcode" className="checkbox_label">
                              <img
                                className="checkbox_label_img checkmark1 img-fluid 18"
                                src={require("../Images/public/checkmark1_checkbox.png")}
                                alt=""
                              />
                            </label>
                            <span className="checkbox_text">
                              {t("zipcode_text4")}
                              {GetPrice(installPrice, pageLanguage, t("TOMANS"), isTabletOrMobile)}
                              {t("zipcode_text5")}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className=" accordion_help">
                    <div className=" help_container">
                      <div className=" help_column help_left_column">
                        <p className=" help_column_header" />
                        <ul className=" help_column_list">
                          <li>{t("stepZip_help_1")}</li>
                          <li>{t("stepZip_help_2")}</li>
                          <li>
                            {t("stepZip_help_3")}
                            <h5
                              className="text_underline pointer"
                              onClick={() => modalHandleShow("Zipcode_how_it_works")}
                            >
                              {t("zipcode_measure_verify")}
                            </h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
          <div className="CustomModelFooter_visible_part">
            <div className="bag_buttons_section_container">
              <button
                className="btn add_to_cart 2"
                disabled={addingLoading || cartLoading}
                onClick={() => {
                  setAddingLoading(true);
                  addToCart();
                }}
              >
                {addingLoading ? t("ADDING...") : t("footer_Add To Cart")}
              </button>
              <button className="btn add_to_cart no_pointer">
                {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
              </button>
              <button
                className="save_to_acc white_btn btn 1"
                onClick={() => {
                  if (step8 === "Same Hardware For All Curtains") {
                    const excludedValues = new Set(["325", "336", "345"]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  } else if (
                    step8 === "I Want To Customize Hardware Per Curtain" ||
                    step3 === "false"
                  ) {
                    const excludedValues = new Set([
                      "8A1",
                      "8A2",
                      "8B2",
                      "8B3",
                      "325",
                      "336",
                      "345",
                    ]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  }

                  if (step31 === "false") {
                    const excludedValues = new Set(["325", "336", "345"]);
                    for (let val of excludedValues) {
                      depSet.delete(val);
                    }
                  }
                  if (roomLabelText !== "" && selectedRoomLabel.length) {
                    setSavingLoading(true);
                    if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa,
                        projectData
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    } else {
                      SaveUserProject(
                        depSet,
                        cartValues,
                        [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                        `${modelID}`,
                        price,
                        defaultModelName,
                        defaultModelNameFa
                      )
                        .then((temp) => {
                          if (temp === 401) {
                            setSaveProjectCount(saveProjectCount + 1);
                          } else if (temp) {
                            modalHandleShow("add_to_project_modal");
                            setProjectModalState(1);
                            setSavingLoading(false);
                          } else {
                            setSavingLoading(false);
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                          setProjectModalState(2);
                          modalHandleShow("add_to_project_modal");
                          setSavingLoading(false);
                        });
                    }
                  } else {
                    setProjectModalState(0);
                    modalHandleShow("add_to_project_modal");
                  }
                }}
                disabled={savingLoading || cartLoading}
              >
                {savingLoading ? t("SAVING...") : t("footer_Save To")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}

      <div
        className={
          filtersShow
            ? "filters_container filters_container_mob_show mobile_only"
            : "filters_container mobile_only"
        }
      >
        <div className="nav_header">
          <div className="nav_header_bottom nav_header_bottom_single">
            <div className="close_menu_icon" onClick={() => setFiltersShow(false)}>
              <img
                src={require("../Images/public/close-button.png")}
                className="img-fluid"
                alt=""
              />
            </div>
          </div>
        </div>
        {filtersShow && (
          <div className="product_filters_container">
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Color")}
                  textOnShow={t("Color")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingColors2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Price")}
                  textOnShow={t("Price")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPrices2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Type")}
                  textOnShow={t("Type")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingTypes2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <Accordion>
              <Accordion.Item eventKey="0">
                <ContextAwareToggleFilters
                  eventKey="0"
                  textOnHide={t("Pattern")}
                  textOnShow={t("Pattern")}
                />
                <Accordion.Body className="product_filter_dropdown">
                  <div className="product_filter_dropdown">{sewingPatterns2}</div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        )}
        <div className="filter_modal_btn_section">
          <button
            className="btn btn-new-dark"
            onClick={() => {
              setIsClearAll(true);
              // setFiltersShow(false);
            }}
          >
            {t("CLEAR")}
          </button>
          <button
            className="btn white_btn"
            onClick={() => {
              setFiltersShow(false);
            }}
          >
            {t("DONE")}
          </button>
        </div>
      </div>

      <ElectricHandModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <CompleteStep4Grommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <FabricSelectionModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />
      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelTypeWarning"] === undefined ? false : modals["panelTypeWarning"]}
        onHide={() => modalHandleClose("panelTypeWarning")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("panelTypeWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelTypeWarning");
                selectChanged(undefined, "6");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("panelTypeWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["SheerHeaderStyleWarning"] === undefined
            ? false
            : modals["SheerHeaderStyleWarning"]
        }
        onHide={() => modalHandleClose("SheerHeaderStyleWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("SheerHeaderStyleWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("SheerHeaderStyleWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep2A(sheerHeaderStyleTemp.stepValue);
                setDeps(
                  "",
                  "2A,8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                );
                setCart(
                  "SheerHeaderStyle",
                  sheerHeaderStyleTemp.cartValue,
                  "RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,Mount8,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                  "SheerHeaderStyleID",
                  [sheerHeaderStyleTemp.id]
                );
                selectChanged(sheerHeaderStyleTemp.event, "8");
                setSheersModelId(sheerHeaderStyleTemp.id);
                setStep8("");
                modalHandleClose("SheerHeaderStyleWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["SheerHeaderStyleWarning2"] === undefined
            ? false
            : modals["SheerHeaderStyleWarning2"]
        }
        onHide={() => modalHandleClose("SheerHeaderStyleWarning2")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("SheerHeaderStyleWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("SheerHeaderStyleWarning2");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep2C(sheerHeaderStyleTemp2.stepValue);
                setDeps(
                  "",
                  "2C,8,81,82,83,84,8A,8A1,8A2,8A3,8A4,8B,8B1,8B2,8B3,8B5,8B51,8B6,8C,8C1,8C2,8C3,8C5,8C51,8C52,8C6"
                );
                setCart(
                  "PrivacyLayerHeaderStyle",
                  sheerHeaderStyleTemp2.cartValue,
                  "RailId,BatonOption,RailDesign,RailDesignEn,RailDesignFa,RailColorEn,RailColorFa,RodColor,Mount8,BatonOptionA,RailDesignA,RailDesignEnA,RailDesignFaA,RailColorEnA,RailColorFaA,RodColorA,MountA,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC",
                  "PrivacyLayerHeaderStyleID",
                  [sheerHeaderStyleTemp2.id]
                );
                selectChanged(sheerHeaderStyleTemp2.event, "8");
                setSheersModelId2(sheerHeaderStyleTemp2.id);
                setStep8("");
                modalHandleClose("SheerHeaderStyleWarning2");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["MountTypeWarning"] === undefined ? false : modals["MountTypeWarning"]}
        onHide={() => modalHandleClose("MountTypeWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("MountTypeWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("MountTypeWarning");
              }}
            >
              {pageLanguage === "en" ? "CANCEL" : "ادامه سفارش"}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3A0(mountTypeTemp.stepValue);
                setStep3("");
                setStep5("");
                setWidth("");
                setHeight("");
                setLeft("");
                setRight("");
                setWidthCart("");
                setWindowWidthPanelType("");
                setHeightCart("");
                setMount("");
                setCeilingToWindow1("");
                setCeilingToWindow2("");
                setCeilingToWindow3("");
                setDepth(undefined);
                setMouldingHeight(undefined);
                setMountErr1(false);
                setMountErr2(false);
                if (mountTypeTemp.stepValue === "Moulding") {
                  setDeps(
                    "3,3A11,3A12",
                    "3A0,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                  );
                } else {
                  setDeps(
                    "3",
                    "3A0,3A11,3A12,31,311,312,3A,3A1,3B,3B1,3C,3D1,3D2,3E,3EFloor,3F,3G,315,3ARod1,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                  );
                }
                setCart(
                  "Mount",
                  mountTypeTemp.cartValue,
                  "Depth,MouldingHeight,calcMeasurements,Width,Height,WidthCart,HeightCart,hasRod,CurtainPosition,FinishedLengthType,Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );
                clearInputs(mountTypeTemp.event, undefined, "3");
                // setMeasurementsNextStep("4");
                modalHandleClose("MountTypeWarning");
              }}
            >
              {pageLanguage === "en" ? "I AGREE, CONTINUE ANYWAY" : "تغییر نحوه نصب"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["CurtainPosWarning"] === undefined ? false : modals["CurtainPosWarning"]}
        onHide={() => modalHandleClose("CurtainPosWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("CurtainPosWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("CurtainPosWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3A(curtainPosTemp.stepValue);
                clearInputs(curtainPosTemp.event);
                setCart(
                  "CurtainPosition",
                  curtainPosTemp.cartValue,
                  "Width3C,ExtensionLeft,ExtensionRight,ShadeMount,Height3E,WindowToFloor,CeilingToFloor,RodWidth,RodToBottom,RodToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );
                if (step3B === "Sill" || step3B === "Apron") {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (curtainPosTemp.stepValue === "Standard" ||
                      curtainPosTemp.stepValue === "Left Corner Window" ||
                      curtainPosTemp.stepValue === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3A,3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (curtainPosTemp.stepValue === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3E,3F,3G",
                      "3A,3B,3B1,3D1,3D2,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    curtainPosTemp.stepValue === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3A,3B,3B1,3D1,3D2,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3E,3F,3G",
                      "3A,3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                } else {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (curtainPosTemp.stepValue === "Standard" ||
                      curtainPosTemp.stepValue === "Left Corner Window" ||
                      curtainPosTemp.stepValue === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3A,3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else if (curtainPosTemp.stepValue === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3EFloor,3F,3G",
                      "3A,3B,3B1,3D1,3D2,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    curtainPosTemp.stepValue === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3A,3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3EFloor,3F,3G",
                      "3A,3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                }
                modalHandleClose("CurtainPosWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={
          modals["FinishedLengthWarning"] === undefined ? false : modals["FinishedLengthWarning"]
        }
        onHide={() => modalHandleClose("FinishedLengthWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("FinishedLengthWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("FinishedLengthWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep3B(finishedLengthTemp.stepValue);
                clearInputs(finishedLengthTemp.event);
                setCart(
                  "FinishedLengthType",
                  finishedLengthTemp.cartValue,
                  "WindowToFloor,RodWidth,Width3C,Height3E,RodToBottom,RodToFloor,CeilingToFloor,CeilingToWindow1,CeilingToWindow2,CeilingToWindow3,CeilingToFloor1,CeilingToFloor2,CeilingToFloor3"
                );

                if (
                  finishedLengthTemp.stepValue === "Sill" ||
                  finishedLengthTemp.stepValue === "Apron"
                ) {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (step3A === "Standard" ||
                      step3A === "Left Corner Window" ||
                      step3A === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3B,3B1,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3E,3F,3G",
                      "3B,3B1,3D1,3D2,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3G",
                      "3B,3B1,3D1,3D2,3E,3F,3EFloor,325,335,336,345,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3E,3F,3G",
                      "3B,3B1,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                } else {
                  if (
                    (step3A0 === "Ceiling" || step3A0 === "Moulding") &&
                    (step3A === "Standard" ||
                      step3A === "Left Corner Window" ||
                      step3A === "Right Corner Window")
                  ) {
                    setDeps(
                      "3C,3D1,3D2,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3B,3B1,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else if (step3A === "Wall to Wall" && step3A0 === "Wall") {
                    setDeps(
                      "3C,3EFloor,3F,3G",
                      "3B,3B1,3D1,3D2,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  } else if (
                    step3A === "Wall to Wall" &&
                    (step3A0 === "Ceiling" || step3A0 === "Moulding")
                  ) {
                    setDeps(
                      "3C,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3",
                      "3B,3B1,3D1,3D2,3E,3F,3G,3EFloor,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3"
                    );
                  } else {
                    setDeps(
                      "3C,3D1,3D2,3EFloor,3F,3G",
                      "3B,3B1,3E,325,335,336,345,3EStandardCeiling1,3EStandardCeiling2,3EStandardCeiling3,3EStandardCeilingFloor1,3EStandardCeilingFloor2,3EStandardCeilingFloor3"
                    );
                  }
                }
                modalHandleClose("FinishedLengthWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["hardwareSheerWarning"] === undefined ? false : modals["hardwareSheerWarning"]}
        onHide={() => modalHandleClose("hardwareSheerWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("hardwareSheerWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("hardwareSheerWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6B("");
                setStep8B1("");
                setStep8B2("");
                setStep8B3("");
                // setStep8B4("");
                setTimeout(() => {
                  setStep8B(hardwareSheerWarningTemp.stepValue);
                }, 300);
                let tempExtended = extendedTitle;
                tempExtended["6"].splice(2, 1);
                tempExtended["8B"] = [t(hardwareSheerWarningTemp.id)];
                setExtendedTitle(tempExtended);
                setCart(
                  "SheerHardware",
                  hardwareSheerWarningTemp.cartValue,
                  "PanelTypeB,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hardwareSheer"
                );
                selectChanged(hardwareSheerWarningTemp.event);
                setDeps("6B,8B1,8B2,8B3", "8B,8B5,8B51,8B6");
                modalHandleClose("hardwareSheerWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["hardwarePLWarning"] === undefined ? false : modals["hardwarePLWarning"]}
        onHide={() => modalHandleClose("hardwarePLWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("hardwarePLWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("hardwarePLWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6C("");
                setStep8C1("");
                setStep8C2("");
                setStep8C3("");
                // setStep8C4("");
                setTimeout(() => {
                  setStep8C(hardwarePLWarningTemp.stepValue);
                }, 300);
                let tempExtended = extendedTitle;
                tempExtended["6"].splice(3, 1);
                tempExtended["8C"] = [t(hardwarePLWarningTemp.id)];
                setExtendedTitle(tempExtended);
                setCart(
                  "PrivacyLayerHardware",
                  hardwarePLWarningTemp.cartValue,
                  "PanelTypeC,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hardwarePrivacyLayer"
                );
                selectChanged(hardwarePLWarningTemp.event);
                setDeps("6C,8C1,8C2,8C3", "8C,8C5,8C51,8C52,8C6");
                modalHandleClose("hardwarePLWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelSheerWarning"] === undefined ? false : modals["panelSheerWarning"]}
        onHide={() => modalHandleClose("panelSheerWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>
            {panelSheerWarningTemp.id === "1" ? t("hardwarePLWarning") : t("panelSheerWarning")}
          </p>
          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelSheerWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                if (panelSheerWarningTemp.id === "1") {
                  console.log("این");

                  setStep6CHead(panelSheerWarningTemp.stepValue);
                  setStep6C("");
                  setStep8B("");
                  setStep8("");
                  setStep81("");
                  let tempExtended = extendedTitle;
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  tempExtended["6"].splice(3);
                  setExtendedTitle(tempExtended);
                  setDeps("6B,8B", "8B1,8B2,8B3,8B5,8B51,8B6");
                  setCart(
                    "",
                    "",
                    "PanelTypeB,PrivacyLayerHardware,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                  );
                } else if (step6BHead === "Rod" && step6CHead === "Track") {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  setStep6B("");
                  setStep8C("");
                  setStep8("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][1] = [];
                  tempExtended["6"][2] = [];
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else if (step6BHead === "Track" && step6CHead === "Track") {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  setStep6B("");
                  setStep8C("");
                  setStep8("");
                  let tempExtended = extendedTitle;
                  tempExtended["6"][1] = [];
                  tempExtended["6"][2] = [];
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  setExtendedTitle(tempExtended);
                } else {
                  setStep6BHead(panelSheerWarningTemp.stepValue);
                  if (panelSheerWarningTemp.stepValue === "Track") {
                    setStep6BHead("Track");
                  }
                  setStep81("");
                  setStep6C("");
                  setStep6B("");
                  setStep8B("");
                  let tempExtended = extendedTitle;
                  tempExtended["8"] = [];
                  tempExtended["8A"] = [];
                  tempExtended["8B"] = [];
                  tempExtended["8C"] = [];
                  tempExtended["6"].splice(1);
                  setExtendedTitle(tempExtended);
                }
                setDeps("6B,8B", "8B1,8B2,8B3,8B5,8B51,8B6");
                setCart(
                  "",
                  "",
                  "PanelTypeB,PrivacyLayerHardware,RailIdB,BatonOptionB,ControlPositionB,RailDesignB,RailDesignEnB,RailDesignFaB,RailColorEnB,RailColorFaB,RodColorB,hasPowerB,MotorPositionB,RemoteNameB,MotorChannelsB"
                );
                modalHandleClose("panelSheerWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`warning_modal2 bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["panelPLWarning"] === undefined ? false : modals["panelPLWarning"]}
        onHide={() => modalHandleClose("panelPLWarning")}
      >
        <Modal.Header>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("panelPLWarning")}</p>

          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                modalHandleClose("panelPLWarning");
              }}
            >
              {t("CANCEL")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                setStep6CHead(panelPLWarningTemp.stepValue);
                setStep6C("");
                setStep8C("");
                let tempExtended = extendedTitle;
                tempExtended["8C"] = [];
                tempExtended["6"].splice(3, 1);
                setExtendedTitle(tempExtended);
                setDeps("6C,8C", "8C1,8C2,8C3,8C5,8C51,8C52,8C6");
                setCart(
                  "",
                  "",
                  "PanelTypeC,PrivacyLayerHardware,RailIdC,BatonOptionC,ControlPositionC,RailDesignC,RailDesignEnC,RailDesignFaC,RailColorEnC,RailColorFaC,RodColorC,hasPowerC,MotorPositionC,RemoteNameC,MotorChannelsC"
                );
                modalHandleClose("panelPLWarning");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <SelectMountGrommetStep4
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <Modal dialogClassName="zoomModal" show={show} onHide={() => handleClose()}>
        <Modal.Header closeButton>{zoomModalHeader}</Modal.Header>
        <Modal.Body>{zoomModalBody}</Modal.Body>
        <Modal.Footer>
          <button
            className={`swatchButton ${hasSwatchId ? "activeSwatch" : ""} ${
              pageLanguage === "fa" ? "font_farsi" : "font_en"
            }`}
            current-state={hasSwatchId ? "1" : "0"}
            onClick={(e) => {
              fabricSwatch(e, swatchId, swatchDetailId, swatchPhotoPath);
            }}
            disabled={swatchId === -1}
          >
            {hasSwatchId ? t("SWATCH IN BAG") : t("ORDER SWATCH")}
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["noPrivacyLayer"] === undefined ? false : modals["noPrivacyLayer"]}
        onHide={() => modalHandleClose("noPrivacyLayer")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          {(() => {
            if (step2A === "" && (step2B === "" || (step2B !== "None" && step2B1 === ""))) {
              return <p>{t("modal_select_PrivacyLayer1")}</p>;
            } else if (step2A === "" && step2C === "") {
              return <p>{t("modal_select_PrivacyLayer2")}</p>;
            } else if (step2A === "") {
              return <p>{t("modal_select_PrivacyLayer3")}</p>;
            } else if (step2B === "" || (step2B !== "None" && step2B1 === "")) {
              return <p>{t("modal_select_PrivacyLayer4")}</p>;
            } else if (step2B !== "None" && step2C === "") {
              return <p>{t("modal_select_PrivacyLayer5")}</p>;
            }
          })()}
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("noPrivacyLayer")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <SelectNoMeasurementsGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />

      <SelectNoPanelTypeModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />
      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["width600cm"] === undefined ? false : modals["width600cm"]}
        onHide={() => modalHandleClose("width600cm")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("width600cm")}</p>

          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("width600cm")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["mountAllChange"] === undefined ? false : modals["mountAllChange"]}
        onHide={() => modalHandleClose("mountAllChange")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_select_mountAllChange")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("mountAllChange")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine"] === undefined ? false : modals["fabricHasLine"]}
        onHide={() => modalHandleClose("fabricHasLine")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine")}</p>
          <br />
          <div className=" text_center">
            <button className=" btn btn-new-dark" onClick={() => modalHandleClose("fabricHasLine")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine2"] === undefined ? false : modals["fabricHasLine2"]}
        onHide={() => modalHandleClose("fabricHasLine2")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine2")}</p>
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("fabricHasLine2")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricHasLine3"] === undefined ? false : modals["fabricHasLine3"]}
        onHide={() => modalHandleClose("fabricHasLine3")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricHasLine3")}</p>
          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => modalHandleClose("fabricHasLine3")}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricUnAvailable"] === undefined ? false : modals["fabricUnAvailable"]}
        onHide={() => {
          setFabricSelected({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep1Check("");
          setStep1Border("");
          setStep1BorderRadio("");
          setStep1Trim("");
          tempExtended["1"] = [];
          setDeps("1", "11,111");
          setCart(
            "",
            "",
            "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
          );
          selectChanged(undefined, "1");
          setExtendedTitle(tempExtended);
          setStep1("");
          modalHandleClose("fabricUnAvailable");
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricUnAvailable")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => {
                setFabricSelected({
                  selectedFabricId: 0,
                  selectedTextEn: "",
                  selectedTextFa: "",
                  selectedDesignCode: "",
                  selectedColorEn: "",
                  selectedColorFa: "",
                  selectedHasTrim: false,
                  selectedPhoto: "",
                  selectedPhoto2: "",
                  FabricWidth: 0,
                  SewingDirection: undefined,
                });
                let tempExtended = extendedTitle;
                setStep1Check("");
                setStep1Border("");
                setStep1BorderRadio("");
                setStep1Trim("");
                tempExtended["1"] = [];
                setDeps("1", "11,111");
                setCart(
                  "",
                  "",
                  "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
                );
                selectChanged(undefined, "1");
                setExtendedTitle(tempExtended);
                setStep1("");
                modalHandleClose("fabricUnAvailable");
              }}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`noMount_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["fabricUnAvailable2"] === undefined ? false : modals["fabricUnAvailable2"]}
        onHide={() => {
          setFabricSelected2({
            selectedFabricId: 0,
            selectedTextEn: "",
            selectedTextFa: "",
            selectedDesignCode: "",
            selectedColorEn: "",
            selectedColorFa: "",
            selectedHasTrim: false,
            selectedPhoto: "",
            selectedPhoto2: "",
            FabricWidth: 0,
            SewingDirection: undefined,
          });
          let tempExtended = extendedTitle;
          setStep2Check("");
          setStep2Check2("");
          setStep2Border("");
          setStep2BorderRadio("");
          setStep2Trim("");
          tempExtended["2"] = [];
          setDeps("2", "21,211", 1);
          setCart(
            "",
            "",
            "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
          );
          selectChanged(undefined, "2");
          setExtendedTitle(tempExtended);
          setStep2("");
          modalHandleClose("fabricUnAvailable2");
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("fabricUnAvailable2")}</p>

          <br />
          <div className=" text_center">
            <button
              className=" btn btn-new-dark"
              onClick={() => {
                setFabricSelected2({
                  selectedFabricId: 0,
                  selectedTextEn: "",
                  selectedTextFa: "",
                  selectedDesignCode: "",
                  selectedColorEn: "",
                  selectedColorFa: "",
                  selectedHasTrim: false,
                  selectedPhoto: "",
                  selectedPhoto2: "",
                  FabricWidth: 0,
                  SewingDirection: undefined,
                });
                let tempExtended = extendedTitle;
                setStep2Check("");
                setStep2Check2("");
                setStep2Border("");
                setStep2BorderRadio("");
                setStep2Trim("");
                tempExtended["2"] = [];
                setDeps("2", "21,211", 1);
                setCart(
                  "",
                  "",
                  "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
                );
                selectChanged(undefined, "2");
                setExtendedTitle(tempExtended);
                setStep2("");
                modalHandleClose("fabricUnAvailable2");
              }}
            >
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        backdrop="static"
        keyboard={false}
        className={`changeFabrics cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["changeFabrics"] === undefined ? false : modals["changeFabrics"]}
        onHide={() => {
          changeFabricsGuardRef.current = false;
          modalHandleClose("changeFabrics");

          // Only clear steps that actually required replacement (=== 1),
          // matching the open logic — do not wipe a valid fabric/sheer selection.
          if (fabricBoard === 1 && sheerBoard === 1) {
            setAccordionActiveKey2("");
            setFabricSelected({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            setFabricSelected2({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });

            let tempExtended = extendedTitle;
            setStep1Check("");
            setStep1Border("");
            setStep1BorderRadio("");
            setStep1Trim("");
            tempExtended["1"] = [];
            setDeps("1,2", "11,111,21,211");
            setCart(
              "",
              "",
              "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition,FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
            );
            selectChanged(undefined, "1,2");
            setStep1("");
            setStep2Check("");
            setStep2Check2("");
            setStep2Border("");
            setStep2BorderRadio("");
            setStep2Trim("");
            tempExtended["2"] = [];
            setExtendedTitle(tempExtended);
            setStep2("");
          } else if (fabricBoard === 1) {
            setAccordionActiveKey2("1");
            setFabricSelected({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            let tempExtended = extendedTitle;
            setStep1Check("");
            setStep1Border("");
            setStep1BorderRadio("");
            setStep1Trim("");
            tempExtended["1"] = [];
            setDeps("1", "11,111");
            setCart(
              "",
              "",
              "FabricId,FabricDesignFa,FabricDesignEn,FabricColorEn,FabricColorFa,PhotoUrl,BorderOrTrimId,BorderOrTrimDesignFa,BorderOrTrimDesignEn,BorderOrTrimColorEn,BorderOrTrimColorFa,BorderOrTrimPhotoUrl,borderPosition"
            );
            selectChanged(undefined, "1");
            setExtendedTitle(tempExtended);
            setStep1("");
          } else if (sheerBoard === 1) {
            setAccordionActiveKey2("2");
            setFabricSelected2({
              selectedFabricId: 0,
              selectedTextEn: "",
              selectedTextFa: "",
              selectedDesignCode: "",
              selectedColorEn: "",
              selectedColorFa: "",
              selectedHasTrim: false,
              selectedPhoto: "",
              selectedPhoto2: "",
              FabricWidth: 0,
              SewingDirection: undefined,
            });
            let tempExtended = extendedTitle;
            setStep2Check("");
            setStep2Check2("");
            setStep2Border("");
            setStep2BorderRadio("");
            setStep2Trim("");
            tempExtended["2"] = [];
            setDeps("2", "21,211", 1);
            setCart(
              "",
              "",
              "FabricId2,leadId,hasLead,FabricDesignFa2,FabricDesignEn2,FabricColorEn2,FabricColorFa2,PhotoUrl2,BorderOrTrimId2,BorderOrTrimDesignFa2,BorderOrTrimDesignEn2,BorderOrTrimColorEn2,BorderOrTrimColorFa2,BorderOrTrimPhotoUrl2,borderPosition2"
            );
            selectChanged(undefined, "2");
            setExtendedTitle(tempExtended);
            setStep2("");
          }

          setFabricBoard(undefined);
          setSheerBoard(undefined);
        }}
      >
        <Modal.Header closeButton>
          <div className="selection_assistant">
            <h1 className="selection_assistant_title">{t("Selection Assistant")}</h1>
            {!!(fabricBoard === 0) && (
              <div className="selection_assistant_fabric_container">
                <div className="selection_assistant_fabric_img">
                  <img
                    className="img-fluid"
                    src={imgUrl(fabricSelected["selectedPhoto2"])}
                    alt=""
                  />
                </div>
                <div className="selection_assistant_fabric_desc">{t("fabricHasLine")}</div>
              </div>
            )}
            {!!(sheerBoard === 0) && (
              <div className="selection_assistant_fabric_container">
                <div className="selection_assistant_fabric_img">
                  <img
                    className="img-fluid"
                    src={imgUrl(fabricSelected2["selectedPhoto2"])}
                    alt=""
                  />
                </div>
                <div className="selection_assistant_fabric_desc" style={{ whiteSpace: "pre-line" }}>
                  {t("fabricHasLine2")}
                </div>
              </div>
            )}
            <div
              className="selection_assistant_desc"
              style={{ whiteSpace: "pre-line", fontSize: "1.2rem" }}
            >
              {fabricBoard === 1 && sheerBoard === undefined
                ? t("selection_assistant_desc")
                : fabricBoard === 1 && sheerBoard === 1
                ? t("selection_assistant_desc3")
                : fabricBoard === undefined && sheerBoard === 1
                ? t("selection_assistant_desc2")
                : fabricBoard === 1 && sheerBoard === 0
                ? t("selection_assistant_desc")
                : t("selection_assistant_desc2")}
            </div>
            {fabricBoard === 1 && sheerBoard === 1 && (
              <h2 className="selection_assistant_title2" style={{ fontSize: "1.25rem" }}>
                {t("Select Options 1 & 2")}
              </h2>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className={
              !!(fabricBoard === 1 && sheerBoard === 1)
                ? "modal_step_container"
                : "modal_step_container modal_step_container_max"
            }
          >
            <Accordion ref={accordion2} flush activeKey={accordionActiveKey2}>
              {fabricBoard === 1 && (
                <Card>
                  <Card.Header>
                    {sheerBoard === 1 && (
                      <ContextAwareToggle2
                        eventKey="1"
                        stepNum={t("1")}
                        stepTitle={t("grommet_step1M")}
                        stepRef="1"
                        type="1"
                        required={requiredStep["1"]}
                        stepSelected={
                          stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]
                        }
                      />
                    )}
                    {sheerBoard !== 1 && (
                      <ContextAwareToggle3
                        eventKey="1"
                        stepNum={t("1")}
                        stepTitle={t("grommet_step1_2")}
                        stepRef="1"
                        type="1"
                        required={requiredStep["1"]}
                        stepSelected={
                          stepSelectedLabel["1"] === undefined ? "" : stepSelectedLabel["1"]
                        }
                      />
                    )}
                  </Card.Header>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="card_body card-body-fabric">
                        <div className="search_filter_container">
                          <div className="search_container">
                            <div className="search_box">
                              <input
                                type="text"
                                placeholder={t("Search for product Name/Code")}
                                className="form-control search_input"
                                name="search_input"
                                value={searchText}
                                ref={search_input}
                                onChange={(e) => {
                                  if (e.target.value !== "") setSearchShow(true);
                                  else setSearchShow(false);
                                  setSearchText(e.target.value);
                                }}
                              />
                              {searchShow && (
                                <div
                                  className="clear-icon-container"
                                  onClick={() => {
                                    search_input.current.value = "";
                                    setSearchText("");
                                    setSearchShow(false);
                                  }}
                                >
                                  <i className="fa fa-times-circle clear-icon" />
                                </div>
                              )}
                              <div className="search-icon-container">
                                <i className="fa fa-search" />
                              </div>
                            </div>
                            <div
                              className="filters_show_hide_container"
                              onClick={() => {
                                if (filtersShow) {
                                  setFiltersShow(false);
                                } else {
                                  setFiltersShow(true);
                                }
                              }}
                            >
                              <span className="filters_toggle">{t("Filters")}</span>
                              <span className="filters_indicator">
                                {filtersShow && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_up.svg").default}
                                    alt=""
                                  />
                                )}
                                {!filtersShow && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_down.svg").default}
                                    alt=""
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          <div
                            className={
                              filtersShow
                                ? "filters_container desktop_only"
                                : "filters_container desktop_only filters_container_hidden"
                            }
                          >
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Color")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="filter_color_items">
                                  <div className="filter_items_container">{sewingColors}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="colors"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Pattern")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingPatterns}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="patterns"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Type")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingTypes}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="types"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Price")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">
                                    {/*<div className="price_filter_description">{t("filter_price_title")}</div>*/}
                                    {sewingPrices}
                                  </div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="prices"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div ref={fabricsContainerRef} className="fabrics_list_container 5">
                          {loading ? "" : fabricsList}
                        </div>
                        {/*<NextStep currentStep="1" eventKey="2">{t("NEXT STEP")}</NextStep>*/}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )}
              {/* step 2 */}
              {sheerBoard === 1 && (
                <Card>
                  <Card.Header>
                    {fabricBoard === 1 && (
                      <ContextAwareToggle2
                        eventKey="2"
                        stepNum={t("2")}
                        stepTitle={t("grommet_step2M")}
                        stepRef="2"
                        type="1"
                        required={requiredStep["2"]}
                        stepSelected={
                          stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]
                        }
                      />
                    )}
                    {fabricBoard !== 1 && (
                      <ContextAwareToggle3
                        eventKey="2"
                        stepNum={t("2")}
                        stepTitle={t("grommet_step2_2")}
                        stepRef="2"
                        type="1"
                        required={requiredStep["2"]}
                        stepSelected={
                          stepSelectedLabel["2"] === undefined ? "" : stepSelectedLabel["2"]
                        }
                      />
                    )}
                  </Card.Header>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="card_body card-body-fabric card-body-fabric-sheer">
                        <div className="search_filter_container">
                          <div className="search_container">
                            <div className="search_box">
                              <input
                                type="text"
                                placeholder={t("Search for product Name/Code")}
                                className="form-control search_input"
                                name="search_input"
                                value={searchText2}
                                ref={search_input2}
                                onChange={(e) => {
                                  if (e.target.value !== "") setSearchShow2(true);
                                  else setSearchShow2(false);
                                  setSearchText2(e.target.value);
                                }}
                              />
                              {searchShow2 && (
                                <div
                                  className="clear-icon-container"
                                  onClick={() => {
                                    search_input2.current.value = "";
                                    setSearchText2("");
                                    setSearchShow2(false);
                                  }}
                                >
                                  <i className="fa fa-times-circle clear-icon" />
                                </div>
                              )}
                              <div className="search-icon-container">
                                <i className="fa fa-search" />
                              </div>
                            </div>
                            <div
                              className="filters_show_hide_container"
                              onClick={() => {
                                if (filtersShow2) {
                                  setFiltersShow2(false);
                                } else {
                                  setFiltersShow2(true);
                                }
                              }}
                            >
                              <span className="filters_toggle">{t("Filters")}</span>
                              <span className="filters_indicator">
                                {filtersShow2 && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_up.svg").default}
                                    alt=""
                                  />
                                )}
                                {!filtersShow2 && (
                                  <img
                                    className="arrow_down img-fluid"
                                    src={require("../Images/public/arrow_down.svg").default}
                                    alt=""
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                          <div
                            className={
                              filtersShow2
                                ? "filters_container desktop_only"
                                : "filters_container desktop_only filters_container_hidden"
                            }
                          >
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Color")}</p>
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="filter_color_items">
                                  <div className="filter_items_container">{sewingColorsSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="colors"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Pattern")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingPatternsSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="patterns"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Type")}</p>

                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">{sewingTypesSheer}</div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="types"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                            <div className="filter_container">
                              <Dropdown autoClose="outside" title="">
                                <Dropdown.Toggle className="dropdown_btn">
                                  <p>{t("filter_Price")}</p>
                                  {/*<img className="select_control_handle_close img-fluid" src={require('../Images/public/arrow_down.svg').default} alt=""/>*/}
                                  <div className="select_control_handle_close img-fluid" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <div className="filter_items_container">
                                    <div className="price_filter_description">
                                      {t("filter_price_title")}
                                    </div>
                                    {sewingPricesSheer}
                                  </div>
                                  <div className="filter_inside_button_section">
                                    <div
                                      className="clear_inside_filter"
                                      text="prices"
                                      data-step="2"
                                      onClick={(e) => clearFilters(e)}
                                    >
                                      {/* {t("filter_Clear Filters")} */}
                                      {i18n.language === "fa" ? "حذف فیلترها" : "Clear Filters"}
                                    </div>
                                    <Dropdown.Toggle as="div" className="done_inside_filter">
                                      {t("filter_Done")}
                                    </Dropdown.Toggle>
                                  </div>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        </div>
                        <div ref={fabricsContainerRef4} className="fabrics_list_container 6">
                          {loading2 ? "" : showEmptyMessage2 ? (
                            <div
                              className={`material_detail ${
                                pageLanguage === "fa" ? "font_farsi" : "font_en"
                              }`}
                              key={"fabric2-board-empty"}
                            >
                              <div
                                className={`material_traits ${
                                  pageLanguage === "fa" ? "font_farsi" : "font_en"
                                }`}
                              >
                                <h5 className="empty_fabrics">
                                  {pageLanguage === "en"
                                    ? "Sorry, no matching fabrics.\nTo view more results, try clearing your filters."
                                    : "متاسفانه این محصول را موجود نداریم.\nبرای دیدن نتایج بهتر، فیلترها را تغییر دهید."}
                                </h5>
                              </div>
                            </div>
                          ) : (
                            fabricsList2
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              )}
            </Accordion>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="go_to_checkout">
            <div className="checkout_button_section small_checkout_button_section">
              <button
                className="basket_checkout btn"
                onClick={() => {
                  if (
                    fabricBoard === 1 &&
                    sheerBoard === 1 &&
                    (!fabricSelected.selectedFabricId || !fabricSelected2.selectedFabricId)
                  ) {
                    if (!fabricSelected.selectedFabricId) {
                      setAccordionActiveKey2("1");
                    } else if (!fabricSelected2.selectedFabricId) {
                      setAccordionActiveKey2("2");
                    }
                  } else {
                    changeFabricsGuardRef.current = false;
                    modalHandleClose("changeFabrics");
                    setFabricBoard(undefined);
                    setSheerBoard(undefined);
                  }
                }}
                disabled={
                  (fabricBoard === 1 && !fabricSelected.selectedFabricId) ||
                  (sheerBoard === 1 && !fabricSelected2.selectedFabricId) ||
                  fabricLoading
                }
              >
                {t("CONFIRM SELECTION")}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore1"] === undefined ? false : modals["learnMore1"]}
        onHide={() => modalHandleClose("learnMore1")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore1")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore2"] === undefined ? false : modals["learnMore2"]}
        onHide={() => modalHandleClose("learnMore2")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <p>{t("modal_learn_more3")}</p>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore2")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore3"] === undefined ? false : modals["learnMore3"]}
        onHide={() => modalHandleClose("learnMore3")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore3_help1")}</li>
            <li>{t("learnMore3_help2")}</li>
            <li>{t("learnMore3_help3")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore3")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogClassName={`learnMore_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["learnMore4"] === undefined ? false : modals["learnMore4"]}
        onHide={() => modalHandleClose("learnMore4")}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <ul className="help_column_list">
            <li>{t("learnMore4_help1")}</li>
            <li>{t("learnMore4_help2")}</li>
            <li>{t("learnMore4_help3")}</li>
            <li>{t("learnMore4_help4")}</li>
          </ul>

          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("learnMore4")}>
              {t("CONTINUE")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <HelpMeasureModalGrommet
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        setHelpMeasure={setHelpMeasure}
        setHelpMeasureLengthType={setHelpMeasureLengthType}
        helpMeasure={helpMeasure}
        helpMeasureLengthType={helpMeasureLengthType}
        step3A0={step3A0}
        t={t}
      />

      <Modal
        dialogClassName={`upload_modal uploadImg_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadImg"] === undefined ? false : modals["uploadImg"]}
        onHide={() => {
          setSelectedFile(undefined);
          setSelectedFileName("");
          setEditedFileName("");
          modalHandleClose("uploadImg");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const { files } = e.dataTransfer;
              if (
                files &&
                files.length &&
                (files[0].type === "image/jpg" ||
                  files[0].type === "image/jpeg" ||
                  files[0].type === "image/png")
              ) {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_img1")}</h2>
            <p className="file_size_description">{t("upload_img2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="image-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_img3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      id="image-upload-btn"
                      name="file"
                      accept="image/png,image/jpeg,image/jpg"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const { files } = e.dataTransfer;
                        if (
                          files &&
                          files.length &&
                          (files[0].type === "image/jpg" ||
                            files[0].type === "image/jpeg" ||
                            files[0].type === "image/png")
                        ) {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_img5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_img4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadImg");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(2);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload Image")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        dialogClassName={`upload_modal uploadPdf_modal mediumSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["uploadPdf"] === undefined ? false : modals["uploadPdf"]}
        onHide={() => {
          modalHandleClose("uploadPdf");
          setDetailsShow(false);
        }}
      >
        <Modal.Header closeButton>{/*<Modal.Title>Modal heading</Modal.Title>*/}</Modal.Header>
        <Modal.Body>
          <div
            onDragOver={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onDrop={(e) => {
              e.preventDefault();
              e.stopPropagation();
              const { files } = e.dataTransfer;
              if (files && files.length && files[0].type === "application/pdf") {
                uploadImg(files[0]);
              } else {
                setSelectedFile(undefined);
                setSelectedFileName("");
              }
            }}
          >
            <h2>{t("upload_pdf1")}</h2>
            <p className="file_size_description">{t("upload_pdf2")}</p>
            <div className="controls">
              <div className="modal_upload_section">
                <div className="modal_upload_item">
                  <label htmlFor="file-upload-btn" className="btn btn-new-gray file-upload-btn">
                    {t("upload_pdf3")}
                    <input
                      type="file"
                      className="custom-file file-upload"
                      name="file"
                      id="file-upload-btn"
                      accept="application/pdf"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length) {
                          uploadImg(e.target.files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const { files } = e.dataTransfer;
                        if (files && files.length && files[0].type === "application/pdf") {
                          uploadImg(files[0]);
                        } else {
                          setSelectedFile(undefined);
                          setSelectedFileName("");
                        }
                      }}
                    />
                  </label>
                  <div className="file-name file-upload-btn">
                    {selectedFileName === "" ? t("upload_pdf5") : selectedFileName}
                  </div>
                </div>
                <div className="modal_upload_item">
                  <input
                    className="file_name_text"
                    type="text"
                    value={editedFileName}
                    onChange={(e) => setEditedFileName(e.target.value)}
                    placeholder={t("upload_pdf4")}
                  />
                </div>
              </div>
            </div>
            <div className="controls">
              <div className="modal_button_section">
                <button
                  className="btn btn-new-gray"
                  onClick={() => {
                    setSelectedFile(undefined);
                    setSelectedFileName("");
                    setEditedFileName("");
                    modalHandleClose("uploadPdf");
                    setDetailsShow(false);
                  }}
                >
                  {t("Cancel")}
                </button>
                <div
                  className="btn btn-new-dark image_submit file-upload-btn btn-disabled"
                  onClick={() => {
                    submitUploadedFile(1);
                  }}
                  disabled={selectedFileName === "" || isUploading}
                >
                  {isUploading ? t("UPLOADING...") : t("Upload PDF")}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["widthDifferent"] === undefined ? false : modals["widthDifferent"]}
        onHide={() => {
          modalHandleClose("widthDifferent");
        }}
      >
        <Modal.Header>
          <p>{t("WIDTH DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("WIDTH DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("WIDTH DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("WIDTH DISCREPANCIES_2.2")}
            </Link>
            {t("WIDTH DISCREPANCIES_2.3")}
          </p>
          <p>{t("WIDTH DISCREPANCIES4")}</p>
          <br />
          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "WidthDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("widthDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("widthDifferent");
                setAccordionActiveKey("3B");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`addToCartErr bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["addToCartErr"] === undefined ? false : modals["addToCartErr"]}
        onHide={() => {
          modalHandleClose("addToCartErr");
        }}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="modal-header-grommet">
            {pageLanguage === "fa"
              ? "برای ادامه نیاز است مراحل زیر را تکمیل کنید:"
              : "PLEASE COMPLETE THE FOLLOWING:"}
          </div>
          <ul
            className={`addToCartErr_list_new ${
              pageLanguage === "fa" ? "addToCartErr_list_font_farsi" : ""
            }`}
          >
            {addCartErr}
          </ul>
          <br />
          <span>{t("addToCartErr1")}</span>
          <span>{t("addToCartErr3")}</span>
          <br />
          <div className="text_center">
            <button className="btn btn-new-dark" onClick={() => modalHandleClose("addToCartErr")}>
              {t("OK")}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <WorkingSevenMedals
        pageLanguage={pageLanguage}
        modals={modals}
        modalHandleClose={modalHandleClose}
        t={t}
      />
      <Modal
        backdrop="static"
        keyboard={false}
        dialogClassName={`warning_modal bigSizeModal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        show={modals["heightDifferent"] === undefined ? false : modals["heightDifferent"]}
        onHide={() => {
          modalHandleClose("heightDifferent");
        }}
      >
        <Modal.Header>
          <p>{t("HEIGHT DISCREPANCIES")}</p>
        </Modal.Header>
        <Modal.Body>
          <p>{t("HEIGHT DISCREPANCIES_1")}</p>
          <br />
          <p>
            {t("HEIGHT DISCREPANCIES_2.1")}
            <Link className="link_between_text" to={"/" + pageLanguage}>
              {t("HEIGHT DISCREPANCIES_2.2")}
            </Link>
            {t("HEIGHT DISCREPANCIES_2.3")}
          </p>
          <p>{t("HEIGHT DISCREPANCIES4")}</p>
          <br />

          <div className="buttons_section">
            <button
              className="btn btn-new-dark"
              onClick={() => {
                clearInputs(undefined, inputDifRef, undefined, "HeightDif");
                setDeps(inputDifdep, "");
                let temp = JSON.parse(JSON.stringify(stepSelectedOptions));
                temp.labels[inputDifRef] = [];
                temp.values[inputDifRef] = [];
                setStepSelectedOptions(temp);
                modalHandleClose("heightDifferent");
              }}
            >
              {t("CHANGE MEASUREMENTS")}
            </button>
            <button
              className="btn white_btn"
              onClick={() => {
                modalHandleClose("heightDifferent");
              }}
            >
              {t("I AGREE, CONTINUE ANYWAY")}
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["cart_modal"] === undefined ? false : modals["cart_modal"]}
        onHide={() => {
          modalHandleClose("cart_modal");
          setCartStateAgree(false);
        }}
        id="cart_modal"
      >
        {cartStateAgree && (
          <div className="custom_cart_header_desc">{`${
            freeShipPrice - sideCartPrice > 0
              ? `${t("cart_agree_free_ship1")}${
                  pageLanguage === "fa"
                    ? NumberToPersianWord.convertEnToPe(
                        `${GetPrice(
                          freeShipPrice - sideCartPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}`
                      )
                    : GetPrice(
                        freeShipPrice - sideCartPrice,
                        pageLanguage,
                        t("TOMANS"),
                        isTabletOrMobile
                      )
                }${t("cart_agree_free_ship2")}`
              : `${t("cart_agree_free_ship")}`
          }`}</div>
        )}
        <Modal.Header>
          {cartStateAgree && (
            <span className="custom_cart_title">
              {t("My Bag")}{" "}
              <h3>
                (
                {pageLanguage === "fa"
                  ? NumberToPersianWord.convertEnToPe(`${cartCount}`)
                  : cartCount}
                )
              </h3>
            </span>
          )}
          {!cartStateAgree && <p className="custom_cart_title">&nbsp;</p>}
          <button
            className="custom_cart_close"
            onClick={() => {
              modalHandleClose("cart_modal");
              setCartStateAgree(false);
              setAddingLoading(false);
              sessionStorage.clear();
              if (backPage === true) {
                navigate(pageLanguage === "fa" ? "/fa" : "/en");
                setBackPage(false);
              }
            }}
          >
            {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div ref={modalTopRef}>
            <p></p>
          </div>
          {cartStateAgree && (
            <RenderSideCart cartObjects={sideCartObjects} setCartCount={setCartCount} />
          )}
          {!cartStateAgree && <h1 className="cart_agree_title1">{t("REVIEW ORDER")}</h1>}
          {!cartStateAgree && <h2 className="cart_agree_title2">{t("TERMS OF SALE")}</h2>}
          {!cartStateAgree && <div>{cartAgree}</div>}
          {!cartStateAgree && (
            <span className="cart_agree_desc">
              <label className="checkbox_style">
                <input
                  type="checkbox"
                  checked={cartAgreeDescription}
                  onChange={(e) => {
                    setCartAgreeDescription(e.target.checked);
                  }}
                  id="cartAgreeDescription"
                />
                <label htmlFor="cartAgreeDescription" className="checkbox_label">
                  <img
                    className="checkbox_label_img checkmark1 img-fluid 20"
                    src={require("../Images/public/checkmark1_checkbox.png")}
                    alt=""
                  />
                </label>
                <span className="checkbox_text">{t("cart_agree_desc")}</span>
              </label>
            </span>
          )}
          {!cartStateAgree && (
            <div className="go_to_checkout">
              <button
                className="basket_checkout"
                onClick={() => {
                  setAddingLoading(true);
                  setBackPage(true);
                  addToCart_agreed();
                  topScroll();
                }}
                disabled={addingLoading || !cartAgreeDescription}
              >
                {editIndex
                  ? addingLoading
                    ? t("UPDATING...")
                    : t("footer_update2")
                  : addingLoading
                  ? t("ADDING...")
                  : t("AGREE & ADD TO BAG")}
              </button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {cartStateAgree && (
            <div className="go_to_checkout" style={{ backgroundColor: "#faf9f7" }}>
              <div className="checkout_button_section small_checkout_button_section">
                <div className="small_cart_price_summary">
                  {sideCartProductTotal > 0 && (
                    <span
                      className="checkout_payment_price_detail payment_price_detail"
                      style={{ marginTop: "0.7rem" }}
                    >
                      <h3>{t("PRODUCT TOTAL")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartProductTotal,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}

                  {sideCartInstallPrice > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("INSTALLATION SERVICES")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartInstallPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}
                  {sideCartTransportPrice > 0 && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("TRANSPORTATION FEE")}</h3>
                      <h4>
                        {GetPrice(
                          sideCartTransportPrice,
                          pageLanguage,
                          t("TOMANS"),
                          isTabletOrMobile
                        )}
                      </h4>
                    </span>
                  )}
                  {(sideCartHasSwatches ||
                    sideCartProductTotal > 0 ||
                    sideCartInstallPrice > 0 ||
                    sideCartTransportPrice > 0) && (
                    <span className="checkout_payment_price_detail payment_price_detail">
                      <h3>{t("SHIPPING")}</h3>
                      <h4>
                        {freeShipPrice > 0 &&
                        (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                          ? t("FREE")
                          : t("CALCULATED AT CHECKOUT")}
                      </h4>
                    </span>
                  )}
                </div>
                <span className="checkout_payment_price_detail payment_price_detail small_cart_subtotal">
                  <h3>
                    {freeShipPrice > 0 &&
                    (isLoggedIn ? sideCartPrice : sideCartProductTotal) >= freeShipPrice
                      ? t("TOTAL")
                      : t("SUBTOTAL")}
                  </h3>
                  <h4>
                    {GetPrice(
                      isLoggedIn
                        ? sideCartPrice
                        : sideCartProductTotal + sideCartInstallPrice + sideCartTransportPrice,
                      pageLanguage,
                      t("TOMANS"),
                      isTabletOrMobile
                    )}
                  </h4>
                </span>
                <Link
                  className="basket_checkout btn"
                  to={"/" + pageLanguage + "/Basket"}
                  onClick={() => {
                    setCartStateAgree(false);
                  }}
                >
                  {t("CHECKOUT")}
                </Link>
              </div>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["add_to_project_modal"] === undefined ? false : modals["add_to_project_modal"]}
        onHide={() => {
          modalHandleClose("add_to_project_modal");
        }}
        id="add_to_project_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {projectModalState === 0 && (
            <div className="add_to_project_container2">
              <h2 className="project_added_text">{t("Please select a room name")}</h2>
              <div className="box100 selectInput_section">
                <div className="room_select">
                  <label className="select_label">{t("Room")}</label>
                  <div className="select_container">
                    <Select
                      className="select"
                      placeholder={t("Please Select")}
                      dropdownPosition="bottom"
                      dropdownHandle={false}
                      dropdownGap={0}
                      values={selectedRoomLabel}
                      dropdownRenderer={({ props, state, methods }) => (
                        <CustomDropdownWithSearch props={props} state={state} methods={methods} />
                      )}
                      contentRenderer={({ props, state, methods }) => (
                        <CustomControl props={props} state={state} methods={methods} />
                      )}
                      onChange={(selected) => {
                        if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                          setDeps("", "1001", 2);
                          roomLabelChanged(selected[0], "10", false);
                          setSelectedRoomLabel(selected);
                          setCart(
                            "RoomNameFa",
                            rooms["fa"].find((opt) => opt.value === selected[0].value).label,
                            "",
                            "RoomNameEn",
                            [selected[0].value]
                          );
                        }
                      }}
                      options={rooms[pageLanguage]}
                    />
                  </div>
                </div>
                <div className="room_select">
                  <label className="select_label">{t("Window Description")}</label>
                  <DebounceInput
                    debounceTimeout={1500}
                    onKeyDown={() => setCartLoading(true)}
                    type="text"
                    placeholder={t("E.g. Bedroom east wall")}
                    className="form-control window_name"
                    name="order_window_name"
                    value={roomLabelText}
                    onChange={(e) => {
                      setTimeout(() => {
                        if (e.target.value === "") {
                          setDeps("1002", "");
                        } else {
                          setDeps("", "1002", 2);
                        }
                        roomLabelChanged(e.target.value, "10", true);
                        setRoomLabelText(e.target.value);
                        setCart("WindowName", e.target.value);
                      }, 300);
                    }}
                  />
                </div>
              </div>
              {!!(roomLabelText !== "" && selectedRoomLabel.length) && (
                <button
                  className="save_item_btn btn-new-dark"
                  onClick={() => {
                    if (roomLabelText !== "" && selectedRoomLabel.length) {
                      setSavingLoading(true);
                      if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          projectData,
                          customAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              modalHandleShow("add_to_project_modal");
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            console.log(err);
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      } else {
                        SaveUserProject(
                          depSet,
                          cartValues,
                          [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                          `${modelID}`,
                          price,
                          defaultModelName,
                          defaultModelNameFa,
                          undefined,
                          customAcc
                        )
                          .then((temp) => {
                            if (temp === 401) {
                              setSaveProjectCount(saveProjectCount + 1);
                            } else if (temp) {
                              setProjectModalState(1);
                              setSavingLoading(false);
                            } else {
                              setSavingLoading(false);
                            }
                          })
                          .catch((err) => {
                            setProjectModalState(2);
                            setSavingLoading(false);
                          });
                      }
                    } else {
                      setProjectModalState(0);
                    }
                  }}
                  disabled={savingLoading}
                >
                  {savingLoading ? t("SAVING...") : t("SAVE ITEM")}
                </button>
              )}
            </div>
          )}
          {projectModalState === 1 && (
            <div className="add_to_project_container">
              <h2 className="project_added_text">{t("1 ITEM ADDED TO YOUR PROJECTS")}</h2>
              <Link
                className="add_to_project_btn btn"
                to={"/" + pageLanguage + "/Account/Projects"}
              >
                {t("VIEW PROJECTS")}
              </Link>
              <button
                className="continue_shopping_btn"
                onClick={() => {
                  modalHandleClose("add_to_project_modal");
                }}
              >
                {cartStateAgree ? t("CONTINUE SHOPPING") : t("EDIT ORDER")}
              </button>
            </div>
          )}
          {projectModalState === 2 && <ModalLogin />}
        </Modal.Body>
      </Modal>
      <Modal
        backdrop="static"
        keyboard={false}
        className={`cart_modal_container cart_agree_container add_to_project_modal side_login_modal ${
          pageLanguage === "fa" ? "font_farsi" : "font_en"
        }`}
        dialogClassName={`cart_modal ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}
        show={modals["side_login_modal"] === undefined ? false : modals["side_login_modal"]}
        onHide={() => {
          modalHandleClose("side_login_modal");
          setSwatchLogin(false);
        }}
        id="side_login_modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <ModalLogin text={t("fabric_login_text")} />
        </Modal.Body>
      </Modal>
      <HardwareImgModal
        t={t}
        modals={modals}
        modalHandleClose={modalHandleClose}
        pageLanguage={pageLanguage}
        rodsListHardware={rodsListHardware}
      />
      <div className={`CustomModelFooter ${pageLanguage === "fa" ? "font_farsi" : "font_en"}`}>
        <div className="CustomModelFooter_hidden_part" />
        <div className="CustomModelFooter_visible_part">
          <div className="bag_buttons_section_container">
            <button
              className="btn add_to_cart 1"
              disabled={addingLoading || cartLoading}
              onClick={() => {
                setAddingLoading(true);
                addToCart();
              }}
            >
              {editIndex
                ? addingLoading
                  ? t("UPDATING...")
                  : t("footer_update")
                : addingLoading
                ? t("ADDING...")
                : t("footer_Add To Cart")}
            </button>
            <button className="btn add_to_cart no_pointer">
              {GetPrice(price, pageLanguage, t("TOMANS"), isTabletOrMobile)}
            </button>
            <button
              className="save_to_acc white_btn btn 2"
              onClick={() => {
                if (roomLabelText !== "" && selectedRoomLabel.length) {
                  setSavingLoading(true);
                  if ((projectId && projectId !== "") || (editIndex && editIndex !== "")) {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      projectData,
                      customAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  } else {
                    SaveUserProject(
                      depSet,
                      cartValues,
                      [uploadedImagesFile, uploadedImagesURL, uploadedPDFFile, uploadedPDFURL],
                      `${modelID}`,
                      price,
                      defaultModelName,
                      defaultModelNameFa,
                      undefined,
                      customAcc
                    )
                      .then((temp) => {
                        if (temp === 401) {
                          setSaveProjectCount(saveProjectCount + 1);
                        } else if (temp) {
                          modalHandleShow("add_to_project_modal");
                          setProjectModalState(1);
                          setSavingLoading(false);
                        } else {
                          setSavingLoading(false);
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                        setProjectModalState(2);
                        modalHandleShow("add_to_project_modal");
                        setSavingLoading(false);
                      });
                  }
                } else {
                  setProjectModalState(0);
                  modalHandleShow("add_to_project_modal");
                }
              }}
              disabled={savingLoading || cartLoading}
            >
              {savingLoading ? t("SAVING...") : t("footer_Save To")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Grommet;
